export default {
  '(4<=条码长度<=10)': '(4<=barcode length<=10)',
  '1*1*1规格或默认规格,不允许被删除': '1 * 1 * 1 specification or default specification, cannot be deleted',
  '17位生鲜条码': '17-digit fresh barcode',
  '2. 打开浏览器扩展程序，并打开右上角开发者模式': '2. Open the browser extensions and the open developer mode in the upper right corner',
  '24位生鲜条码': '24-digit fresh barcode',
  '3. 点击“加载已解压的扩展程序”按钮，选择第一步下载并解压的文件目录': '3. Click the "load the unzipped extension", select the document catalog downloaded and decompressed in the first step',
  '4. 此时可看到扩展程序里有一个串口插件，将插件ID复制到本页面又上角的检查插件页面': '4. There is a serial port plug-in in the extension and the plug-in ID could be copied to the check plug-in page at the top corner of this page',
  '5. 刷新页面即可': '5. Refresh the page',
  ':共生成{length}张供应商拣货单': ': A total of {length} supplier picking lists have been generated',
  '<空>': '<blank>',
  'AGV入库回传': 'AGV Receipt Return',
  'AGV入库暂存位': 'AGV warehouse-in temporary location',
  'AGV内部管理指令': 'AGV internal management instructions',
  'AGV出库分拣机': 'AGV outbound sorter',
  'AGV出库暂存位': 'AGV ex-warehouse temporary location',
  'AGV异常处理位': 'Abnormal disposal location of AGV',
  'AGV拣货': 'AGV picking',
  'AGV拣货位': 'AGV picking location',
  'AGV盘点库存处理方式配置': 'AGV inventory processing method configuration',
  'AGV盘点移库': 'AGV inventory transfer',
  'AGV移库': 'AGV warehouse shifting',
  'AGV移库出': 'AGV warehouse transfer out',
  'AGV配置': 'AGV configuration',
  'AGV集货': 'AGV collection',
  'App操作': 'App operation',
  'EAN128码': 'EAN128 code',
  'EAN128码打印机配置': 'EAN128 code printer configuration',
  'ERP发起': 'ERP Initiation',
  'Failed to update theme': 'Failed to update theme',
  'IPS拣货': 'IPS picking',
  'IP地址': 'IP address',
  'I型货道-由大到小': 'Type I Cargo Lane - Large to Small',
  'I型货道-由小到大': 'Type I cargo lane - from small to large',
  'OMS订单号': 'OMS order No.',
  'PC打印': 'PC printing',
  'RFiD配置': 'RFiD configuration',
  'RF上传': 'RF upload',
  'RF上架是否启用货位别名二次校验': 'Whether to enable the goods location for RF release, also known as secondary verification',
  'RF作业数量默认录入方式配置': 'The entry mode configuration is in default for the RF operation qty',
  'RF安装文件': 'RF document installation',
  'RF安装文件不能为空': 'RF document installed cannot be left blank',
  'RF容器复查计入方式': 'Container Review Counting Methods of RF',
  'RF库存分配限制配置': 'en-RF库存分配限制配置',
  'RF库存查询忽略货位用途配置': 'RF inventory inquiry, ignore the configuration oif goods location purposes',
  'RF快捷键配置': 'RF shortcut key configuration',
  'RF打印': 'RF print',
  'RF打印机': 'RF printer',
  'RF打印机管理配置': 'Management configuration of RF printer',
  'RF收货混载框勾选配置': 'Ticking configuration of RF receiving mixed loading frame',
  'RF模块名': 'RF module name',
  'RF模块名称': 'RF module name',
  'RF生成拣货指令货位': 'RF generates the goods location of the picking instruction',
  'RF生成拣货指令货位配置': 'RF generates the goods location configuration of the picking instruction',
  'RF管理': 'RF',
  'RF装车': 'RF loading',
  'RF记录卸货方式': 'US RF记录卸货方式',
  'RF货位展示及录入配置': 'RF goods location display and entry configuration',
  'RF货位展示及确认配置': 'RF goods location display and confirmed configuration',
  'RF边拣边播任务获取方式配置': 'Acquisition data configuration of RF picking and distribution tasks',
  'RF边拣边播任务获取方式：': 'Acquisition data of RF picking and distribution tasks',
  'RF边拣边播自动分配容器类型配置': 'Type configuration of automatic allocation container of RF picking and allocation',
  'RF退仓收货是否展示退货条件信息': 'Whether to display the return condition information for RF return receipt',
  'RF退仓收货自动上架': 'RF returns and receipts are automatically put on the shelves',
  'SCC配置': 'SCC configuration',
  'TMS配置': 'TMS configuration',
  'Token不能为空': 'token cannot be left blank',
  'T值尾盘修复': 'T value end plate repair',
  '按整箱': 'Whole container',
  '严格出货量': 'Strict pick qty',
  'T型上架配置': 'Type T inventory in-log configuration',
  'U型货道': 'U-shaped cargo lane',
  'WCS包装机配置': 'WCS packaging machine configuration',
  'WCS配置': 'VCU configuration',
  'WMS系统功能': 'WMS system function',
  'Web摘果实拣显示': 'Web picking fruit picking display',
  'Web播种实拣显示': 'Web digital-assorting picking display',
  'Web操作': 'Web operations',
  'Web收货': 'Web Received',
  'WEB收货': 'Web Received',
  'Web端权限': 'Web-end permission',
  'XX 指数': 'XX Index',
  'Your device does not support files downloading. Please try again in desktop browser.': 'Your device does not support files downloading.  Please try again in desktop browser.',
  ']吗?': '?',
  ']角色吗?': '] role?',
  'account.center.setting.avatar.button': 'Change profile photo',
  'account.center.setting.avatar.tips.add': 'Add pictures',
  'account.center.setting.avatar.tips.update': 'Modify the  picture',
  'account.center.setting.avatar.title': 'Profile photo',
  'account.center.setting.avatar.validate.message.Limit2M': 'The picture size is no more than 2M.',
  'account.center.setting.avatar.validate.message.notImage': 'Only support the images in PNG, GIF or JPG',
  'account.center.setting.button.updateInfo': 'Confirm modification',
  'account.center.setting.form.item.avatar': 'Profile photo',
  'account.center.setting.form.item.code': 'Code',
  'account.center.setting.form.item.name': 'Name',
  'account.center.setting.form.item.name.placeholder': 'Please enter the name',
  'account.center.setting.form.item.name.validate.message.limitLength': 'The max length of the username is 30',
  'account.center.setting.form.item.name.validate.message.notNull': 'The username shall not be left blank',
  'account.center.setting.form.item.orgs': 'Organization',
  'account.center.setting.form.item.phone': 'Phone number',
  'account.center.setting.form.item.phone.placeholder': 'Please enter the phone number',
  'account.center.setting.form.item.phone.validate.message.integrality': 'Please enter the real mobile phone number',
  'account.center.setting.form.item.phone.validate.message.notNull': 'Mobile number cannot be left blank',
  'account.center.setting.message.success.changeAvatar': 'Update avatar successfully',
  'account.center.setting.message.success.changeBasicInfo': 'Change the information successfully',
  'account.center.setting.tittle': 'Account Information',
  'adjBill.adjBillItems': 'Details of correction list',
  'adjBill.adjer': 'Modifying staff',
  'adjBill.article': 'Commodity',
  'adjBill.binAndBinUsage': 'Goods location and its purpose',
  'adjBill.contained': 'Container',
  'adjBill.down': 'Reverse collection',
  'adjBill.endTime': 'End time',
  'adjBill.handover': 'handover',
  'adjBill.manageReason': 'Manage correction reason',
  'adjBill.note': 'Remarks',
  'adjBill.reason': 'Causes',
  'adjBill.receiver': 'consignee',
  'adjBill.rtner': 'liquidator',
  'adjBill.sourceBill': 'Source No.',
  'adjBill.spec': 'Specification',
  'adjBill.startTime': 'Start time',
  'adjBill.state': 'Status',
  'adjBill.title': 'Correction List',
  'adjBill.type': 'Correction type',
  'adjBill.up': 'Forward correction',
  'alcDiff.diffReason': 'Reasons for the difference',
  'alcDiff.manageDiffReason': 'Manage the difference reason',
  'alcDiff.manageDiffType': 'Manage the type of dispatch order',
  'alcNtc.alcDate': 'Allocation date',
  'alcNtc.alcTime': 'Allocation time',
  'alcNtc.articleItems': 'Commodity details',
  'alcNtc.batch.fail': 'Fail in acquiring the batch import template',
  'alcNtc.createTime': 'Receiving time of dispatching order',
  'alcNtc.endPickTime': 'End the picking time',
  'alcNtc.endShipTime': 'End the loading time',
  'alcNtc.expireDate': 'Expiry date',
  'alcNtc.groupName': 'Group',
  'alcNtc.manageType': 'Manage the type of distribution',
  'alcNtc.oldArticle': 'original product',
  'alcNtc.pickUpload': 'Order picking and upload',
  'alcNtc.pickUploadDate': 'Picking upload date',
  'alcNtc.qpcStrAndMunit': 'Package specification/unit',
  'alcNtc.replaceItems': 'Replacement details',
  'alcNtc.shipState': 'Loading status',
  'alcNtc.shipUpload': 'Loading -- upload',
  'alcNtc.shipUploadDate': 'Upload date of loading',
  'alcNtc.sourceBillNumber': 'Source No.',
  'alcNtc.sourceOrderBillNumber': 'Order/source order No',
  'alcNtc.startPickTime': 'Picking time',
  'alcNtc.startShipTime': 'Time of loading',
  'alcNtc.title': 'Allocation Notice',
  'alcNtc.type': 'Allocation type',
  'alcNtc.waveBillNumber': 'Wave no.',
  'app.analysis.all-day': 'Today',
  'app.analysis.all-month': 'Current month',
  'app.analysis.all-week': 'This week',
  'app.analysis.all-year': 'Total',
  'app.analysis.channel.all': 'All channels',
  'app.analysis.channel.online': 'Online',
  'app.analysis.channel.stores': 'Store',
  'app.analysis.conversion-rate': 'Conversion rate',
  'app.analysis.day': 'Day-on-day basis',
  'app.analysis.day-sales': 'Daily sales amount',
  'app.analysis.day-visits': 'Daily visits',
  'app.analysis.introduce': 'Index description',
  'app.analysis.online-top-search': 'Online popular search',
  'app.analysis.operational-effect': 'Effects of operation activity',
  'app.analysis.payments': 'Number of payments',
  'app.analysis.per-capita-search': 'Search times per capita',
  'app.analysis.sales': 'Sales amount',
  'app.analysis.sales-ranking': 'Ranking of the store\'s sales amount',
  'app.analysis.sales-trend': 'Sales trend',
  'app.analysis.search-users': 'Number of users in search',
  'app.analysis.table.rank': 'Ranking',
  'app.analysis.table.search-keyword': 'Searching keyword',
  'app.analysis.table.users': 'Number of users',
  'app.analysis.table.weekly-range': 'ZHOU Zhangfu',
  'app.analysis.test': '{no} outlet on Gongzhuan road',
  'app.analysis.the-proportion-of-sales': 'Proportion of sales category',
  'app.analysis.total-sales': 'Total sales amount',
  'app.analysis.traffic': 'Passenger volume',
  'app.analysis.visits': 'Visits',
  'app.analysis.visits-ranking': 'Ranking of the store visits',
  'app.analysis.visits-trend': 'Visits trend',
  'app.analysis.week': 'Weekly comparison',
  'app.desc': 'Heading system is unique',
  'app.desc.end': 'Heading system is unique',
  'app.desc.front': 'The warehouses are similar,',
  'app.exception.back': 'Back to Home',
  'app.exception.description.403': 'Sorry, you do not have access to this page',
  'app.exception.description.404': 'Sorry, the page you have visited does not exist',
  'app.exception.description.500': 'Sorry, the server is wrong',
  'app.exist.account.title': 'Log in the existing account',
  'app.forget.title': 'Forget passwords',
  'app.forms.basic.description': 'Form pages are used to collect or validate information from users. Basic forms are commonly used in form scenarios with fewer data items.',
  'app.forms.basic.title': 'Basic List',
  'app.home.introduce': 'Introduction',
  'app.login.againPassword': '6-16 digit passwords, case sensitive',
  'app.login.change-captcha': 'Change',
  'app.login.ckeckPassword': 'The password shall be the combination of 6-16 numbers, letters and symbols',
  'app.login.forgot-password': 'Forget passwords',
  'app.login.login': 'Log in',
  'app.login.message-invalid-credentials': 'Errors in account or passwords',
  'app.login.message-invalid-verification-code': 'Error in verification code',
  'app.login.password': 'Please enter the passwords',
  'app.login.remember-me': 'Remember me',
  'app.login.sign-in-with': 'Other login methods',
  'app.login.signup': 'Accounts registration',
  'app.login.sure': 'OK',
  'app.login.tab-login-credentials': 'Login with the account passwords',
  'app.login.tab-login-mobile': 'Login with phone number',
  'app.login.title': 'Log in',
  'app.login.type.account.title': 'Login with the account passwords',
  'app.login.type.phone.title': 'Login with phone number',
  'app.login.user.not.exist': 'The user does not exist',
  'app.login.userName': 'Please enter the phone number',
  'app.monitor.activity-forecast': 'Activity forecast',
  'app.monitor.efficiency': 'Voucher verification efficiency',
  'app.monitor.fast-food': 'Chinese-style fast food',
  'app.monitor.fund-surplus': 'Remaining subsidies',
  'app.monitor.hot-pot': 'Hot pot',
  'app.monitor.popular-searches': 'Hot search',
  'app.monitor.proportion-per-category': 'Category proportion',
  'app.monitor.ratio': 'Bounce rate',
  'app.monitor.remaining-time': 'Time remaining',
  'app.monitor.resource-surplus': 'Resource surplus',
  'app.monitor.sales-target': 'Completion rate of sales goal',
  'app.monitor.total-transactions': 'Total transaction amount today',
  'app.monitor.total-transactions-per-second': 'Total amount of trade every second',
  'app.monitor.trading-activity': 'Real-time trading in the activity',
  'app.monitor.waiting-for-implementation': 'Waiting for implementation',
  'app.monitor.western-food': 'Western cuisine',
  'app.register-result.activation-email': 'The activation email has been sent to your mailbox and is valid for 24 hours. Please log in to your email and click the link in the email to activate your account.',
  'app.register-result.back-home': 'Back to Home',
  'app.register-result.msg': 'Your account: {email} Successfully register',
  'app.register-result.view-mailbox': 'Check the emails',
  'app.register.get-verification-code': 'Get verification code',
  'app.register.register': 'Registration',
  'app.register.sing-in': 'Log in the existing account',
  'app.result.error.btn-text': 'Back for modification',
  'app.result.error.description': 'Please check and modify the following information Then, submit it again',
  'app.result.error.hint-btn1': 'Unfreezing immediately',
  'app.result.error.hint-btn2': 'Upgrade now',
  'app.result.error.hint-text1': 'Your account has been frozen',
  'app.result.error.hint-text2': 'Your account has no qualification to apply',
  'app.result.error.hint-title': 'The contents submitted have the following errors:',
  'app.result.error.title': 'Submission failed',
  'app.result.success.btn-print': 'Print',
  'app.result.success.btn-project': 'View the project',
  'app.result.success.btn-return': 'Back to the list',
  'app.result.success.description': 'The submission results page is used to provide feedback on the processing results of a series of operational tasks. If it is only a simple operation, use the Message global prompt to provide feedback. This text area can display simple supplementary explanations. If there is a similar need to display "documents", the gray area below can present more complex content',
  'app.result.success.operate-id': 'Item ID:',
  'app.result.success.operate-time': 'Effective time:',
  'app.result.success.operate-title': 'Item name',
  'app.result.success.principal': 'Person in charge:',
  'app.result.success.step1-operator': 'QU Lili',
  'app.result.success.step1-title': 'Create item',
  'app.result.success.step2-extra': 'Hurry up',
  'app.result.success.step2-operator': 'ZHOU Maomao',
  'app.result.success.step2-title': 'First review of department',
  'app.result.success.step3-title': 'Financial review',
  'app.result.success.step4-title': 'Complete',
  'app.result.success.title': 'Submission succeeded',
  'app.setting.content-width': 'Length of content area',
  'app.setting.content-width.fixed': 'Fixed width',
  'app.setting.content-width.fluid': 'Flow',
  'app.setting.copy': 'Copy setting',
  'app.setting.copyinfo': 'Successful copy, please visit src/defaultSettingsjs  and replace the default configuration',
  'app.setting.fixedheader': 'Fixed  Header',
  'app.setting.fixedsidebar': 'Fixed side menu',
  'app.setting.fixedsidebar.hint': 'Configuration under the side menu layout',
  'app.setting.hideheader': 'Hide Header in sliding down',
  'app.setting.hideheader.hint': 'Configured in the fixed Header',
  'app.setting.navigationmode': 'Navigation mode',
  'app.setting.othersettings': 'Other setting',
  'app.setting.pagestyle': 'Whole-piece style setting',
  'app.setting.pagestyle.dark': 'Dark menu style',
  'app.setting.pagestyle.light': 'Bright menu style',
  'app.setting.production.hint': 'The configuration bar is only used for preview in the development environment, and will not be displayed in the production environment. Please copy and manually modify the configuration file',
  'app.setting.sidemenu': 'Side menu layout',
  'app.setting.themecolor': 'Accents',
  'app.setting.themecolor.cyan': 'Mingqing',
  'app.setting.themecolor.daybreak': 'Dawn blue (default)',
  'app.setting.themecolor.dust': 'Dusk',
  'app.setting.themecolor.geekblue': 'Geek blue',
  'app.setting.themecolor.green': 'Aurora green',
  'app.setting.themecolor.purple': 'Got it',
  'app.setting.themecolor.sunset': 'Nightfall',
  'app.setting.themecolor.volcano': 'Volcano',
  'app.setting.topmenu': 'Top menu layout',
  'app.setting.weakmode': 'Color weakness mode',
  'app.settings.basic.address': 'Street address',
  'app.settings.basic.address-message': 'Please enter your address!',
  'app.settings.basic.avatar': 'Profile photo',
  'app.settings.basic.change-avatar': 'Change profile photo',
  'app.settings.basic.country': 'Country / region',
  'app.settings.basic.country-message': 'Please enter your country or region!',
  'app.settings.basic.email': 'Email',
  'app.settings.basic.email-message': 'Please enter your email!',
  'app.settings.basic.geographic': 'City and province',
  'app.settings.basic.geographic-message': 'Please enter the city and province!',
  'app.settings.basic.nickname': 'Nickname',
  'app.settings.basic.nickname-message': 'Please enter your nickname!',
  'app.settings.basic.phone': 'Contact Tel.',
  'app.settings.basic.phone-message': 'Please enter your phone number!',
  'app.settings.basic.profile': 'Personal Prodocument',
  'app.settings.basic.profile-message': 'Please enter your profile!',
  'app.settings.basic.profile-placeholder': 'Personal Prodocument',
  'app.settings.basic.update': 'Update the basic information',
  'app.settings.binding.alipay': 'Bind to Alipay',
  'app.settings.binding.alipay-description': 'The Alipay account is not bound',
  'app.settings.binding.bind': 'Binding',
  'app.settings.binding.dingding': 'Bind to Dingtalk',
  'app.settings.binding.dingding-description': 'The DingTalk account is not bound',
  'app.settings.binding.taobao': 'Bind to Taobao',
  'app.settings.binding.taobao-description': 'The Taobao account is not bound',
  'app.settings.close': 'Close',
  'app.settings.menuMap.basic': 'Basic setting',
  'app.settings.menuMap.binding': 'Account binding',
  'app.settings.menuMap.notification': 'New message notification',
  'app.settings.menuMap.security': 'Security settings',
  'app.settings.notification.messages': 'System messages',
  'app.settings.notification.messages-description': 'The system message will be informed in the list of the in-site letters',
  'app.settings.notification.password': 'Account password',
  'app.settings.notification.password-description': 'Messages from other users will be notified in the list of in-site letters',
  'app.settings.notification.todo': 'Account password',
  'app.settings.notification.todo-description': 'Account password',
  'app.settings.open': 'Open',
  'app.settings.security.bind': 'Binding',
  'app.settings.security.email': 'Spare mailbox',
  'app.settings.security.email-description': 'E-mail bound:',
  'app.settings.security.medium': 'Medium',
  'app.settings.security.mfa': 'MFA device',
  'app.settings.security.mfa-description': 'Not bind the MFA equipment Conduct the secondary confirmation after binding',
  'app.settings.security.modify': 'Modification',
  'app.settings.security.password': 'Account password',
  'app.settings.security.password-description': 'Current password strength:',
  'app.settings.security.phone': 'Password protection phone',
  'app.settings.security.phone-description': 'Mobile phone bound:',
  'app.settings.security.question': 'Password protection',
  'app.settings.security.question-description': 'The passwords are not set and it could protect the account security effectively',
  'app.settings.security.set': 'Settings',
  'app.settings.security.strong': 'Strong',
  'app.settings.security.weak': 'Weak',
  'article.attachment.column.articleAttachmentRatioLocale': 'Proportion between the commodity pcs and attachment pcs',
  'article.attachment.column.attachmentLocale': 'Attachment',
  'article.barcode': 'Barcode',
  'article.barcode.qpcStr': 'Specification',
  'article.column.barcode': 'Second code',
  'article.column.category': 'Category',
  'article.column.categoryCodeName': 'Category code/title',
  'article.column.checkType': 'Type of quality inspection',
  'article.column.codeNameBarcode': 'Code/name/barcode',
  'article.column.defaultVendor': 'Default supplier',
  'article.column.deliveryControlDays': 'Delivery Control Days',
  'article.column.groupName': 'Group',
  'article.column.origin': 'Origin',
  'article.column.owner': 'Owner',
  'article.column.physicsCheckType': 'Strength of quality inspection',
  'article.column.pluCode': 'Plu code',
  'article.column.priceType': 'Pricing type',
  'article.column.processing': 'Manufacturing before shipment',
  'article.column.purchasePrice': 'Purchase price',
  'article.column.qcr': 'Require the free pratique',
  'article.column.receiveControlDays': 'Days controlled for receiving',
  'article.column.returnControlDays': 'Days controlled for return',
  'article.column.salePrice': 'Selling price',
  'article.column.shelfLifeDays': 'Days of guarantee period',
  'article.column.shelfLifeType': 'Type of guarantee period',
  'article.column.spec': 'Measurement',
  'article.column.taxRate': 'Rate',
  'article.column.trackRecord': 'Generate the traceability code',
  'article.create': 'Create Commodity',
  'article.create.beforeuploadsizetip': 'The size of the picture is no more than 1M',
  'article.create.beforeuploadtypetip': 'The image supports the PNG/JPG formats',
  'article.create.title': 'Create Commodity',
  'article.create.unloadAdvice': 'Manage unloading guidance',
  'article.create.uploaderror': 'An error occurs when the picture is saved to OSs Please retry it',
  'article.create.uploading': 'Uploading',
  'article.create.uploadtips': 'Drag to &nbsp; or &nbsp; Click to upload <br/> and limit it within 1M.',
  'article.dc.setting': 'Distribution setting',
  'article.detail.basicinfo.picture': 'Image',
  'article.detail.tab.barcode': 'Barcode details',
  'article.detail.tab.basicInfo': 'Commodity data',
  'article.detail.tab.dclist': 'Scope of distribution center',
  'article.detail.tab.maintaincate': 'Classification in attachment maintenance, binding maintenance',
  'article.detail.tab.qc': 'Quality inspection of commodity',
  'article.detail.tab.qpc': 'Details of specification',
  'article.detail.tab.storePickQpc': 'Details of minimum demand of the store ',
  'article.detail.tab.storeprice': 'Store price',
  'article.detail.tab.vendor': 'Supplier details',
  'article.import.article': 'Import the commodity',
  'article.import.articleBarcode': 'Import the commodity barcode',
  'article.import.articleQpc': 'Import the commodity specification',
  'article.import.articleVendor': 'Import the commodity supplier',
  'article.import.storePickQty': 'Minimum demand in importing the commodity store',
  'article.mixGroup': 'Mixed loading group',
  'article.panel.basic': 'Basic information',
  'article.panel.business': 'Business Information',
  'article.panel.note': 'Remarks',
  'article.panel.shelfLife': 'Guarantee period',
  'article.physics.column.articlePhysics': 'Physical and chemical quality inspection items',
  'article.physics.column.qualifiedRange': 'Scope of qualified range',
  'article.physics.column.qualifiedType': 'Conformity Mark',
  'article.qpc.column.defaultQpcStr': 'Default specification',
  'article.qpc.column.height': 'Height (cm)',
  'article.qpc.column.length': 'Length (cm)',
  'article.qpc.column.munit': 'Measuring unit',
  'article.qpc.column.paq': 'Number of packages',
  'article.qpc.column.qpcStr': 'Package specification',
  'article.qpc.column.weight': 'Weight (g)',
  'article.qpc.column.width': 'Width (cm)',
  'article.qpc.validate.munit.notNull': 'Please enter the unit of measurement',
  'article.qpc.validate.plateAdvice.notMatch': 'Please enter the loading suggestions of the commodity with the format of m*n and its length shall not exceed 30.',
  'article.qpc.validate.qpcStr.notMatch': 'Please enter the specification with the format of 1*m*n',
  'article.sense.column.articlesense': 'Items of sensory quality inspection',
  'article.storepickqty.column.count': 'Shipment multiple',
  'article.storepickqty.column.pickQpc': 'Min demand',
  'article.storepickqty.column.sourceCount': 'Multiple of upstream shipment',
  'article.storepickqty.column.storeType': 'Store format',
  'article.storepickqty.validate.count': 'The shipment multiple must be an integer greater than 0 and less than or equal to 1000.',
  'article.storeprice.column.deductedWeight': 'Loss weight',
  'article.storeprice.column.price': 'Unit price',
  'article.title': 'Commodity',
  'article.vendor.column.defaultReceive': 'Preferred receiving',
  'article.vendor.column.defaultReceivePrice': 'Default warehousing price (RMB)',
  'article.vendor.column.defaultReturn': 'Preferred return',
  'article.vendor.column.defaultReturnPrice': 'Default return price (RMB)',
  'article.vendor.column.isDefaultVendor': 'Default supplier',
  'article.vendor.column.vendor': 'Supplier',
  'article.vendor.message.setDefaultVendor': 'Set up the default supplier successfully',
  'article.vendor.operate.setPreferred': 'Set as preferred',
  'articleBusiness.column.binState': 'Commodity status',
  'articleBusiness.column.outProcess': 'Manufacturing before shipment',
  'articleBusiness.column.overDeliveryRate': 'Exceeded proportion (%)',
  'articleBusiness.column.overPickRate': 'Over-picked proportion (%)',
  'articleBusiness.column.overReceiveRate': 'Excessive receiving proportion (%)',
  'articleBusiness.column.process': 'Processing after receiving',
  'articleBusiness.column.putawayBin': 'Goods location added',
  'articleBusiness.column.settleQpcStr': 'Standard specification',
  'articleBusiness.column.settleUnit': 'Settlement unit',
  'articleBusiness.column.stockMode': 'stock mode',
  'articleBusiness.column.storageType': 'Storage conditions',
  'articleBusiness.column.unLoadAdvice': 'Unloading guidance',
  'articleBusiness.column.weighing': 'Support the decimal operation',
  'articlePlate.column.plate': 'Number of loading pcs',
  'articlePlate.column.plateAdvice': 'Loading suggestions',
  'articleReplace.adaptAllStore': 'Support all stores',
  'articleReplace.adjustOrder': 'S/N adjustment',
  'articleReplace.articleCode': 'Commodity code',
  'articleReplace.articleName': 'Commodity name',
  'articleReplace.createReplaceScheme': 'Create Commodity Alternative Scheme',
  'articleReplace.items': 'Details',
  'articleReplace.judgeFalse': 'No',
  'articleReplace.judgeTrue': 'Yes',
  'articleReplace.replaceArticleItems': 'Alternative commodity',
  'articleReplace.replaceArticleItemsIsNull': 'The alternative commodity details are left blank in the alternative scheme',
  'articleReplace.replaceOrder': 'S/N',
  'articleReplace.replaceStoreItems': 'Suitable for the store',
  'articleReplace.storeCode': 'Store code',
  'articleReplace.storeName': 'Name of the store',
  'articleReplace.title': 'Commodity Alternative Scheme',
  'articleStorage.article': 'Commodity',
  'articleStorage.articleCodeName': 'Code/name',
  'articleStorage.binRange': 'Scope of goods location:',
  'articleStorage.binRange.add': 'Scope of goods location:',
  'articleStorage.binRange.not.match': 'The location range does not match.',
  'articleStorage.create.title': 'Add',
  'articleStorage.qpcStr': 'Specifications',
  'articleStorage.select': 'Commodity',
  'articleStorage.select.article': 'Commodity',
  'articleStorage.title': 'Configuration of the commodity storage scope',
  'basic.data.order': 'Only the number is allowed to enter for the sequence field',
  'bill.config': 'Document configuration',
  'bill.maxCount': 'Max number of the details',
  'bin.facility.path': 'cargo lane',
  'bin.facility.shelf': 'Shelves',
  'bin.facility.stockInfo': 'Inventory information of goods location',
  'bin.facility.zone': 'Goods area',
  'bin.modal.alterBinAlias': 'Set up the alias of goods location',
  'bin.modal.alterType': 'Modify the type of goods location',
  'bin.modal.alterUsage': 'Modify the purposes of goods location',
  'bin.modal.bin': 'Create Goods Location',
  'bin.modal.bin.bin.avgcount': 'Average goods lane',
  'bin.modal.bin.column.range': 'Scope of column code',
  'bin.modal.bin.level.range': 'Layer code scope',
  'bin.modal.bin.path.avgcount': 'Average goods lane',
  'bin.modal.bin.quick': 'Quick create location',
  'bin.modal.bin.shelf.avgcount': 'Average goods location',
  'bin.modal.bin.start': 'Starting goods location',
  'bin.modal.path': 'Create Goods Lane',
  'bin.modal.path.range': 'Scope of goods lane',
  'bin.modal.path.start': 'Starting goods lane',
  'bin.modal.remove': 'Delete',
  'bin.modal.shelf': 'Create Goods Shelf',
  'bin.modal.shelf.range': 'Scope of goods shelf',
  'bin.modal.shelf.start': 'Starting goods shelf',
  'bin.modal.zone': 'Create Goods Area',
  'bin.modal.zone.range': 'Scope of goods area',
  'bin.search': 'Please enter',
  'bin.state.exception': 'Abnormality',
  'bin.state.free': 'idle',
  'bin.state.locked': 'Locked',
  'bin.state.using': 'Using',
  'bin.table.article.code': 'Commodity code',
  'bin.table.article.name': 'Commodity name',
  'bin.table.binAlias': 'Alias of goods location',
  'bin.table.bincode': 'Code of goods location',
  'bin.table.container': 'Container',
  'bin.table.pathcode': 'Code of goods lane',
  'bin.table.price': 'Unit price',
  'bin.table.productionDate': 'Date of production',
  'bin.table.qpcStr': 'Package specification',
  'bin.table.qty': 'Quantity',
  'bin.table.shelfcode': 'Code of goods shelf',
  'bin.table.stockBatch': 'Batch',
  'bin.table.supplier': 'Supplier',
  'bin.table.validDate': 'Expiry date',
  'bin.table.zooncode': 'Code of goods area',
  'bin.title': 'Goods location',
  'bin.usage': 'Purpose of goods location',
  'bin.validate.bin.address': 'The code of goods location must be 8 digits',
  'bin.validate.bin.bin.avgcount.notnull': 'The average goods location shall not be left blank',
  'bin.validate.bin.bin.start.notnull': 'The starting goods location shall not be left blank',
  'bin.validate.bin.column.code': 'The column code shall be 1 digit',
  'bin.validate.bin.column.endcode.notnull': 'The end column code shall not be left blank',
  'bin.validate.bin.column.startcode.notnull': 'The starting code shall not be left blank',
  'bin.validate.bin.level.code': 'The floor code shall be 1 digit',
  'bin.validate.bin.level.endcode.notnull': 'The end floor code shall not be left blank',
  'bin.validate.bin.level.startcode.notnull': 'The starting floor code shall not be left blank',
  'bin.validate.bin.path.avgcount.notnull': 'The average goods lane shall not be left blank',
  'bin.validate.bin.path.start.notnull': 'The starting goods lane shall not be left blank',
  'bin.validate.bin.shelf.avgcount.notnull': 'The average goods shelf shall not be left blank',
  'bin.validate.bin.shelf.start.notnull': 'The starting goods shelf shall not be left blank',
  'bin.validate.bintype.notnull': 'The type of goods location shall not be left blank',
  'bin.validate.binusage.notnull': 'The purpose of goods location shall not be left blank',
  'bin.validate.path.code': 'The track code must be 4 digits or the first two digits plus the third letter plus the fourth digit or letter',
  'bin.validate.path.endcode.notnull': 'The code of end goods lane shall not be left blank',
  'bin.validate.path.start.length': 'The starting track code is 1 or 2 digits or the first letter plus the second letter or number',
  'bin.validate.path.startcode.notnull': 'The code of the starting goods lane shall not be left blank',
  'bin.validate.shelf.code': 'The shelf code is illegal',
  'bin.validate.shelf.endcode.notnull': 'The code of end goods shelf shall not be left blank',
  'bin.validate.shelf.start.length': 'The starting shelf code is 1 or 2 digits or the first letter plus the second letter or number',
  'bin.validate.shelf.startcode.notnull': 'The code of the starting goods shelf shall not be left blank',
  'bin.validate.wrh.notnull': 'The warehouse location cannot be left blank',
  'bin.validate.zone.code': 'The code of goods area shall be two digits or capital letters',
  'bin.validate.zone.code.notnull': 'The code of goods area cannot be left blank',
  'bin.validate.zone.endcode.notnull': 'The code of end goods area shall not be left blank',
  'bin.validate.zone.startcode.notnull': 'The code of starting goods area shall not be left blank',
  'binTypeStorage.binType': 'Goods Location Type',
  'binTypeStorage.binTypeCode': 'Goods Location Type',
  'binTypeStorage.create.title': 'Add',
  'binTypeStorage.select': 'Goods Location Type',
  'binTypeStorage.select.binType': 'Goods Location Type',
  'binTypeStorage.storageBinType': 'Type of storable goods position',
  'binTypeStorage.storageBinTypeCode': 'Type of the storable goods location',
  'binTypeStorage.title': 'Type and storage configuration of the goods location',
  'binView.binFormat': 'Display format of goods location',
  'binView.binFormat.add': 'Please fill in the display format of the goods location',
  'bindConfig.BINDING': 'Binding',
  'bindConfig.SPLITSAND': 'merge',
  'bindConfig.title': 'Configuration of container binding/split and combination',
  'bintype.create.basic': 'Basic information',
  'bintype.create.button.cancel': 'Cancel',
  'bintype.create.button.confirm': 'OK',
  'bintype.create.button.confirmCreate': 'Confirm and Create',
  'bintype.create.form.item.code': 'Code',
  'bintype.create.form.item.code.validate.message.integrality': 'The code shall only be 2-7 digits, letters, numbers or alphanumeric combination',
  'bintype.create.form.item.code.validate.message.notNull': 'The code shall not be left blank',
  'bintype.create.form.item.dc': 'Distribution Center',
  'bintype.create.form.item.dc.validate.message.notNull': 'The distribution center does not be exist',
  'bintype.create.form.item.height': 'Height (cm)',
  'bintype.create.form.item.height.validate.length': 'The max height is 12 digits',
  'bintype.create.form.item.height.validate.message.notNull': 'The height shall not be left blank',
  'bintype.create.form.item.input.placeholder': 'Please enter',
  'bintype.create.form.item.input.placeholder.code': 'Please enter the code',
  'bintype.create.form.item.input.placeholder.name': 'Please enter 4 to 30 characters',
  'bintype.create.form.item.input.placeholder.note': 'Please enter the remark',
  'bintype.create.form.item.length': 'Length (cm)',
  'bintype.create.form.item.length.validate.length': 'The max length is 12 digits',
  'bintype.create.form.item.length.validate.message.notNull': 'The length shall not be left blank',
  'bintype.create.form.item.name': 'Name',
  'bintype.create.form.item.name.validate.message.limitLength': 'The max length of title is 30.',
  'bintype.create.form.item.name.validate.message.notNull': 'The name cannot be left blank',
  'bintype.create.form.item.note': 'Remarks',
  'bintype.create.form.item.note.validate.message.limitLength': 'The max length of the remarks is 255',
  'bintype.create.form.item.option.placeholder': 'please choose',
  'bintype.create.form.item.plotRatio': 'Plot ratio(%)',
  'bintype.create.form.item.plotratio.validate.message.notNull': 'The plot ratio shall not be left blank',
  'bintype.create.form.item.storageNumber': 'Number of storage tray',
  'bintype.create.form.item.storageNumber.validate.int': 'The number of storage tray shall be the integer that is greater than 0.',
  'bintype.create.form.item.storageNumber.validate.message.notNull': 'The number of storage tray shall not be left blank',
  'bintype.create.form.item.weight': 'Bearing (kg)',
  'bintype.create.form.item.weight.validate.length': 'The max loading is 12 digits',
  'bintype.create.form.item.weight.validate.message.notNull': 'The bearing shall not be left blank',
  'bintype.create.form.item.width': 'Width (cm)',
  'bintype.create.form.item.width.validate.length': 'The max width is 12 digits',
  'bintype.create.form.item.width.validate.message.notNull': 'The width shall not be left blank',
  'bintype.create.note': 'Remarks',
  'bintype.create.qpc': 'Information for specification',
  'bintype.create.title': 'Create Goods Location Type',
  'bintype.detail.basic': 'Basic information',
  'bintype.detail.basic.code': 'Code',
  'bintype.detail.basic.dc': 'Distribution Center',
  'bintype.detail.basic.height': 'Height (cm)',
  'bintype.detail.basic.length': 'Length (cm)',
  'bintype.detail.basic.name': 'Name',
  'bintype.detail.basic.note': 'Remarks',
  'bintype.detail.basic.plotRatio': 'Plot ratio(%)',
  'bintype.detail.basic.storageNumber': 'Number of storage tray',
  'bintype.detail.basic.weight': 'Bearing (kg)',
  'bintype.detail.basic.width': 'Width (cm)',
  'bintype.detail.button.back': 'Back',
  'bintype.detail.button.cancel': 'Cancel',
  'bintype.detail.button.confirm': 'OK',
  'bintype.detail.label.edit': 'Edit',
  'bintype.detail.label.remove': 'Delete',
  'bintype.detail.tab.binTypeInfo': 'Type of goods location',
  'bintype.detail.tab.operateInfo': 'Operation log',
  'bintype.edit.title': 'Modify the type of goods location',
  'bintype.index.message.success.operate': 'Operation succeeded',
  'bintype.index.search.button.reset': 'Reset',
  'bintype.index.search.button.search': 'Query',
  'bintype.index.search.input.code': 'Code',
  'bintype.index.search.input.name': 'Name',
  'bintype.index.search.input.placeholder': 'Please enter the keywords for inquiry',
  'bintype.index.table.button.new': 'Create',
  'bintype.index.table.column.code': 'Code',
  'bintype.index.table.column.dc': 'Distribution Center',
  'bintype.index.table.column.height': 'Height (cm)',
  'bintype.index.table.column.length': 'Length (cm)',
  'bintype.index.table.column.name': 'Name',
  'bintype.index.table.column.operate': 'Operate',
  'bintype.index.table.column.plotRatio': 'Plot ratio(%)',
  'bintype.index.table.column.storageNumber': 'Number of storage tray',
  'bintype.index.table.column.weight': 'Bearing (kg)',
  'bintype.index.table.column.width': 'Width (cm)',
  'bintype.index.table.operate.edit': 'Edit',
  'bintype.index.table.operate.view': 'Check',
  'bintype.title': 'Goods Location Type',
  'bintype.update.title': 'Edit the type of goods location',
  'book.abort.confirm': 'Do you confirm the appointment list void?',
  'book.allArticles': 'total number of items',
  'book.allOrders': 'Total Number of orders',
  'book.audit.confirm': 'Do you audit the appointment list ?',
  'book.beginBook': 'Start appointment',
  'book.beginTime': 'Start time',
  'book.bookArticleQty': 'Number of items appointed',
  'book.booker': 'Appointment personnel',
  'book.date': 'Appointment date',
  'book.dockGroup': 'Dock set',
  'book.endTime': 'End time',
  'book.orderInfo': 'Order information',
  'book.qtyStr': 'Pieces appointed',
  'book.remove.confirm': 'Are you sure to delete the appointment list?',
  'book.timeRange': 'Appointed time range',
  'book.title': 'Appointment List',
  'book.type': 'Appointment method',
  'bookQtyStrConfig.column.dockGroup': 'Dock set',
  'bookQtyStrConfig.column.dockGroupCode': 'Dock set code',
  'bookQtyStrConfig.column.dockGroupCodeName': 'Dock set code/title',
  'bookQtyStrConfig.column.dockGroupName': 'Title of dock set',
  'bookQtyStrConfig.column.exceedRatio': 'Over-appointed proportion',
  'bookQtyStrConfig.column.maxReceiveArticleCount': 'Max appointed items',
  'bookQtyStrConfig.column.maxReceiveQtyStr': 'Max appointed pieces',
  'bookQtyStrConfig.create.title': 'Configuration of collection quantity of the newly-added dock',
  'bookQtyStrConfig.title': 'Configuration of appointment volume',
  'bookTimeConfig.column.endTime': 'End time',
  'bookTimeConfig.column.preDays': 'Days appointed in advance (day)',
  'bookTimeConfig.column.startTime': 'Start time',
  'bookTimeConfig.column.time': 'Appointment time',
  'bookTimeConfig.column.timeRange': 'Unit time of appointment (min)',
  'bookTimeConfig.title': 'Appointed time configuration',
  'bookTimeConfigPattern.column.preDays': 'The days of appointment shall be greater than or equal to 0',
  'bookTimeConfigPattern.column.time': 'The appointed time range shall be greater than 0',
  'carrier.code': 'Code',
  'carrier.contactPhone': 'Contact information',
  'carrier.contactor': 'Contact person',
  'carrier.create.form.item.homeUrl.name': 'Homepage',
  'carrier.create.form.item.homeUrl.validate.message.limitLength': 'The max length on the homepage is 100',
  'carrier.detail.tab.basicInfo': 'Information of the Carrier',
  'carrier.index.button.new': 'Create',
  'carrier.index.button.reset': 'Reset',
  'carrier.index.button.search': 'Query',
  'carrier.index.column.operate': 'Operate',
  'carrier.index.search.button.close': 'Pack up',
  'carrier.index.search.button.open': 'Unfold',
  'carrier.index.search.content.all': 'all',
  'carrier.index.search.content.offline': 'Disabled',
  'carrier.index.search.content.online': 'Enabled',
  'carrier.index.search.input.codeName': 'Code/title of the carrier',
  'carrier.index.search.input.state': 'Status',
  'carrier.index.table.content.offline': 'Disabled',
  'carrier.index.table.content.online': 'Enabled',
  'carrier.name': 'Name',
  'carrier.note': 'Remarks',
  'carrier.owner': 'Owner',
  'carrier.placeholder': 'Please enter',
  'carrier.popup.addTitle': 'Newly-added carrier',
  'carrier.popup.code.validate.integrality': 'The max length is 4 and it could only be the letter and number',
  'carrier.popup.code.validate.notNull': 'The code shall not be left blank',
  'carrier.popup.contactPhone.validate.limitLength': 'The max length of the contact information is 30',
  'carrier.popup.contactPhone.validate.notNull': 'Contact information cannot be left blank',
  'carrier.popup.contactor.validate.limitLength': 'The max length of the contact is 30',
  'carrier.popup.contactor.validate.notNull': 'The contact person cannot be left blank',
  'carrier.popup.editTitle': 'Edit the carrier',
  'carrier.popup.name.validate.limitLength': 'The max length of title is 30.',
  'carrier.popup.name.validate.notNull': 'The name cannot be left blank',
  'carrier.popup.note.validate.limitLength': 'The max length of the remarks is 255',
  'carrier.popup.shortName.validate.limitLength': 'The maximum length of short name is 30.',
  'carrier.popup.shortName.validate.notNull': 'The short name cannot be left blank',
  'carrier.popup.title': 'Basic information',
  'carrier.popup.zipCode.validate.limitLength': 'The max length of the postal code is 30.',
  'carrier.shortName': 'Short name',
  'carrier.sourceWay': 'Source mode',
  'carrier.title': 'Carrier',
  'carrier.zipCode': 'Postal code',
  'category.IPopconfirmTitle': 'Whether to delete the category of the commodity',
  'category.create.button': 'Create Type',
  'category.create.child': 'Newly add the category of the sub-level commodity',
  'category.create.form.item.code.validate.message.limitLength': 'The max length of category is 30.',
  'category.create.form.item.code.validate.message.notNull': 'The category code cannot be left blank',
  'category.create.form.item.level.validate.message.notNull': 'The category level shall not be left blank',
  'category.create.form.item.name.validate.message.limitLength': 'The max length of the category title is 10',
  'category.create.form.item.name.validate.message.notNull': 'The title of category shall not be left blank',
  'category.create.form.item.note.validate.message.limitLength': 'The max length of the remark is 255',
  'category.create.form.item.state.validate.message.notNull': 'The category status cannot be left blank',
  'category.create.from.code': 'Category code',
  'category.create.from.level': 'Level',
  'category.create.from.level.select.placeholder': 'Please select category',
  'category.create.from.name': 'Category name',
  'category.create.from.note': 'Remarks',
  'category.create.from.note.select.placeholder': 'The length does not exceed 255',
  'category.create.from.owner': 'Owner',
  'category.create.from.sourceWay': 'Source mode',
  'category.create.from.state': 'Status',
  'category.create.super': 'Newly add the category of the level I commodity',
  'category.detail.tab.dclist': 'Scope of distribution center',
  'category.index.search.button.open.and.close': 'Expand/pack up',
  'category.index.search.placeholder': 'Category code/title',
  'category.index.table.column.code': 'Code',
  'category.index.table.column.level': 'Level',
  'category.index.table.column.name': 'Name',
  'category.index.table.column.operate': 'Operate',
  'category.index.table.column.owner': 'Owner',
  'category.index.table.column.upperCategory.name': 'Higher-ups category',
  'category.index.table.operate.create.child': 'Newly-added sub-level',
  'category.index.table.operate.edit': 'Edit',
  'category.index.table.operate.remove': 'Delete',
  'category.modify.child': 'Edit the category of the sub-level commodity',
  'category.modify.super': 'Edit the category of the level I commodity',
  'category.pretype.level.manage': 'Category and grade of managed commodity',
  'category.pretype.level.title': 'Grade of commodity category',
  'category.small.title': 'Category',
  'category.title': 'product category',
  'categoryStorageConfig.AddTitle': 'Add',
  'categoryStorageConfig.Categorye': 'product category',
  'categoryStorageConfig.Placeholder': 'Please enter',
  'categoryStorageConfig.code': 'Code',
  'categoryStorageConfig.column.binRange': 'Scope of goods location:',
  'categoryStorageConfig.column.categoryCode': 'Code of commodity category',
  'categoryStorageConfig.column.categoryName': 'Title of commodity category',
  'categoryStorageConfig.name': 'Name',
  'categoryStorageConfig.title': 'Class Storage Range Configuration',
  'checkInWrh.bookedArticleCount': 'Number of items appointed',
  'checkInWrh.bookedQtyStr': 'Pieces appointed',
  'checkInWrh.businessType': 'Business type',
  'checkInWrh.checkin': 'Registration',
  'checkInWrh.checkin.inWrh': 'Entry registration',
  'checkInWrh.checkin.outWrh': 'Exit registration',
  'checkInWrh.checkin.type': 'Registration type',
  'checkInWrh.clear': 'Clear',
  'checkInWrh.driver': 'Driver',
  'checkInWrh.driverInfo': 'Driver information',
  'checkInWrh.driverName': 'Driver\'s name',
  'checkInWrh.driverPhone': 'Contact information',
  'checkInWrh.inWrhBillNumber': 'Entry list No.',
  'checkInWrh.inWrhInfo': 'Entry information',
  'checkInWrh.orderInfo': 'Order information',
  'checkInWrh.receiptBusinessType': 'Order receiving',
  'checkInWrh.releaseContent': 'Release contents',
  'checkInWrh.returnBusinessType': 'Return of goods',
  'checkInWrh.state': 'Status',
  'checkInWrh.stevedoreState': 'Loading and unloading conditions',
  'checkInWrh.title': 'Entry And Exit Registration',
  'checkInWrh.totalArticleCount': 'Number of the items delivered',
  'checkInWrh.totalQtyStr': 'Pcs delivered',
  'checkInWrh.vehicleNum': 'License plate number',
  'close.closeBill': 'Warehouse sealing receipt',
  'close.closeReason': 'Causes of the sealing and release receipt',
  'close.column.closer': 'Operator',
  'close.column.reason': 'Cause',
  'close.column.type': 'Document type',
  'close.title': 'Sealing and Release Receipt',
  'close.validate.binCodeRepeat': 'The location codes of {line1} and {line2} are repeated',
  'closeConfig.title': 'Configuration of the sealing and release receipt',
  'collectBin.collectBin': 'Goods location',
  'collectBin.collectBinScope': 'Scope of goods location',
  'collectBin.confirm.clear': 'The details may be cleared if the {item} is modified Do you confirm to modify?',
  'collectBin.dock': 'Dock',
  'collectBin.dockGroup': 'Dock set',
  'collectBin.dockGroupItem': 'Dock set details',
  'collectBin.dockItem': 'Dock details',
  'collectBin.logisticMode': 'Logistics model',
  'collectBin.loopFindLable': 'Circular search',
  'collectBin.loopFindPlaceholder': 'Circular search or not',
  'collectBin.mgrType': 'Management type',
  'collectBin.pickarea': 'Picking Partition',
  'collectBin.sourceBin': 'source location',
  'collectBin.sourceBinScope': 'Scope of source location',
  'collectBin.startFromFirstLable': 'Search from the starting position',
  'collectBin.startFromFirstPlaceholder': 'Whether to check from the initial position every time',
  'collectBin.storeFixCollectBin': 'Scope of the fixed goods location of the store',
  'collectBin.title': 'Collection Scheme',
  'collectBinReviewBill.beginReviewTime': 'Starting time of review',
  'collectBinReviewBill.collectBin': 'Goods location',
  'collectBinReviewBill.createReviewBillTime': 'Creation time',
  'collectBinReviewBill.dockGroup': 'Dock set',
  'collectBinReviewBill.endReviewTime': 'End the review time',
  'collectBinReviewBill.reviewItem': 'Review item',
  'collectBinReviewBill.reviewType': 'Type of review',
  'collectBinReviewBill.reviewed': 'Review',
  'collectBinReviewBill.reviewedInfo': 'Review information',
  'collectBinReviewBill.reviewedQtyStr': 'Pcs of review',
  'collectBinReviewBill.reviewedWholeContainerQtyStr': 'Number of FCL reviewed',
  'collectBinReviewBill.reviewer': 'Review personnel',
  'collectBinReviewBill.stockQtyStr': 'Original quantity',
  'collectBinReviewBill.stockWholeContainerQtyStr': 'FCL',
  'collectBinReviewBill.store': 'Review object',
  'collectBinReviewBill.title': 'Shipping Area Review List',
  'collectSchemeConfig.likeStepCollectBinScheme': 'Category cross-dock collection scheme',
  'collectSchemeConfig.oneStepCollectBinScheme': 'One-step cross-dock goods collection solution',
  'collectSchemeConfig.title': 'Allocation of goods collection scheme',
  'collectSchemeConfig.twoStepCollectBinScheme': 'Two-step cross-dock goods collection solution',
  'collectSchemeConfig.unifyCollectBinScheme': 'Unified allocation and collection scheme',
  'common.action.add': 'Add',
  'common.action.approve': 'Approved',
  'common.action.audit': 'Audit',
  'common.action.create': 'Create',
  'common.action.delete': 'Delete',
  'common.action.edit': 'Edit',
  'common.action.editNode': 'Modify the remark',
  'common.action.finish': 'Complete',
  'common.action.import': 'Import',
  'common.action.save': 'Save',
  'common.action.setDefault': 'Set as default',
  'common.action.view': 'Check',
  'common.address': 'Address',
  'common.address.notNull': 'Address shall not be left blank',
  'common.addressDetail.limitLength': 'The max length of the detailed address is 200.',
  'common.addressDetail.notNull': 'Please enter a detailed address',
  'common.addressSelected': 'Please select the district/city/province/country',
  'common.all': 'all',
  'common.allAmount': 'Total amount',
  'common.allBillCount': 'Total orders',
  'common.allPlanAmount': 'Planned amount',
  'common.allPlanArticleCount': 'Number of items planned',
  'common.allPlanBillCount': 'Planned single item',
  'common.allPlanQty': 'Total planned quantity',
  'common.allPlanQtyStr': 'Total planned pcs',
  'common.allPlanStoreCount': 'Number of the stores planned',
  'common.allPlanVolume': 'Planned volume (m3)',
  'common.allPlanWeight': 'Planned weight (kg)',
  'common.allQty': 'The total number',
  'common.allQtyStr': 'Total pieces',
  'common.allRealAmount': 'Actual amount',
  'common.allRealArticleCount': 'Actual items',
  'common.allRealBillCount': 'Actual order quantity',
  'common.allRealQty': 'Total actual quantity',
  'common.allRealQtyStr': 'Total actual pcs',
  'common.allRealStoreCount': 'Actual stores',
  'common.allRealVolume': 'Actual volume (m3)',
  'common.allRealWeight': 'Actual weight (kg)',
  'common.allShipAmount': 'Loading amount',
  'common.allShipArticleCount': 'Number of loading items',
  'common.allShipBillCount': 'Single item of loading',
  'common.allShipQtyStr': 'Total pcs installed',
  'common.allShipStoreCount': 'Number of loading stores',
  'common.allShipVolume': 'Loading volume (m3)',
  'common.allShipWeight': 'Loading weight (kg)',
  'common.allStoreCount': 'Total stores',
  'common.allVolume': 'Total volume (m3)',
  'common.allWeight': 'Total weight (kg)',
  'common.allTotalAmount': 'Total amount(ten thousand)',
  'common.amount': 'amount',
  'common.articleCount': 'total number of items',
  'common.billNumner': 'Number',
  'common.binCode': 'Code of goods location',
  'common.binScope': 'Scope of goods location:',
  'common.binUsage': 'Purpose of goods location',
  'common.bookDate': 'Appointment date',
  'common.button.back': 'Back',
  'common.button.batchDelete': 'Delete',
  'common.button.batchDisable': 'Disable',
  'common.button.batchEdit': 'Edit',
  'common.button.batchEnable': 'Enable',
  'common.button.cancel': 'Cancel',
  'common.button.confirm': 'OK',
  'common.button.confirm.new': 'Confirm and Create',
  'common.button.edit': 'Edit',
  'common.button.import': 'Import',
  'common.button.manage': 'Management',
  'common.button.new': 'Create',
  'common.button.reset': 'Reset',
  'common.button.search': 'Query',
  'common.code': 'Code',
  'common.component.StantardtTable.tag.alreadySelected': 'Selected',
  'common.component.StantardtTable.tag.clear': 'Clear',
  'common.component.StantardtTable.tag.item': 'Item',
  'common.component.StantardtTable.tag.total': 'Total',
  'common.confirm.audit': 'Are you sure to audit the item?',
  'common.confirm.clearItems': 'The details may be cleared if the {item} is modified Do you confirm to modify?',
  'common.content.city': 'City',
  'common.content.country': 'State',
  'common.content.description': 'Format description',
  'common.content.district': 'District',
  'common.content.format': 'Format',
  'common.content.meaning': 'Meaning',
  'common.content.province': 'Province',
  'common.content.street': 'Detailed address:',
  'common.detail.operate': 'Operating information',
  'common.detail.operate.table.column.detail': 'Details',
  'common.detail.operate.table.column.operateTime': 'Operation duration',
  'common.detail.operate.table.column.operateType': 'Operation type',
  'common.detail.operate.table.column.operator': 'Operator',
  'common.downloadDate': 'Distribution time',
  'common.excelImport.result.button.continueImport': 'Continue to import',
  'common.excelImport.result.button.downloadFailed': 'Download failed',
  'common.excelImport.result.message.error.import': 'Batch import failure',
  'common.excelImport.result.message.error.noData': 'No data are detected in Excel and it could not imported',
  'common.excelImport.result.message.success.import': 'Batch import succeeded',
  'common.excelImport.result.message.success.someError': 'Several parts fail, please download the failure document to check',
  'common.excelImport.result.tips.failed': 'Failed',
  'common.excelImport.result.tips.importSituation': 'Import conditions',
  'common.excelImport.result.tips.importing': 'Importing, please wait',
  'common.excelImport.result.tips.record': 'Piece',
  'common.excelImport.result.tips.successed': 'Succeeded',
  'common.excelImport.select.button.downloadTemplate': 'Download',
  'common.excelImport.select.button.downloadTemplate.errror': 'Fail in acquiring the batch import template',
  'common.excelImport.select.button.next': 'Next step',
  'common.excelImport.select.excelLimit': 'Only support the documents in the format of xls and xlsx',
  'common.excelImport.select.fileSizeLimit': 'The document size shall not be larger than 2M.',
  'common.excelImport.select.nextTips': 'Please click the next-step button for batch import',
  'common.excelImport.select.ossErrorTips': 'The error occurs when the document is saved in OSS and it could not be continued Please re-try it',
  'common.excelImport.select.templateEmptyTips': 'The imported template is left blank and it could not be downloaded',
  'common.excelImport.select.templateTips': 'For the specific format specification of imported document, please download the template for reference',
  'common.excelImport.select.tips.1': '1. The pcs of suggestion are ≤ 1000. If there are too many pieces, they can be imported in batches;',
  'common.excelImport.select.tips.2': '2. The red items in the template are required;',
  'common.excelImport.select.tips.3': '3. Select the document and cache on the back end Then, click the next step for batch import;',
  'common.excelImport.select.tips.4': '4. If the batch import has data import failure, the specific data with failure import could be downloaded (including the causes of import failure)',
  'common.excelImport.select.tips.title': 'Tips:',
  'common.excelImport.select.uploadText': 'Drag the file here or click to upload the file',
  'common.excelImport.select.uploadTips': 'Support the xls and xlsx documents It is suggested that the size of documents uploaded does not exceed 2M.',
  'common.excelImport.step1.tips': 'Please import the files',
  'common.excelImport.step2.tips': 'Import result',
  'common.excelImport.title': 'Import',
  'common.excelImportSet.select.tips.2': '2. Select the document and cache on the back end Then, click the next step for batch import;',
  'common.excelImportSet.select.tips.3': '3. If the batch import has data import failure, the specific data with failure import could be downloaded (including the causes of import failure)',
  'common.form.input.placeholder': 'Please enter',
  'common.form.select.placeholder': 'please choose',
  'common.leaveconfirm.action.edit': 'Edit',
  'common.leaveconfirm.action.new': 'Create',
  'common.line': 'Row',
  'common.logisticMode': 'Logistics model',
  'common.message.error.authorize': 'Authorization failed, please try again',
  'common.message.error.create': 'New addition failed, please try again',
  'common.message.error.delete': 'Deletion failed, please try again',
  'common.message.error.disable': 'Disabling failed, please try again',
  'common.message.error.enable': 'Enabling failed, please try again',
  'common.message.error.modify': 'Modification failed, please try again',
  'common.message.error.operate': 'Operation failed, please try again',
  'common.message.success.authorize': 'Authorization succeeded',
  'common.message.success.create': 'New addition successfully',
  'common.message.success.delete': 'Delete successfully',
  'common.message.success.modify': 'Successfully modified',
  'common.message.success.operate': 'Operation succeeded',
  'common.name': 'Name',
  'common.no': 'No',
  'common.notnull.validate': '{name} cannot be left blank',
  'common.operate': 'Operate',
  'common.operate.abort': 'Void',
  'common.operate.approve': 'Approved',
  'common.operate.audit': 'Audit',
  'common.operate.batchAdd': 'Batch add',
  'common.operate.confirm': 'OK',
  'common.operate.confirm.audit': 'Are you sure to audit the item?',
  'common.operate.confirm.clearItems': 'The details may be cleared if the {item} is modified Do you confirm to modify?',
  'common.operate.confirm.delete': 'Are you sure to delete?',
  'common.operate.confirm.disable': 'Are you sure to disable?',
  'common.operate.confirm.enable': 'Are you sure to enable operation?',
  'common.operate.confirm.lineFieldNotNull': 'The {item} at {line} shall not be left blank',
  'common.operate.copy': 'Copy',
  'common.operate.create': 'Create',
  'common.operate.dcset': 'Distribution setting',
  'common.operate.delete': 'Delete',
  'common.operate.disable': 'Disable',
  'common.operate.edit': 'Edit',
  'common.operate.enable': 'Enable',
  'common.operate.finish': 'Complete',
  'common.operate.modify': 'Modification',
  'common.operate.modifyState': 'Modification state',
  'common.operate.new': 'Add',
  'common.operate.replace': 'Replace',
  'common.operate.view': 'Check',
  'common.operateMethod': 'Operation method',
  'common.orderBillNumner': 'Order No.',
  'common.pagination.tag.records': 'Piece',
  'common.pagination.tag.total': 'co-owned',
  'common.placeholder': 'Please enter {name}',
  'common.placeholder.choose': 'Please select {name}',
  'common.placeholder.choose.contained': 'Please select the {name}',
  'common.placeholder.contained': 'Please enter the {name}',
  'common.price': 'Unit price',
  'common.productDate': 'Date of production',
  'common.productionBatch': 'Batch No.',
  'common.progress.confirmModal.title': 'Batch',
  'common.progress.progressModal.title': 'Completion progress',
  'common.progress.retry': 'Try again',
  'common.progress.select.tips': 'Please tick, and then perform batch operations',
  'common.qpcAndMunit': 'Specifications/Units of Measurement',
  'common.qty': 'Quantity',
  'common.qtyStr': 'Pcs',
  'common.remark': 'customize',
  'common.remark1': 'User-defined 1',
  'common.remark2': 'User-defined 2',
  'common.remark3': 'User-defined 3',
  'common.remark4': 'User-defined 4',
  'common.remark5': 'User-defined 5',
  'common.remark6': 'User-defined 6',
  'common.sourceBill': 'source document',
  'common.sourceBillNumber': 'Source No.',
  'common.sourceOrderBillNumber': 'Source order No.',
  'common.sourceType': 'Source document type',
  'common.sourceWay': 'Source mode',
  'common.sourceWay.create.name': 'Create by hand',
  'common.sourceWay.fileImport.name': 'File import',
  'common.sourceWay.interfaceImport.name': 'Interface import',
  'common.state': 'Status',
  'common.stock.article': 'Commodity',
  'common.stock.bincode': 'Goods Location',
  'common.stock.caseQtyStr': 'Pcs',
  'common.stock.container': 'Container',
  'common.stock.owner': 'Owner',
  'common.stock.productionBatch': 'Batch No.',
  'common.stock.productionDate': 'Date of production',
  'common.stock.qpc': 'Packaging',
  'common.stock.qpcStr': 'Specification',
  'common.stock.qty': 'Quantity',
  'common.stock.stockBatch': 'External batch',
  'common.stock.validDate': 'Expiry date',
  'common.stock.vendor': 'Supplier',
  'common.stockBatch': 'Batch',
  'common.table.content.disabled': 'Disabled',
  'common.table.content.enabled': 'Enabled',
  'common.tips.empty': 'No data temporarily',
  'common.tmsAllWeight': 'Total weight (ton)',
  'common.tmsWeight': 'Weight (t)',
  'common.toolong.validate': 'The length shall not exceed {length}',
  'common.uplaodDate': 'Upload time',
  'common.validDate': 'Expiry date',
  'common.volume': 'Volume (m3)',
  'common.waveType': 'Wave type',
  'common.weight': 'Weight (kg)',
  'common.yes': 'Yes',
  'company.authorize.form.item.resources.name': 'Permission',
  'company.authorize.form.item.validDate.name': 'Expiry date',
  'company.authorize.form.item.validDate.validate.message.notNull': 'Please select the date',
  'company.authorize.title': 'Authorization',
  'company.create.basic': 'Basic information',
  'company.create.button.cancel': 'Cancel',
  'company.create.button.confirm': 'OK',
  'company.create.button.confirmCreate': 'Confirm and create',
  'company.create.button.save': 'Save',
  'company.create.button.saveAndAudit': 'Save and audit',
  'company.create.form.item.adminName.name': 'Title of the administrator',
  'company.create.form.item.adminName.validate.message.limitLength': 'The max length for the title of administrator is 30.',
  'company.create.form.item.adminName.validate.message.notNull': 'The administrator code cannot be left blank',
  'company.create.form.item.adminPhone.name': 'Mobile phone number of the administrator',
  'company.create.form.item.adminPhone.validate.message.integrality': 'Please enter the real phone number of the administrator',
  'company.create.form.item.adminPhone.validate.message.notNull': 'Mobile number cannot be left blank',
  'company.create.form.item.code.name': 'Enterprise code',
  'company.create.form.item.code.validate.message.integrality': 'The code shall be four digits, alphanumeric combination, pure number or pure letter',
  'company.create.form.item.code.validate.message.limitLength': 'The max length is 4',
  'company.create.form.item.code.validate.message.notNull': 'The code shall not be left blank',
  'company.create.form.item.interfaceUrl.name': 'Interface Platform',
  'company.create.form.item.interfaceUrl.validate.message.limitLength': 'Max length of interface platform 100',
  'company.create.form.item.interfaceUrl.validate.message.notNull': 'Platform cannot be left blank',
  'company.create.form.item.maxCarrierUserCount.name': 'Max number of users of the carrier',
  'company.create.form.item.maxCompanyUserCount.name': 'Max number of the user at the enterprise end',
  'company.create.form.item.maxDcCount.name': 'Max number of distribution center',
  'company.create.form.item.maxDcUserCount.name': 'Max number of the user at the distribution end',
  'company.create.form.item.maxStoreUserCount.name': 'Maximum number of users in the store ',
  'company.create.form.item.maxUserCount.name': 'Max users',
  'company.create.form.item.maxUserCount.validate.message.notNull': 'Max users cannot be left blank',
  'company.create.form.item.maxVendorUserCount.name': 'Max number of users of the supplier',
  'company.create.form.item.name.name': 'Company Name',
  'company.create.form.item.name.validate.message.limitLength': 'The max length of title is 30.',
  'company.create.form.item.name.validate.message.notNull': 'The name cannot be left blank',
  'company.create.form.item.placeholder.adminName': 'Please enter 2 to 10 characters',
  'company.create.form.item.placeholder.adminPhone': 'please enter a 11-digit mobile number',
  'company.create.form.item.placeholder.code': 'Please enter 4 digits or letters',
  'company.create.form.item.placeholder.companyAdminName': 'Please enter the title of the administrator',
  'company.create.form.item.placeholder.companyCode': 'Please enter the enterprise code',
  'company.create.form.item.placeholder.companyInterfaceUrl': 'Please enter the interface platform',
  'company.create.form.item.placeholder.companyName': 'Please enter enterprise name',
  'company.create.form.item.placeholder.companyNumber': 'Please enter the number',
  'company.create.form.item.placeholder.companyPhone': 'Please enter the phone number',
  'company.create.form.item.placeholder.companyReportUrl': 'Please enter the statement route',
  'company.create.form.item.placeholder.name': 'Please enter 4 to 30 characters',
  'company.create.form.item.placeholder.number': 'Please enter the number greater than 0',
  'company.create.form.item.placeholder.validDate': 'please choose',
  'company.create.form.item.reportUrl.name': 'Statement route',
  'company.create.form.item.reportUrl.validate.message.limitLength': 'The max length of the statement route is 100.',
  'company.create.form.item.reportUrl.validate.message.notNull': 'The statement route shall not be left blank',
  'company.create.form.item.validDate.name': 'Expiry date',
  'company.create.form.item.validDate.validate.message.notNull': 'Expiry date shall not be left blank',
  'company.create.permission': 'Permission information',
  'company.create.register': 'Registration information',
  'company.create.title': 'Create Enterprise',
  'company.daily.time': 'Daily settlement time of the enterprise',
  'company.detail.basic': 'Basic information',
  'company.detail.basic.administratorName': 'Title of the administrator',
  'company.detail.basic.administratorPhone': 'Mobile phone number of the administrator',
  'company.detail.basic.code': 'Code',
  'company.detail.basic.name': 'Name',
  'company.detail.basic.status': 'Status',
  'company.detail.button.back': 'Back',
  'company.detail.button.cancel': 'Cancel',
  'company.detail.button.confirm': 'OK',
  'company.detail.dc': 'Distribution Center',
  'company.detail.erp': 'ERP',
  'company.detail.interfaceAddress': 'Interface address',
  'company.detail.label.edit': 'Edit',
  'company.detail.operate': 'Operating information',
  'company.detail.operate.table.column.detail': 'Details',
  'company.detail.operate.table.column.event': 'Events',
  'company.detail.operate.table.column.operateTime': 'Operation duration',
  'company.detail.operate.table.column.operator': 'Operator',
  'company.detail.tab.comapnyInfo': 'Enterprise information',
  'company.detail.tab.dcConfiguration': 'Configuration of distribution center',
  'company.detail.tab.erpConfiguration': 'ERP configuration',
  'company.detail.tab.operateInfo': 'Operation log',
  'company.detail.tab.permissionInfo': 'Permission information',
  'company.detail.used': 'Operating information',
  'company.detail.used.CarrierUser': 'Number of the carrier',
  'company.detail.used.CompanyUser': 'Enterprise-terminal user',
  'company.detail.used.DcCount': 'DC quantity',
  'company.detail.used.DcUser': 'Distribution-end users',
  'company.detail.used.StoreUser': 'Number of stores',
  'company.detail.used.User': 'Total users',
  'company.detail.used.VendorUser': 'Number of the supplier:',
  'company.detail.used.validDate': 'Expiry date',
  'company.importTemplate.create.temp': 'Create Template',
  'company.importTemplate.create.temp.button': 'Import template',
  'company.importTemplate.create.temp.name': 'Template name',
  'company.importTemplate.create.temp.type': 'Template type',
  'company.importTemplate.manageTitle': 'Management of imported template',
  'company.importTemplate.title': 'Import template',
  'company.importTemplate.upload.fail': 'Upload failed',
  'company.importTemplate.upload.success': 'Uploaded successfully',
  'company.index.search.button.reset': 'Reset',
  'company.index.search.button.search': 'Query',
  'company.index.search.input.codeName': 'Enterprise code/name',
  'company.index.search.input.codeName.placeholder': 'Please enter the keywords for inquiry',
  'company.index.search.input.status': 'Status',
  'company.index.search.input.status.placeholder': 'Please select the status',
  'company.index.search.input.validDate': 'Expiry date',
  'company.index.table.button.batchDisable': 'Disable',
  'company.index.table.button.batchEnable': 'Enable',
  'company.index.table.button.new': 'Create',
  'company.index.table.column.code': 'Code',
  'company.index.table.column.dcInfo': 'DC information',
  'company.index.table.column.name': 'Name',
  'company.index.table.column.operate': 'Operate',
  'company.index.table.column.remainingDays': 'Remaining days',
  'company.index.table.column.status': 'Status',
  'company.index.table.column.userInfo': 'User information',
  'company.index.table.column.validDate': 'Expiry date',
  'company.index.table.column.valided': 'Expired',
  'company.index.table.content.disable': 'Disabled',
  'company.index.table.content.enable': 'Enabled',
  'company.index.table.operate.authorize': 'Authorization',
  'company.index.table.operate.confirm': 'OK',
  'company.index.table.operate.disable': 'Disable',
  'company.index.table.operate.edit': 'Edit',
  'company.index.table.operate.enable': 'Enable',
  'company.index.table.operate.view': 'Check',
  'company.message.error.create': 'Failed to create the enterprise',
  'company.message.error.disbale': 'Fail to disable an enterprise',
  'company.message.error.enbale': 'Fail to enable an enterprise',
  'company.message.error.update': 'Fail to modify the enterprise\'s basic information',
  'company.message.error.usedInfo': 'Fail to modify the enterprise\'s use information',
  'company.message.success.create': 'Successfully create the enterprise',
  'company.message.success.disable': 'Disable the enterprise successfully',
  'company.message.success.enbale': 'Enable the enterprise successfully',
  'company.message.success.update': 'Modify the enterprise information successfully',
  'company.message.success.updateBasic': 'Modify the enterprise\'s basic information successfully',
  'company.message.success.usedInfo': 'Succeed in modifying the enterprise\'s use information',
  'company.printTemplate.create.temp': 'Create Template',
  'company.printTemplate.create.temp.name': 'Template name',
  'company.printTemplate.create.temp.path': 'Template path',
  'company.printTemplate.create.temp.type': 'Template type',
  'company.printTemplate.manageTitle': 'Printing',
  'company.returnDistributionTypeConfig.name': 'Name',
  'company.returnDistributionTypeConfig.title': 'Configuration of return type',
  'company.title': 'Enterprise Registration',
  'component.globalHeader.event': 'To do',
  'component.globalHeader.event.empty': 'You have completed all to-dos',
  'component.globalHeader.help': 'Use the document',
  'component.globalHeader.message': 'Message',
  'component.globalHeader.message.empty': 'You have read all messages',
  'component.globalHeader.notification': 'Notice',
  'component.globalHeader.notification.empty': 'You have viewed all notices',
  'component.globalHeader.search': 'Site search',
  'component.globalHeader.search.example1': 'Search hint I',
  'component.globalHeader.search.example2': 'Search hint II',
  'component.globalHeader.search.example3': 'Search hint III',
  'component.noticeIcon.clear': 'Clear',
  'component.noticeIcon.cleared': 'Clear',
  'component.noticeIcon.empty': 'No data temporarily',
  'config.containerTypeBind.containerType': 'Type of child-container',
  'config.containerTypeBind.containerType.CodeAndName': 'Type of child-container',
  'config.containerTypeBind.containerType.code': 'Code of the type of child-container',
  'config.containerTypeBind.containerType.name': 'Title of the type of child-container',
  'config.containerTypeBind.parentContainerType': 'Type of parent container',
  'config.containerTypeBind.parentContainerType.CodeAndName': 'Type of parent container',
  'config.containerTypeBind.parentContainerType.code': 'Code of the type of parent container',
  'config.containerTypeBind.parentContainerType.name': 'Title of the type of parent container',
  'config.containerTypeBind.title': 'Configuration of type bearing relationship of the container',
  'config.stockTakeConfig.decincState': 'Status of the profit and loss statement',
  'config.stockTakeConfig.maxBins': 'Max number of goods location',
  'config.title': 'Configuration information',
  'consumingBill.consumingStore': 'Requisition object',
  'consumingBill.consumingType': 'Requisition type',
  'consumingBill.consuminger': 'Recipient',
  'consumingBill.title': 'Requisition List',
  'consumingRtnBill.rtn': 'Backing object',
  'consumingRtnBill.rtnStore': 'Requisition return object',
  'consumingRtnBill.rtnType': 'Type of return',
  'consumingRtnBill.rtner': 'Requisition returnee',
  'consumingRtnBill.title': 'Requisition Return List',
  'consumingRtnBillLocale.consumingNumber': 'receipt number',
  'container.title': 'Container',
  'container.validate.genCount': 'The quantity generated shall be the integer between 1 and 999.',
  'cost.cost': 'Expense Item',
  'cost.includeText': 'Including the fields',
  'cost.info': 'Note',
  'cost.state': 'Status',
  'cost.textSum': 'Number of fields',
  'create': 'create',
  'cunsuming.formItem_Warning': 'The details may be cleared if the {name} is modified Do you confirm to modify?',
  'daily.config': 'Daily settlement   Configuration',
  'dc.create.button.cancel': 'Cancel',
  'dc.create.button.confirm': 'OK',
  'dc.create.button.confirmCreate': 'Confirm and create',
  'dc.create.form.item.address.validate.message.limitLength': 'The max length of the address is 100',
  'dc.create.form.item.address.validate.message.notNull': 'Address shall not be left blank',
  'dc.create.form.item.code.validate.message.integrality': 'The code shall be four digits, alphanumeric combination, pure number or pure letter',
  'dc.create.form.item.code.validate.message.limitLength': 'The max length of code is 30',
  'dc.create.form.item.code.validate.message.notNull': 'The code shall not be left blank',
  'dc.create.form.item.contactPhone.validate.limitLength': 'The max length of the contact information is 30',
  'dc.create.form.item.contactPhone.validate.message.integrality': 'Please enter the real phone number of the contact',
  'dc.create.form.item.contactPhone.validate.message.notNull': 'Mobile number cannot be left blank',
  'dc.create.form.item.contactor.validate.message.limitLength': 'The max length of the contact is 30',
  'dc.create.form.item.contactor.validate.message.notNull': 'The contact person cannot be left blank',
  'dc.create.form.item.name.validate.message.limitLength': 'The max length of title is 30.',
  'dc.create.form.item.name.validate.message.notNull': 'The name cannot be left blank',
  'dc.create.form.item.note.name': 'Remarks',
  'dc.create.form.item.note.validate.message.limitLength': 'The max length of the remarks is 255',
  'dc.create.form.item.operatingArea.name': 'Operation area (㎡)',
  'dc.create.form.item.operatingArea.validate.message.greaterThanZero': 'The operation area shall be greater than or equal to 0.',
  'dc.create.form.item.owner.name': 'Owner',
  'dc.create.form.item.placeholder': 'Please enter',
  'dc.create.form.item.shortName.name': 'Short name',
  'dc.create.form.item.shortName.validate.message.limitLength': 'The maximum length of short name is 30.',
  'dc.create.form.item.useWMS.validate.message.notNull': 'WMS shall not be left blank',
  'dc.create.form.item.zipCode.name': 'Postal code',
  'dc.create.form.item.zipCode.validate.message.limitLength': 'The max length of the postal code is 30.',
  'dc.create.title': 'Create Distribution Center',
  'dc.detail.button.cancel': 'Cancel',
  'dc.detail.button.confirm': 'OK',
  'dc.detail.tab.dcInfo': 'Information of distribution center',
  'dc.detail.tab.operateInfo': 'Operation log',
  'dc.edit.title': 'Modify the distribution center',
  'dc.index.message.success.operate': 'Operation succeeded',
  'dc.index.search.button.reset': 'Reset',
  'dc.index.search.button.search': 'Query',
  'dc.index.search.content.all': 'all',
  'dc.index.search.content.disable': 'Disabled',
  'dc.index.search.content.enable': 'Enabled',
  'dc.index.search.input.codeName': 'Code/title of distribution center',
  'dc.index.search.input.state': 'Status',
  'dc.index.table.button.new': 'Create',
  'dc.index.table.column.address': 'Address',
  'dc.index.table.column.code': 'Code',
  'dc.index.table.column.contactPhone': 'Contact Tel.',
  'dc.index.table.column.contactor': 'Contact person',
  'dc.index.table.column.name': 'Name',
  'dc.index.table.column.operate': 'Operate',
  'dc.index.table.column.shortName': 'Short name',
  'dc.index.table.column.state': 'Status',
  'dc.index.table.column.useWMS': 'Use WMS',
  'dc.index.table.operate.edit': 'Edit',
  'dc.message.success.disable': 'Disable the distribution center successfully',
  'dc.message.success.enable': 'Enable the distribution center successfully',
  'dc.select.no': 'No',
  'dc.select.please': 'please choose',
  'dc.select.yes': 'Yes',
  'dc.title': 'Distribution Center',
  'dec.btn.manageType': 'Manage the loss type',
  'dec.column.amount': 'Loss amount',
  'dec.column.article': 'Including the commodity',
  'dec.column.bin': 'Code of goods location included',
  'dec.column.container': 'Container code included',
  'dec.column.decer': 'Loss reporter',
  'dec.column.qty': 'Loss quantity',
  'dec.column.qtyStr': 'Loss pieces',
  'dec.column.realAmount': 'Actual loss amount',
  'dec.column.realQty': 'Actual loss quantity',
  'dec.column.realQtyStr': 'Number of actual loss pcs',
  'dec.column.type': 'Loss type',
  'dec.confirm.audit': 'Are you sure to audit the',
  'dec.confirm.clear': 'The details may be cleared if the {item} is modified Do you confirm to modify?',
  'dec.items': 'Details of loss list',
  'dec.title': 'Loss List',
  'dec.validate.itemNotLessZero': '{item} of {line} for the details of raw materials of the loss list shall not be less than 0.',
  'dec.validate.itemNotZero': '{item} of {line} for the details of raw materials of the loss list shall not be 0.',
  'dec.validate.itemRepeat': '{line1} and {line2} are repeated for the details of the loss list',
  'dec.validate.noteTooLong': 'The max length of the note at {line} is 255.',
  'dec.validate.realQtyTooBig': 'The actual loss quantity at the {line} shall not greater than the loss quantity',
  'decincConfig.ALL': 'all',
  'decincConfig.LOCK': 'Lock',
  'decincConfig.LOSS': 'Loss',
  'decincConfig.SPILL': 'Surplus',
  'decincConfig.STOCKADJ': 'Inventory adjustment',
  'decincConfig.column.binUsage': 'Purpose of goods location',
  'decincConfig.column.configType': 'Type of configuration',
  'decincConfig.column.note': 'Remarks',
  'decincConfig.create.form.item.input.placeholder.binUsage': 'Please enter the purposes of goods location',
  'decincConfig.title': 'Profit and loss rules',
  'deliverycycle.add': 'Create Distribution Cycle',
  'deliverycycle.preserveWave': 'Maintenance wave',
  'deliverycycle.update': 'Update the delivery cycle',
  'displayBoard.alcNtcBillNumber': 'Delivery notice number',
  'displayBoard.allocateType': 'Type of inventory allocation',
  'displayBoard.articleGroups': 'Commodity group',
  'displayBoard.articleInfo': 'Commodity data',
  'displayBoard.canUse': 'Allocatable quantity',
  'displayBoard.comment': 'Unread message',
  'displayBoard.fillRate': 'Wave satisfaction rate (%)',
  'displayBoard.fillRateForStock': 'Fill rate (%)',
  'displayBoard.force': 'Mandatory distribution',
  'displayBoard.generate': 'Generate the instruction',
  'displayBoard.itemInfo': 'Details',
  'displayBoard.itemViewButton': 'Details',
  'displayBoard.noWaveInfoMessage': 'No temporary wave in progress',
  'displayBoard.planQty': 'Wave has been distributed',
  'displayBoard.planQtyForForce': 'Planned distributed volume',
  'displayBoard.planQtyForStock': 'Planned amount',
  'displayBoard.qpcStr': 'Specification',
  'displayBoard.qty': 'Wave demand quantity',
  'displayBoard.qtyForStock': 'quantity required',
  'displayBoard.replace': 'Replace',
  'displayBoard.replaceArticle': 'Replace the commodity',
  'displayBoard.replaceQty': 'Replacement quantity',
  'displayBoard.reserve': 'Reserved',
  'displayBoard.reserveCount': 'Reserved volume',
  'displayBoard.setAllocateType': 'Set up the type of inventory allocation',
  'displayBoard.stockInfo': 'Inventory details',
  'displayBoard.stockOutTabTitle': 'Out-of-stock board',
  'displayBoard.stockTabTitle': 'Inventory board',
  'displayBoard.stockView': 'Inventory check',
  'displayBoard.storeInfo': 'Store information',
  'displayBoard.title': 'Goods Preparation Board',
  'displayBoard.usableStock': 'Available in stock',
  'displayBoard.waveBillNumber': 'Wave no.',
  'displayBoard.waveInfo': 'Wave information',
  'dock.code': 'Code',
  'dock.create.form.item.input.placeholder.code': 'Please enter the code',
  'dock.create.form.item.input.placeholder.name': 'Please enter 4 to 30 characters',
  'dock.create.form.item.input.placeholder.note': 'Please enter the remark',
  'dock.create.form.item.option.placeholder': 'please choose',
  'dock.detail.label.edit': 'Edit',
  'dock.detail.tab.basicInfo': 'Code information',
  'dock.detail.tab.operateInfo': 'Operation log',
  'dock.dockGroup': 'Dock set',
  'dock.index.button.dockGroup': 'Dock set',
  'dock.index.search.input.codeName': 'Dock code/title',
  'dock.index.search.input.codeName.placeholder': 'Please enter',
  'dock.index.search.input.state': 'Status',
  'dock.index.table.column.operate': 'Operate',
  'dock.name': 'Name',
  'dock.note': 'Remarks',
  'dock.popup.addTitle': 'Newly-added dock',
  'dock.popup.code.validate.integrality': 'The max length is 4 and it could only be the letter and number',
  'dock.popup.code.validate.notNull': 'The code shall not be left blank',
  'dock.popup.dockGroup.validate.notNull': 'The dock set shall not be left blank',
  'dock.popup.editTitle': 'Edit the dock',
  'dock.popup.name.validate.limitLength': 'The max length of title is 30.',
  'dock.popup.name.validate.notNull': 'The name cannot be left blank',
  'dock.popup.note.validate.limitLength': 'The max length of the remarks is 255',
  'dock.popup.title': 'Basic information',
  'dock.popup.usages.validate.notNull': 'The dock purpose shall not be left blank',
  'dock.state': 'Status',
  'dock.state.all': 'all',
  'dock.state.assinged': 'Allocated',
  'dock.state.disenabled': 'terminated',
  'dock.state.free': 'idle',
  'dock.state.using': 'Using',
  'dock.title': 'Dock',
  'dock.usage.delivery': 'Shipment',
  'dock.usage.receipt': 'Order receiving',
  'dock.usage.returned': 'Return of goods',
  'dock.usages': 'Purpose',
  'dockGroup.code': 'Code',
  'dockGroup.create.form.item.input.placeholder.code': 'Please enter the code',
  'dockGroup.create.form.item.input.placeholder.name': 'Please enter 4 to 30 characters',
  'dockGroup.create.form.item.input.placeholder.note': 'Please enter the remark',
  'dockGroup.create.form.item.option.placeholder': 'please choose',
  'dockGroup.index.search.input.codeName': 'Dock code/title',
  'dockGroup.index.search.input.codeName.placeholder': 'Please enter',
  'dockGroup.name': 'Name',
  'dockGroup.note': 'Remarks',
  'dockGroup.popup.addTitle': 'Newly-added dock',
  'dockGroup.popup.code.validate.integrality': 'The max length is 4 and it could only be the letter and number',
  'dockGroup.popup.code.validate.notNull': 'The code shall not be left blank',
  'dockGroup.popup.editTitle': 'Edit the dock',
  'dockGroup.popup.name.validate.limitLength': 'The max length of title is 30.',
  'dockGroup.popup.name.validate.notNull': 'The name cannot be left blank',
  'dockGroup.popup.note.validate.limitLength': 'The max length of the remarks is 255',
  'dockGroup.popup.title': 'Basic information',
  'dockGroup.title': 'Dock set',
  'end.test': 'Stop testing',
  'end.test.success': 'Stop testing successfully',
  'end.work': 'Stop operation',
  'end.work.success': 'Stop operation successfully',
  'excel表字段': 'excel sheet field',
  'form.captcha.second': 'Second',
  'form.client.label': 'Customer',
  'form.client.label.tooltip': 'Target service object',
  'form.client.placeholder': 'Please describe the customer you serve, internal customer directly @ name/job number',
  'form.confirm-password.placeholder': 'Confirm the password',
  'form.date.label': 'Start & expiry date',
  'form.date.placeholder.end': 'Ending date',
  'form.date.placeholder.start': 'Start date',
  'form.email.placeholder': 'Email',
  'form.get-captcha': 'Send code',
  'form.goal.label': 'Target description',
  'form.goal.placeholder': 'Please enter the phased work target',
  'form.invites.label': 'Reviewer',
  'form.invites.placeholder': 'Please @ name/employee No. directly, invite up to 5 people',
  'form.optional': '(Optional)',
  'form.password.placeholder': 'At least 6-digit passwords, case sensitive',
  'form.phone-number.placeholder': '11-digit mobile phone number',
  'form.public.label': 'Target disclosure',
  'form.public.label.help': 'It is shared by default for the consumers and reviewers',
  'form.public.radio.partially-public': 'Partial disclosure',
  'form.public.radio.private': 'Not published',
  'form.public.radio.public': 'Public',
  'form.publicUsers.option.A': 'Colleague A',
  'form.publicUsers.option.B': 'Colleague B',
  'form.publicUsers.option.C': 'Colleague C',
  'form.publicUsers.placeholder': 'Public',
  'form.save': 'Save',
  'form.standard.label': 'Measuring standards',
  'form.standard.placeholder': 'Please enter the measurement standards',
  'form.submit': 'Submit',
  'form.title.label': 'Title',
  'form.title.placeholder': 'Give the target a name',
  'form.verification-code.placeholder': 'Verification code',
  'form.weight.label': 'Weight',
  'form.weight.placeholder': 'Please enter',
  'fresh.freshPickOrderConfig.title': 'Configuration of fresh food picking sequence',
  'fresh.freshPickTempBinConfig.name': 'Picking staging',
  'fresh.freshPickTempBinConfig.title': 'Configuration of temporary location of fresh food picking',
  'fresh.storeAllocationSchemeConfig.storeAllocation': 'Scheme of the store distribution location',
  'fresh.storeAllocationSchemeConfig.title': 'Configuration of the distribution location of the store',
  'freshPickBoardConfig.HangPrintTemplate': 'Printing template of the suspension scale',
  'freshPickBoardConfig.boardPickOrderScheme': 'Scheme of the panel picking sequence',
  'freshPickBoardConfig.boardPickOrderSchemeLog': 'Operation log of the panel picking sequence scheme',
  'freshPickBoardConfig.pickPrintConfig': 'Configuration of picking printing',
  'freshPickBoardConfig.pickPrintConfigLog': 'Pick printing configuration for operation log',
  'freshPickBoardConfig.pickPrintTemplate': 'Template of digital picking printing',
  'freshPickBoardConfig.sowPrintTemplate': 'digital assorting print template',
  'freshPickBoardConfig.whetherHangPrint': 'Whether to configure the printing of suspension scale',
  'freshPickBoardConfig.whetherPickPrint': 'Whether to configure the digital picking printing',
  'freshPickBoardConfig.whetherSowPrint': 'Whether to configure the digital assorting printing',
  'freshPickUp.PickType': 'Digital assorting latitude',
  'freshPickUp.PickTypeForArticle': 'Commodity latitude',
  'freshPickUp.PickTypeForStore': 'Store latitude',
  'freshPickUp.articleCountForPick': 'Items to be picked',
  'freshPickUp.articleGroup': 'Commodity group',
  'freshPickUp.batchGenerateTask': 'Bulk generation of tasks',
  'freshPickUp.binCode': 'Distribution location',
  'freshPickUp.changeContainerButton': 'Container switch',
  'freshPickUp.changeOrderButton': 'Sequence adjustment',
  'freshPickUp.containerBarcode': 'Distribution container',
  'freshPickUp.customTask': 'User-defined task',
  'freshPickUp.freshPickTitle': 'digital pick of fresh food',
  'freshPickUp.freshSowTitle': 'Digital assorting of fresh food',
  'freshPickUp.getInstruct': 'Acquire the instruction',
  'freshPickUp.getInstructSuccess': 'Successfully acquire the picking instruction',
  'freshPickUp.instructTitle': 'Instruction',
  'freshPickUp.mergeTask': 'Combined task',
  'freshPickUp.myPickTask': 'My digital picking task',
  'freshPickUp.mySowTask': 'My digital assorting picking task',
  'freshPickUp.onViewButton': 'Details',
  'freshPickUp.overDeliveryNum': 'Over-dispatched quantity',
  'freshPickUp.overDeliveryRate': 'Over-dispatched proportion',
  'freshPickUp.pick': 'fruit picking',
  'freshPickUp.pickTask': 'digital picking task',
  'freshPickUp.pickTaskTitle': 'Board of digital picking tasks',
  'freshPickUp.pickUpButton': 'Picking',
  'freshPickUp.pickingProgress': 'Picking progress',
  'freshPickUp.qty': 'Quantity pickable',
  'freshPickUp.qtyForSow': 'Quantity to be distributed',
  'freshPickUp.qtyStr': 'Pieces to be picked',
  'freshPickUp.qtyStrForSow': 'Pcs to be distributed',
  'freshPickUp.realArticleCountForPick': 'Number of items actually picked',
  'freshPickUp.realQty': 'Actual Picking Quantity',
  'freshPickUp.realQtyStr': 'number of cases',
  'freshPickUp.realStoreCountForSow': 'Number of real-distribution store',
  'freshPickUp.realTaskCountForPick': 'Number of actual-picking instruction',
  'freshPickUp.realTaskCountForSow': 'Number of actual distribution instruction',
  'freshPickUp.registerContainerTitle': 'Container registration',
  'freshPickUp.release': 'Release',
  'freshPickUp.sow': 'sowing',
  'freshPickUp.sowTask': 'Digital assorting tasks',
  'freshPickUp.sowTaskTitle': 'Board of digital assorting tasks',
  'freshPickUp.storeCountForSow': 'Number of the stores to be distributed',
  'freshPickUp.storeGroup': 'Store group',
  'freshPickUp.storePickOrderSchema': 'Pick Sequence Scheme',
  'freshPickUp.targetNumber': 'Target S/N',
  'freshPickUp.taskCount': 'Number of instruction',
  'freshPickUp.taskCountForPick': 'Number of the instruction to be picked',
  'freshPickUp.taskCountForSow': 'Number of the instructions to be distributed',
  'freshPickUp.taskNumber': 'Instruction No.',
  'freshPickUp.taskTitle': 'Task pane',
  'freshPickUp.taskType': 'Operating mode',
  'freshPickUp.type': 'Mode',
  'freshPickUp.unitVolumn': 'HB/L volume',
  'freshReceive.articleCode': 'Commodity barcode',
  'freshReceive.articleCodeUnExit': 'Commodity barcode does not exist',
  'freshReceive.articleInfo': 'Commodity data',
  'freshReceive.articleName': 'Commodity name',
  'freshReceive.articleUnFinishReceive': 'The current commodity has not been received',
  'freshReceive.billNumber': 'Order No./entry list/pre-tax S/N',
  'freshReceive.checkResult': 'Eligibility',
  'freshReceive.checkType': 'Type of quality inspection',
  'freshReceive.chooseArticle': 'Please select an item',
  'freshReceive.clearButton': 'Clear screen',
  'freshReceive.codeAndBarCodeAndName': 'Code, barcode and name',
  'freshReceive.codeAndName': 'Name code',
  'freshReceive.comment': 'Remarks upon receiving',
  'freshReceive.confirmButton': 'OK',
  'freshReceive.confirmFull': 'Confirm the full capacity',
  'freshReceive.containerBarcode': 'Container barcode',
  'freshReceive.containerName': 'Container name',
  'freshReceive.containerType': 'Container Type',
  'freshReceive.endButton': 'End',
  'freshReceive.fullButton': 'Full capacity',
  'freshReceive.hadReceivable': 'Received',
  'freshReceive.inWrh': 'warehousing',
  'freshReceive.makeSureEnd': 'Confirm the end',
  'freshReceive.netWeight': 'Net weight',
  'freshReceive.noCareShelfDate': 'Does not manage shelf life',
  'freshReceive.plateAdvice': 'Loading suggestions',
  'freshReceive.receivable': 'Receivables',
  'freshReceive.receiveAndWaitQty': 'Quantity receivable/ to be received',
  'freshReceive.receiveBill': 'Receipt of order number',
  'freshReceive.receiveBillInfo': 'Information of receiving note',
  'freshReceive.receiveQpcStr': 'Receiving specification',
  'freshReceive.retrieve': 'Return',
  'freshReceive.sense': 'Quality inspection items',
  'freshReceive.shelfLifeDays': 'Days of guarantee period',
  'freshReceive.tare': 'Tare weight',
  'freshReceive.title': 'Order receiving',
  'freshReceive.toReceiveQtyStr': 'Number of pieces to receive',
  'freshReceive.unReceivedArticleCount': 'Items not received:',
  'freshReceive.unReceivedOrderInfo': 'Order non-receipt information',
  'freshReceive.unReceivedQtyStr': 'Pieces not received:',
  'freshReceive.viewButton': 'Details',
  'freshReceive.viewItemTitle': 'Check details',
  'freshReceive.waitReceivable': 'To be received',
  'freshReceive.weight': 'Gross weight',
  'goodsGroupConfig.goodsGroup': 'Commodity group',
  'goodsGroupConfig.storeBin': 'Please enter the virtual location',
  'goodsGroupConfig.title': 'Configuration of commodity group',
  'highLowStock.article': 'Commodity',
  'highLowStock.binCode': 'Goods Location',
  'highLowStock.binCodeRange': 'Scope of goods location:',
  'highLowStock.binType': 'Goods Location Type',
  'highLowStock.binTypeAndRange.validate.message.notNull': 'The location type and its range shall not be left blank at the same time',
  'highLowStock.highStockExplain': 'Max inventory (case/bag/pieces)',
  'highLowStock.highStockQty': 'Max inventory',
  'highLowStock.highStockQty.validate.message.integrality': 'Only the integer is allowed to enter as the max inventory',
  'highLowStock.highStockQty.validate.message.notNull': 'The max inventory shall not be left blank',
  'highLowStock.highStockQtyStr': 'Max inventory pieces',
  'highLowStock.lowAndHighStock.validate.message.notNull': 'The min inventory and the max inventory shall not be left blank at the same time',
  'highLowStock.lowStockExplain': 'Min inventory (case/bag/pieces)',
  'highLowStock.lowStockQty': 'Min inventory',
  'highLowStock.lowStockQty.validate.message.integrality': 'Only the integer is allowed to enter as the min inventory',
  'highLowStock.lowStockQty.validate.message.notNull': 'The min inventory shall not be left blank',
  'highLowStock.lowStockQtyStr': 'Min inventory pieces',
  'highLowStock.qpcStr': 'Specification',
  'highLowStock.select.fixValue': 'Fixed value',
  'highLowStock.select.placeholder': 'all',
  'highLowStock.select.plate': 'Loading specification',
  'highLowStock.title': 'Max and Min Inventory',
  'inWrhBill.articleCount': 'Order items',
  'inWrhBill.assignDockErrorMessage': 'Please select the dock',
  'inWrhBill.assignReceiptDock': 'Allocation and receiving docks',
  'inWrhBill.assignReturnDock': 'Allocation return dock',
  'inWrhBill.bookArticleCount': 'Number of items appointed in the order',
  'inWrhBill.bookBillNumber': 'Appointment list No.',
  'inWrhBill.bookQtyStr': 'Number of pcs appointed in the order',
  'inWrhBill.bookTime': 'Appointment time',
  'inWrhBill.button.audit': 'Audit',
  'inWrhBill.button.delete': 'Delete',
  'inWrhBill.button.save': 'Save',
  'inWrhBill.button.saveAndAudit': 'Save and audit',
  'inWrhBill.cancelReceiptAssignment': 'Cancel the allocation and receiving docks',
  'inWrhBill.cancelReturnAssignment': 'Cancel the allocation and return docks',
  'inWrhBill.carNumber': 'License plate number',
  'inWrhBill.configAutoFresh': 'Automatic refresh of configuration',
  'inWrhBill.configReleaseContent': 'Release contents of configuration',
  'inWrhBill.dock': 'Dock',
  'inWrhBill.dockAssignDate': 'Dock distribution time',
  'inWrhBill.dockCancelDate': 'Dock release time',
  'inWrhBill.dockEmptyErrorMessage': 'No dock information for the moment',
  'inWrhBill.driver': 'Driver',
  'inWrhBill.driverPhone': 'Driver\'s contact information',
  'inWrhBill.inWrhBillNumber': 'Entry list No.',
  'inWrhBill.inWrhErrorMessage': 'Please select the entry list',
  'inWrhBill.inWrhNumberErrorMessage': 'Please select the single-item entry list',
  'inWrhBill.isReceipt': 'Whether it has been received',
  'inWrhBill.isReturn': 'Whether to return',
  'inWrhBill.note': 'Remarks',
  'inWrhBill.operate': 'Operate',
  'inWrhBill.operateType': 'Operation method',
  'inWrhBill.orderState': 'Appointment status',
  'inWrhBill.outTime': 'Exit time',
  'inWrhBill.qtyStr': 'Number of orders',
  'inWrhBill.receipt': 'Order receiving',
  'inWrhBill.receiptInformation': 'Receiving information',
  'inWrhBill.return': 'Return of goods',
  'inWrhBill.returnInformation': 'Return information',
  'inWrhBill.stevedoreState': 'Configured unloading',
  'inWrhBill.time': 'Entry time',
  'inWrhBill.title': 'Entry Board',
  'inc.binCodes': 'Code of goods location included',
  'inc.containerBarCodes': 'Container code included',
  'inc.incer': 'Surplus reporter',
  'inc.manage.type': 'Type in managing the surplus',
  'inc.title': 'Surplus List',
  'inc.type': 'Type of surplus',
  'iwms.create.button.cancel': 'Cancel',
  'iwms.create.button.confirm': 'OK',
  'iwms.create.button.confirmCreate': 'Confirm and Create',
  'iwms.create.title.create': 'Create',
  'iwms.create.title.edit': 'Edit',
  'iwms.index.create.basic': 'Basic information',
  'iwms.index.create.bussiness': 'Business Information',
  'iwms.index.create.remark': 'Remarks',
  'iwms.index.search.button.collapse': 'Pack up/fold',
  'iwms.index.search.button.reset': 'Reset',
  'iwms.index.search.button.search': 'Query',
  'iwms.print.tips': 'Detail data cannot be left blank',
  'labelSow.title': 'Total label/ Distributionn',
  'labelTpick.searchform.containerdivider': 'Container allocation mode:',
  'labelTpick.searchform.printoption': 'Printing options',
  'labelTpick.title': 'total label',
  'layout.user.link.help': 'Help',
  'layout.user.link.privacy': 'Privacy',
  'layout.user.link.terms': 'Clauses',
  'lockConfig.title': 'Inventory locking and unlocking configuration',
  'manage': 'Management',
  'menu.account': 'Personal Center',
  'menu.account.center': 'Account Information',
  'menu.account.logout': 'Logout',
  'menu.account.modify': 'Modify Password',
  'menu.account.switch': 'Switch Organization',
  'menu.account.version': 'Version Information',
  'menu.api': 'Interface Platform',
  'menu.api.config': 'Interface Platform Configuration',
  'menu.api.dispath': 'Interface Board',
  'menu.api.erpdown': 'WMS&ERP Downstream Interface',
  'menu.api.erpup': 'WMS&ERP Upstream Interface',
  'menu.api.log': 'Interface Log',
  'menu.api.notify': 'Data To Be Executed For Interface',
  'menu.api.wcsdown': 'WMS&WCS Downstream Interface',
  'menu.api.wcsup': 'WMS&WCS Upstream Interface',
  'menu.basic': 'Basic Information',
  'menu.basic.article': 'Commodity',
  'menu.basic.carrier': 'Carrier',
  'menu.basic.category': 'Category',
  'menu.basic.dc': 'Distribution Center',
  'menu.basic.owner': 'Owner',
  'menu.basic.store': 'Store',
  'menu.basic.vendor': 'Supplier',
  'menu.basic.wrh': 'Warehouse Location',
  'menu.bigData': 'Big Data',
  'menu.bms': 'Billing',
  'menu.bms.accountBill': 'Bill',
  'menu.bms.contract': 'Contract',
  'menu.bms.cost': 'Expense Item',
  'menu.bms.dataSource': 'Expense Data Pool',
  'menu.bms.feeBill': 'Fee Bill',
  'menu.bms.genFeeBill': 'Manually Generated Cost List',
  'menu.bms.sortScheme': 'Node Classification Scheme',
  'menu.call': 'Order',
  'menu.call.alcNtc': 'Allocation Notice',
  'menu.call.storeHandover': 'Store Handover',
  'menu.call.vehicleMonitoring': 'Vehicle Monitoring',
  'menu.chargeManagement': 'Billing',
  'menu.chargeManagement.accountClassScheme': 'Node Classification Scheme',
  'menu.chargeManagement.cost': 'Expense Item',
  'menu.compmgr': 'System',
  'menu.compmgr.billImport': 'Document Import',
  'menu.compmgr.config': 'Configuration Center',
  'menu.compmgr.customImport': 'User-defined Import',
  'menu.compmgr.report': 'Report',
  'menu.compmgr.role': 'Role',
  'menu.compmgr.template': 'Printing',
  'menu.compmgr.user': 'Users',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.Demo': 'Demo',
  'menu.dashboard.analysis': 'Analysis Page',
  'menu.dashboard.monitor': 'Monitoring Page',
  'menu.dashboard.workplace': 'Workbench',
  'menu.dcmgr': 'Warehouse',
  'menu.dcmgr.processingScheme': 'Machining Scheme',
  'menu.exception': 'Abnormal Page',
  'menu.exception.not-find': '404',
  'menu.exception.not-permission': '403',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Triggering Error',
  'menu.facility': 'Logistics Facility',
  'menu.facility.allocateWall': 'Distribution Wall',
  'menu.facility.articleReplace': 'Commodity Alternative Scheme',
  'menu.facility.bin': 'Goods Location',
  'menu.facility.binType': 'Goods Location Type',
  'menu.facility.collectBin': 'Collection Scheme',
  'menu.facility.config': 'Configuration Center',
  'menu.facility.container': 'Container',
  'menu.facility.containerType': 'Container Type',
  'menu.facility.deliverycycle': 'Distribution Cycle Scheme',
  'menu.facility.dock': 'Dock',
  'menu.facility.dynamicpickupgroup': 'Dynamic Picking Group',
  'menu.facility.highLowStock': 'Max and Min Inventory',
  'menu.facility.pickArea': 'Picking Partition',
  'menu.facility.pickOrder': 'Pick Sequence Scheme',
  'menu.facility.stockorder': 'Inventory Allocation Scheme',
  'menu.facility.storeAllocationScheme': 'Distribution Scheme',
  'menu.facility.superManagementBoard': 'Over-insured Board',
  'menu.facility.wrh': 'Warehouse Location',
  'menu.form': 'Form Page',
  'menu.form.advancedform': 'Advanced Form',
  'menu.form.basicform': 'Basic List',
  'menu.form.stepform': 'Step-by-step list',
  'menu.form.stepform.confirm': 'Step-by-step list (confirm the transfer information)',
  'menu.form.stepform.info': 'Step-by-step list (fill in the transfer information)',
  'menu.form.stepform.result': 'Step-by-step list (completed)',
  'menu.hdmgr': 'Heading',
  'menu.hdmgr.RFManage': 'RF',
  'menu.hdmgr.comp': 'Enterprise Registration',
  'menu.hdmgr.config': 'Configuration Center',
  'menu.hdmgr.imTemplate': 'Import',
  'menu.hdmgr.licence': 'License',
  'menu.hdmgr.onlinehelp': 'Online Support And Maintenance',
  'menu.hdmgr.report': 'Report',
  'menu.hdmgr.server': 'Server',
  'menu.hdmgr.template': 'Printing',
  'menu.home': 'Homepage',
  'menu.in': 'Inbound',
  'menu.in.adjBill': 'Correction List',
  'menu.in.book': 'Appointment List',
  'menu.in.bookboard': 'Appointed Panel',
  'menu.in.checkinwrh': 'Entry And Exit Registration',
  'menu.in.freshReceive': 'Web Received',
  'menu.in.inwrhbill': 'Entry Board',
  'menu.in.mixbox': 'LCL Order',
  'menu.in.move': 'Plane move list',
  'menu.in.order': 'Inbound order',
  'menu.in.physicsCheckNtc': 'Quality Inspection Notice',
  'menu.in.physicscheck': 'Physical and Chemical Quality Checklist',
  'menu.in.physicscheckpool': 'Physical and Chemical Quality Inspection Board',
  'menu.in.precheck': 'Pre-inspection List',
  'menu.in.putaway': 'Put Away List',
  'menu.in.receive': 'Receiving Note',
  'menu.in.senseCheck': 'Sensory Quality Check Sheet',
  'menu.inMsg': 'Inbound',
  'menu.inMsg.order': 'Inbound order',
  'menu.inMsg.receive': 'Receiving Note',
  'menu.inner': 'Internal',
  'menu.inner.close': 'Sealing and Release Receipt',
  'menu.inner.consuming': 'Requisition List',
  'menu.inner.consumingNtc': 'Requisition Notice',
  'menu.inner.consumingRtnBill': 'Requisition Return List',
  'menu.inner.containerAssert': 'Container Entry And Exit List',
  'menu.inner.dec': 'Loss List',
  'menu.inner.electcert': 'Electronic Voucher',
  'menu.inner.freshTake': 'Fresh Inventory',
  'menu.inner.inc': 'Surplus List',
  'menu.inner.movebill': 'Transfer Order',
  'menu.inner.pickBinAdjBill': 'Picking Position Adjustment Form',
  'menu.inner.prerpl': 'Pre-replenishment Business',
  'menu.inner.processBill': 'Work Order',
  'menu.inner.processTask': 'Machining Tasks',
  'menu.inner.processingScheme': 'Machining Scheme',
  'menu.inner.rawRequisitionBill': 'Raw Requisition List',
  'menu.inner.stockAdjBill': 'Inventory Adjustment List',
  'menu.inner.stockTakeBill': 'Check List',
  'menu.inner.stockTakePlan': 'Inventory Plan',
  'menu.inner.stocklock': 'Locking and Unlocking List',
  'menu.inner.supermanagement': 'Over-insured Board',
  'menu.inner.webProcess': 'Web Process',
  'menu.list': 'List Page',
  'menu.list.basiclist': 'Standard Lists',
  'menu.list.cardlist': 'Card List',
  'menu.list.searchlist': 'Search List',
  'menu.list.searchlist.applications': 'Search List (Application)',
  'menu.list.searchlist.articles': 'Search List (Article)',
  'menu.list.searchlist.projects': 'Search List (Item)',
  'menu.list.searchtable': 'Enquiry Form',
  'menu.notice': 'Notice Release',
  'menu.out': 'Outbound',
  'menu.out.crossAllocate': 'Cross Allocate Board',
  'menu.out.alcNtc': 'Allocation Notice',
  'menu.out.articleArrangement': 'Allocate Item Pick Quantities',
  'menu.out.carriertransfer': 'Carrier Delivery Note',
  'menu.out.checkPack': 'Review Packing Table',
  'menu.out.checkplate': 'Review Packing Table',
  'menu.out.collectbinreview': 'Shipping Area Review List',
  'menu.out.containerItemreview': 'Container Review',
  'menu.out.containerbind': 'Container Binding',
  'menu.out.containermerger': 'Container Dismantling and Single',
  'menu.out.containerreview': 'Container Review Sheet',
  'menu.out.displayBoard': 'Goods Preparation Board',
  'menu.out.ecBill': 'E-commerce Waybill Information',
  'menu.out.freshPickUp': 'Picking Board',
  'menu.out.labelTpick': 'Total label/ Distributionn',
  'menu.out.pickInstruct': 'Picking Order',
  'menu.out.pickUpBill': 'Picking List',
  'menu.out.pickupCombined': 'PickupCombined',
  'menu.out.pickUpBillPrintLabel': 'Print the Label and Pick',
  'menu.out.picking': 'Digital Picking',
  'menu.out.processWave': 'Ex-warehouse Manufacturing',
  'menu.out.rpl': 'Replenishment List',
  'menu.out.sow': 'Digital Assorting Picking',
  'menu.out.sowingPickUp': 'Digital Assorting Picking List',
  'menu.out.storePickAdjustPanel': 'Adjustment Panel of The Store\'s Picking Information',
  'menu.out.waveBill': 'Wave List',
  'menu.out.alcPrintDisboard': 'Board of Distribution Print',
  'menu.profile': 'Detail Page',
  'menu.profile.advanced': 'Advanced Detailed Page',
  'menu.profile.basic': 'Basic Detailed Page',
  'menu.result': 'Results Page',
  'menu.result.fail': 'Failure Page',
  'menu.result.success': 'Successful Page',
  'menu.rtn': 'Reverse Logistics',
  'menu.rtn.rtnPutaway': 'Return Put Away List',
  'menu.rtn.storeRtn': 'Return List',
  'menu.rtn.storeRtnNtc': 'Return Notice List',
  'menu.rtn.vendorDispatch': 'Supplier\'s Return Board',
  'menu.rtn.vendorHandover': 'Supplier Handover',
  'menu.rtn.vendorRtnNtc': 'Supplier\'s Return Notice',
  'menu.rtn.vendorRtnPick': 'Supplier Pick List',
  'menu.rtnMsg': 'Return',
  'menu.rtnMsg.storeRtn': 'Return list of the store ',
  'menu.rtnMsg.storeRtnNtc': 'Return Notice List',
  'menu.tms': 'Transportation',
  'menu.tms.ShipPlanDispatch': 'Dispatching Board',
  'menu.rtn.alcDiff': 'Distribution Discrepancy',
  'menu.tms.carrier': 'Carrier',
  'menu.tms.carriertransfer': 'Carrier Delivery Note',
  'menu.tms.config': 'Configuration Center',
  'menu.tms.containerRecycle': 'Container Recovery',
  'menu.tms.serialArch': 'Route System',
  'menu.tms.shipbill': 'Loading List',
  'menu.tms.shipplanbill': 'Dispatch List',
  'menu.tms.storehandoverbill': 'Store Handover',
  'menu.tms.vehicle': 'Vehicle',
  'menu.tms.vehicleMonitoring': 'Vehicle Monitoring',
  'menu.tms.vehicleType': 'Model',
  'menu.tmsMsg': 'Transportation',
  'menu.tmsMsg.shipbill': 'Loading List',
  'menu.tmsMsg.shipplanbill': 'Dispatch List',
  'menu.tmsMsg.storeHandover': 'Store Handover',
  'menu.tmsMsg.vehicle': 'Vehicle',
  'menu.tmsMsg.vehicleMonitoring': 'Vehicle Monitoring',
  'menu.wcs': 'WCS',
  'menu.wcs.agv': 'AGV',
  'menu.wcs.agv.agvin': 'Inventory Instruction',
  'menu.wcs.agv.agvinner': 'Internal Executive Instruction',
  'menu.wcs.agv.agvout': 'Outbound Order',
  'menu.wcs.asrs': 'AS/RS',
  'menu.wcs.dps': 'DPS',
  'menu.wcs.dps.ElectronicLabelLog': 'E-tag Log',
  'menu.wcs.dps.facilitiesMaintenance': 'Equipment Maintenance',
  'menu.wcs.dps.job': 'Electronic Label Picking Operation',
  'menu.wcs.dps.operationPoint': 'Basic Data Maintenance',
  'menu.wcs.dps.pickUpBillElectronicLabel': 'E-tag Printing',
  'menu.wcs.electronicBalance': 'Electronic Scale',
  'menu.wcs.hangWeight': 'Suspension Scale',
  'menu.wcs.hangWeight.hangWeightSowing': 'Hanging Weigh Distribution',
  'menu.wcs.packager': 'Packing Machine',
  'menu.wcs.packager.articleConsumable': 'Commodity Consumables',
  'menu.wcs.packager.consumable': 'Package Consumables',
  'menu.wcs.packager.instructBoard': 'Instruction Board',
  'menu.wcs.packager.packDeviceConfig': 'Packaging Machine Product Maintenance',
  'menu.wcs.print': 'Print',
  'menu.wcs.print.printplug': 'Print Plugin',
  'menu.wcs.sorter': 'Sorter',
  'menu.wcs.sorter.sortCrossing': 'Sorting Crossing',
  'menu.wcs.sorter.sortStrategy': 'Store Crossing Relationship Scheme',
  'menu.wcs.sorter.sortorder': 'Sorter Instruction Kanban',
  'menu.wcs.sorter.stockManage': 'Sorting Crossing Scheme',
  'moveBill.fromBin': 'source location',
  'moveBill.fromBinUsage': 'Source location purpose',
  'moveBill.fromContainer': 'Source container',
  'moveBill.fromWrh': 'Source of warehouse location',
  'moveBill.manageMoveType': 'Type in managing the warehouse shifting',
  'moveBill.moveType': 'Type of warehouse shifting',
  'moveBill.mover': 'Warehouse transferor',
  'moveBill.title': 'Transfer Order',
  'moveBill.toBin': 'target location',
  'moveBill.toBinUsage': 'Purpose of target location',
  'moveBill.toContainer': 'Target container',
  'moveBill.toWrh': 'Target warehouse location',
  'moveruleConfig.column.changeOwner': 'Whether to modify the owner',
  'moveruleConfig.column.fromBinUsage': 'Source location purpose',
  'moveruleConfig.column.targetOwnerType': 'Type of owners',
  'moveruleConfig.column.toBinUsage': 'Purpose of target location',
  'moveruleConfig.create.form.item.input.placeholder.fromBinUsage': 'Please enter the purposes of source location',
  'moveruleConfig.create.form.item.input.placeholder.toBinUsage': 'Please enter the purpose of target location',
  'moveruleConfig.modify': 'Modification',
  'moveruleConfig.not.modify': 'No modification',
  'moveruleConfig.title': 'Rules of warehouse shifting',
  'navBar.lang': 'Language',
  'notice.create.AllCOMPANY': 'All enterprises',
  'notice.create.CARRIER': 'All carriers',
  'notice.create.COMPANY': 'Enterprise',
  'notice.create.DC': 'All distribution center',
  'notice.create.HEADING': 'Heading',
  'notice.create.SELF': 'Mine',
  'notice.create.STORE': 'All stores',
  'notice.create.VENDOR': 'All suppliers',
  'notice.create.answer': 'Support the reply',
  'notice.create.attachment': 'Attachment',
  'notice.create.receiver': 'Recipient',
  'notice.create.receiver.placeholder': 'Please select Heading, store, distribution center, supplier and carrier',
  'notice.create.text': 'Main text',
  'notice.create.title': 'Title',
  'notice.create.upload': 'Upload attachment',
  'notice.create.uploadDescribe': 'Support the extension: .rar .zip .doc .docx .pdf .jpg..',
  'notice.create.uploadError': 'File upload failed',
  'notice.create.uploadSuccess': 'File upload succeeded',
  'notice.index.button.new': 'Go to publish',
  'notice.index.radioAll': 'all',
  'notice.index.radioReceived': 'My receipt',
  'notice.index.radiopublished': 'My distribution',
  'notice.inputTitle': 'Please enter the title',
  'notice.item.close': 'Click to return',
  'notice.item.download': 'Download attachment',
  'notice.item.hasReaded': 'Read',
  'notice.item.noAttachment': 'No attachment temporarily',
  'notice.item.open': 'Click to show',
  'notice.item.readedCount': 'Pcs read',
  'notice.item.reply': 'Reply',
  'notice.item.text.validate': 'The contents shall not be left blank and the length shall not be greater than 255.',
  'notice.item.unReaded': 'Not read',
  'notice.new': 'Create Notice',
  'notice.placeholder': 'Please enter',
  'notice.published': 'Released on',
  'notice.responsed': 'Reply you',
  'notice.title': 'Notice',
  'notice.title.new': 'Notice Release',
  'notice.type': 'Types',
  'notice.type.manage': 'Manage the type of notice',
  'notice.viewAll': 'Check all notices',
  'onlinehelp.title': 'Online Support And Maintenance',
  'orderBill.abort': 'Void',
  'orderBill.abort.confirm': 'Whether to make the order void',
  'orderBill.arrivalDate': 'Arrival date',
  'orderBill.articleAndSpec': 'Commodity/ commodity specification',
  'orderBill.articleCodeMessege': 'Commodity code',
  'orderBill.articleCount': 'total number of items',
  'orderBill.articleInfo': 'Commodity data',
  'orderBill.articleTableTitle': 'Commodity data',
  'orderBill.articles': 'Commodity in the order:',
  'orderBill.audit.confirm': 'Confirm to audit',
  'orderBill.audit.confirm.message': 'Are you sure to audit the inbound order? After passing the audit, start the collection',
  'orderBill.batch.fail': 'Fail in acquiring the batch import template',
  'orderBill.batchPricing': 'Pricing',
  'orderBill.beginReceiveUploadTime': 'Receiving and upload',
  'orderBill.bookedArticleCount': 'Items of pre-check',
  'orderBill.bookedQtyStr': 'Pcs appointed',
  'orderBill.createTime': 'Reception date',
  'orderBill.endReceiveUploadTime': 'End the receipt and upload',
  'orderBill.finish.confirm': 'Whether to complete the orders',
  'orderBill.isPricing': 'Whether to check the price',
  'orderBill.lastModified': 'Last modification date',
  'orderBill.loadNumber': 'Loading number',
  'orderBill.originalPrice': 'Original price',
  'orderBill.preCheck': 'Pre-inspection',
  'orderBill.preCheckedQtyStr': 'Number of pre-check pcs',
  'orderBill.price': 'Unit price',
  'orderBill.qpcPrice': 'Specification price',
  'orderBill.pricing': 'Pricing',
  'orderBill.pricingContent': 'Check it based on the original price',
  'orderBill.pricingSuccess': 'Check price successfully',
  'orderBill.qtyStrs': 'Number of pieces receivable/received in advance/actually received',
  'orderBill.receive': 'Order receiving',
  'orderBill.receivedAmount': 'Amount received',
  'orderBill.receivedAndAmount': 'Amount received/commodity amount',
  'orderBill.receivedAndQtyStr': 'Pcs received/commodity pcs',
  'orderBill.receivedArticleCount': 'Items received',
  'orderBill.receivedQtyStr': 'Pcs received',
  'orderBill.remove.confirm': 'Whether to delete the order',
  'orderBill.sourceBillNumber': 'Source No.',
  'orderBill.steps': 'Process schedule',
  'orderBill.stepsBeginReceiveTime': 'Time of starting collection',
  'orderBill.stepsCreateTime': 'Order receiving time',
  'orderBill.stepsEndReceiveTime': 'End the receiving time',
  'orderBill.stepsUploadTime': 'Upload date',
  'orderBill.title': 'Inbound order',
  'orderBill.totalReceivedVolume': 'Total volume received (m3)',
  'orderBill.totalReceivedWeight': 'Total weight received {kg)',
  'orderBill.totalVolume': 'Total volume (m3)',
  'orderBill.totalWeight': 'Total weight (kg)',
  'orderBill.type': 'Order type',
  'orderBill.validate.itemRepeat': '{line1} and {line2} are repeated for the order details',
  'orderBill.wrh': 'Inbound warehouse location',
  'owner.create.basic': 'Basic information',
  'owner.create.button.cancel': 'Cancel',
  'owner.create.button.confirm': 'OK',
  'owner.create.button.confirm.new': 'Confirm and Create',
  'owner.create.form.item.address.name': 'Address',
  'owner.create.form.item.address.validate.message.limitLength': 'The max length of the address is 100',
  'owner.create.form.item.address.validate.message.notNull': 'Address shall not be left blank',
  'owner.create.form.item.code.name': 'Code',
  'owner.create.form.item.code.validate.message.integrality': 'The code shall be four digits, alphanumeric combination, pure number or pure letter',
  'owner.create.form.item.code.validate.message.notNull': 'The code shall not be left blank',
  'owner.create.form.item.contactPhone.name': 'Contact information',
  'owner.create.form.item.contactPhone.validate.message.limitLength': 'The max length of the contact\'s phone number is 30',
  'owner.create.form.item.contactPhone.validate.message.notNull': 'Mobile number cannot be left blank',
  'owner.create.form.item.contactor.name': 'Contact person',
  'owner.create.form.item.contactor.validate.message.limitLength': 'The max length of the contact is 30',
  'owner.create.form.item.contactor.validate.message.notNull': 'The contact person cannot be left blank',
  'owner.create.form.item.homePage.name': 'Homepage',
  'owner.create.form.item.homePage.validate.message.limitLength': 'The max length of the homepage is 255',
  'owner.create.form.item.input.placeholder': 'Please enter',
  'owner.create.form.item.input.placeholder.address': 'Please enter the address',
  'owner.create.form.item.input.placeholder.code': 'Please enter the code',
  'owner.create.form.item.input.placeholder.contactPhone': 'Please enter the contact information',
  'owner.create.form.item.input.placeholder.contactor': 'Please enter contact',
  'owner.create.form.item.input.placeholder.homePage': 'Please enter the homepage',
  'owner.create.form.item.input.placeholder.name': 'Please enter 4 to 30 characters',
  'owner.create.form.item.input.placeholder.note': 'Please enter the remark',
  'owner.create.form.item.input.placeholder.shortName': 'Please enter the short name',
  'owner.create.form.item.input.placeholder.zipCode': 'Please enter the postal code',
  'owner.create.form.item.name.name': 'Name',
  'owner.create.form.item.name.validate.message.limitLength': 'The max length of title is 30.',
  'owner.create.form.item.name.validate.message.notNull': 'The name cannot be left blank',
  'owner.create.form.item.note.name': 'Remarks',
  'owner.create.form.item.note.validate.message.limitLength': 'The max length of the remarks is 255',
  'owner.create.form.item.shortName.name': 'Short name',
  'owner.create.form.item.shortName.validate.message.limitLength': 'The maximum length of short name is 30.',
  'owner.create.form.item.zipCode.name': 'Postal code',
  'owner.create.form.item.zipCode.validate.message.limitLength': 'The max length of the postal code is 30.',
  'owner.create.title': 'Create Owner',
  'owner.detail.basic': 'Basic information',
  'owner.detail.basic.address': 'Address',
  'owner.detail.basic.code': 'Code',
  'owner.detail.basic.contactPhone': 'Contact information',
  'owner.detail.basic.contactor': 'Contact person',
  'owner.detail.basic.homePage': 'Homepage',
  'owner.detail.basic.name': 'Name',
  'owner.detail.basic.note': 'Remarks',
  'owner.detail.basic.shortName': 'Short name',
  'owner.detail.basic.zipCode': 'Postal code',
  'owner.detail.button.back': 'Back',
  'owner.detail.button.cancel': 'Cancel',
  'owner.detail.button.confirm': 'OK',
  'owner.detail.label.edit': 'Edit',
  'owner.detail.tab.dclist': 'Scope of distribution center',
  'owner.detail.tab.operateInfo': 'Operation log',
  'owner.detail.tab.ownerInfo': 'Owner information',
  'owner.index.search.button.reset': 'Reset',
  'owner.index.search.button.search': 'Query',
  'owner.index.search.content.all': 'all',
  'owner.index.search.content.disable': 'Disabled',
  'owner.index.search.content.enable': 'Enabled',
  'owner.index.search.input.codeName': 'Owner code/title',
  'owner.index.search.input.codeName.placeholder': 'Please enter the keywords for inquiry',
  'owner.index.search.input.state': 'Status',
  'owner.index.search.input.state.placeholder': 'all',
  'owner.index.table.button.new': 'Create',
  'owner.index.table.column.code': 'Code',
  'owner.index.table.column.name': 'Name',
  'owner.index.table.column.operate': 'Operate',
  'owner.index.table.column.shortName': 'Short name',
  'owner.index.table.column.sourceWay': 'Source mode',
  'owner.index.table.column.state': 'Status',
  'owner.index.table.content.disable': 'Disabled',
  'owner.index.table.content.enable': 'Enabled',
  'owner.index.table.operate.edit': 'Edit',
  'owner.index.table.operate.view': 'Check',
  'owner.message.error.create': 'Failed to create the owner',
  'owner.message.error.disbale': 'Fail to disable the owner',
  'owner.message.error.enbale': 'Fail to enable the owner',
  'owner.message.error.update': 'Fail to modify the owner',
  'owner.message.success.create': 'Create the owner successfully',
  'owner.message.success.disable': 'Disable the owner successfully',
  'owner.message.success.enbale': 'Enable the owner successfully',
  'owner.message.success.update': 'Successfully modify the owner',
  'owner.title': 'Owner',
  'owner.update.title': 'Edit the owner',
  'pick.rpl.config.title': 'Replenishment configuration',
  'pick.type.title': 'Configuration',
  'pickArea.CASEANDSPLIT': 'Whole piece + dismantling',
  'pickArea.CASEORSPLIT': 'Whole piece/split',
  'pickArea.DT': 'Number of downward patches',
  'pickArea.IPopconfirmTitle': 'Whether to delete the picking partition',
  'pickArea.PICKING': 'Single outlet digital picking',
  'pickArea.PICKUPTPICK': 'Overall picking',
  'pickArea.STORAGE': 'Storage bit increase',
  'pickArea.STORAGET': 'Entire-pallet overall picking at the storage location',
  'pickArea.STORAGETPICK': 'Overall picking of backboard at the storage location',
  'pickArea.STOREANDPICK': 'Mixed overall picking',
  'pickArea.UT': 'Number of upward patches',
  'pickArea.WHOLEPICK': 'Entire pallet of single outlet',
  'pickArea.addPickInfo': '+ Add the order picking mode',
  'pickArea.adjustOrderNo': 'Sequence adjustment',
  'pickArea.allocateBinScope': 'Scope of distribution location',
  'pickArea.allocateMethod': 'Distribution tool',
  'pickArea.allocateSheme': 'Scheme of the store distribution location',
  'pickArea.allocateShemeNew': 'Allocate management scheme',
  'pickArea.allocateTransferBin': 'Transition during distribution',
  'pickArea.allocateType': 'Type of distribution location',
  'pickArea.basicDirectCollect': 'Whether the entire-pallet picking is directly collected',
  'pickArea.basicUnifyCollectTempBin': 'Temporary collection location',
  'pickArea.binScope': 'Scope of goods location:',
  'pickArea.containerType': 'Container Type',
  'pickArea.create.title': 'Create Picking Partition',
  'pickArea.create.title.case': 'Whole-piece configuration',
  'pickArea.create.title.split': 'Separation configuration',
  'pickArea.customPickBinOrder': 'User-defined picking route',
  'pickArea.directCollect': 'direct collection',
  'pickArea.index.create.button': 'Create',
  'pickArea.lastVolumeRate': 'Volume unit ratio (%)',
  'pickArea.maxArticleCount': 'HB/L items',
  'pickArea.maxVolume': 'HB/L volume (m3)',
  'pickArea.orderNo': 'S/N',
  'pickArea.pickBinOrderType': 'Picking route sequence',
  'pickArea.pickMethod': 'Picking mode',
  'pickArea.pickMode': 'Picking mode',
  'pickArea.pickTempBin': 'Picking staging',
  'pickArea.pickType': 'Pick Type',
  'pickArea.qtyStr': 'Single-outlet pcs',
  'pickArea.rplMethod': 'Replenishment algorithm',
  'pickArea.rplMethodExtend': 'Enhanced replenishment algorithm',
  'pickArea.rplMode': 'Replenishment mode',
  'pickArea.rplStep': 'Replenishment steps',
  'pickArea.rplTempBin': 'Temporary replenishment location',
  'pickArea.rplType': 'Replenishment type',
  'pickArea.storeArticleCount': 'Number of items in the single outlet',
  'pickArea.title': 'Picking Partition',
  'pickArea.tpickMethod': 'Tools of overall picking',
  'pickArea.unifyCollectTempBin': 'Temporary collection location',
  'pickArea.update.title': 'Edit the picking partition',
  'pickArea.wholeContainer': 'Whether it is the entire-pallet picking',
  'pickArea.wholePickMethod': 'Entire-pallet picking mode',
  'pickBinOrderConfig.pickOrder': 'Pick order',
  'pickBinOrderConfig.title': 'Picking sequence configuration of picking location',
  'pickInstruct.actualPickQtr': 'number of cases',
  'pickInstruct.actualPickQty': 'Actual Picking Quantity',
  'pickInstruct.addBookOrder': 'Create Appointment List',
  'pickInstruct.articleCountforPicking': 'Items to be picked',
  'pickInstruct.billNumber': 'Instruction No.',
  'pickInstruct.goodsGroup': 'Commodity group',
  'pickInstruct.inQpc': 'Specification',
  'pickInstruct.operator': 'Operator',
  'pickInstruct.pickQtr': 'Pieces to be picked',
  'pickInstruct.pickQty': 'Quantity pickable',
  'pickInstruct.pickSpeed': 'Picking progress (%)',
  'pickInstruct.pickViewTitle': 'Check the picking operation',
  'pickInstruct.pickarea': 'Picking Partition',
  'pickInstruct.picker': 'Picking staff',
  'pickInstruct.picking': 'fruit picking',
  'pickInstruct.pickupDepth': 'Picking depth',
  'pickInstruct.psTaskNumber': 'Task no.',
  'pickInstruct.realArticleCount': 'Number of items actually picked',
  'pickInstruct.realQty': 'Actual Picking Quantity',
  'pickInstruct.realQtyStr': 'number of cases',
  'pickInstruct.realStoreCount': 'Number of real-distribution store',
  'pickInstruct.realTaskCount': 'Number of actual-picking instruction',
  'pickInstruct.realTaskCountForSow': 'Number of actual distribution instruction',
  'pickInstruct.sow': 'sowing',
  'pickInstruct.sowSpeed': 'Distribution progress (%)',
  'pickInstruct.state': 'Status',
  'pickInstruct.storeCount': 'Number of the stores to be distributed',
  'pickInstruct.targetContainerBarcode': 'Target container',
  'pickInstruct.taskCount': 'Number of the instruction to be picked',
  'pickInstruct.taskCountForSow': 'Number of the instructions to be distributed',
  'pickInstruct.taskDrawerTitle': 'Task instruction',
  'pickInstruct.title': 'Picking Order',
  'pickInstruct.todoQty': 'Quantity pickable',
  'pickInstruct.todoQtyStr': 'Pieces to be picked',
  'pickInstruct.waveNumber': 'Wave no.',
  'pickOrder.addScheme': 'Create',
  'pickOrder.addStoreGroup': 'Add the store group',
  'pickOrder.addStorePickOrder': 'Add the store',
  'pickOrder.endOrder': 'en-结束顺序',
  'pickOrder.noData': 'No data temporarily',
  'pickOrder.orderNo': 'S/N',
  'pickOrder.pickOrderScheme': 'Pick Sequence Scheme',
  'pickOrder.progressTitle': 'Delete the picking sequence of the store',
  'pickOrder.progressWarn': 'Please tick, and then perform batch operations',
  'pickOrder.scheme': 'Picking scheme',
  'pickOrder.schemeCode': 'Program code',
  'pickOrder.schemeName': 'Scheme name',
  'pickOrder.startOrder': 'en-起始顺序',
  'pickOrder.storeGroupAdd': 'Newly added store group',
  'pickOrder.storeGroupTitle': 'Store group',
  'pickOrder.storeGroupUpdate': 'Modify the store group',
  'pickOrder.syn.line': 'Synchronous',
  'pickOrder.syn.line.Scheme': 'Synchronous route system scheme',
  'pickOrder.tabOperateInfoTitle': 'Operation log',
  'pickOrder.tabPickOrderTitle': 'Pick order',
  'pickOrder.title': 'Store\'s picking sequence',
  'pickOrder.validate.startOrderGreatEndOrder': 'en-拣货顺序起始顺序不能大于结束顺序',
  'pickSchema.column.caseBin': 'Whole-piece picking location',
  'pickSchema.column.splitBin': 'Separation picking location',
  'pickSchema.message.noDefaultQpcStr': 'There is no default specification of the commodity Failure to save',
  'pickScopeConfig.pickArea': 'Picking Partition',
  'pickScopeConfig.picker': 'Picking staff',
  'pickScopeConfig.pickerCodeAndName': 'Employee code or title',
  'pickScopeConfig.title': 'Operation configuration of the picking staff',
  'rawRequisitionPickerConfig.processTables': 'Processing table',
  'rawRequisitionPickerConfig.picker': 'Picker',
  'rawRequisitionPickerConfig.pickerCodeAndName': 'Employee code or title',
  'rawRequisitionPickerConfig.title': 'Operation configuration of the raw requisition picker',
  'pickUp.articleCount': 'Items to be picked',
  'pickUp.auditMessage': 'Confirm to audit',
  'pickUp.batchModifyOperate': 'Bulk modification of picking mode',
  'pickUp.batchModifyPickType': 'Bulk modification of picking type',
  'pickUp.binContain': 'Code of goods location included',
  'pickUp.containerBarcode': 'Picking container',
  'pickUp.containerBarcodeQty': 'Number of containers',
  'pickUp.electronicLabel': 'Electronic tags',
  'pickUp.endPickTime': 'End the picking time',
  'pickUp.isAudit': 'Print and audit',
  'pickUp.modifyOperate': 'Modify the picking mode',
  'pickUp.operate': 'Operation method',
  'pickUp.operateMethod': 'Picking mode',
  'pickUp.pickType': 'Pick Type',
  'pickUp.pickarea': 'Picking Partition',
  'pickUp.picker': 'Picking staff',
  'pickUp.pickerCodeEnter': 'Punch the card/enter the card number and confirm',
  'pickUp.price': 'Amount pickable',
  'pickUp.printLabel': 'Print the Label and Pick',
  'pickUp.printRecord': 'Printing records',
  'pickUp.qtyStr': 'Pieces to be picked',
  'pickUp.queryResult': 'Query result',
  'pickUp.realArticleCount': 'Number of items actually picked',
  'pickUp.realPrice': 'Actual-picking amount',
  'pickUp.realQtyStr': 'number of cases',
  'pickUp.realVolume': 'Actual picking volume (m3)',
  'pickUp.realWeight': 'Actually-picking weight (kg)',
  'pickUp.recalculate': 'Recalculate',
  'pickUp.sourceOperate': 'Current operation mode',
  'pickUp.startPickTime': 'Picking time',
  'pickUp.targetBinCode': 'target location',
  'pickUp.targetBinCodeUsage': 'Purpose of target location',
  'pickUp.targetContainerBarcode': 'Target container',
  'pickUp.targetOperate': 'Target operation mode',
  'pickUp.title': 'Picking List',
  'pickUp.volume': 'Volume pickable (m3)',
  'pickUp.waveBillNumber': 'Wave no.',
  'pickUp.weight': 'Pickable weight (kg)',
  'pickareaStorageConfig.column.binRange': 'Scope of goods location:',
  'pickareaStorageConfig.column.pickarea': 'Picking Partition',
  'pickareaStorageConfig.column.pickareaCode': 'Code of picking partition',
  'pickareaStorageConfig.column.pickareaCodeName': 'Code/name',
  'pickareaStorageConfig.column.pickareaName': 'Title of picking partition',
  'pickareaStorageConfig.create.title': 'Add',
  'pickareaStorageConfig.title': 'Configuration of storage scope in the picking partition',
  'planeMove.IPopconfirmAbortTitle': 'Are you sure to audit the plane move list',
  'planeMove.adjBinCodes': 'Suggested goods location',
  'planeMove.articleAndSpec': 'Commodity/ commodity specification',
  'planeMove.containerBarcodes': 'Including the container',
  'planeMove.containerBarcodesRule': 'The container barcode is separated by the comma.',
  'planeMove.endPlanMoveDate': 'End the time of translation',
  'planeMove.mover': 'Translation staff',
  'planeMove.qpcStrAndMunit': 'Package specification/unit',
  'planeMove.sourceBinCode': 'source location',
  'planeMove.sourceContainerBarcode': 'Source container',
  'planeMove.sourceWrh': 'Source of warehouse location',
  'planeMove.startPlanMoveDate': 'Starting time of translation',
  'planeMove.targetBinCode': 'target location',
  'planeMove.targetContainerBarcode': 'Target container',
  'planeMove.targetWrh': 'Target warehouse location',
  'planeMove.title': 'Plane move list',
  'planeMove.type': 'Type of translation',
  'plu码': 'Plu code',
  'pretype.back': 'Back',
  'pretype.create': 'Create',
  'pretype.create.form.item.input.limitLength.note': 'The max length of the note is 255',
  'pretype.create.form.item.input.placeholder.name': 'Please enter the name',
  'pretype.create.form.item.input.placeholder.note': 'Please enter the description',
  'pretype.create.form.item.name.validate.message.notNull': 'The title of type shall not be left blank',
  'pretype.create.form.name': 'Type name',
  'pretype.create.form.note': 'Note',
  'pretype.index.column.operate': 'Operate',
  'pretype.index.search.input.placeholder.pretype.name': 'Please enter the type and name for inquiry',
  'pretype.name': 'Name',
  'pretype.note': 'Note',
  'pretype.title': 'Types',
  'printerConfig.defaultPrintMethod': 'RF default printing method',
  'printerConfig.getPrinter': 'Acquire the printer',
  'printerConfig.printAddress': 'Printing service address',
  'printerConfig.shortName': 'Alias',
  'processBill.confirm.change': 'The details may be cleared if the {item} is changed Do you confirm to modify?',
  'processBill.confirm.clear': 'The details may be cleared if the {item} is modified Do you confirm to modify?',
  'processBill.containsBarCode': 'Container code included',
  'processBill.containsBinCode': 'Code of goods location included',
  'processBill.end': 'Finished product',
  'processBill.endInfoList': 'Details of finished products',
  'processBill.items': 'Details of processing list',
  'processBill.processScheme': 'Machining Scheme',
  'processBill.raw': 'Raw material',
  'processBill.rawInfoList': 'Details of raw materials',
  'processBill.spec': 'Specifications',
  'processBill.title': 'Work Order',
  'processBill.validate.cannotProcessPlan': 'The processing scheme shall be added',
  'processBill.validate.confirmTitleOnSave': 'There is no entry processing scheme, continue to save?',
  'processBill.validate.confirmTitleOnSaveAndAudit': 'There is no entry processing scheme, continue to save and audit?',
  'processBill.validate.itemNotLessZero': '{item} of {line} for the details of raw materials of processing list shall not be less than 0.',
  'processBill.validate.itemNotZero': '{item} of {line} for the details of raw materials of processing list shall not be 0.',
  'processBill.validate.itemRepeat': '{line1} and {line2} are repeated for the details of raw materials of processing list',
  'processBill.validate.itemRepeatend': '{line1} and {line2} are repeated for the details of finished products of processing list',
  'processBill.validate.noteTooLong': 'The max note length is 255 at the {line} in details of raw materials of processing list',
  'processBill.validate.realQtyTooBig': 'The actual pty at the {line} for details of raw materials of the processing list shall not exceed the quantity',
  'processTask.createTask': 'Generate tasks',
  'processTask.title': 'Generate the processing task',
  'processing.articleAndSpec': 'Commodity/ commodity specification',
  'processing.detail.tab.dclist': 'Scope of distribution center',
  'processing.endproduct.article': 'Finished product',
  'processing.endproduct.article.codes': 'Code of finished products',
  'processing.raw.article': 'Raw material commodity',
  'processing.raw.article.codes': 'Code of raw material commodity',
  'processing.scheme.title': 'Machining Scheme',
  'putaway.IPopconfirmDeleteTitle': 'Confirm deletion',
  'putaway.adjBinCodes': 'Suggested goods location',
  'putaway.articleAndSpec': 'Commodity/ commodity specification',
  'putaway.auditMessage': 'Are you sure to audit the put away list?',
  'putaway.endTime': 'Time to end adding',
  'putaway.putawayBillType': 'Type of objects added',
  'putaway.putawayer': 'Putaway clerk',
  'putaway.sourceBin': 'source location',
  'putaway.sourceBinUsage': 'Source location purpose',
  'putaway.sourceContainerBar': 'Source container',
  'putaway.spec': 'Package specification',
  'putaway.startTime': 'Start the release time',
  'putaway.stockTableTitle': 'Inventory information',
  'putaway.targetBin': 'target location',
  'putaway.targetBinUsage': 'Purpose of target location',
  'putaway.targetContainerBar': 'Target container',
  'putaway.title': 'Put Away List',
  'receive.allArticles': 'total number of items',
  'receive.article': 'Commodity',
  'receive.article.placeholder': 'The codes shall be separated by commas',
  'receive.audit.confirm': 'Are you sure to audit the receiving note?',
  'receive.businessInfo': 'Business Information',
  'receive.endReceiveTime': 'End the receiving time',
  'receive.method': 'Receiving mode',
  'receive.overReceive': 'Commodity: {articleCode} The excessive receiving proportion is 0 and the excessive receiving is not allowed',
  'receive.receiver': 'consignee',
  'receive.remove.confirm': 'Are you sure to delete the receiving note?',
  'receive.startReceiveTime': 'Time of starting collection',
  'receive.targetBin': 'target location',
  'receive.targetBinCode': 'Code of target location',
  'receive.title': 'Receiving Note',
  'receive.type': 'Receiving type',
  'refund.received': 'The return exists Do you allow the receipt',
  'releaseContent.operate': 'Operate',
  'releaseContent.placeholder.search': 'Please enter the title of release contents to inquiry',
  'releaseContent.title': 'Release contents',
  'report.baisc.directory.name': 'Catalog name',
  'report.basic.directory.name.validate.message.limitLength': 'The max length of catalog is 30.',
  'report.basic.directory.name.validate.message.notNull': 'The title of directory shall not be left blank',
  'report.basic.report.name': 'Name of statement',
  'report.basic.report.name.validate.message.limitLength': 'The max length of statement is 30.',
  'report.basic.report.name.validate.message.notNull': 'The title of statement shall not be left blank',
  'report.basic.report.path': 'Template path',
  'report.basic.report.path.validate.message.limitLength': 'The max length of template path is 30.',
  'report.display': 'Display terminal',
  'report.display.validate.message.notNull': 'Display terminal shall not be left blank',
  'report.headingReport': 'Heading statement',
  'report.new.directory': 'Create Directory',
  'report.import': 'Import',
  'report.export': 'Export',
  'report.new.report': 'Create Report',
  'report.no': 'No',
  'report.note': 'Remarks',
  'report.note.validate.message.limitLength': 'The max length of notes is 100',
  'report.title': 'Report load',
  'report.yes': 'Yes',
  'role.addUser.search.placeholder': 'Member code/User name',
  'role.addUser.title': 'Add user',
  'role.create.form.item.code.validate.message.integrality': 'The code shall be four digits, alphanumeric combination, pure number or pure letter',
  'role.create.form.item.code.validate.message.limitLength': 'The max length of code is 30',
  'role.create.form.item.code.validate.message.notNull': 'The code shall not be left blank',
  'role.create.form.item.name.validate.message.limitLength': 'The max length of title is 30.',
  'role.create.form.item.name.validate.message.notNull': 'The name cannot be left blank',
  'role.create.form.item.placeholder': 'Please enter',
  'role.create.title': 'Create Role',
  'role.edit.title': 'Modify role',
  'role.index.button.addUser': 'Add user',
  'role.index.button.batchDelete': 'Remove',
  'role.index.button.delete': 'Delete',
  'role.index.button.modify': 'Modification',
  'role.index.button.new': 'Create',
  'role.index.button.newRole': 'Create Role',
  'role.index.disable': 'Disabled',
  'role.index.enable': 'Enabled',
  'role.index.tab.permissionInfo': 'Permission information',
  'role.index.tab.userInfo': 'User information',
  'role.index.table.column.code': 'Code',
  'role.index.table.column.name': 'Name',
  'role.index.table.column.operate': 'Operate',
  'role.index.table.column.phone': 'Tel.',
  'role.index.table.operate.delete': 'Remove',
  'role.message.error.addUser': 'Failed to add, please try again',
  'role.message.error.fetchUserInfo': 'Fail to acquire the role information',
  'role.message.success.addUser': 'Successfully add the user',
  'role.title': 'Role',
  'rpl.currentMode': 'Current operation mode',
  'rpl.endRplTime': 'End the replenishment time',
  'rpl.fromBinCode': 'source location',
  'rpl.fromBinCodes': 'Code of goods location included',
  'rpl.fromContainerBarCode': 'Source container',
  'rpl.genFrom': 'Replenishment source',
  'rpl.mode': 'Replenishment mode',
  'rpl.modifyMode': 'Modify the replenishment mode',
  'rpl.pickArea': 'Picking Partition',
  'rpl.rpler': 'Replenishment personnel',
  'rpl.startRplTime': 'Time of replenishment',
  'rpl.step': 'Replenishment steps',
  'rpl.targetMode': 'Target operation mode',
  'rpl.title': 'Replenishment List',
  'rpl.toBinCode': 'target location',
  'rpl.toBinCodes': 'Code of goods location included',
  'rpl.type': 'Replenishment type',
  'rpl.waveBillNumber': 'Wave no.',
  'rtnPutaway.column.method': 'Operation method',
  'rtnPutaway.column.sourceBin': 'source location',
  'rtnPutaway.column.targetBin': 'target location',
  'rtnPutaway.putAwayer': 'Putaway clerk',
  'rtnPutaway.sourceContainer': 'Source container',
  'rtnPutaway.targetContainer': 'Target container',
  'rtnPutaway.title': 'Return Put Away List',
  'senseCheck.checkDate': 'Quality inspection time',
  'senseCheck.checkResult': 'Quality inspection results',
  'senseCheck.checkType': 'Type of quality inspection',
  'senseCheck.checker': 'Quality inspector',
  'senseCheck.sense': 'Items of sensory quality inspection',
  'senseCheck.title': 'Sensory Quality Check Sheet',
  'sowingPickUpBill.allocateType': 'Type of distribution',
  'sowingPickUpBill.binContain': 'Code of goods location included',
  'sowingPickUpBill.collectBin': 'Goods location',
  'sowingPickUpBill.collectTempBin': 'Temporary collection location',
  'sowingPickUpBill.crossAllocateBin': 'Transition during distribution',
  'sowingPickUpBill.endPickTime': 'End the picking time',
  'sowingPickUpBill.endSowingTime': 'Time of completion of digital assorting',
  'sowingPickUpBill.pickQty': 'Quantity pickable',
  'sowingPickUpBill.pickQtyStr': 'Pieces to be picked',
  'sowingPickUpBill.pickTempBin': 'Picking staging',
  'sowingPickUpBill.pickTime': 'Picking time',
  'sowingPickUpBill.pickType': 'Picking mode',
  'sowingPickUpBill.pickarea': 'Picking Partition',
  'sowingPickUpBill.picker': 'Picking staff',
  'sowingPickUpBill.realPickQty': 'Actual Picking Quantity',
  'sowingPickUpBill.realPickQtyStr': 'number of cases',
  'sowingPickUpBill.realSowingQtyStr': 'Total actually pcs of distribution',
  'sowingPickUpBill.sourceBinCode': 'source location',
  'sowingPickUpBill.sourceContainerBarcode': 'Source container',
  'sowingPickUpBill.sower': 'Distribution staff',
  'sowingPickUpBill.sowingItems': 'Distribution details',
  'sowingPickUpBill.sowingMethod': 'Distribution method',
  'sowingPickUpBill.sowingPickStockItems': 'Details of distribution inventory',
  'sowingPickUpBill.sowingQtyStr': 'Pcs to be distributed',
  'sowingPickUpBill.sowingState': 'Distribution status',
  'sowingPickUpBill.sowingTime': 'Distribution time',
  'sowingPickUpBill.startPickTime': 'Picking time',
  'sowingPickUpBill.startSowingTime': 'Time of digital assorting',
  'sowingPickUpBill.storeSowingBin': 'Store distribution',
  'sowingPickUpBill.sumPickMethod': 'total way',
  'sowingPickUpBill.summaryPickItems': 'Picking details',
  'sowingPickUpBill.summaryPickMethod': 'Overall picking mode',
  'sowingPickUpBill.summaryPickStockItems': 'Details of picking inventory',
  'sowingPickUpBill.summaryState': 'Status of overall picking',
  'sowingPickUpBill.summaryType': 'Type of overall picking',
  'sowingPickUpBill.targetBinCode': 'target location',
  'sowingPickUpBill.targetContainerBarcode': 'Target container',
  'sowingPickUpBill.title': 'Digital Assorting Picking List',
  'sowingPickUpBill.totalRealSowingArticleCount': 'Total items of actual distribution',
  'sowingPickUpBill.totalRealSowingQtyStr': 'Total actually pcs of distribution',
  'sowingPickUpBill.totalRealSowingStoreCount': 'Total stores of actual distribution',
  'sowingPickUpBill.totalRealSowingVolume': 'Total actually distribution volume',
  'sowingPickUpBill.totalRealSowingWeight': 'Total actual distribution weight',
  'sowingPickUpBill.totalRealSummaryArticleCount': 'Total items of overall picking of actual distribution',
  'sowingPickUpBill.totalRealSummaryQtyStr': 'Total actual pcs in overall picking',
  'sowingPickUpBill.totalRealSummaryVolume': 'Total actual volume in overall picking',
  'sowingPickUpBill.totalRealSummaryWeight': 'Total actual weight in overall picking',
  'sowingPickUpBill.totalSowingArticleCount': 'Total items of distribution',
  'sowingPickUpBill.totalSowingQtyStr': 'Total pcs of distribution',
  'sowingPickUpBill.totalSowingStoreCount': 'Total stores of distribution',
  'sowingPickUpBill.totalSowingVolume': 'Total distribution volume',
  'sowingPickUpBill.totalSowingWeight': 'Total weight of distribution',
  'sowingPickUpBill.totalSummaryArticleCount': 'Total items in overall picking',
  'sowingPickUpBill.totalSummaryQtyStr': 'Total pcs in overall picking',
  'sowingPickUpBill.totalSummaryVolume': 'Total volume in overall picking',
  'sowingPickUpBill.totalSummaryWeight': 'Total weight in overall picking',
  'sowingPickUpBill.waveBillNumber': 'Wave no.',
  'start.test': 'Start test',
  'start.test.success': 'Start test successfully',
  'start.work': 'Start operation',
  'start.work.success': 'Successful start operation',
  'stevedorestate.title': 'Unloading',
  'stockBatch.configInfo': 'Configuration information',
  'stockBatch.dateLength': 'Date length',
  'stockBatch.flowLength': 'Serial number length',
  'stockBatch.operate.info': 'Operation log',
  'stockLockBill.IPopconfirmDeleteTitle': 'Confirm deletion',
  'stockLockBill.articleAndSpec': 'Commodity/ commodity specification',
  'stockLockBill.articleInfo': 'Commodity data',
  'stockLockBill.auditMessage': 'Confirm to audit the inventory locking list',
  'stockLockBill.billItem.notNull.message': 'The details of the inventory locking and unlocking list shall not be left blank',
  'stockLockBill.bin': 'Goods Location',
  'stockLockBill.lockBill': 'Inventory locking list',
  'stockLockBill.locker': 'Operator',
  'stockLockBill.ownerChange.moda.message': 'Modifying the owner will cause the details to be cleared. Please confirm the modification?',
  'stockLockBill.reason': 'Cause',
  'stockLockBill.reasonButton': 'Locking and unlocking reason',
  'stockLockBill.reasonTitle': 'Locking and unlocking reason',
  'stockLockBill.title': 'Locking and Unlocking List',
  'stockLockBill.type': 'Document type',
  'stockLockBill.typeChange.modal.message': 'The details may be cleared after the type of the document is modified Do you confirm to modify?',
  'stockOrder.addScheme': 'Create Scheme',
  'stockOrder.addStore': 'Add the store',
  'stockOrder.addStoreGroup': 'Add the store group',
  'stockOrder.down': 'Move down',
  'stockOrder.order': 'Sequence',
  'stockOrder.orderNo': 'S/N',
  'stockOrder.progressTitle': 'Delete the inventory allocation sequence of the store',
  'stockOrder.progressWarn': 'Please tick, and then perform batch operations',
  'stockOrder.scheme': 'Allocation scheme',
  'stockOrder.schemeCode': 'Program code',
  'stockOrder.schemeName': 'Scheme name',
  'stockOrder.storeGroupAdd': 'Newly added store group',
  'stockOrder.storeGroupTitle': 'Store group',
  'stockOrder.storeGroupUpdate': 'Modify the store group',
  'stockOrder.storeStockOrderTitle': 'Inventory allocation sequence of the store',
  'stockOrder.success': 'Succeeded',
  'stockOrder.tabStockOrderTitle': 'inventory allocation sequence',
  'stockOrder.title': 'Inventory Allocation Scheme',
  'stockOrder.up': 'Move up',
  'stockOutConfig.stockAllocateScheme': 'Scheme of inventory allocation scheme',
  'stockOutConfig.stockAllocateType': 'Type of inventory allocation',
  'stockOutConfig.title': 'Scheme of out-of-stock inventory allocation',
  'stockTakePlan.articleScope': 'Commodity scope',
  'stockTakePlan.change': 'Sales promotion',
  'stockTakePlan.changeTimes': 'Times',
  'stockTakePlan.conditionInfo.byBinUsage': 'Purpose of goods location',
  'stockTakePlan.conditionInfo.byPath': 'cargo lane',
  'stockTakePlan.conditionInfo.byPickArea': 'Picking Partition',
  'stockTakePlan.conditionInfo.byZone': 'Goods area',
  'stockTakePlan.conditionInfo.message.notNull': 'HB/L basis shall not be left blank',
  'stockTakePlan.existStock': 'The inventory exists',
  'stockTakePlan.maxBillCount': 'Max number of the document',
  'stockTakePlan.maxBinCount': 'Max number of goods location',
  'stockTakePlan.maxBinCount.message.notNull': 'The quantity cannot be left blank',
  'stockTakePlan.owner.message.notNull': 'The owner shall not be left blank',
  'stockTakePlan.splitCondition': 'HB/L conditions',
  'stockTakePlan.splitCondition.message.notNull': 'HB/L conditions shall not be left blank',
  'stockTakePlan.startDate': 'Date of sales promotion',
  'store.create.basic': 'Basic information',
  'store.create.button.cancel': 'Cancel',
  'store.create.button.confirm': 'OK',
  'store.create.button.confirm.new': 'Confirm and Create',
  'store.create.form.item.address.name': 'Address of store',
  'store.create.form.item.address.validate.message.limitLength': 'The max length of the address is 100',
  'store.create.form.item.address.validate.message.notNull': 'Address shall not be left blank',
  'store.create.form.item.code.name': 'Store code',
  'store.create.form.item.code.validate.message.integrality': 'The code shall be four digits, alphanumeric combination, pure number or pure letter',
  'store.create.form.item.code.validate.message.notNull': 'The code shall not be left blank',
  'store.create.form.item.contactPhone.name': 'Contact information',
  'store.create.form.item.contactPhone.validate.message.limitLength': 'The max length of the contact tel. is 30',
  'store.create.form.item.contactPhone.validate.message.notNull': 'Mobile number cannot be left blank',
  'store.create.form.item.contactor.name': 'Contact person',
  'store.create.form.item.contactor.validate.message.limitLength': 'The max length of the contact is 30',
  'store.create.form.item.contactor.validate.message.notNull': 'The contact person cannot be left blank',
  'store.create.form.item.distance.name': 'Distance from warehouse',
  'store.create.form.item.distance.unit': 'Km',
  'store.create.form.item.distance.validate.message.greaterThanZero': 'The distance from warehouse shall be greater than 0.',
  'store.create.form.item.homeUrl.name': 'Homepage',
  'store.create.form.item.homeUrl.validate.message.limitLength': 'The max length on the homepage is 100',
  'store.create.form.item.input.placeholder': 'Please enter',
  'store.create.form.item.input.placeholder.address': 'Please enter the specific address',
  'store.create.form.item.input.placeholder.addressChoose': 'Please select the  district/city/province/country',
  'store.create.form.item.input.placeholder.code': 'Please enter 4 digits or letters',
  'store.create.form.item.input.placeholder.contactPhone': 'Please enter the contact information',
  'store.create.form.item.input.placeholder.contactor': 'Please enter contact',
  'store.create.form.item.input.placeholder.distance': 'Please enter the distance from the owner\'s warehouse',
  'store.create.form.item.input.placeholder.homeUrl': 'Please enter the homepage',
  'store.create.form.item.input.placeholder.inputNumber': 'Please enter the number greater than 0',
  'store.create.form.item.input.placeholder.name': 'Please enter 4 to 30 characters',
  'store.create.form.item.input.placeholder.note': 'Please enter additional remarks for this store It shall not be more than 255 words',
  'store.create.form.item.input.placeholder.operatingArea': 'Please enter the operating area',
  'store.create.form.item.input.placeholder.shortName': 'Please enter the short name',
  'store.create.form.item.input.placeholder.zipCode': 'Please enter the postal code of the store\'s address',
  'store.create.form.item.name.name': 'Name of the store',
  'store.create.form.item.name.validate.message.limitLength': 'The max length of title is 30.',
  'store.create.form.item.name.validate.message.notNull': 'The name cannot be left blank',
  'store.create.form.item.note.name': 'Remarks',
  'store.create.form.item.note.validate.message.limitLength': 'The max length of the remarks is 255',
  'store.create.form.item.operatingArea.name': 'Operation area',
  'store.create.form.item.operatingArea.unit': 'm2',
  'store.create.form.item.operatingArea.validate.message.greaterThanZero': 'The operation area shall be greater than 0.',
  'store.create.form.item.operatingType.name': 'Business type',
  'store.create.form.item.operatingType.validate.message.notNull': 'The type of store management shall not be left blank',
  'store.create.form.item.owner.name': 'Owner',
  'store.create.form.item.owner.validate.message.limitLength': 'The max length of the owner is 30.',
  'store.create.form.item.owner.validate.message.notNull': 'The owner shall not be left blank',
  'store.create.form.item.select.placeholder': 'please choose',
  'store.create.form.item.select.placeholder.operatingType': 'Please select the business type of the store',
  'store.create.form.item.select.placeholder.owner': 'Please select the owner',
  'store.create.form.item.select.placeholder.storeType': 'Please select a store format',
  'store.create.form.item.shortName.name': 'Short name',
  'store.create.form.item.shortName.validate.message.limitLength': 'The maximum length of short name is 30.',
  'store.create.form.item.shortName.validate.message.notNull': 'The short name cannot be left blank',
  'store.create.form.item.sourceWay.name': 'Source mode',
  'store.create.form.item.state.name': 'Status',
  'store.create.form.item.storeType.name': 'Store format',
  'store.create.form.item.storeType.validate.message.limitLength': 'Maximum length of store format 30',
  'store.create.form.item.storeType.validate.message.notNull': 'Store format cannot be empty',
  'store.create.form.item.zipCode.name': 'Postal code',
  'store.create.form.item.zipCode.validate.message.limitLength': 'The max length of the postal code is 30.',
  'store.create.form.item.zipCode.validate.message.notNull': 'The postcode cannot be left blank',
  'store.create.title': 'Create Store',
  'store.detail.basic': 'Basic information',
  'store.detail.basic.address': 'Address',
  'store.detail.basic.code': 'Code',
  'store.detail.basic.contactPhone': 'Contact information',
  'store.detail.basic.contactor': 'Contact person',
  'store.detail.basic.distance': 'Distance from warehouse (km)',
  'store.detail.basic.homeUrl': 'Homepage',
  'store.detail.basic.name': 'Name',
  'store.detail.basic.note': 'Remarks',
  'store.detail.basic.operatingArea': 'Operation area (㎡)',
  'store.detail.basic.operatingType': 'Business type',
  'store.detail.basic.owner': 'Owner',
  'store.detail.basic.shortName': 'Short name',
  'store.detail.basic.type': 'store format',
  'store.detail.basic.zipCode': 'Postal code',
  'store.detail.button.back': 'Back',
  'store.detail.button.cancel': 'Cancel',
  'store.detail.button.confirm': 'OK',
  'store.detail.label.edit': 'Edit',
  'store.detail.tab.dclist': 'Scope of distribution center',
  'store.detail.tab.operateInfo': 'Operation log',
  'store.detail.tab.storeInfo': 'Store information',
  'store.import.title': 'Import stores',
  'store.index.search.button.close': 'Pack up',
  'store.index.search.button.more': 'Display more',
  'store.index.search.button.reset': 'Reset',
  'store.index.search.button.search': 'Query',
  'store.index.search.content.disable': 'Disabled',
  'store.index.search.content.enable': 'Enabled',
  'store.index.search.input.codeName': 'Store code/title',
  'store.index.search.input.codeName.placeholder': 'Please enter the keywords for inquiry',
  'store.index.search.input.operatingType': 'Business type',
  'store.index.search.input.placeholder': 'all',
  'store.index.search.input.state': 'Status',
  'store.index.search.input.storeType': 'Types',
  'store.index.table.button.new': 'Create',
  'store.index.table.column.code': 'Code',
  'store.index.table.column.name': 'Name',
  'store.index.table.column.operate': 'Operate',
  'store.index.table.column.operatingType': 'Business type',
  'store.index.table.column.shortName': 'Short name',
  'store.index.table.column.sourceWay': 'Source mode',
  'store.index.table.column.state': 'Status',
  'store.index.table.column.storeType': 'Store format',
  'store.index.table.content.disable': 'Disabled',
  'store.index.table.content.enable': 'Enabled',
  'store.index.table.operate.edit': 'Edit',
  'store.index.table.operate.view': 'Check',
  'store.manage. operateType': 'Manage the business type of the store',
  'store.manage.type': 'Manage the store format',
  'store.message.error.create': 'Fail to newly establish the stores ',
  'store.message.error.disbale': 'Fail to disable the store',
  'store.message.error.enbale': 'Fail to enable the store',
  'store.message.error.update': 'Fail to modify the store',
  'store.message.success.create': 'Newly establish the stores successfully ',
  'store.message.success.disable': 'Disable the store successfully',
  'store.message.success.enbale': 'Enable the store successfully',
  'store.message.success.update': 'Successfully modify the store',
  'store.name': 'Store',
  'store.operating': 'Store manament',
  'store.title': 'Store',
  'store.update.title': 'Edit the store',
  'storeAllocation.allocation': 'Distribution location',
  'storeAllocation.createTitle': 'New addition of distribution location of store',
  'storeAllocation.select': 'Drop-down box of the store',
  'storeAllocation.selectAllocation': 'Drop-down box of the distribution location',
  'storeAllocation.store': 'Store',
  'storeAllocation.title': 'Configuration of the distribution location of store',
  'storeAllocationScheme.addStore': 'Add the store',
  'storeAllocationScheme.batchConfig': 'Bulk setting',
  'storeAllocationScheme.progressTitle': 'Delete the distribution location of the store',
  'storeAllocationScheme.storeAllocation': 'Store distribution',
  'storeAllocationScheme.title': 'Scheme of the store distribution location',
  'storeGroupConfig.storeGroup': 'Store group',
  'storeGroupConfig.title': 'Configuration of the store group',
  'storeRtn.button.batchRefreshContainer': 'Bulk setting of target container',
  'storeRtn.button.batchRefreshType': 'Bulk setting of the return type',
  'storeRtn.column.articleCount': 'total number of items',
  'storeRtn.column.method': 'Operation method',
  'storeRtn.column.rtner': 'liquidator',
  'storeRtn.column.targetBin': 'target location',
  'storeRtn.column.type': 'Type of return',
  'storeRtn.rtnNtcBillNumber': 'Notice No.',
  'storeRtn.title': 'Return List',
  'storeRtnNtc.button.copy': 'Copy',
  'storeRtnNtc.button.manageLessBackReason': 'Manage the less-return reason',
  'storeRtnNtc.button.manageReason': 'Manage the return reason',
  'storeRtnNtc.button.manageType': 'Manage the type of warehouse return',
  'storeRtnNtc.button.rtnWrh': 'Return',
  'storeRtnNtc.column.expireDate': 'Expiry time',
  'storeRtnNtc.column.reason': 'Return reason',
  'storeRtnNtc.column.rtnDate': 'Return time',
  'storeRtnNtc.column.sourceBillNumber': 'Source No.',
  'storeRtnNtc.column.type': 'Type of return',
  'storeRtnNtc.detail.tab.batch': 'Batch',
  'storeRtnNtc.detail.tab.pieces': 'Pcs',
  'storeRtnNtc.detail.tab.quantity': 'Quantity',
  'storeRtnNtc.detail.tab.realPieces': 'Number of actually-returned pcs',
  'storeRtnNtc.detail.tab.realQuantity': 'Actually-returned quantity',
  'storeRtnNtc.detail.tab.uploadTime': 'Upload time',
  'storeRtnNtc.title': 'Return Notice List',
  'superManagementBoard.ValidIdentification': 'Valid mark',
  'superManagementBoard.add': 'Add',
  'superManagementBoard.articleCodeName': 'Commodity',
  'superManagementBoard.batchInvalid': 'Invalid batch',
  'superManagementBoard.billTitle': 'Over-insured policy',
  'superManagementBoard.date': 'Date',
  'superManagementBoard.endDate': 'Expiry date',
  'superManagementBoard.invalid': 'Invalid',
  'superManagementBoard.newControlDays': 'New control days',
  'superManagementBoard.oldControlDays': 'Original control days',
  'superManagementBoard.operateTime': 'Operation duration',
  'superManagementBoard.operator': 'Operator',
  'superManagementBoard.shelf': 'Days of guarantee period',
  'superManagementBoard.shelfType': 'Type of guarantee period',
  'superManagementBoard.startDate': 'Starting date',
  'superManagementBoard.startToEndDate': 'Start & expiry date',
  'superManagementBoard.title': 'Over-insured Board',
  'superManagementBoard.type': 'Over-insured type',
  'superManagementBoard.valid': 'efficient',
  'tag.start.address': 'The label range must be 4 digits',
  'taskScopeConfig.binRange': 'Scope of goods location:',
  'taskScopeConfig.binRange.notAllNull': 'Not all scopes of goods location are left blank',
  'taskScopeConfig.manualSelectionType': 'Type of manually-selected instruction',
  'taskScopeConfig.orderNo': 'S/N',
  'taskScopeConfig.priority.alreadyFirst': 'The current record priority has been the highest',
  'taskScopeConfig.priority.upSuccess': 'Successful adjustment of priority',
  'taskScopeConfig.priority.validate': 'Fail to delete the priority of the current record',
  'taskScopeConfig.taskType': 'Operation instructions',
  'taskScopeConfig.tasker': 'High-level forklift worker',
  'taskScopeConfig.taskerCodeAndName': 'Employee code or title',
  'taskScopeConfig.title': 'Operation configuration of the high-level forklift worker',
  'user.authorize.form.item.resources.name': 'Permission',
  'user.authorize.form.item.role.name': 'Role',
  'user.authorize.form.item.role.placeholder': 'Please Select a role',
  'user.authorize.title': 'Authorization',
  'user.create.form.item.code.name': 'Code',
  'user.create.form.item.code.validate.message.limitLength': 'The max length of code is 30',
  'user.create.form.item.code.validate.message.notNull': 'The code shall not be left blank',
  'user.create.form.item.input.placeholder': 'Please enter',
  'user.create.form.item.name.name': 'Name',
  'user.create.form.item.name.validate.message.limitLength': 'The max length of title is 30.',
  'user.create.form.item.name.validate.message.notNull': 'The name cannot be left blank',
  'user.create.form.item.org.name': 'Organization',
  'user.create.form.item.org.validate.message.required': 'Required item of organization',
  'user.create.form.item.phone.name': 'Phone number',
  'user.create.form.item.phone.validate.message.integrality': 'Please enter the real phone number',
  'user.create.form.item.phone.validate.message.notNull': 'Mobile number cannot be left blank',
  'user.create.form.item.role.name': 'Role',
  'user.create.form.item.role.validate.message.required': 'Role required',
  'user.create.form.item.select.placeholder': 'please choose',
  'user.create.title': 'Create User',
  'user.detail.basic': 'Basic information',
  'user.detail.basic.code': 'Code',
  'user.detail.basic.name': 'Name',
  'user.detail.basic.phone': 'Phone number',
  'user.detail.button.back': 'Back to search',
  'user.detail.org': 'Organization',
  'user.detail.org.disable': 'Disable',
  'user.detail.org.enable': 'Enable',
  'user.detail.org.table.column.code': 'Organization code',
  'user.detail.org.table.column.name': 'Name of organization',
  'user.detail.org.table.column.operate': 'Operate',
  'user.detail.org.table.column.status': 'Status',
  'user.detail.org.table.column.type': 'Organization type',
  'user.detail.role': 'Role list',
  'user.detail.role.offline': 'Disabled',
  'user.detail.role.online': 'Enabled',
  'user.detail.role.table.column.code': 'Role code',
  'user.detail.role.table.column.name': 'Role name',
  'user.detail.role.table.column.status': 'Role status',
  'user.forget.againPassword': '6-16 digit passwords, case sensitive',
  'user.forget.confirm-password.required': 'Confirm the password',
  'user.forget.confirm-password.required.notnull': 'The confirmed passwords cannot be left blank',
  'user.forget.find.password': 'Retrieve password',
  'user.forget.get-verification-code': 'Get verification code',
  'user.forget.password.setting.success': 'Succeed in setting passwords',
  'user.forget.phone-number.placeholder': '11-digit mobile phone number',
  'user.forget.phone-number.required': 'Please enter the phone number',
  'user.forget.phone-number.wrong-format': 'format error of phone number',
  'user.forget.placeholder': 'At least 6-digit passwords, case sensitive',
  'user.forget.register.sing-in': 'Log in the existing account',
  'user.forget.second': 'Second',
  'user.forget.sure': 'OK',
  'user.forget.twice.pwd.not.same': 'Inconsistent passwords',
  'user.forget.validation.password.required': 'The login passwords cannot be left blank',
  'user.forget.verification-code.required': 'Please enter the verification code',
  'user.index.search.button.reset': 'Reset',
  'user.index.search.button.search': 'Query',
  'user.index.search.input.code': 'Code',
  'user.index.search.input.code.placeholder': 'Please enter',
  'user.index.search.input.name': 'Name',
  'user.index.search.input.name.placeholder': 'Please enter',
  'user.index.table.button.batchDelete': 'Delete',
  'user.index.table.button.new': 'Create',
  'user.index.table.column.code': 'Code',
  'user.index.table.column.name': 'Username',
  'user.index.table.column.operate': 'Operate',
  'user.index.table.column.phone': 'Phone number',
  'user.index.table.operate.authorize': 'Authorization',
  'user.index.table.operate.confirmDelete': 'Are you sure to delete?',
  'user.index.table.operate.delete': 'Delete',
  'user.index.table.operate.edit': 'Edit',
  'user.modify.checkOrg.success': 'Successful switch of organization',
  'user.modify.ckeckPassword': 'The password shall be the combination of 6-16 numbers, letters and symbols',
  'user.modify.new.password': 'Please enter the new passwords',
  'user.modify.new.password.label': 'New password',
  'user.modify.new.password.sure': 'Reconfirm new passwords',
  'user.modify.old.password': 'Please enter the original passwords',
  'user.modify.old.password.label': 'Original password',
  'user.modify.password.success': 'Modified',
  'user.modify.twice.pwd.not.same': 'Inconsistent passwords',
  'user.title': 'Users',
  'user.update.title': 'Modify the user',
  'validation.againPassword.required': 'The confirmed passwords cannot be left blank',
  'validation.confirm-password.required': 'Please confirm the password',
  'validation.date.required': 'Please select the start & expiry date',
  'validation.email.required': 'Please enter the e-mail address',
  'validation.email.wrong-format': 'The format of the E-mail address is wrong',
  'validation.goal.required': 'Please enter the target description',
  'validation.loginAccount.required': 'The login phone number shall not be left blank',
  'validation.password.required': 'Please enter the passwords',
  'validation.password.strength.medium': 'Strength: Medium',
  'validation.password.strength.msg': 'Please at least enter 6 characters Please do not use the passwords that are easy to guess',
  'validation.password.strength.short': 'Strength: Too short',
  'validation.password.strength.strong': 'Strength: Strong',
  'validation.password.twice': 'The two passwords you typed do not match!',
  'validation.phone-number.required': 'Please enter the phone number',
  'validation.phone-number.wrong-format': 'format error of phone number',
  'validation.standard.required': 'Please enter the measurement standards',
  'validation.title.required': 'Please enter the title',
  'validation.verification-code.required': 'Please enter the verification code',
  'vendor.basic.info': 'Basic information',
  'vendor.code': 'Code',
  'vendor.contactPhone': 'Contact information',
  'vendor.contactor': 'Contact person',
  'vendor.create.button.cancel': 'Cancel',
  'vendor.create.button.confirm': 'OK',
  'vendor.create.button.confirmAndAdd': 'Confirm and create',
  'vendor.create.form.item.code.name': 'Code',
  'vendor.create.form.item.code.validate.message.integrality': 'The code shall be four digits, alphanumeric combination, pure number or pure letter',
  'vendor.create.form.item.code.validate.message.notNull': 'The code shall not be left blank',
  'vendor.create.form.item.contactPhone.name': 'Contact Tel.',
  'vendor.create.form.item.contactPhone.validate.message.limitLength': 'The max length of the contact\'s tel. is 30',
  'vendor.create.form.item.contactPhone.validate.message.notNull': 'The tel. of contact person cannot be left blank',
  'vendor.create.form.item.contactor.name': 'Contact person',
  'vendor.create.form.item.contactor.validate.message.limitLength': 'The max length of the contact is 30',
  'vendor.create.form.item.contactor.validate.message.notNull': 'The contact person cannot be left blank',
  'vendor.create.form.item.homeUrl.name': 'Homepage',
  'vendor.create.form.item.homeUrl.validate.message.limitLength': 'The max length on the homepage is 100',
  'vendor.create.form.item.input.placeholder': 'Please enter',
  'vendor.create.form.item.name.name': 'Name',
  'vendor.create.form.item.name.validate.message.limitLength': 'The max length of title is 30.',
  'vendor.create.form.item.name.validate.message.notNull': 'The name cannot be left blank',
  'vendor.create.form.item.note.name': 'Remarks',
  'vendor.create.form.item.note.validate.message.limitLength': 'The max length of the remarks is 255',
  'vendor.create.form.item.owner.name': 'Owner',
  'vendor.create.form.item.owner.validate.message.limitLength': 'The max length of the owner is 30.',
  'vendor.create.form.item.owner.validate.message.notNull': 'The owner shall not be left blank',
  'vendor.create.form.item.shortName.name': 'Short name',
  'vendor.create.form.item.shortName.validate.message.limitLength': 'The maximum length of short name is 30.',
  'vendor.create.form.item.zipCode.name': 'Postal code',
  'vendor.create.form.item.zipCode.validate.message.limitLength': 'The max length of the postal code is 30.',
  'vendor.create.title': 'Create Supplier',
  'vendor.customField1': 'User-defined field 1',
  'vendor.detail.tab.dclist': 'Scope of distribution center',
  'vendor.homeUrl': 'Homepage',
  'vendor.index.search.button.close': 'Pack up',
  'vendor.index.search.button.open': 'Unfold',
  'vendor.index.search.button.reset': 'Reset',
  'vendor.index.search.button.search': 'Query',
  'vendor.index.search.content.disable': 'Disabled',
  'vendor.index.search.content.enable': 'Enabled',
  'vendor.index.search.input.code': 'Code',
  'vendor.index.search.input.code.placeholder': 'Please enter',
  'vendor.index.search.input.codeAndName': 'Code/name',
  'vendor.index.search.input.name': 'Name',
  'vendor.index.search.input.name.placeholder': 'Please enter',
  'vendor.index.search.input.state': 'Status',
  'vendor.index.search.input.state.placeholder': 'please choose',
  'vendor.index.table.button.new': 'Create',
  'vendor.index.table.column.code': 'Code',
  'vendor.index.table.column.contactPhone': 'Contact Tel.',
  'vendor.index.table.column.contactor': 'Contact person',
  'vendor.index.table.column.name': 'Name',
  'vendor.index.table.column.operate': 'Operate',
  'vendor.index.table.column.state': 'Status',
  'vendor.index.table.content.disable': 'Disabled',
  'vendor.index.table.content.enable': 'Enabled',
  'vendor.index.table.operate.edit': 'Edit',
  'vendor.index.table.operate.view': 'Check',
  'vendor.info': 'Supplier information',
  'vendor.message.success.disable': 'Disable the supplier successfully',
  'vendor.message.success.enable': 'Enable the supplier successfully',
  'vendor.name': 'Name',
  'vendor.note': 'Remarks',
  'vendor.operate.info': 'Operation log',
  'vendor.operatorRecordCode': 'Filling code of the operator',
  'vendor.owner': 'Owner',
  'vendor.ownerUuid': 'Owner uuid',
  'vendor.shortName': 'Short name',
  'vendor.sourceCode': 'Source data',
  'vendor.state': 'Status',
  'vendor.title': 'Supplier',
  'vendor.update.title': 'Modify the supplier',
  'vendor.zipCode': 'Postal code',
  'vendorDispatch.containerCount': 'Number of trays',
  'vendorDispatch.containerInfo': 'Container information',
  'vendorDispatch.genPickupBill': 'Generate the picking list',
  'vendorDispatch.genSuccess': 'Generate the picking list successfully',
  'vendorDispatch.method': 'Operation method',
  'vendorDispatch.shelveInfo': 'Off-shelf information',
  'vendorDispatch.stockInfo': 'Inventory information',
  'vendorDispatch.title': 'Supplier\'s Return Board',
  'vendorDispatch.unShelveInfo': 'Information to be removed',
  'vendorDispatch.vendorCode': 'Supplier code',
  'vendorDispatch.vendorName': 'Supplier name',
  'vendorHandover.IPopconfirmAuditTitle': 'Whether to confirm to audit the supplier\'s EIR',
  'vendorHandover.IPopconfirmDeleteTitle': 'Whether to delete the supplier\'s EIR',
  'vendorHandover.beginHandoverTime': 'Handover time',
  'vendorHandover.containerCount': 'Number of trays',
  'vendorHandover.containerInfo': 'Container information',
  'vendorHandover.endHandoverTime': 'Time of handover completion',
  'vendorHandover.genPickupBill': 'Generate the picking list',
  'vendorHandover.genSuccess': 'Generate the picking list successfully',
  'vendorHandover.handover': 'handover',
  'vendorHandover.handoverTime': 'Handover time',
  'vendorHandover.method': 'Operation method',
  'vendorHandover.outBillNumber': 'Notice',
  'vendorHandover.stockInfo': 'Inventory information',
  'vendorHandover.title': 'Supplier Handover',
  'vendorRtnNtc.IPopconfirmAbortTitle': 'Whether to make the notice void',
  'vendorRtnNtc.IPopconfirmApproveTitle': 'Whether to audit the notice',
  'vendorRtnNtc.IPopconfirmConfirmTitle': 'Whether to confirm to notice',
  'vendorRtnNtc.IPopconfirmCopyTitle': 'Whether to copy the notice',
  'vendorRtnNtc.IPopconfirmDeleteTitle': 'Whether to delete the notice',
  'vendorRtnNtc.IPopconfirmFinishTitle': 'Whether to confirm to complete the notice',
  'vendorRtnNtc.IPopconfirmRollbackTitle': 'Whether to roll back the notice',
  'vendorRtnNtc.amount': 'Total amount',
  'vendorRtnNtc.articleCount': 'total number of items',
  'vendorRtnNtc.confirm': 'OK',
  'vendorRtnNtc.confirmSuccess': 'Confirm it successfully',
  'vendorRtnNtc.copy': 'Copy',
  'vendorRtnNtc.copySuccess': 'Copy succeeded',
  'vendorRtnNtc.createTime': 'Creation time',
  'vendorRtnNtc.endHandoverTime': 'Time of handover completion',
  'vendorRtnNtc.endPickTime': 'End the picking time',
  'vendorRtnNtc.expireDate': 'Expiry date',
  'vendorRtnNtc.generate': 'Generate the picking list',
  'vendorRtnNtc.generateSuccess': 'Generation succeeded',
  'vendorRtnNtc.handoverAmount': 'Handover amount',
  'vendorRtnNtc.handoverArticleCount': 'Number of the handover items',
  'vendorRtnNtc.handoverQty': 'Handover quantity',
  'vendorRtnNtc.handoverQtyStr': 'Number of handover pieces',
  'vendorRtnNtc.handoverVolume': 'Handover volume',
  'vendorRtnNtc.handoverWeight': 'Handover weight',
  'vendorRtnNtc.method': 'Operation method',
  'vendorRtnNtc.pickAmount': 'Picking amount',
  'vendorRtnNtc.pickArticleCount': 'Picking items',
  'vendorRtnNtc.pickQty': 'Picking quantity',
  'vendorRtnNtc.pickQtyStr': 'Number of Picked Pieces',
  'vendorRtnNtc.pickVolume': 'Picking volume',
  'vendorRtnNtc.pickWeight': 'Picking weight',
  'vendorRtnNtc.planAmount': 'Planned amount',
  'vendorRtnNtc.planArticleCount': 'Number of items planned',
  'vendorRtnNtc.planQtyStr': 'number of planned pieces',
  'vendorRtnNtc.planVolume': 'Planned volume',
  'vendorRtnNtc.planWeight': 'Planned weight',
  'vendorRtnNtc.qtyStr': 'Total pieces',
  'vendorRtnNtc.rollback': 'Rollback',
  'vendorRtnNtc.rollbackSuccess': 'Rollback successfully',
  'vendorRtnNtc.rtnDate': 'Return date',
  'vendorRtnNtc.sourceBillNumber': 'Source No.',
  'vendorRtnNtc.startHandoverTime': 'Handover time',
  'vendorRtnNtc.startPickTime': 'Picking time',
  'vendorRtnNtc.title': 'Supplier\'s Return Notice',
  'vendorRtnNtc.type': 'Type of return',
  'vendorRtnNtc.uploadTime': 'Upload time',
  'vendorRtnNtc.vendorPickUpBill': 'Supplier Pick List',
  'vendorRtnNtc.volume': 'Total volume',
  'vendorRtnNtc.weight': 'Total weight',
  'vendorRtnPick.IPopconfirmAuditTitle': 'Whether to confirm to audit the supplier\'s picking list',
  'vendorRtnPick.batchAddBinCode': 'Batch add location',
  'vendorRtnPick.batchAddContainer': 'Batch add container',
  'vendorRtnPick.batchAlterMethod': 'Modify the operation mode',
  'vendorRtnPick.batchAlterPicker': 'Modify the picking staff',
  'vendorRtnPick.batchWholeAudit': 'Entire-pallet audit',
  'vendorRtnPick.beginPickTime': 'Picking time',
  'vendorRtnPick.binCode': 'source location',
  'vendorRtnPick.containerBarcode': 'Source container',
  'vendorRtnPick.content': 'Whether to confirm to modify the operation mode of the supplier\'s picking list',
  'vendorRtnPick.endPickTime': 'End the picking time',
  'vendorRtnPick.method': 'Operation method',
  'vendorRtnPick.ntcBillNumber': 'Order No. of the supplier\'s return notice',
  'vendorRtnPick.ntcBillNumberAndSource': 'Notice No.',
  'vendorRtnPick.pickTime': 'Picking time',
  'vendorRtnPick.picker': 'Picking staff',
  'vendorRtnPick.qtyStr': 'Pieces to be picked',
  'vendorRtnPick.realQty': 'Actual Picking Quantity',
  'vendorRtnPick.realQtyStr': 'number of cases',
  'vendorRtnPick.sourceBillNumber': 'Source No.',
  'vendorRtnPick.title': 'Supplier Pick List',
  'vendorRtnPick.toBinCode': 'target location',
  'vendorRtnPick.toContainerBarcode': 'Target container',
  'vendorRtnPick.type': 'Pick Type',
  'vendorRtnPick.uploadTime': 'Upload time',
  'vendorRtnPick.vendorInntcBillNumber': 'Number',
  'vendorRtnPick.vendorInntcSourceBillNumber': 'Source No.',
  'version.account': 'Account component',
  'version.basic': 'Components of basic information',
  'version.facility': 'Component of business process',
  'version.openapi': 'Interface Component',
  'version.rf': 'RF customer end',
  'version.title': 'Version Information',
  'wave.addAlcNtc': 'Additive order',
  'wave.alcBillNumber': 'dispatching order number',
  'wave.alcNtcBillAmount': 'Number of dispatching order',
  'wave.alcNtcBillNumber': 'Allocation notice   Number',
  'wave.alcNtcTab': 'Allocation order',
  'wave.all': 'all',
  'wave.collectBin': 'Goods location',
  'wave.collectBinMgrScheme': 'Collection Scheme',
  'wave.confirm.clear': 'The details may be cleared if the {item} is modified Do you confirm to modify?',
  'wave.confirmButton': 'OK',
  'wave.confirmTime': 'Confirm time',
  'wave.createdTime': 'Creation time',
  'wave.deliverycycle': 'Distribution cycle',
  'wave.endPickTime': 'End the picking time',
  'wave.endRplTime': 'End the replenishment time',
  'wave.fillRate': 'Fill rate (%)',
  'wave.finishOrder': 'Whether to complete the orders',
  'wave.lineNum': 'Picking rows',
  'wave.message': 'Details',
  'wave.operateMethod': 'Picking mode',
  'wave.pickOrder': 'Pick order',
  'wave.pickOrderBillNUmber': 'Pick order number',
  'wave.pickOrderScheme': 'Pick Sequence Scheme',
  'wave.pickTask': 'Instruction pool',
  'wave.pickTaskNumber': 'Instruction No.',
  'wave.pickUpTab': 'Picking List',
  'wave.pickarea': 'Picking Partition',
  'wave.pickupBillNum': 'Picking quantity',
  'wave.pickupTotalAmount': 'Amount pickable',
  'wave.pickupTotalQtyStr': 'Pieces to be picked',
  'wave.planQty': 'Planned distribution quantity',
  'wave.qty': 'quantity requested',
  'wave.rollBack': 'Rollback',
  'wave.rplBillNumber': 'Replenishment number',
  'wave.rplMode': 'Replenishment mode',
  'wave.rplRealTotalAmount': 'Actual-replenished amount',
  'wave.rplRealTotalQtyStr': 'Completion cases',
  'wave.rplTab': 'Replenishment List',
  'wave.rplTotalQtyStr': 'Number of requests',
  'wave.schedule': 'Execution progress',
  'wave.selectStoreGroup': 'en-请选择门店组',
  'wave.showDifferentButton': 'view differences',
  'wave.start': 'Enable',
  'wave.startCompleteTime': 'Completion time of enabling',
  'wave.startPickTime': 'Picking time',
  'wave.startRplTime': 'Time of replenishment',
  'wave.startTime': 'Enabling time',
  'wave.stockAllocateScheme': 'Inventory Allocation Scheme',
  'wave.stockAllocateType': 'Type of inventory allocation',
  'wave.stockOrder': 'inventory allocation sequence',
  'wave.stockQty': 'Available quantity of inventory',
  'wave.store': 'Store',
  'wave.storeAmount': 'Number of stores',
  'wave.title': 'Wave List',
  'wave.totalAmount': 'Demand amount',
  'wave.totalPlanAmount': 'Amount pickable',
  'wave.totalPlanQtyStr': 'Pieces to be picked',
  'wave.totalQtyStr': 'Number of items',
  'wave.totalRealAmount': 'Actual-picking amount',
  'wave.totalRealQtyStr': 'number of cases',
  'wave.totalShipAmount': 'Loading amount',
  'wave.totalShipQtyStr': 'Pcs installed',
  'wave.type': 'Wave reason',
  'wave.waveConfirm': 'Confirmation of wave',
  'wave.waveNumber': 'Wave',
  'wave.waveType': 'Manage the wave',
  'wave.waveWeeks': 'ZHOU Shijian',
  'web单据审核': 'web document review',
  'web打印机': 'web printer',
  'wms下发': 'wms delivery',
  'wrh.create.basic': 'Basic information',
  'wrh.create.button.cancel': 'Cancel',
  'wrh.create.button.confirm': 'OK',
  'wrh.create.button.confirmCreate': 'Confirm and Create',
  'wrh.create.form.item.code.name': 'Code',
  'wrh.create.form.item.code.validate.message.integrality': 'The code shall be the numbers, letters and the combination, and the max length is 30 digits',
  'wrh.create.form.item.code.validate.message.notNull': 'The code shall not be left blank',
  'wrh.create.form.item.dc.name': 'Distribution Center',
  'wrh.create.form.item.dc.validate.message.notNull': 'The distribution center does not be exist',
  'wrh.create.form.item.input.placeholder.code': 'Please enter the code',
  'wrh.create.form.item.input.placeholder.name': 'Please enter the name',
  'wrh.create.form.item.input.placeholder.note': 'Please enter the remark',
  'wrh.create.form.item.name.name': 'Name',
  'wrh.create.form.item.name.validate.message.limitLength': 'The max length of title is 30.',
  'wrh.create.form.item.name.validate.message.notNull': 'The name cannot be left blank',
  'wrh.create.form.item.note.name': 'Remarks',
  'wrh.create.form.item.note.validate.message.limitLength': 'The max length of the remarks is 255',
  'wrh.create.form.item.option.placeholder': 'please choose',
  'wrh.create.form.item.placeholder': 'Please enter',
  'wrh.create.form.item.sourceWrhCode.name': 'Upstream warehouse location code',
  'wrh.create.form.item.sourceWrhCode.validate.message.limitLength': 'The max length of the upstream warehouse location code is 10',
  'wrh.create.title': 'Create Warehouse Location',
  'wrh.detail.basic': 'Basic information',
  'wrh.detail.basic.code': 'Code',
  'wrh.detail.basic.dc': 'Distribution Center',
  'wrh.detail.basic.name': 'Name',
  'wrh.detail.basic.note': 'Remarks',
  'wrh.detail.basic.sourceWrhCode': 'Upstream warehouse location code',
  'wrh.detail.button.back': 'Back',
  'wrh.detail.button.cancel': 'Cancel',
  'wrh.detail.button.confirm': 'OK',
  'wrh.detail.label.edit': 'Edit',
  'wrh.detail.tab.operateInfo': 'Operation log',
  'wrh.detail.tab.wrhInfo': 'Warehouse Location information',
  'wrh.edit.title': 'Modify the warehouse location',
  'wrh.index.message.success.operate': 'Operation succeeded',
  'wrh.index.search.button.reset': 'Reset',
  'wrh.index.search.button.search': 'Query',
  'wrh.index.search.content.disable': 'Disabled',
  'wrh.index.search.content.enable': 'Enabled',
  'wrh.index.search.input.codeName': 'Warehouse Location code/name',
  'wrh.index.search.input.codeName.placeholder': 'Please enter the keywords for inquiry',
  'wrh.index.search.input.state': 'Status',
  'wrh.index.search.input.state.placeholder': 'all',
  'wrh.index.table.button.new': 'Create',
  'wrh.index.table.column.code': 'Code',
  'wrh.index.table.column.dc': 'Distribution Center',
  'wrh.index.table.column.name': 'Name',
  'wrh.index.table.column.operate': 'Operate',
  'wrh.index.table.column.sourceWrhCode': 'Upstream warehouse location code',
  'wrh.index.table.column.sourceWrhName': 'Title of the upstream warehouse location',
  'wrh.index.table.column.state': 'Status',
  'wrh.index.table.content.disable': 'Disabled',
  'wrh.index.table.content.enable': 'Enabled',
  'wrh.index.table.operate.edit': 'Edit',
  'wrh.index.table.operate.view': 'Check',
  'wrh.message.error.create': 'Failed to create the warehouse location',
  'wrh.message.error.disbale': 'Fail to disable warehouse location',
  'wrh.message.error.enbale': 'Fail to enable warehouse location',
  'wrh.message.error.update': 'Fail to modify the warehouse location',
  'wrh.message.success.create': 'Successfully create the warehouse location',
  'wrh.message.success.disable': 'Disable warehouse location successfully',
  'wrh.message.success.enable': 'Enable warehouse location successfully',
  'wrh.message.success.enbale': 'Enable warehouse location successfully',
  'wrh.message.success.update': 'Modify the warehouse location successfully',
  'wrh.title': 'Warehouse Location',
  'wrh.update.title': 'Edit the warehouse location',
  '{action}完成': '{action} completed',
  '{barcode}为自动生成的条码不允许删除': '{barcode} is an automatically generated barcode and cannot be deleted',
  '{caption}模块{caption}所在行不能为空': '{caption} The row of module {caption} cannot be empty',
  '{caption}模块所在行不能为空': '{caption} The row of the module cannot be empty',
  '{caption}第{line}行与第{otherLine}盘点员不一致': 'The {caption} line {line} is inconsistent with the {otherLine} count clerk',
  '{caption}第{line}行与第{otherLine}行容器相同，货位不同！': 'The container in line {line} of {caption} is the same as that in line {otherLine}, but the storage location is different!',
  '{caption}第{line}行与第{otherLine}行重复！': 'The {caption} line {line} is duplicated with the {otherLine} line!',
  '{caption}第{line}行商品不能为空！': '{caption} Line {line} product cannot be empty!',
  '{caption}第{line}行容器条码不能为空！': 'The container barcode in row {line} of {caption} cannot be empty!',
  '{caption}第{line}行生产日期不能为空！': 'The production date in line {line} of {caption} cannot be empty!',
  '{caption}第{line}行生产日期不能晚于当前日期！': 'The production date in line {line} of {caption} cannot be later than the current date!',
  '{caption}第{line}行盘点员不能为空！': 'The count clerk in line {line} of {caption} cannot be empty!',
  '{caption}第{line}行商品未维护业务信息（结算单位）！': 'Business information not maintained for commodities in line {line} of {caption} (settlement unit)',
  '{caption}第{line}行货位代码不能为空！': 'The location code of line {line} of {caption} cannot be empty!',
  '{id}行道口重复': '{id} The crossing is repeated',
  '{line}行件数不能小于0！': 'The number of {line} lines cannot be less than 0!',
  '{line}行实盘数量不能为0！': 'The firm offer quantity in line {line} cannot be 0!',
  '{line}行数量不能小于0！': 'The number of {line} rows cannot be less than 0!',
  '{line}行数量不能等于0！': 'The number of {line} rows cannot be equal to 0!',
  '{line}行数量和件数不能同时等于0！': '{line} The number of lines and pieces cannot be equal to 0 at the same time!',
  '{line}行目标货位不能为空！': 'The target location of line {line} cannot be empty!',
  '{line}行退仓数量不能为0！': '{line} Line return quantity cannot be 0!',
  '{name}-选择释放时机': '{name} - Select the release time',
  '{name}大小超过5M,无法上传': '{name} size exceeds 5M, unable to upload',
  '{name}文件上传失败': '{name} file upload failed',
  '{name}文件上传成功': '{name} File uploaded successfully',
  '{name}格式不正确,请检查后上传': '{name} format is incorrect, please check and upload',
  '{title}{logisticMode}容器类型不能为空': 'en-{title}{logisticMode}容器类型不能为空',
  '{title}{logisticMode}打印模板不能为空': 'en-{title}{logisticMode}打印模板不能为空',
  '{title}物流模式不能为空': 'en-{title}物流模式不能为空',
  '{type}不能大于保质期天数': 'en-{type}不能大于保质期天数',
  '|\n\t\t\t\t总实盘件数：': '|\n\t\t\t\t Number of pcs of the total firm:',
  '|\n\t\t\t\t总实盘数量：': '|\n\t\t\t\t Quantity of pcs of the total firm:',
  '一件一容器': 'One piece one container',
  '一件一标签': 'One tag for every piece',
  '一单一容器': 'One container for one order',
  '一品一容器': 'One container for one item',
  '一品一标签': 'One tag for every item',
  '一次性': 'At one time',
  '一次性补货': 'One-time replenishment',
  '一步二步补货': 'One-step, two-step replenishment',
  '一步补货': 'One-step replenishment',
  '一步补货来源货位': 'US 一步补货来源货位',
  '一步补货补货单将修改为二步补货，二步补货补货单将修改为一步补货': 'The one-step replenishment will be changed to the two-step replenishment, and the two-step replenishment will be changed to the one-step replenishment',
  '一步越库': 'One-step cross-docking',
  '一步越库分播管理方案配置': 'One-step cross-library multicast management scheme configuration',
  '一步越库容器类型': 'Type of the one-step cross-dock container',
  '一步越库打印模板': 'Printing template of the one-step cross-dock',
  '一步越库收货': 'Goods receiving of the one-step cross-dock',
  '一步越库收货后去向': 'One step over the warehouse after receiving goods',
  '一步越库收货实收显示': 'One-step cross-dock receipt actual receipt display',
  '一步越库收货暂存位': 'One-step cross-dock receipt staging location',
  '一步越库收货暂存位范围': 'Scope of the goods-receiving temporary location of the one-step cross-dock',
  '一步越库自动获取容器': 'Automatic container acquisition through one-step library crossing',
  '一键复核': 'One-key review',
  '一键装车配置': 'One-key loading configuration',
  '三项不能同时为空！': 'The three items cannot be empty at the same time!',
  '上一单': 'Last order',
  '上一步': 'Previous step',
  '上传供应商': 'Uploading supplier',
  '上传供应商退货交接单': 'Upload the return handover EIR of the supplier',
  '上传供应商退货通知单': 'Upload the return notice of the supplier',
  '上传加工单': 'Upload work order',
  '上传商品': 'Upload commodity',
  '上传商品类别': 'Type of uploaded commodity',
  '上传商品装盘建议': 'Upload product loading suggestions',
  '上传库存锁定解锁单': 'Upload Inventory Lock Unlock Form',
  '上传成功': 'Uploaded successfully',
  '上传承运商': 'upstream carrier',
  '上传损耗单': 'Upload loss slip',
  '上传收货单': 'Receiving note uploaded',
  '上传时间': 'Upload time',
  '上传溢余单': 'Surplus note uploaded',
  '上传用户': 'Upload users',
  '上传移库单': 'Upload transfer order',
  '上传自动差错配货差异单': 'Upload the automatic error distribution difference  list',
  '上传许可证': 'Upload License',
  '上传车辆': 'Upload the vehicle',
  '上传退仓单': 'Upload return order',
  '上传配货差异单': 'Upload a delivery discrepancy note',
  '上传门店': 'upload store',
  '上传门店交接单': 'Upload store handover slip',
  '上传附件': 'Upload attachment',
  '上传附件不能为空': 'Uploaded attachment cannot be left blank',
  '上分拣机': 'Sorter',
  '上架': 'Inventory in-log',
  '上架中': 'On shelf',
  '上架中转位': 'Transit location of inventory in-log',
  '上架中转位配置': 'In-shelf transposition configuration',
  '上架允许修改目标货位': 'Putting on the shelf allows modifying the target location',
  '上架入': 'put on the shelf',
  '上架展示库存货位': 'On-shelf display inventory',
  '上海海鼎信息工程股份有限公司 版权所有': 'Shanghai Heading Information Engineering Co., Ltd   All rights reserved',
  '上移': 'Move up',
  '上限': 'Upper limit',
  '下一个门店组': 'Next Store Group',
  '下一单': 'Next order',
  '下一单门店': 'Next single store',
  '下单时间': 'Order time',
  '下发明细': 'Distribution details',
  '下架员': 'Off-shelf personnel',
  '下载': 'Download',
  '下载安装': 'Download and install',
  '下载模板': 'Download',
  '下限': 'Lower limit',
  '不上传商品类别配置': 'Type and configuration of the commodity not uploaded',
  '不上传商品配置': 'Not upload the commodity configuration',
  '不允许为空': 'It shall not be left blank',
  '不勾选默认是商品拆并，勾选是整箱拆并': 'If unticked, it shall be considered as the goods split and combination Otherwise, it shall be considered as the split and combination of the whole package',
  '不合格': 'Unqualified',
  '不合格数量': 'Unqualified quantity',
  '不启用': 'Disable',
  '不存在上一单': 'There is no previous order',
  '不存在下一单': 'There is no next order',
  '不得输入空格': 'No spaces allowed',
  '不控制': 'do not control',
  '不校验': 'Do not verify',
  '不管理': 'No management',
  '不管理保质期': 'Does not manage shelf life',
  '不维护': 'No maintenance',
  '不能替换为当前商品': 'Cannot be replaced with current item',
  '不能替换为自己': 'cannot be replaced by oneself',
  '不选择商品时，货位类型和货位范围不可同时为空': 'When no product is selected, the location type and location range cannot be empty at the same time',
  '不采集': 'No acquisition',
  '不限制': 'not limited',
  '业务信息': 'Business Information',
  '业务功能': 'Business functions',
  '业务单据使用货位用途配置': 'Purpose and configuration of goods location in the business document',
  '业务单据操作限制配置': 'Configuration of operation limitation in the business document',
  '业务模块': 'Business module',
  '业务生成': 'en-业务生成',
  '业务类型': 'Business type',
  '业务集货方案配置': 'Allocation of goods collection scheme',
  '严格控制': 'Strict control',
  '严格管理': 'Strict management',
  '严格限制': 'Strict control',
  '个': 'Pcs',
  '个人中心': 'Personal Center',
  '个商品': 'Commodity',
  '个选项': 'Option',
  '个选项?': 'Option?',
  '个选项，\n               失败': 'Option?, \n             fail',
  '个选项，\n               跳过': 'Option?, \n             skip',
  '个选项，\n        失败': 'Option, \n       fail',
  '个选项，\n        跳过': 'Option, \n       skip',
  '中国': 'China',
  '中断': 'Interruption',
  '中间表': 'Intermediate table',
  '中间表名': 'Intermediate table name',
  '中间表字段名': 'Field name of intermediate table',
  '临时车辆': 'Temporary vehicles',
  '主体码': 'Subject code',
  '主动': 'Master',
  '主动上架': 'Actively put on the shelves',
  '主机': 'Host',
  '买单单价': 'Unit price of purchase order',
  '买单金额': 'Amount of purchase amount',
  '事件': 'Events',
  '二步类越库容器类型': 'Type of the two-step category cross-dock container',
  '二步补货': 'Two-step replenishment',
  '二步补货上限': 'Upper limit of the second-step replenishment',
  '二步越库': 'Two-step cross-docking',
  '二步越库分播管理方案配置': 'Two - step over - library multicast management scheme configuration',
  '二步越库打印模板': 'Printing template of the two-step cross-dock',
  '二步越库收货暂存、分播中转位': 'Temporary storage and distribution transit location in second step cross-dock receipt',
  '二步越库收货暂存位': 'Temporary location of the two-step cross-dock receipt',
  '二步越库自动获取容器': 'Two-step Cross docking automatic get container',
  '二步越库配单是否按订单全部添加': 'Whether to add all the two-step inventory allocation documents by order',
  '二步越库配单是否按订单全部添加配置': 'Whether to add all allocation list based on orders for Two-step Cross docking configuration',
  '交接中': 'handover',
  '交接信息': 'Transfer information',
  '交接单': 'EIR',
  '交接员': 'handover',
  '交接明细': 'Handover details',
  '交接状态': 'Handover status',
  '交接类型': 'Type of handover',
  '交接项': 'Handover item',
  '产品商标': 'Product trademark',
  '产品批次': 'Product batch',
  '产地': 'Origin',
  '人员': 'personnel',
  '人员信息': 'Personnel information',
  '人员类型': 'Personnel type',
  '仅提示': 'Only prompt',
  '仅质检': 'Only quality inspection',
  '仅配置': 'US 仅配置',
  '仓位': 'Warehouse Location',
  '仓位:{wrh}未配置虚拟货位': 'Warehouse Location: {wrh} no virtual goods location configured',
  '仓位下没有退仓收货暂存位，无法退仓': 'There is no temporary storage warehouse location for warehouse return and goods receipt under the warehouse, and warehouse return cannot be performed',
  '仓位不能为空。': 'The warehouse location cannot be empty.',
  '仓位为空时只允许配置一条明细': 'Only one detail can be configured when the warehouse location is empty',
  '仓位代码': 'Warehouse Location code',
  '仓位名称': 'Name of warehouse location',
  '仓位和货主不能空。': 'The warehouse location and owner cannot be empty.',
  '仓位：{wrh}已有配置项': 'Warehouse Location: {wrh} already has a configuration item',
  '仓库看板': 'Board in warehouse',
  '代码': 'Code',
  '代码/名称': 'Code/name',
  '代码/名称,多个代码以逗号隔开': 'Code/name, multiple codes separated by commas',
  '代码/车牌': 'Code/license plate',
  '代码不能为空': 'The code shall not be left blank',
  '代码只能是四位数字': 'The code could only be four digits',
  '代码必须是4位字母、数字、二者组合': 'The code shall be four-digit letters, numbers, combination of both.',
  '代码必须是4位数字': 'The code  shall be 4-bit digits',
  '代码必须是4位数字、字母或者二者组合': 'The code must be 4 digits, letters, or a combination of both',
  '代码必须是数字、字母、二者组合，长度最大为30位': 'The code shall be the numbers, letters and the combination, and the max length is 30 digits',
  '以下': 'Below',
  '以复查结果装车': 'Loading with the review results',
  '以容器计算配置': 'Calculate the configuration with the container',
  '以整箱计算配置': 'Calculate the configuration with the full container load',
  '以整箱计算配置，容器类型“[-]-”必选': 'The configuration is calculated based on the whole container, and the container type "[-]-" must be selected',
  '件': 'Pcs',
  '件/重': 'Pcs/weight',
  '件数': 'Pcs',
  '件数/净重': 'Pcs/net weight',
  '件数/重量': 'pcs/weight',
  '件数为0': 'The number of pieces is 0.',
  '件数信息': 'Piece information',
  '件数信息第{line}行件数必须大于0！': 'The number of pieces in the line {line} of piece count information must be greater than 0!',
  '件数信息第{line}行码头集不能为空！': 'The terminal set in the {line}  row of piece count information cannot be empty!',
  '件数信息第{line}行装车项不能为空！': 'The loading item in line {line}  of piece count information cannot be empty!',
  '件数信息第{line}行门店不能为空！': 'Store in line {line} of piece count information cannot be empty!',
  '件数复查': 'Piece check',
  '件数小于0': 'The number of pieces is less than 0.',
  '件数选择应拣数量，目标货位必填！': 'The number of selected should pick the number, the target location must be filled!',
  '价格': 'Price',
  '任务号': 'Task no.',
  '任务量': 'Task quantity',
  '任意': 'any',
  '企业': 'Enterprise',
  '企业代码': 'Enterprise code',
  '企业代码不能为空': 'The enterprise code cannot be left blank',
  '企业名称': 'Company Name',
  '企业权限信息': 'Enterprise permission information',
  '企业组织': 'Enterprise organization',
  '优先拣货位': 'Priority picking location',
  '优先级': 'Priority',
  '优先级调整': 'Priority adjustment',
  '传输方向': 'Transmission direction',
  '传输时间': 'Transmission time',
  '体积(cm³)': 'Volume (cm3)',
  '体积(m³)': 'Volume (m3)',
  '体积不能为空': 'Volume shall not be left blank',
  '体积取值来源': 'Volume value source',
  '体积大于等于': 'Volume greater than or equal to',
  '体积小于等于': 'Volume less than or equal to',
  '体积模式配置': 'Volume mode configuration',
  '体积范围': 'Volume range',
  '体积范围(m³)': 'Volume scope (m3)',
  '品项数范围': 'Range of article numbers',
  '最大值': 'Maximum value',
  '最小值': 'Minimum value',
  '最大值不能为空': 'The maximum value cannot be empty',
  '作业模式': 'Operating mode',
  '作业点': 'work point',
  '作业点代码': 'Code of operation point',
  '作业点号': 'Operation point number',
  '作业点名称': 'Name of the operation point',
  '作业点顺序': 'Operation point sequence',
  '作业类型': 'Operation type',
  '作业面板配置': 'Operation panel configuration',
  '作废': 'Void',
  '作废{length}个选项': 'Void {length} options',
  '作废供应商退货通知单': 'Cancel the supplier\'s return notice',
  '作废成功': 'void success',
  '作废订单': 'Cancel the orders',
  '作废退仓通知单': 'Cancel the return notice list',
  '作废配货通知单': 'Void Shipping Notice',
  '使用中': 'Using',
  '使用本地打印机': 'Use the local printer',
  '使用率': 'usage',
  '使用货位': 'Use the goods location',
  '供应商': 'Supplier',
  '供应商:{vendors},不在退仓调拨配置范围内，请添加配置': 'Supplier: {vendors}, not within the configuration range of return warehouse Allocate, please add a configuration',
  '供应商交接单': 'Supplier Handover',
  '供应商交接单日结': 'Supplier handover day settlement',
  '供应商交接单明细不能为空': 'Supplier delivery order details cannot be empty',
  '供应商代码': 'Supplier code',
  '供应商作条件': 'Supplier conditions',
  '供应商创建': 'Created by the supplier',
  '供应商名称': 'Supplier name',
  '供应商寄售管理': 'Consignment management of the supplier',
  '供应商拣货单': 'Supplier Pick List',
  '供应商拣货单默认操作方式配置': 'Vendor picking list default operation mode configuration',
  '供应商权限信息': 'Supplier permission',
  '供应商独占': 'Exclusive for the supplier',
  '供应商独占退货位': 'Exclusive return position of the supplier',
  '供应商组织': 'Supplier organization',
  '供应商调整': 'Supplier adjustment',
  '供应商退货': 'Supplier returns',
  '供应商退货位': 'Supplier\'s return location',
  '供应商退货位容器管理': 'Management container of the supplier\'s return goods location',
  '供应商退货位容器管理 保存成功': 'Successfully saved the container of vendor return config',
  '供应商退货位配置': 'Configuration of the supplier\'s return location',
  '供应商退货单分单退货类型配置': 'US 供应商退货单分单退货类型配置',
  '供应商退货拣货暂存位': 'Temporary position of the supplier\'s return and picking',
  '供应商退货控制天数': 'Days of the supplier\'s return and control',
  '供应商退货是否限制供应商': 'Whether the supplier\'s return restricts the supplier',
  '供应商退货是否需要交接': 'Whether the supplier\'s return needs the handover',
  '供应商退货是否需要交接配置': 'Does supplier return require handover configuration?',
  '供应商退货通知单': 'Supplier\'s Return Notice',
  '供应商退货通知单交接日结': 'Supplier Return Notice Handover Date Closing',
  '供应商退货通知单单号/来源单号': 'Supplier\'s return notice No./Source order No.',
  '供应商退货通知单回传时机配置': 'Configuration of return timing of supplier return notice',
  '供应商退货通知单过期日结': 'Supplier Return Notice Expiration Date Settlement',
  '供应商退货限制配置': 'Does supplier return limit supplier configuration',
  '供应商退货集货位': 'Return goods location of the supplier',
  '供应商退货集货暂存位': 'Temporary position of the supplier\'s return and collection',
  '供应商集货位': 'Supplier\'s goods location',
  '供应商集货位配置': 'Supplier collection location configuration',
  '供应商：': 'supplier:',
  '供应商：{code} 为默认供应商,不允许删除': 'Supplier: {code} is the default supplier and cannot be deleted',
  '供应商：{code} 已存在': 'Supplier: {code} already exists',
  '供应商：{code}不允许主动退货': 'Supplier: {code} Do not allow active returns',
  '供应商：{code}不允许生成拣货单': 'Supplier: {code} Picking list is not allowed to be generated',
  '依次分配': 'Allocated in turn',
  '依次满足': 'Meet in turn',
  '保存': 'Save',
  '保存/修改': 'Save/modification',
  '保存上传附件成功': 'Save the uploaded attachment successfully',
  '保存并审核成功': 'Save and review successfully',
  '保存成功': 'Saved successfully',
  '保存更正': 'Save Corrections',
  '保底拣货位': 'Min picking location',
  '保底比例分配': 'Min proportional allocation',
  '保质期': 'Guarantee period',
  '保质期天数不能小于供应商退货控制天数': 'en-保质期天数不能小于供应商退货控制天数',
  '保质期天数不能小于收货控制天数': 'en-保质期天数不能小于收货控制天数',
  '保质期天数不能小于返厂控制天数': 'en-保质期天数不能小于返厂控制天数',
  '保质期天数不能小于退货控制天数': 'en-保质期天数不能小于退货控制天数',
  '保质期天数不能小于配货控制天数': 'en-保质期天数不能小于配货控制天数',
  '保质期类型': 'Type of guarantee period',
  '信息': 'Information',
  '信息填写': 'Information filling',
  '信息未补全': 'Information mot completed',
  '修改': 'Modification',
  '修改交接单会清除明细信息，是否确认修改？': 'Modifying the delivery order will clear the detailed information. Do you want to confirm the modification?',
  '修改仓位会导致商品信息清空，请确认修改？': 'Modifying the warehouse location will cause the product information to be cleared. Please confirm the modification?',
  '修改仓位会导致明细清空，请确认修改？': 'Modifying the warehouse location will cause the details to be cleared. Please confirm the modification?',
  '修改仓位会清空明细信息，请确认修改？': 'Modifying the warehouse location will clear the detailed information, please confirm the modification?',
  '修改仓位会清空明细，请确认修改？': 'Modifying the warehouse location will clear the details, please confirm the modification?',
  '修改仓位会清除明细信息，是否确认修改？': 'Modifying the warehouse location will clear the detailed information. Do you want to confirm the modification?',
  '修改仓位将导致明细清空,确定修改？': 'Modifying the warehouse location will cause the details to be cleared. Are you sure to modify?',
  '修改供应商会导致商品信息清空，请确认修改？': 'Modifying the supplier will cause the product information to be cleared. Please confirm the modification?',
  '修改供应商会导致明细清空，请确认修改？': 'Modifying the supplier will cause the details to be cleared. Please confirm the modification?',
  '修改供应商会清空明细信息，请确认修改？': 'Modifying the supplier will clear the detailed information, please confirm the modification?',
  '修改供应商会清空明细，请确认修改？': 'Modifying the supplier will clear the details, please confirm the modification?',
  '修改修正类型会导致明细清空，请确认修改？': 'Modifying the correction type will cause the details to be cleared. Please confirm the modification?',
  '修改分播方式': 'Modify the distribution mode',
  '修改单号': 'Modified list No.',
  '修改单号会导致商品信息清空，请确认修改？': 'The commodity information may be cleared after the order number is changed Do you confirm to modify?',
  '修改单据类型会导致明细清空，请确认修改？': 'The details may be cleared after the type of the document is modified Do you confirm to modify?',
  '修改可用库存失败': 'Failed to modify available inventory',
  '修改可用库存成功': 'Modify available inventory successfully',
  '修改可用条码解析规则失败': 'Failed to modify available barcode resolution rules',
  '修改可用条码解析规则成功': 'Successfully modified the available barcode resolution rules',
  '修改商品规格': 'Modify the commodity specification',
  '修改容器条码': 'Modify the container barcode',
  '修改密码': 'Modify Password',
  '修改快递单号': 'Modify the tracking number',
  '修改感官质检单会导致明细改变，请确认修改？': 'Modifying the sensory quality inspection sheet will cause the details to change. Please confirm the modification?',
  '修改成功': 'Successfully modified',
  '修改承运商': 'Modify Carrier',
  '修改承运商会导致明细清空，确认修改？': 'The details may be cleared after the carrier chamber of commerce is modified',
  '修改拣货员': 'Modify the picking staff',
  '修改拣货员{length}个选项': 'Modify {length} options for picking clerk',
  '修改拣货方式{length}个选项': 'Modify the {length} options of the picking method',
  '修改拣货类型': 'Modify Picking Type',
  '修改拣货类型{length}个选项': 'Modify the {length} picking type options',
  '修改控制器': 'Modify controller',
  '修改提总方式': 'Modify the total method',
  '修改操作方式': 'Modify the operation mode',
  '修改操作方式{length}个选项': 'Modify {length} options for operation mode',
  '修改日志级别': 'Modify the log grade',
  '修改来源仓位会导致明细清空，请确认修改？': 'The details may be cleared after the source warehouse location is modified Do you confirm to modify?',
  '修改标签': 'Modify tags',
  '修改波次单将会导致明细清空，确认修改？': 'Modifying a wave order will result in clearing the details. Are you sure you want to modify it?',
  '修改波次类型会导致明细改变，请确认修改？': 'Modifying the wave type will cause the details to change. Please confirm the modification?',
  '修改物流模式会导致商品信息清空，请确认修改？': 'Modifying the logistics mode will cause the product information to be cleared. Please confirm the modification?',
  '修改物流模式会导致订单或者明细清空，请确认修改？': 'The order or the details may be cleared after modifying the logistics mode Do you confirm to modify?',
  '修改状态': 'Modification state',
  '修改状态成功': 'Modify the status successfully',
  '修改盘点员': 'Modify the inventory staff',
  '修改盘点方式': 'Modify the inventory mode',
  '修改盘点模式': 'Modify the check mode',
  '修改目标仓位会导致明细清空，请确认修改？': 'The details may be cleared after the target warehouse location is modified Do you confirm to modify?',
  '修改类型会导致相关明细清空，请确认修改？': 'en-修改类型会导致相关明细清空，请确认修改？',
  '修改类型会清空其他信息，请确认修改？': 'Other information may be cleared after modifying the type Do you confirm the modification?',
  '修改线路体系会导致明细清空，请确认修改？': 'The details may be cleared after the route system is modified Do you confirm to modify?',
  '修改网关服务': 'Modify the gateway service',
  '修改补货方式': 'Modify the replenishment mode',
  '修改补货方式{length}个选项': 'Modify {length} options for replenishment method',
  '修改补货步骤': 'Modify the replenishment step',
  '修改补货步骤{length}个选项': 'Modify the {length} options of the replenishment step',
  '修改角色': 'Modify role',
  '修改订单会导致仓位及明细改变，请确认修改？': 'Modifying the order will cause the warehouse location and details to change. Please confirm the modification?',
  '修改订单会导致明细改变，请确认修改？': 'Modifying the order will cause the details to change, please confirm the modification?',
  '修改调整类型会导致明细清空，请确认修改？': 'The details may be cleared after the type of adjustment is modified Do you confirm to modify?',
  '修改货主会导致商品信息清空，请确认修改？': 'Modifying the owner will cause the product information to be cleared, please confirm the modification?',
  '修改货主会导致库存信息清空，请确认修改？': 'Modifying the owner will cause the inventory information to be cleared. Please confirm the modification?',
  '修改货主会导致明细清空，请确认修改？': 'Modifying the owner will cause the details to be cleared. Please confirm the modification?',
  '修改货主会导致相关明细清空，请确认修改？': 'Modifying the owner will cause the relevant details to be cleared. Please confirm the modification?',
  '修改货主会导致订单或明细清空，请确认修改？': 'The order or the details may be cleared after modifying the owner Do you confirm to modify?',
  '修改货主会清空其他信息，请确认修改？': 'Modifying the owner will clear other information, please confirm the modification?',
  '修改货主会清除门店和明细信息，是否确认修改？': 'The store and detailed information may be cleared after the owner is modified Do you confirm the modification?',
  '修改货位用途': 'Modify the purposes of goods location',
  '修改货位类型': 'Modify the type of goods location',
  '修改货区': 'Modify the goods area',
  '修改超控制天数出库配置失败': 'Failed to modify the outbound configuration of days beyond the control',
  '修改超控制天数出库配置成功': 'Modifying the out-of-stock configuration of days beyond the control is successful',
  '修改退仓类型': 'Modify the refund type',
  '修改通知单会导致明细改变，请确认修改？': 'Modifying the notice will cause the details to change. Please confirm the modification?',
  '修改配送中心会导致仓位及商品信息清空，请确认修改？': 'Modifying the distribution center will cause the warehouse location and product information to be cleared. Please confirm the modification?',
  '修改配送中心会导致明细清空，请确认修改？': 'Modifying the distribution center will cause the details to be cleared, please confirm the modification?',
  '修改配送中心会导致订单类型、仓位及商品信息清空，请确认修改？': 'Modifying the distribution center will cause the order type, warehouse location and product information to be cleared. Please confirm the modification?',
  '修改配送中心会导致配货类型、仓位及商品信息清空，请确认修改？': 'Modifying the distribution center will cause the distribution type, warehouse location and commodity information to be cleared. Please confirm the modification?',
  '修改门店会清除明细信息，是否确认修改？': 'Modifying the store will clear the detailed information. Do you want to confirm the modification?',
  '修改门店组': 'Modify the store group',
  '修改领用单会导致明细清空，请确认修改？': 'Modifying the receipt will cause the details to be cleared. Please confirm the modification?',
  '修正': 'correct',
  '修正单': 'Correction List',
  '修正原因': 'Causes',
  '倒排序': 'Reverse order',
  '停止': 'Stop',
  '停止位': 'Stop location',
  '停止读取': 'Stop reading',
  '停用': 'Disable',
  '偶数货架': 'Even number of shelves',
  '允分分货满足率': 'en-允分分货满足率(%)',
  '允分收货占比': 'en-允分收货占比(%)',
  '允许': 'allow',
  '不允许': 'not allow',
  '允许主动退货': 'en-允许主动退货',
  '允许多次执行': 'Allow multiple executions',
  '允许定位交接': 'Allow location handover',
  '允许批号混载': 'Mixed batches are allowed',
  '允许收货': 'Allow the receipt',
  '允许空闲容器装车': 'Allow free containers to load',
  '允许装车': 'Loading allowed',
  '允许负库存的业务操作配置': 'Allow the business operation configuration of the negative inventory',
  '允许退仓': 'US 允许退仓',
  '允许重复执行': 'Allow the repeated execution',
  '元': 'RMB',
  '入园单': 'Entry form',
  '入库': 'warehousing',
  '入库业务': 'Entry business',
  '入库仓位': 'Inbound warehouse location',
  '入库指令': 'Inventory Instruction',
  '入库管理': 'Inbound',
  '入库订单': 'Inbound order',
  '入库订单号': 'Inbound order No.',
  '入库订单来源单号': 'Inbound order source document number',
  '入库订单行号': 'Inbound order line number',
  '入库配置': 'Warehousing configuration',
  '入库采集皮重信息': 'Collect the tare weight in warehousing',
  '入库采集皮重维度': 'Collect the tare weight dimension in warehousing',
  '入库采集皮重维度设置': 'Dimension setting in collecting the tare weight',
  '全家便利店': 'Family Convenience Store',
  '全部': 'all',
  '全部供应商': 'All suppliers',
  '全部导入': 'Import All',
  '全部添加': 'add all',
  '全部项目': 'All items',
  '公共资源': 'Public resource',
  '共': 'co-owned',
  '共 {total} 条': 'A total of {total} items',
  '共{number}个控制器': '{number} controllers in total',
  '共生成{data}张拣货单': 'A total of {data} picking lists were generated',
  '关联货位': 'Associated goods location',
  '关联货位配置': 'Associated slot configuration',
  '关闭': 'close',
  '其他': 'Others',
  '内存详情': 'Memory details',
  '内宽(cm)': 'Inner width (cm)',
  '内部管理': 'Internal',
  '内部管理指令': 'Internal Executive Instruction',
  '内部配置': 'Internal configuration',
  '内长(cm)': 'Internal length (cm)',
  '内长/宽/高(cm)': 'Internal length/width/height (cm)',
  '内高(cm)': 'Internal height (cm)',
  '冷藏': 'Refrigeration',
  '凭证原因': 'Credential reason',
  '凭证附件': 'Proof of attachment',
  '凭证附件支持jpg、jpeg、png、docx、xlsx等格式文件,建议上传文件大小不超过1M': 'The voucher attachment supports the documents in the format of jpg, jpeg, png, docx and xlsx, etc. It is suggested that the size of the uploaded document should not exceed 1M.',
  '凭证附件支持jpg、jpeg、png、docx、xlsx等格式文件,建议上传文件大小不超过5M': 'Voucher attachments support files in formats such as jpg, jpeg, png, docx, and xlsx. It is recommended that the size of the uploaded file not exceed 5M',
  '出库': 'out of stock',
  '出库使用皮重记录': 'Tare weight record in ex-warehouse',
  '出库加工': 'Ex-warehouse Manufacturing',
  '出库单': 'Outbound order',
  '出库打印机': 'Ex-warehouse printer',
  '出库打印模板': 'Ex-warehouse printing template',
  '出库指令': 'Outbound Order',
  '出库控制': 'Outbound Control',
  '出库管理': 'Outbound',
  '出库配置': 'Ex-warehouse configuration',
  '出货': 'Shipment',
  '出货前加工': 'Manufacturing before shipment',
  '出货后打印容器条码': 'Print the container barcode before shipment',
  '出货容器后置打印': 'Rear printing of shipment container',
  '出货打印容器': 'Shipment printing container',
  '出货打印模板配置': 'Shipment print template configuration',
  '出货打印模板配置日志': 'Log of shipment print template configuration',
  '出车里程数': 'Dispatching mileage',
  '分区': 'Partition',
  '分区名称': 'Name of partition',
  '分区编号': 'Zone No.',
  '分区配置': 'Partition configuration',
  '分区顺序': 'Partition sequence',
  '分单体积': 'HB/L volume',
  '分单依据': 'HB/L basis',
  '分单内容': 'HB/L contents',
  '分单数量': 'HB/L quantity',
  '分单条件': 'HB/L conditions',
  '分单配置': 'HB/L configuration',
  '分单门店数': 'Number of HB/L store',
  '分拣口': 'Sorting port',
  '分拣序号': 'Sorting S/N',
  '分拣扫描': 'Sorting Scan',
  '分拣机': 'Sorter',
  '分拣机中转暂存位': 'Temporary storage location for transfer of the sorter',
  '分拣机拣货': 'Sorter picking',
  '分拣机指令看板': 'Sorter Instruction Kanban',
  '分拣机收货': 'Sorter receipt',
  '分拣机集货': 'Sorter\'s goods collection',
  '分拣机集货暂存位': 'Temporary storage location for collection of the sorter',
  '分拣策略': 'Sorting strategy',
  '分拣策略不存在': 'The sorting strategy does not exist',
  '分拣道口': 'Sorting crossing',
  '分拣道口方案': 'Sorting Crossing Scheme',
  '分拣道口管理': 'Sorting Crossing',
  '分拣道口管理不存在': 'Sorting crossing management does not exist',
  '分拨中': 'Distributing',
  '分播': 'Distribution',
  '分播中': 'In distribution',
  '分播中转位': 'Transition during distribution',
  '分播件数': 'Number of sowing',
  '分播件数必须大于0！': 'The number of distribution pieces must be greater than 0!',
  '分播位': 'Distribution location',
  '分播位不能为空': 'The distribution bit cannot be empty',
  '分播位方案': 'Distribution plan',
  '分播列表': 'Multicast List',
  '分播墙': 'Distribution Wall',
  '分播墙类型': 'Distribution Wall Type',
  '分播墙：': 'Distribution Wall:',
  '分播审核': 'Distribution audit',
  '分播序号': 'distribution sequence number',
  '分播成功': 'Distribution succeeded',
  '分播打印模板': 'Distribution printing template',
  '分播数量': 'Number of broadcasts',
  '分播数量必须大于0！': 'The number of distributions must be greater than 0!',
  '分播方式': 'Distribution method',
  '分播方案': 'distribution plan',
  '分播状态': 'Distribution status',
  '分播管理方案': 'Distribution Scheme',
  '分播管理方案:{code}不存在': 'Multicast management scheme: {code} does not exist',
  '分播管理方案不存在': 'The distribution management scheme does not exist',
  '分播门店': 'Distribution store',
  '分组': 'Grouping',
  '分组成功': 'Group successfully',
  '分配': 'Allocation',
  '分配{number}个选项': 'Assign {number} options',
  '分配件数': 'number of pieces',
  '分配商品拣货量': 'Allocate Item Pick Quantities',
  '分配成功': 'Allocation succeeded',
  '分配数量': 'Allocation quantity',
  '分配数量大于库存数量,分配数量应小于等于库存数量！': 'The allocated quantity is greater than the inventory quantity. The allocated quantity should be less than or equal to the inventory quantity!',
  '分配状态': 'Allocation status',
  '分配集货位': 'Allocating a collection slot',
  '切换商品': 'Switch the commodity',
  '切换指令': 'switch command',
  '切换组织': 'Switch Organization',
  '切换门店': 'Switch the store',
  '列展示': 'Column display',
  '列数': 'Column No.',
  '列码': 'Column code',
  '列码范围': 'Scope of column code',
  '列码范围不为空，请填写完整': 'The scope of the column code shall not be left blank, please fully complete it',
  '列表': 'list',
  '列表页行数': 'Number of rows for the list page',
  '创建': 'create',
  '创建/接收': 'Creation/receiving',
  '创建/接收时间': 'Creation/receiving time',
  '创建人': 'Created by',
  '创建信息': 'Creation information',
  '创建方式': 'how to create',
  '创建日期': 'Creation date',
  '创建时间': 'Creation time',
  '初始': 'Initial',
  '初始化或者手动配置供应商退货位管理容器配置': 'Initialization or manual configuration of the management container configuration of the returned goods location',
  '删除': 'Delete',
  '删除{length}个选项': 'Delete {length} options',
  '删除失败': 'Deletion failed',
  '删除成功': 'Delete successfully',
  '删除标签': 'Delete the tag',
  '删除网关服务失败': 'Failure to delete the gateway service',
  '删除货位': 'Delete the goods location:',
  '到效日期': 'Expiry date',
  '到效期': 'Expiry date',
  '到效期不能早于当前日期': 'The expiry date shall not be earlier than the current date',
  '刷新任务成功': 'The refresh task succeeded',
  '刷新装车员': 'Refresh the loading staff',
  '前端地址不能为空': 'The front-end address can\'t be left blank',
  '剩余件数': 'Number of pieces remaining',
  '剩余原料': 'Remaining raw materials',
  '剩余原料/成品': 'Remaining raw materials/ finished products',
  '剩余库存转移': 'Remaining inventory transfer',
  '剩余成品': 'Remaining finished products',
  '剩余数量': 'The remaining amount',
  '剩余门店数': 'Number of remaining stores',
  '功能': 'function',
  '加工中': 'Processing',
  '加工人数': 'Number of people processed',
  '加工任务': 'Machining Tasks',
  '加工倍数': 'Processing multiple',
  '加工单': 'Work Order',
  '加工单原料明细第{line}行{rawRecordTitle}不能为空！': 'The {rawRecordTitle} in the {line} line of the processing order raw material details cannot be empty!',
  '加工单成品明细第{line}行{endRecordTitle}不能为空！': 'The {line} line {endRecordTitle} of the finished product details of the processing order cannot be empty!',
  '加工单成品明细第{line}行供应商不能为空！': 'The supplier in the {line} line of the finished product details of the processing order cannot be blank!',
  '加工单成品明细第{line}行到效期不能为空！': 'The expiration date of the {line} line of the finished product details of the processing order cannot be blank!',
  '加工单成品明细第{line}行单价不能为空！': 'The unit price in the {line} line of the finished product details of the processing order cannot be blank!',
  '加工单成品明细第{line}行商品不能为空！': 'The product in the {line} line of the finished product details of the processing order cannot be empty!',
  '加工单成品明细第{line}行容器条码不能为空！': 'The container barcode in the {line} line of the finished product details of the processing order cannot be empty!',
  '加工单成品明细第{line}行生产日期不能为空！': 'The production date in the {line} line of the finished product details of the processing order cannot be blank!',
  '加工单成品明细第{line}行货位代码不能为空！': 'The location code in the {line} line of the finished product details of the processing order cannot be empty!',
  '加工单记录值信息配置': 'Information configuration of record value of the processing list',
  '领料单默认操作方式配置': 'Raw requisition bill default operation mode configuration',
  '领料员作业配置': 'Operation configuration of the raw requisition picker',
  '加工单配方限制': 'Formula limit of the processing list',
  '加工单限制配置': 'Limit configuration of the processing list',
  '加工单限制配置 保存成功': 'Successfully saved the processing order restriction configuration',
  '满容录入附件限制配置': 'Limit configuration of the container full attachment',
  '满容录入附件限制配置 保存成功': 'Successfully saved the container full attachment configuration',
  '退仓超退限制影响配置': 'Store return exceed ration limit effect',
  '退仓超退限制影响配置 保存成功': 'Successfully saved the store return exceed ration limit effect configuration',
  '加工台': 'Processing workbench',
  '加工台管理': 'Management of processing workbench',
  '加工员': 'Processing personnel',
  '加工方案': 'Machining Scheme',
  '加工波次': 'Process wave',
  '加工波次单号': 'Process wave no.',
  '加载中...': 'Loading..',
  '动态': 'Dynamic',
  '动态分播位': 'Dynamic distribution bit',
  '动态存储区域配置': 'Configuration of dynamic storage area',
  '动态拣货': 'Dynamic picking',
  '动态拣货分组代码/名称': 'Code/title of dynamic picking group',
  '动态拣货区域配置': 'Configuration of dynamic picking area',
  '动态拣货组': 'Dynamic Picking Group',
  '动态拣货组有值，是否继续保存': 'The value exists for the dynamic picking group, will it continue to be saved',
  '动态拣货补货算法': 'Algorithm of dynamic picking replenishment',
  '动态拣货配置': 'Dynamic picking configuration',
  '动态方案': 'Dynamic scheme',
  '动态补货': 'Dynamic replenishment',
  '动销': 'Sales promotion',
  '勾选为累计，不勾选为替换': 'Tick to accumulate and untick to replace',
  '勾选后RF上架和混载上架的时候建议位置展示推荐系统库存位置': 'After ticking it for RF and mixed Inventory in-log, is recommended for the system inventory position for the position display',
  '勾选后RF上架的时候会进行货位别名栏显示并进行校验': 'After ticking it for RF inventory-in-log, the alias column of the goods location shall be displayed and checked',
  '勾选后RF单品复查扫描条码显示规格数量': 'After ticking for review of RF singled item, scan the barcode for the specification and quantity',
  '勾选后RF拣货获取到拣货单的时候提示该门店支持哪些容器类型拣货': 'After ticking, the RF picking will prompt which category of the container is available in the store after getting the picking list',
  '勾选后RF收货记录卸货方式': 'US 勾选后RF收货记录卸货方式',
  '勾选后RF正常收货/快速收货显示商品拆零拣货位，不勾选不显示': 'After ticking, RF indicates the commodity separation picking location under the normal receipt/quick receipt It will not display if not ticking',
  '勾选后RF正常收货模块,实收处显示待收信息,不勾选显示空,允许修改': 'After ticking, the information to be received is displayed at the actual receipt under the RF normal receipt module It shows left blank if not ticking and the modification is allowed',
  '勾选后RF生鲜摘果使用容器方式为自动分配': 'After ticking, the container mode for the RF fresh food is the automatic allocation',
  '勾选后RF统配拣货模块(含明细)显示商品代码,不勾选不显示': 'After ticking, the RF unified picking module (including details) displays the commodity code, and it will not be displayed if not ticked',
  '勾选后RF统配拣货模块,实拣处显示待拣信息,不勾选显示空,允许修改': 'After ticking, the information to be picked is displayed at the actual picking site under the RF unified distribution module It shows left blank if not ticking and the modification is allowed',
  '勾选后RF统配拣货满容后自动跳转平移': 'After ticking, the automatic skip translation after the RF unified picking is full.',
  '勾选后RF装车界面装车时允许扫描空闲容器装车': 'After ticking it for RF inventory-in-log, the RF loading interface to allow scanning of idle containers when loading',
  '勾选后RF装车界面，待装车容器按容器最后修改时间升序排序': 'After ticking, the containers to be loaded are sorted in ascending order according to the last modification time of the containers',
  '勾选后RF退仓收货模块,收货处显示待退信息,不勾选显示空,允许修改': 'After ticking, the information to be returned is displayed at the receipt under the RF return module It shows left blank if not ticking and the modification is allowed',
  '勾选后WEB摘果默认显示件数/数量': 'After ticking, WEB digital picking displays the pcs/quantity by default',
  '勾选后WEB播种默认显示件数/数量': 'After ticking, WEB digital assorting displays the pcs/quantity by default',
  '勾选后上架可不输入推荐的上架货位': 'After ticking, the inventory in-log position recommended may not be recommended',
  '勾选后以外部批次作为系统批次管理，反之单独管理': 'After ticking, the external batch is taken as the system batch for management Otherwise, it shall be managed separately',
  '勾选后优先查询拣货单中缺货或跳过的数据': 'After ticking, it will give priority to query the data that is out of stock or skipped in the picking list',
  '勾选后出货打印容器条码': 'After ticking, print the container barcode for shipment',
  '勾选后则启用': 'Enable it after ticking',
  '勾选后单品复查扫描条码后显示条码对应规格数量,不勾选显示数量1': 'After ticking and scanning the barcode for single item review, display the quantity specified in the corresponding specification Otherwise, it will display the quantity 1.',
  '勾选后可在排车看板页面查看一步越库收货暂存位上的信息，不可装车': 'After ticking, the information of the temporary receipt location of the one-step cross-dock could be viewed on the dispatch board page The loading could not be carried out',
  '勾选后可在排车看板页面查看拣货暂存位上的信息，不可装车': 'After ticking, the information of the temporary receipt location of picking could be viewed on the dispatch board page The loading could not be carried out',
  '勾选后可在排车看板页面查看统配集货暂存位上的信息': 'After ticking, ticking check the information of the temporary goods location of unified distribution in the dispatching board page',
  '勾选后可在排车看板页面查看越库集货暂存位上的信息': 'After ticking, ticking check the information of the temporary cross-dock goods location in the dispatching board page',
  '勾选后可在排车看板页面查看门店分播位上的信息': 'After ticking, check the information of store distribution location on the dispatch board page',
  '勾选后可在排车看板页面查看集货位上的信息': 'After ticking, ticking check the information of the goods location in the dispatching board page',
  '勾选后在RF退仓收货展示商品退货条件信息': 'After ticking, display the return condition information in the RF return receipt',
  '勾选后平移时输入的目标位置，可以不在系统建议货位范围内': 'After ticking, the target location entered in transfer could not fall in the scope of the recommended goods location',
  '勾选后平移界面显示固定拣货位、集货位信息，显示货位代码': 'After ticking, the transfer interface displays the fixed picking location and picking location, and the picking location code',
  '勾选后支持web单据审核负库存': 'After ticking, support the web document to audit the negative inventory',
  '勾选后支持打印标签拣货负库存': 'After ticking, support the printed label for negative picking inventory',
  '勾选后收货打印容器条码': 'After ticking, print the container barcode for receiving',
  '勾选后显示类越库分播门店代码，不勾选不显示': 'After ticking, display the code of the category cross-dock distribution store Otherwise, it will not display the information',
  '勾选后电商提总自动带出箱零': 'After ticking, the e-commerce\'s overall picking will automatically take out the remaining part',
  '勾选后类越库分播显示门店代码，不勾选不显示': 'After ticking, display the code of the category cross-dock distribution store Otherwise, it will not display the information',
  '勾选后系统扫描容器后，若商品未混载系统自动跳转到容器一栏，不需要扫描商品确认，分播另一家门店的时候光标跳转到容器一栏': 'After ticking for scanning the container, if it is automatically skipped to the container column due to that the commodity is not mixed, it will not scan the commodity for confirmation When it is distributed to another store, the cursor will be skipped to the container',
  '勾选后累加,不勾选为替换': 'Tick to accumulate and untick to replace',
  '勾选后自动回主界面': 'After ticking, return to the main interface automatically',
  '勾选后配合rf分配复选框可以自动跳转到库存分配界面，不勾选不跳转': 'After ticking, cooperate with rf allocation checkbox to skip to the inventory allocation interface automatically Otherwise, I will not be skipped',
  '勾选后高叉作业补货跳过源容器校验': 'After ticking, skip the source container checking for the replenishment of high-level forklift operation',
  '勾选的明细必须退仓类型必须是好退或返厂类型': 'The selected details must be returned. The type must be good return or return to the factory.',
  '勾选的明细退仓类型必须是好退类型': 'The selected detailed withdrawal type must be a good refund type',
  '包名': 'Packet name',
  '包名不能为空': 'The packet name cannot be left blank',
  '包含的商品代码': 'Product code included',
  '包含的商品代码,多个代码以逗号隔开': 'en-包含的商品代码,多个代码以逗号隔开',
  '包含的组别': 'Included Groups',
  '包含的门店': 'Included Stores',
  '包含的门店代码,多个代码以逗号隔开': 'en-包含的门店代码,多个代码以逗号隔开',
  '包含门店': 'Include the store',
  '包装代码': 'Packaging code',
  '包装件数': 'Number of packages',
  '包装名称': 'Package name',
  '包装形式': 'package style',
  '包装机': 'Packing Machine',
  '包装机/分拣机配置': 'Configuration of packaging machine/sorter',
  '包装机商品维护': 'Packaging Machine Product Maintenance',
  '包装机类型': 'Type of packaging machine',
  '包装耗材': 'Package consumables',
  '包装耗材代码': 'Code of package consumables',
  '包装耗材名称': 'Name of package consumables',
  '包装耗材管理': 'Package Consumables',
  '包装耗材配置': 'Configuration of package consumables',
  '包装规格/计量单位': 'Package specification/unit of measurement',
  '包裹号': 'Package No',
  '包裹重量(kg)': 'Package weight (kg)',
  '区域': 'area',
  '区域代码': 'Area code',
  '区域名称': 'Area name',
  '区段': 'segment',
  '区段代码': 'District code',
  '区段名称': 'District name',
  '区段标签': 'Section label',
  '区段顺序': 'Section sequence',
  '华北': 'Northern China',
  '单件皮重': 'Tare weight per piece',
  '单件皮重(g)': 'Tare weight per piece (g)',
  '单件皮重(kg)': 'Tare weight per piece (kg)',
  '单价': 'Unit price',
  '单价或者扣损重量': 'Unit price or deducted weight',
  '单位': 'unit',
  '单号': 'Number',
  '单号/容器': 'Track number/container',
  '单号/来源单号': 'Doc No./Source Doc No',
  '单号/来源单号/网络订单号，多个以逗号隔开': 'Order number/source order number/network order number, multiple separated by commas',
  '单号不存在': 'Track number does not exist',
  '单号：': 'No.:',
  '单品复查': 'Single-item review',
  '单品复查扫描条码显示数量': 'Single product review scan barcode display quantity',
  '单品最大数量': 'Max quantity of single item',
  '单品最大金额': 'Max amount of single item',
  '单品模式': 'Single-item mode',
  '单品模式的拣货单将修改为多品模式，多品模式的将修改为单品模式': 'The picking list in single item mode will be modified to multiple item mode, and those in multiple item mode will be modified to single item mode',
  '单品要货数量上限': 'Upper quantity demand of single item',
  '单店摘果': 'Single outlet digital picking',
  '单店整托盘': 'Entire pallet of single outlet',
  '单据': 'document',
  '单据使用容器后置打印配置': 'The container post printing configuration is used for the document',
  '单据供应商': 'Document supplier',
  '单据供应商取值配置': 'Value configuration of document supplier',
  '单据信息': 'Document information',
  '单据创建配置': 'Configuration of document creation',
  '单据字段': 'Document field',
  '单据导入': 'Document Import',
  '单据日结': 'Daily settlement of document',
  '单据日结配置': 'Daily settlement configuration of document',
  '单据明细': 'Document details',
  '单据明细不能为空': 'Document details cannot be empty',
  '单据状态配置': 'Configuration of document status',
  '单据类型': 'Document type',
  '单据类型与所选复核台不匹配': 'The document type does not match the selected review station',
  '单据装车': 'Document loading',
  '单据规格': 'Document specification',
  '单据规格取值配置': 'Value configuration of document specification',
  '单据配置': 'Document configuration',
  '单据默认仓位取值配置': 'The warehouse location value configuration is default in the document',
  '单据默认仓位取值配置{successLocale}': 'Default Warehouse Location Value for Documents Configuration {successLocale}',
  '单独释放': 'release alone',
  '卡片': 'card',
  '卸货方式': 'US 卸货方式',
  '原件数': 'Original quantity',
  '原商品': 'original product',
  '原因': 'Cause',
  '原数量': 'Original quantity',
  '原料': 'Raw material',
  '原料信息': 'Information on raw materials',
  '原料加工位': 'Processing position of raw materials',
  '原料加工位代码': 'Code of processing position of raw materials',
  '原料明细': 'Details of raw materials',
  '原料明细不能为空': 'The details of raw materials shall not be left blank',
  '原料明细第{line}行件数不能为0': 'The number of pieces in line {line} of raw material details cannot be 0',
  '原料明细第{line}行包装规格不能为空': 'The packaging specification in line {line} of the raw material details cannot be empty',
  '原料池': 'Raw material pool',
  '原料记录值是否有默认值': 'Whether there is default recorded value for raw material.',
  '原料记录值标题': 'Title of recorded value of raw materials',
  '原料量上下限制计算维度': 'Upper and lower limit of the raw material volume to calculate dimension',
  '县/区': 'County (district)',
  '参考规格': 'Reference specifications',
  '发票': 'invoice',
  '发票打印机': 'Invoice printer',
  '发票打印模板': 'Invoice printing template',
  '发送成功': 'Sent successfully',
  '发送拣货单到IPS': 'Send the picking list to IPS',
  '发送日期': 'Send date',
  '发送时间': 'send time',
  '取值不能为空': 'The value shall not be left blank',
  '取消': 'Cancel',
  '取消{length}个选项': 'Cancel {length} options',
  '取消分配成功': 'Unassign succeeded',
  '取消成功': 'Cancel succeeded',
  '取消收藏': 'Cancel collection',
  '可分配量': 'Allocatable quantity',
  '可替换商品明细第{line}行商品不能为空！': 'Line {line} of replaceable product details cannot be empty!',
  '可替换商品明细第{line}行商品不能和被替换商品相同！': 'The product in line {line} of replaceable product details cannot be the same as the replaced product!',
  '可用处理方式': 'Available processing methods:',
  '可用库存货位用途范围配置': 'Configuration of purposes and scope of the available inventory goods location',
  '可用条码解析规则配置': 'Available barcode resolution rule configurations',
  '可用空间': 'Available space',
  '可缺货处理配单类型': 'Out-of-stock processing distribution order type',
  '司机': 'Driver',
  '合并任务': 'Combined task',
  '合并规则': 'Merging rules',
  '合格': 'Qualified',
  '合格区间': 'Qualifying interval',
  '合格区间范围': 'Scope of qualified range',
  '合格标识': 'Conformity Mark',
  '合计单数': 'Total Singles',
  '同一货架内校验码不重复': 'The check code shall not be repeated in the same goods shelf.',
  '同单同品记录': 'Same order and same product record',
  '同步线路体系方案': 'Synchronous route system scheme',
  '名称': 'Name',
  '名称不能为空': 'The name cannot be left blank',
  '向上修正': 'improvement fix',
  '向下修正': 'correction down',
  '否': 'No',
  '含税单价': 'Tax-included unit price',
  '启动': 'Enable',
  '启动中': 'Enabling',
  '启动完成': 'Enabled',
  '启动异常': 'Abnormal enabling',
  '启动成功': 'Successfully started',
  '启动时间': 'Enabling time',
  '启动波次': 'Enable wave',
  '启用': 'Enable',
  '启用{length}个选项': 'Enable {length} options',
  '启用封签号': 'Activate seal number',
  '启用成功': 'Enable successfully',
  '员工': 'Employee',
  '员工代码': 'en-员工代码',
  '员工名称': 'en-员工名称',
  '员工工号': 'Employee No.',
  '周一': 'Monday',
  '周三': 'Wednesday',
  '周二': 'Tuesday',
  '周五': 'Friday',
  '周六': 'Saturday',
  '周四': 'Thursday',
  '周日': 'Sunday',
  '品项': 'Item',
  '品项数': 'Number of items',
  '商品': 'Commodity',
  '商品/商品规格': 'Commodity/ commodity specification',
  '商品: {article}': 'en-商品: {article}',
  '商品[{article}]不在当前容器内，是否继续？': 'en-商品[{article}]不在当前容器内，是否继续？',
  '商品{article}未维护长宽高重信息': 'Product {article} does not maintain length, width, height, and weight information',
  '商品{code}正在收货，确认切换？': 'Product {code} is receiving goods. Are you sure to switch?',
  '商品{repeatItem}存在多个规格，不允许收货': 'Product {repeatItem} has multiple specifications and cannot be received',
  '商品{repeatItem}存在多个规格，不允许预检': 'Product {repeatItem} has multiple specifications, Pre inspection is not allowed',
  '商品{repeatItem}存在多个规格，是否继续收货': 'Product {repeatItem} has multiple specifications. Whether Continue receiving',
  '商品{repeatItem}存在多个规格，是否继续预检': 'Product {repeatItem} has multiple specifications. Whether continue pre inspection',
  '商品不能为空': 'The commodity cannot be left blank',
  '商品业务信息': 'Business information of commodity',
  '商品代码': 'Commodity code',
  '商品代码,多个商品以逗号隔开': 'Product code, multiple products separated by commas',
  '商品代码/名称': 'Commodity code/title',
  '商品代码/容器': 'en-商品代码/容器',
  '商品代码{newArticleCodeStr}是新品，请维护商品业务信息后再进行{operate}操作': 'The product code {newArticleCodeStr} is a new product. Please maintain the product business information before performing the {operate} operation',
  '商品代码{newArticleCodeStr}是新品，请维护商品业务信息后再进行收货操作': 'The product code {newArticleCodeStr} is a new product. Please maintain the product business information before performing the receipt operation',
  '商品代码{newArticleCodeStr}是新品，请维护商品业务信息后再进行预检操作': 'The product code {newArticleCodeStr} is a new product. Please maintain the product business information before performing the pre inspection operation',
  '商品件数和附件个数比例': 'Proportion between the commodity pcs and attachment pcs',
  '商品件数和附件个数比例 最长是30': 'The max proportion between the commodity pcs and attachment pcs is 30.',
  '商品件数：{totalQtyStr}/{canBookQtyStr}（单个时间段{maxReceiveQtyStr}）': 'Number of items: {totalQtyStr}/{canBookQtyStr} (single time period {maxReceiveQtyStr})',
  '商品供应商': 'Commodity supplier',
  '商品信息': 'Commodity data',
  '商品信息刷新失败': 'Product information refresh failed',
  '商品分播管理方案配置': 'Configuration of management scheme of commodity distribution',
  '商品名称': 'Commodity name',
  '商品品项数：      {totalArticleCount}/{maxReceiveArticleCount}': 'Number of commodity items: {totalArticleCount}/{maxReceiveArticleCount}',
  '商品备注': 'Notes to the commodity',
  '商品存储范围配置': 'Configuration of the commodity storage scope',
  '商品尺寸规格信息维护提示': 'Maintenance prompt of the size specification of commodity',
  '收货规格是否需确认': 'Whether the receiving specifications need to be confirmed',
  '商品是否严格按明细供应商收货': 'Whether the goods are received strictly according to the detailed suppliers',
  '商品库存不足': 'Insufficient inventory of goods',
  '商品收货成功': 'Goods received successfully',
  '商品明细': 'Commodity details',
  '商品是否跨容器': 'Whether the commodity crosses the containers',
  '商品条码': 'Commodity barcode',
  '商品状态': 'Commodity status',
  '商品类别': 'product category',
  '商品组': 'Commodity group',
  '商品组分单': 'Commodity group list',
  '商品组分单配置': 'Commodity group list configuration',
  '商品组名称': 'Commodity name',
  '商品组配置': 'Configuration of commodity group',
  '商品结算方式配置': 'Configuration of the commodity\'s settlement mode:',
  '商品维度': 'product dimension',
  '商品耗材': 'Commodity Consumables',
  '商品耗材不存在': 'Commodity consumables do not exist',
  '商品耗材管理': 'Commodity Consumables',
  '商品耗材配置': 'Configuration of commodity consumables',
  '商品范围': 'Commodity scope',
  '商品范围最大长度100': 'Product range max length 100',
  '商品规格': 'Specifications',
  '商品超过到效期': 'The product is past the expiry date',
  '商品超过收货控制天数': 'The item exceeds the number of days of receipt control',
  '商品默认信息配置': 'Default information configuration of commodity',
  '商品默认信息配置 保存成功': 'Product default information configuration saved successfully',
  '商品：[{articleCode}]{articleName}/{qpcStr}已收完，请切换规格或商品再提交': 'Product: [{articleCode}] {articleName}/{qpcStr} has been received. Please switch specifications or product before submitting',
  '商品：{codename}分播数量不能大于拣货数量': 'Product: {codename} Distribution quantity cannot be greater than picking quantity',
  '商品：{tips}，已超收，是否继续？': 'Product: {tips}, overcharged, continue?',
  '回仓': 'Returning to warehouse',
  '回传日期': 'return date',
  '回传时间': 'Return time',
  '回收信息': 'Recycling information',
  '回收信息不能为空': 'Recycling information cannot be empty',
  '回收容器取值模式': 'Recycling container value taking  mode',
  '回收容器取值模式配置': 'Recycle container value taking mode configuration',
  '回收成功': 'Successful recycling',
  '回收数量': 'Collection quantity',
  '回收明细': 'Recovery details',
  '回收类型': 'Type of recovery',
  '回滚': 'Rollback',
  '回滚成功': 'Rollback successfully',
  '回车中': 'Carriage return',
  '回车里程数': 'Carriage return mileage:',
  '团队': 'Team',
  '团队内排名': 'Ranking in the team',
  '固定值': 'Fixed value',
  '固定分播位': 'Fixed distribution location',
  '固定方案': 'Fixed plan',
  '图片': 'Image',
  '图片：{name}上传成功': 'Image: {name} uploaded successfully',
  '在店': 'In store',
  '在门店': 'in store',
  '地址': 'Address',
  '地址不能为空': 'Address shall not be left blank',
  '基本信息': 'Basic information',
  '基本信息的货主和仓位不能为空，请选择之后再检索！': 'The owner and warehouse location under the basic information shall not be left blank Please search after choosing!',
  '基本资料': 'Basic Information',
  '基本资料维护': 'Basic Data Maintenance',
  '填写序号': 'Fill in the S/N',
  '填写打印时间间隔': 'Fill in the printing interval.',
  '填写振幅': 'Fill in amplitude',
  '填写最小打印标签数': 'Fill in the min number of printed labels',
  '填写连续打印次数': 'Fill in the number of continuous printing',
  '填写降幅': 'Fill in decreasing amplitude',
  '填写预留操作高度': 'Fill in the reserved operation height',
  '处理中...': 'In process..',
  '处理人': 'handler',
  '处理方式': 'Treatment method',
  '备注': 'Remarks',
  '备注不能为空': 'Remarks shall not be left blank',
  '备注最大长度为255': 'The max length of the remark is 255',
  '备注：': 'remarks:',
  '备用字段1': 'Standby field 1',
  '备用字段2': 'Standby field 2',
  '备用字段3': 'Standby field 3',
  '备用字段4': 'Standby field 4',
  '备货(%)': 'Preparation of goods (%)',
  '备货满足率(%)': 'Stocking Satisfaction Rate (%)',
  '复制{length}个选项': 'Copy {length} options',
  '复制成功': 'Copy succeeded',
  '复查': 'Review',
  '复查/装车': 'Review/loading',
  '复查件数': 'Pcs of review',
  '复查员': 'Review personnel',
  '复查子容器数': 'Number of child-container in review',
  '复查容器': 'Review container',
  '复查总件数': 'Total pcs of review',
  '复查总体积': 'Total volume of review',
  '复查总品项数': 'Total items of review',
  '复查总重量': 'Total weight of review',
  '复查总金额': 'Total amount of review',
  '复查数据存在差异，是否确认结束？': 'en-复查数据存在差异，是否确认结束？',
  '复查数量': 'Review qty',
  '复查方式': 'en-复查方式',
  '复查类型': 'Type of review',
  '复查组织': 'Review organization',
  '复查项': 'Review item',
  '复查项为容器，一次只能提交一个数量': 'en-复查项为容器，一次只能提交一个数量',
  '复核中': 'Under review',
  '复核件数': 'Number of review pieces',
  '复核区': 'Review area',
  '复核区还有待提交数据，请先满箱': 'There is still data to be submitted in the review area, please fill the box first',
  '复核台': 'Review desk',
  '复核台不能为空': 'Review workbench shall not be left blank',
  '复核台代码': 'Code of review workbench',
  '复核台名称': 'Title of review workbench',
  '复核台配置': 'Configuration of review workbench',
  '复核台配置代码': 'Configuration code of review workbench',
  '复核商品': 'Review commodity',
  '复核对应承运商': 'Review of the corresponding carrier',
  '复核差异生成': 'Review variance generation',
  '复核成功': 'Review successfully',
  '复核打包': 'Review packaging',
  '复核打印': 'Review print',
  '复核数量': 'Number of reviews',
  '复核数量不能为0': 'The review quantity cannot be 0',
  '复核数量异常,请检查你的拣货单': 'Check the quantity is abnormal, please check your picking list',
  '复核规格': 'Review specification',
  '复核配置代码': 'Review the configuration code',
  '复核配置名称': 'Title of review configuration',
  '复满': 'Review completion',
  '复盘': 'Review',
  '复盘{length}个选项': 'Duplicate {length} options',
  '复盘成功': 'Recovery is successful',
  '复盘次数': 'Times of review',
  '外宽(cm)': 'Outer width (cm)',
  '外部批号': 'External batch',
  '外部批号存储解析': 'Storage analysis of external batch number',
  '外部批号展示解析': 'Display analysis of external batch number',
  '外部批号解析配置': 'Analysis and configuration of external batch number',
  '外部批次': 'External batch',
  '外长(cm)': 'External length (cm)',
  '外长/宽/高(cm)': 'External length/width/height (cm)',
  '外高(cm)': 'External height (cm)',
  '多个以逗号隔开,不可输入特殊符号,最大长度100': 'It is separated by the comma and no special symbol could be entered The max length is 100.',
  '多品模式': 'Multiple-item mode',
  '多店整托盘': 'en-多店整托盘',
  '多店整托盘、单店摘果和三种提总至少需选择一项': 'US 多店整托盘、单店摘果和三种提总至少需选择一项',
  '多店整托盘、存储位提总、拣货位提总、混合提总、四种模式最多只允许存在一项': 'US 多店整托盘、存储位提总、拣货位提总、混合提总、四种模式最多只允许存在一项',
  '多货强分算法加强': 'Enhancement of multiple goods strong division algorithm',
  '多轮录入': 'Multi-round entry',
  '多配': 'Multi-match',
  '多配不可重复配置可用处理方式': 'Multiple configuration can not be repeated configurable available processing mode',
  '多配可用处理方式': 'Multiple available processing methods',
  '够出货量': 'enough to ship',
  '大型拣货位': 'Large picking location',
  '大型拣货位自动生成拣货指令商品配置': 'The large picking location automatically generates the configuration of picking instruction commodity',
  '大型拣货位范围': 'Large pick slot range',
  '大型集货位范围': 'Scope of large-scale goods location',
  '大润发条码': 'RT-Mart Barcode',
  '失效': 'Invalid',
  '失效成功': 'Failed successfully',
  '失败': 'Failed',
  '失败{action}': 'Failed {action}',
  '奇偶位': 'parity bit',
  '奇数货架': 'Odd shelves',
  '好退': 'Easy return',
  '好退控制天数': 'Control days of easy return',
  '好退的目标货位': 'Target location of easy return',
  '无独占退货位时默认退货位配置': 'Default return position configuration without exclusive return position',
  '好退退仓收货中': 'Good Return Return warehouse Receiving',
  '如果输入多个，以英文逗号隔开': 'If too items are entered, it shall be separated by English comma.',
  '子容器': 'Child-container',
  '子容器拣货': 'Pickup of child-container',
  '子容器数': 'Number of the child-container',
  '子容器满容': 'Full capacity of the child-container',
  '字符串': 'string',
  '存储位': 'storage location',
  '存储位优先': 'memory bit first',
  '存储位提总': 'Storage bit increase',
  '存储位整托盘提总': 'Storage position for the entire pallet',
  '存储位非整托盘提总': 'Storage position partial pallet lift total',
  '存储区域': 'Storage region',
  '存储范围': 'Storage scope',
  '存储货位高度限制': 'Height limitation of storage goods location',
  '存储过程': 'Stored procedure',
  '存储过程名': 'Stored Procedure name',
  '存在原料明细剩余数量件数大于原始数量件数': 'There are raw material details, the remaining number of pieces is greater than the original number of pieces',
  '存在商品库存为0和商品库存小于门店要货量的数据，确认继续执行分配？': 'The data exist that the commodity inventory is 0 and the commodity inventory is less than the demand quantity Do you confirm to execute the distribution?',
  '存在商品库存为0的数据，确认继续执行分配？': 'The data exist that the commodity inventory is 0. Do you confirm to continue to execute the distribution?',
  '存在商品库存小于门店要货量的数据，确认继续执行分配？': 'The data exist that the commodity inventory is less than the demand quantity of the store Do you confirm to execute the distribution?',
  '存在库存': 'The inventory exists',
  '存在重命名未保存，请先回车保存': 'There is a rename that has not been saved, please press Enter to save it',
  '存在门店未分播，是否确认结束加工': 'There are stores that are not distributed. Are you sure to end processing',
  '完成': 'Complete',
  '完成{length}个选项': 'Complete {length} options',
  '完成加工波次单成功': 'Successfully completed the processing wave order',
  '完成成功': 'Completed successfully',
  '完成指示': 'Complete the instruction',
  '完成日期': 'Completion date',
  '完成时间': 'Completion time',
  '完成装车': 'Finish loading',
  '完成装车时间': 'Complete the loading time',
  '完成订单': 'Order completed',
  '完成进度': 'Completion progress',
  '完成退仓通知单': 'Complete the return notice list',
  '完成配货通知单': 'Complete the delivery notice',
  '定价类型': 'Pricing type',
  '实体日志表保留时长(天)': 'Retention days in the entity log sheet',
  '实体日志表保留时长不能为空': 'The retention days in the entity log sheet shall not be left blank',
  '实体标示': 'entity marking',
  '实分件数': 'actual number',
  '实分数量': 'Number of real points',
  '实拣': 'Actual picking up',
  '实拣件数': 'number of cases',
  '实拣件数不为0时，数量不允许为0': 'When the actual number of pieces picked is not 0, the quantity cannot be 0',
  '实拣分播数量': 'Actual picking and distribution quantity',
  '实拣品项数': 'Number of items actually picked',
  '实拣拣货单数': 'Number of actual picking orders',
  '实拣数量': 'Actual Picking Quantity',
  '实拣数量不能为0': 'The actually-picked quantity cannot be 0',
  '实拣数量不能大于应拣数量': 'The actual picking quantity cannot be greater than the quantity to be picked',
  '实拣重量': 'Actual-picking weight',
  '实损件数': 'Number of cases',
  '实损数量': 'Actual loss',
  '实播': 'Real-time distribution',
  '实播 :': 'Actual sowing:',
  '实播件数': 'Number of actual sowing',
  '实播数量': 'Number of live broadcasts',
  '实盘件数': 'Number of firm offer pcs',
  '实盘数量': 'Firm offer quantity',
  '实盘结果一致，是否更新盘点数据': 'The actual results are consistent, whether to update the inventory data',
  '实盘结果存在差异，是否更新盘点数据': 'If there is a discrepancy in the actual results, whether to update the inventory data',
  '实补件数': 'Completion cases',
  '实退数量不等于应退数量，是否确认完成？': 'The actually-returned quantity shall not be equal to the refundable quantity Do you confirm the completion?',
  '实际交接数': 'Actual handover quantity',
  '实际件数': 'Number of actual pcs',
  '实际件数不能大于件数': 'The actual number of pieces cannot be greater than the number of pieces',
  '实际值': 'Actual value',
  '实际原料量': 'Actual raw material quantity',
  '实际回收数': 'Actual quantity recovered',
  '实际成品量': 'Number of actual finished products',
  '实际数量': 'Actual quantity',
  '实际数量不等于下发数量提示': 'The actual quantity is not equal to the distributed quantity',
  '实际数量大于超拣数量，是否确认？': 'The actual quantity is greater than the over-picking quantity Do you confirm?',
  '实际返配件数': 'Actual pcs of returned parts',
  '实际集货位': 'Actual collection location',
  '实验数量': 'Experiment quantity',
  '审核': 'Audit',
  '审核{length}个选项': 'Audit  {length} options',
  '审核成功': 'Review succeeded',
  '审核领用单': 'Audit the requisition list',
  '客户下单时间': 'Ordering time',
  '客户单数': 'number of customers',
  '客户单数不能为空': 'Customer pcs shall not be left blank',
  '容器': 'Container',
  '容器/整箱': 'Container/full container',
  '容器[{container}]不是当前的子容器，是否继续？': 'en-容器[{container}]不是当前的子容器，是否继续？',
  '容器{containerCode}中没有需要复查的明细': 'en-容器{containerCode}中没有需要复查的明细',
  '容器不存在': 'The container does not exist',
  '容器不能为空': 'The container shall not be left blank',
  '容器代码': 'Container code',
  '容器件数': 'Number of the container',
  '容器件数复查': 'Container Piece Review',
  '容器信息': 'Container information',
  '容器出入单': 'Container Entry And Exit List',
  '容器出入单明细不能为空': 'Container entry and exit details cannot be empty',
  '容器分配方式': 'Container allocation mode:',
  '容器号': 'Container No.',
  '容器后置打印配置日志': 'Post-printing configuration log of the container',
  '容器回收': 'Container Recovery',
  '容器复查': 'Container Review',
  '容器复查单': 'Container Review Sheet',
  '容器复查单日结': 'Container review single-day closing',
  '容器复查数量不能为空': 'The review quantity of the container shall not be left blank',
  '容器复查最大输入数量': 'Max input quantity in container review',
  '容器库存': 'Container inventory',
  '容器打印机推荐': 'Recommendation of the container printer',
  '容器拆并': 'Container split and combination',
  '容器拆并单': 'Container Dismantling and Single',
  '容器拆并单日结': 'Container dismantling and single-day settlement',
  '容器拆并默认操作方式': 'Container disassembly and default operation mode',
  '容器数': 'Number of containers',
  '容器明细': 'Container details',
  '容器条码': 'Container barcode',
  '容器条码最多8位最少4位': 'Container barcode with a max of 8 digits and a min of 4 digits',
  '容器满容复查配置': 'Review configuration for the full capacity of container',
  '容器状态': 'Container status',
  '容器码': 'Container code',
  '容器管理': 'Container management',
  '容器类型': 'Container Type',
  '容器类型大类': 'Container Type Sort',
  '大类': 'Sort',
  '容器类型不能为空': 'The type of container shall not be left blank',
  '容器类型代码': 'Code of the type of container',
  '容器类型代码/名称': 'Code/name of the container type',
  '容器类型名称': 'Title of the type of container',
  '容器类型承载关系': 'Type bearing relationship of the container',
  '容器类型承载绑定时机': 'Type bearing biding time of the container',
  '容器类型承载绑定时机{successLocale}': 'Container type bearer binding timing {successLocale}',
  '容器绑定/拆并': 'Container binding/split and combination',
  '容器绑定单': 'Container Binding',
  '容器绑定单日结': 'Container-bound single-day settlement',
  '容器：{barcode}': 'Container: {barcode}',
  '容积率(%)': 'Plot ratio(%)',
  '容超上限': 'Exceed the upper limit',
  '宽': 'Width',
  '宽(cm)': 'Width (cm)',
  '密码': 'Password',
  '对于重量结算的商品,在RF生鲜摘果拣货,RF类越库分播模块,RF类越库商品分播模块,web端摘果拣货和播种拣货,当拣货数量大于等于应拣数量时,自动提交完成,自动获取并跳转下一个拣货任务': 'For goods with weight settlement, in the RF fresh fruit picking module, the RF similar cross stock and distribution module, the web side fruit picking and seeding picking module, when the picking quantity is greater than or equal to the required picking quantity, the system automatically submits the goods, automatically obtains them, and jumps to the next picking task',
  '对于重量结算的商品,在RF生鲜摘果拣货,RF类越库分播模块,RF类越库商品分播模块,当拣货数量大于等于应拣数量时,自动提交完成,自动获取并跳转下一个拣货任务': 'For the commodity with weight settlement, pick in RF fresh food In the RF category cross-dock distribution module, when the picking quantity is greater than or equal to the quantity that shall be picked, submit and acquire it automatically, and skip to the next picking task',
  '对应码头用途不符，是否分配？': 'en-对应码头用途不符，是否分配？',
  '对接外部系统': 'en-对接外部系统',
  '导入': 'Import',
  '导入{title}': 'en-导入{title}',
  '导入单据': 'Import the document',
  '导入明细': 'Import of the details',
  '导入模板': 'Import template',
  '导入模板名称': 'Title of imported template',
  '导入通知单': 'Import notice',
  '导入门店': 'Import stores',
  '导出': 'export',
  '封仓': 'closed warehouse',
  '封仓人': 'Sealer',
  '封仓解仓配置': 'Configuration of the sealing and release receipt',
  '封仓锁定': 'en-封仓锁定',
  '封存仓位': 'Sealing warehouse location',
  '封存数量': 'Sealing quantity',
  '小数位数不超过4位': 'No more than 4 decimal places',
  '小润发生鲜条码': 'Xiaorun Fresh Barcode',
  '少退原因': 'Reasons for less return',
  '少配': 'less match',
  '少配不可重复配置可用处理方式': 'Less configuration, non repeatable configuration, available processing methods',
  '少配可用处理方式': 'Less configuration available processing methods',
  '尾板': 'Tail board',
  '尾板剩余': 'Remaining tail board',
  '层数': 'Floors',
  '层码': 'Floor code',
  '层码范围': 'Layer code scope',
  '层码范围不为空，请填写完整': 'The scope of the floor code shall not be left blank, please fully complete it',
  '展开': 'Unfold',
  '展示货位取值': 'Display the values of goods location',
  '差异件数': 'Difference pcs',
  '差异体积': 'Difference volume',
  '差异信息': 'Difference information',
  '差异原因': 'Reasons for the difference',
  '差异品项数': 'Difference items',
  '差异处理': 'Dispose the differences',
  '差异容器数': 'Number of difference containers',
  '差异数量': 'Difference quantity',
  '差异明细不能为空': 'Difference details cannot be empty',
  '差异类型': 'Type of difference',
  '差异虚拟维护': 'Virtual maintenance of difference',
  '差异货位数': 'Different designated number',
  '差异重量': 'Different amount',
  '差异量': 'amount of difference',
  '差异金额': 'Difference amount',
  '已下架': 'has been removed',
  '已交接': 'Handed over',
  '已作废': 'Voided',
  '已使用': 'Used',
  '已保存': 'Saved',
  '已停用': 'terminated',
  '已入园': 'Entry',
  '已出园': 'Exit',
  '已分配': 'Allocated',
  '已分配码头': 'Dock assigned',
  '已分配集货位': 'Goods location distributed',
  '已分量': 'Quantified',
  '已删除': 'Deleted',
  '已发送': 'Sent',
  '已启用': 'Enabled',
  '已回传': 'Returned',
  '已回收': 'Recovery',
  '已回收数': 'Items recovery',
  '已复SKU数': 'Number of SKUs Checked',
  '已复数量': 'Checked Quantity',
  '已复核': 'Reviewed',
  '已复箱': 'Reviewed',
  '已完成': 'Completed',
  '已审核': 'Audited',
  '已打印': 'Printed',
  '已执行': 'Executed',
  '已批准': 'Approved',
  '已拣货': 'Picked',
  '已排车': 'Loaded',
  '已揽件': 'Collected',
  '已收/应收件数': 'Pcs received/receivable',
  '已收/应收数量': 'Quantity received/receivable',
  '已收/拒收/件数': 'Received/Rejected/Number of Pieces',
  '已收/拒收/数量': 'Received/ refusal/quantity',
  '已收货件数': 'Shipments received',
  '已收货体积': 'Received volume',
  '已收货品项数': 'Items received',
  '已收货重量': 'Received weight',
  '已收货金额': 'Amount received',
  '已有{workType}人员{empName}': 'already exist {workType} personnel {empName}',
  '已核价': 'Reviewed',
  '已添加': 'Added',
  '已添加{number}个用户': '{number} users have been added',
  '已盘入': 'already loaded',
  '已禁用': 'Disabled',
  '已签收': 'Signed',
  '已被设置为标准规格，不允许被删除': 'It has been set as standard specification and cannot be deleted',
  '已装车': 'Loaded',
  '已超过预约配置的最大可预约件数,是否确认保存？': 'The max number of appointed pieces configured has been exceeded Do you confirm to save?',
  '已跳过！': 'Skipped!',
  '已退/总件数': 'Returned/total pcs',
  '已退/总数量': 'Returned/ total quantity',
  '已退/总金额': 'Returned/total amount',
  '已退件数': 'Pcs returned',
  '已退品项数': 'Items returned',
  '已退金额': 'Returned amount',
  '已选中': 'Selected',
  '已锁定': 'Locked',
  '已预约': 'Appointed',
  '已领用': 'Received',
  '市': 'City',
  '帐单': 'Bill',
  '帮助说明': 'Help text',
  '常温': 'Ambient temperature',
  '常规': 'conventional',
  '平均货架数': 'Average goods location',
  '平均货道数': 'Average goods lane',
  '平板模块名': 'Pad module name',
  '平板模块名称': 'Pad module name',
  '平移': 'Translation',
  '平移中': 'Ransferring',
  '平移允许修改目标位置': 'Pan allows to modify the target position',
  '平移入': 'flat immigration',
  '平移展示拣/集货位信息': 'Pan display picking/collecting location information',
  '序列号': 'S/N',
  '序号': 'S/N',
  '序号调整': 'S/N adjustment',
  '库存+配置+空闲': 'us 库存+配置+空闲',
  '库存不足': 'Inventory shortage',
  '库存件数': 'Inventory quantity',
  '库存信息': 'Inventory information',
  '库存分配方案': 'Inventory Allocation Scheme',
  '库存分配类型：': 'Inventory allocation type:',
  '库存合并': 'Inventory combination',
  '库存处理': 'Inventory processing',
  '库存复查': 'Inventory review',
  '库存实物': 'Physical inventory',
  '库存对账': 'Inventory reconciliation',
  '库存批号': 'Inventory batch No.',
  '库存批号校验': 'Verification of inventory batch No.',
  '库存操作日志表保留时长(天)': 'Retention days of the inventory log sheet',
  '库存操作日志表保留时长不能为空': 'The retention days of the inventory operation log sheet shall not be left blank',
  '库存数量': 'Inventory quantity',
  '库存方案': 'Inventory scheme',
  '库存日期': 'stock date',
  '库存日结': 'Inventory day end',
  '库存明细': 'Inventory details',
  '库存模式': 'stock mode',
  '库存模式&商品状态使用配置': 'Configuration of inventory mode & commodity status',
  '库存比例': 'Inventory ratio',
  '库存流水表保留时长(天)': 'Remaining days of the inventory statement',
  '库存流水表保留时长不能为空': 'The remaining days of the inventory statement shall not be left blank',
  '库存调整': 'Inventory adjustment',
  '库存调整单': 'Inventory Adjustment List',
  '库存调整配置': 'Configuration of inventory adjustment',
  '库存转移成功': 'Inventory transfer succeeded',
  '库存过期日结': 'Inventory expiration date',
  '库存过配货控制天数日结': 'Inventory over-distribution control days',
  '应交接数': 'Deliverables',
  '应分件数': 'Number of applications',
  '应分数量': 'Amount to be scored',
  '应回收数': 'Items recovery',
  '应拣': 'Pickable',
  '应拣件数': 'Pieces to be picked',
  '应拣分播数量': 'The quantity to be sorted',
  '应拣品项数': 'Items to be picked',
  '应拣拣货单数': 'Number of pick orders to be picked',
  '应拣数量': 'Quantity pickable',
  '应播': 'should be broadcast',
  '应播件数': 'Pcs distributable',
  '应播数量': 'Quantity to be distributable',
  '应播：{qtyStr}/{qty}   实播：{realQtyStr}/{realQty}': 'Picked:{qtyStr}/{qty}  Actual:{realQtyStr}/{realQty}',
  '应收': 'Receivables',
  '应收数量': 'Quantity to be received',
  '应用名称': 'Application Name',
  '应用详情': 'Application details',
  '应补件数': 'Number of requests',
  '建议原料量': 'Recommended amount of raw materials',
  '开启': 'open',
  '开始上架': 'Start listing',
  '开始上架时间': 'Start the release time',
  '开始交接': 'Start the handover',
  '开始作业': 'Start operation',
  '开始复查': 'Start the review',
  '开始复查时间': 'Starting time of review',
  '开始平移': 'start panning',
  '开始拆并': 'start to dismantle',
  '开始拆并时间': 'Starting time of split and combination',
  '开始拣货': 'Start picking',
  '开始排车': 'start platooning',
  '开始排车时间': 'Loading time',
  '开始播种': 'Start digital assorting',
  '开始收货': 'Start collecting',
  '开始收货时间': 'Time of starting collection',
  '开始时间': 'Start time',
  '开始盘点': 'start inventory',
  '开始盘点时间': 'Start inventory time',
  '开始移库': 'Start moving library',
  '开始移库时间': 'Start warehouse shifting time',
  '开始绑定': 'Start to bind',
  '开始绑定时间': 'Time of binding',
  '开始补货': 'start restocking',
  '开始装车': 'Start loading',
  '开始装车时间': 'Time of loading',
  '开始退仓': 'Start return',
  '开始退仓时间': 'Start return time',
  '开始配送': 'Start delivery',
  '开始预检': 'start preflight',
  '异常': 'Abnormality',
  '异常原因': 'Cause of abnormality',
  '异常口': 'abnormal mouth',
  '异常品出货配置': 'Configuration of shipment of abnormal articles',
  '异常处理信息': 'Abnormal handling information',
  '异常处理明细第{line}行与第{otherLine}行重复！': 'The exception handling details of line {line} are repeated with those of line {otherLine}!',
  '异常处理明细第{line}行处理方式不能为空！': 'Quantity cannot be empty for line {line}!',
  '异常处理明细第{line}行数量不能为空！': 'The quantity in the {line} line of exception handling details cannot be empty!',
  '异常处理明细第{line}行条码不能为空！': 'Barcode cannot be empty for line {line}!',
  '异常待处理': 'Abnormal pending',
  '异常货位范围': 'Scope of abnormal goods location',
  '张单据已被打印，是否重复打印？': 'The document has been printed, whether to re-print it?',
  '强分': 'Mandatory distribution',
  '强分数量大于可用库存！': 'The number of strong points is greater than the available stock!',
  '强制': 'mandatory',
  '强制不使用': 'Force not to use',
  '强制使用': 'Forced to use',
  '强制报错': 'Force an error',
  '强制整托盘': 'Mandatory entire pallet',
  '强制限制': 'Mandatory limitation',
  '归还标识': 'Return identification',
  '当前': 'Current',
  '当前任务拣货完成！': 'The current task has been completed!',
  '当前位置': 'Current position',
  '当前位置用途': 'Purpose of the current position',
  '当前加工波次不存在原料商品明细，无法分播': 'There is no raw material commodity details in the current processing wave and cannot be broadcast',
  '当前商品图': 'Current commodity figure',
  '当前商品已超收，是否继续收货': 'The current commodity has been over-received Whether to continue to receive',
  '当前商品收货未完成，是否换商品？': 'The receipt of current commodity has not been completed, whether to alter the commodity?',
  '当前商品超收比例为0，不允许超收': 'The over-receipt proportion of the current commodity is 0 and the over receipt is not allowed',
  '当前库存内存在更新的库存批号': 'There is an updated stock lot number in the current stock',
  '当前快递单号': 'Current tracking number',
  '当前承运商': 'Current carrier',
  '当前指令已结束！': 'The current instruction has ended!',
  '当前指令拣货完成！': 'The picking has been completed for the current instruction!',
  '当前无可生成拣货单的通知单': 'There are currently no notifications to generate picklists',
  '当前无容器，无法满容！': 'There are currently no containers and cannot be filled!',
  '当前电商承运商未配置打印配置': 'he E-commerce carrier has not configured a printing configuration',
  '当前箱号': 'Current CTN No.',
  '当前箱号不能为空或-,请确定当前箱号': 'The current box number cannot be empty or -, please confirm the current box number',
  '当前箱号：': 'The current box number:',
  '当前网络不可用': 'The current network is unavailable',
  '当前角色下存在用户,不能被删除': 'The users exist under the current role and it could not be deleted',
  '当前订单中包含正在进行中的收货单，确认是否完成该订单?': 'The current order includes the receiving note in progress Do you confirm whether to complete the order?',
  '当前订单收货完成，确认是否结束？': 'The current order has been received, do you confirm to end?',
  '当前货位': 'Current goods location',
  '当前门店分播任务已结束！': 'The current store distribution task has ended!',
  '当天': 'the day',
  '当月一号': '1st of the month',
  '录入方式': 'Entry mode',
  '录入结果1': 'Entry result 1',
  '录入结果1盘点员与录入结果2盘点员不可重复': 'Entry Result 1 Counter and Entry Result 2 Counter cannot be repeated',
  '录入结果2': 'Entry result 2',
  '录入默认值': 'Default value for entry',
  '影响库存分配算法': 'Algorithm that affects the inventory allocation',
  '待分/应分门店': 'Store to be distributed/distributable',
  '待分件数': 'Waiting number',
  '待分数量': 'Number of points to be scored',
  '待分量': 'Weight to be divided',
  '待司机交接': 'Waiting for the driver to hand over',
  '待回容器数(总)': 'Number of the container to be recovered (total)',
  '待回容器数(数量)': 'Number of the container to be recovered ( quantity)',
  '待回容器数(条码)': 'Number of the container to be recovered ( barcode)',
  '待回收数': 'Items to be recovered',
  '待处理数量': 'Quantity to be processed',
  '待处理货位': 'Goods location to be handled',
  '待复': 'Wait for reply',
  '待复SKU数：': 'SKU to be replicated:',
  '待复数量：': 'Quantity to be replicated:',
  '待复核区': 'Awaiting replication area',
  '待复箱号：': 'Awaiting replication box number：',
  '待拣货': 'Awaiting picking',
  '待揽收': 'To be collected',
  '待播 :': 'Awaiting spreading：',
  '待收': 'To be received',
  '待收数量': 'Quantity to receive',
  '待生成': 'To be generated',
  '待签收': 'To sign',
  '待补货出': 'Awaiting outbound replenishment',
  '待补货进': 'To be replenished',
  '待配货': 'To be distributed',
  '待释放': 'pending release',
  '待领用件数': 'Number of cases for waiting period',
  '待领用数量': 'Quantity to be used',
  '循环分配': 'round robin',
  '必检': 'Must check',
  '必须为0-100之间的整数': 'It shall be the integer between 0 and 100.',
  '必须满足AABBCCDD，以-隔开的格式': 'Must meet the format AABBCCDD, separated by -',
  '快捷键配置': 'Shortcut key configuration',
  '快照件数': 'Pcs of snapshot',
  '快照数量': 'Quantity of snapshot',
  '快递公司': 'courier company',
  '快递公司不能为空': 'The courier services company shall not be left blank',
  '快递公司代码': 'Courier company code',
  '快递单号': 'Tracking No.',
  '快递单号不能为空': 'The tracking No. shall not be left blank',
  '快递单号状态日志': 'Log of tracking number status',
  '快递单号链接配置': 'Link configuration of the tracking number',
  '快递无法配送地址维护': 'The express delivery could not be delivered to the address for maintenance',
  '快递无法配送地址配置': 'The courier cannot deliver the address configuration',
  '快递状态': 'Express status',
  '快递配置名称': 'Title of express configuration',
  '快递面单': 'courier bill',
  '快递面单号': 'Express order number',
  '快速开始 / 便捷导航': 'Express start/convenient navigation',
  '快速收货': 'fast delivery',
  '快速装车': 'Quick loading',
  '忽略': 'neglect',
  '总件数': 'Total pieces',
  '总体积': 'Total volume',
  '总体积(m³)': 'Total volume (m3)',
  '总品项数': 'total number of items',
  '总实盘件数': 'Total actual number of pieces',
  '总实盘数量': 'Total firm offer quantity',
  '总容器数': 'Number of total containers',
  '总店/待分': 'General store/to be distributed',
  '总数量': 'The total number',
  '总皮重': 'total tare',
  '总要货/待播 :': 'Total demand/to be spread:',
  '总订单数': 'Total Number of orders',
  '总货位数': 'Total goods locations',
  '总重量': 'Total weight',
  '总金额': 'Total amount',
  '总门店数': 'Total stores',
  '您将修改为{method}，是否修改？': 'You will change to {method}, do you want to change?',
  '悬挂称': 'Suspension Scale',
  '悬挂称分播': 'Hanging Weigh Distribution',
  '悬挂称打印模板': 'Printing template of the suspension scale',
  '悬挂称配置': 'Configuration of configuration scale',
  '感官质检': 'Sensory quality inspection',
  '感官质检保存成功': 'Sensory inspection save success',
  '感官质检单': 'Sensory Quality Check Sheet',
  '感官质检单为空': 'The sensory quality inspection list is empty',
  '感官质检配置': 'Configuration of sensory quality inspection',
  '成功': 'Succeeded',
  '成功{action}': 'Success {action}',
  '成功批量{action}{success}个选项，跳过{skip}个选项': 'Successfully batched {action} {success} options, skipped {skip} options',
  '成功批量{action}{success}个选项，跳过{skip}个选项，共生成拣货指令{generatedPickTaskCnt}个': 'Successfully batched {action} {success} options, skipped {skip} options, generated {generatedPickTaskCnt} picking instructions in total',
  '成功退仓0个选项，跳过{length}个选项': 'Successfully return 0 option, skipped {length} options',
  '成功退仓{length}个选项，跳过{skipUuids}个选项，失败{failNumber}个选项': 'Successfully return {length} options, skipped {skipUuids} options, failed {failNumber} options; Finished product {0} has been disabled',
  '成员代码/名称': 'Member code/title',
  '成品': 'Finished product',
  '成品件数': 'Pcs of finished products',
  '成品信息': 'Information of finished products',
  '成品加工位': 'Processing position of finished products',
  '成品加工位代码': 'Code of processing position of finished products',
  '成品商品': 'Finished product',
  '成品容器': 'Container of finished products',
  '成品数量/重量': 'Quantity/weight of the finished products',
  '成品明细': 'Details of finished products',
  '成品明细不能为空': 'The details of finished products shall not be left blank',
  '成品明细第{line}行件数不能为0': 'The piece number cannot be 0 for line {line} of finished product details',
  '成品明细第{line}行包装规格不能为空': 'The packaging specification cannot be empty for line {line} of finished product details',
  '成品记录值是否有默认值': 'Whether there is default recorded value for finished product',
  '成品记录值标题': 'Title of recorded values of finished products',
  '所填写的内容将不会被保存，确认离开{name}页面吗？': 'The filled-in contents will not be saved, are you sure to leave the {name} page?',
  '所填写的内容将不会被保存，确认离开当前页面吗？': 'The filled-in contents will not be saved, are you sure to leave the current page?',
  '所填写的录入结果数据将不会被保存': 'The data of entry results filled will not be saved',
  '所属对象': 'Object belonged',
  '所属组织': 'Organization',
  '所属组织类型': 'Organization type belonged',
  '所属配送中心：': 'Affiliated distribution center:',
  '所执行的操作将不会被保存': 'The action performed will not be saved',
  '所有供应商不允许主动退货': 'All suppliers are not allowed to initiate returns',
  '所有供应商不允许生成拣货单': 'All suppliers are not allowed to generate picking lists',
  '所有商品': 'All commodities',
  '所有门店': 'All stores',
  '手动包装': 'Manual packaging',
  '手工创建': 'Create by hand',
  '手工单据': 'Manual document',
  '手工差错': 'Manual errors',
  '手工扫描': 'Manual scan',
  '手工指定虚拟货位': 'Manually specifying virtual storage locations',
  '手工模式': 'Manual mode',
  '手工预约': 'Manual appointment',
  '手持终端': 'Hand-held terminal',
  '手机号仅支持20位以内的字符': 'Mobile phone numbers only support characters within 20 characters',
  '手机号码': 'Mobile phone',
  '打包复核': 'Packing and review',
  '打包复核台': 'Packaging Review Desk',
  '打包完成位': 'Packaging completion location',
  '打包完成位/集货位': 'Packaging completion location/collection location',
  '打包拣货': 'Packaging order picking',
  '打包暂存位': 'Pack temporary storage',
  '打包目标位': 'Target packaging location',
  '打印': 'Print',
  '打印后是否自动回主界面': 'Whether to return to the main interface after printing',
  '打印失败：原因未知': 'Failed to print: reason unknown',
  '打印并审核': 'Print and audit',
  '打印成功': 'Print succeeded',
  '打印插件': 'Print Plugin',
  '打印时机': 'print timing',
  '打印时间': 'Printing time',
  '打印时间间隔': 'Print interval',
  '打印机': 'Printer',
  '打印机设置': 'Printer Settings',
  '打印标签': 'Print label',
  '打印标签{length}个选项': 'Print label {length} options',
  '打印标签前询问': 'Inquiry before printing the label.',
  '打印标签拣货': 'Print the Label and Pick',
  '打印标签配置': 'Configuration of label printing',
  '打印模板': 'Print template',
  '打印模板设置': 'Print Template Settings',
  '打印进度': 'Printing progress',
  '打开设备端口失败，检查插件是否正常': 'Failed to open device port, check if the plug-in is normal',
  '扣重比例': 'Deduction ratio',
  '执行': 'Execute',
  '执行失败！': 'Execution failed!',
  '执行成功！': 'Execution succeeded!',
  '执行标准': 'Executive standard',
  '执行结果': 'Execution result',
  '执行进度': 'Execution progress',
  '扩展信息': 'Extended information',
  '扩展程序，并解压到本地目录，妥善存储': 'Expand the program and extract it to the local directory for proper storage',
  '扫描件数': 'Pieces scanned',
  '扫描数量': 'Scanned quantity',
  '扫描方式': 'Scanning mode',
  '扫描枪': 'Scanner',
  '扫描添加': 'Scan to add',
  '批准{length}个选项': 'Approve {length} options',
  '批准成功': 'Approved successfully',
  '批号': 'Batch No.',
  '批号调整': 'Lot number adjustment',
  '批次': 'Batch',
  '批次皮重调整': 'Batch Tare Adjustment',
  '批次规则配置': 'Configuration of batch rules',
  '批注': 'Annotation',
  '批注管理': 'Annotation management',
  '批量修改': 'Bulk modification',
  '批量修改供应商': 'Batch Modify Suppliers',
  '批量修改拣货员': 'Bulk modification of the picking staff',
  '批量修改状态成功': 'Batch modification status succeeded',
  '批量修改生产日期': 'Batch Modify Production Date',
  '批量分配': 'Mass distribution',
  '批量删除': 'Batch deletion',
  '批量删除成功': 'Batch delete successfully',
  '批量填充实盘数量': 'Batch filling of the firm offer quantity',
  '批量处理框': 'Bulk processing box',
  '批量复核': 'Batch review',
  '批量复核成功': 'Batch review succeeded',
  '批量完成': 'Batch completion',
  '批量平移': 'batch pan',
  '批量录入': 'Batch input',
  '批量录入{title}': 'Batch input {title}',
  '批量搜索': 'Bulk search',
  '批量搜索货位': 'Bulk search for cargo locations',
  '批量添加': 'Batch add',
  '批量生成`{data}`个货位': 'Generate \'{data}\' locations in batch',
  '批量生成`{data}`个货架': 'Generate \'{data}\' shelves in batch',
  '批量生成`{data}`个货道': 'Generate \'{data}\'  cargo lanes',
  '批量确认': 'Batch confirmation',
  '批量移除': 'Batch removing',
  '批量设置': 'Bulk setting',
  '批量设置供应商目标供应商退货位{count}条成功！': 'Batch setting target supplier return location for {count} items successful!',
  '批量设置商品目标拣货位{count}条成功！': 'Batch setting target picking location for {count} items successful!',
  '批量设置处理方式': 'Batch Setting Processing Method',
  '批量设置容器': 'Batch Settings Container',
  '批量设置差异原因': 'Bulk setting of difference reasons',
  '批量设置成功': 'Batch setup succeeded',
  '批量设置拒收原因': 'Bulk setting of refusal reasons',
  '批量设置拒收数量': 'Bulk setting of refusal quantity',
  '批量设置拣货位': 'Batch Set Picking Locations',
  '批量设置生产日期': 'Bulk setting of production date',
  '批量设置盘点员': 'Bulk setting of the inventory staff',
  '批量设置目标位置': 'Batch Set Target Location',
  '批量设置目标供应商退货位': 'Bulk setting of return location of the target supplier',
  '批量设置目标容器': 'Bulk setting of target container',
  '批量设置目标容器为来源容器': 'Bulk setting of the target container is the source container',
  '批量设置目标拣货位': 'Bulk setting of the target picking location',
  '批量设置目标货位': 'Bulk setting of target location',
  '批量设置目标货位需先选择商品和退仓类型！': 'Batch setting target location requires selecting the product and return type first!',
  '批量设置调整数量': 'Batch Set Adjustment Quantity',
  '批量设置货位': 'Bulk setting of goods location',
  '批量设置货位别名成功': 'Batch setting storage location alias successfu',
  '批量设置货位校验码成功': 'Successful bulk setting of location check code',
  '批量设置集货位': 'Batch setting grouping location',
  '批量退仓成功,共生成{data}张退仓单': 'Batch return successful, {data} return orders were generated',
  '找不到此商品条码,请核对拣货单': 'Product barcode not found, please check the picking list',
  '承运商': 'Carrier',
  '承运商不存在': 'The carrier does not exist',
  '承运商交接单': 'Carrier Delivery Note',
  '承运商交接单不存在': 'Carrier delivery note does not exist',
  '承运商交接单号': 'Carrier delivery order number',
  '承运商打印模板配置': 'Configuration of the supplier\'s printing template',
  '承运商权限信息': 'Permission information of the carrier',
  '承运商组织': 'Organization of the carrier',
  '承重(kg)': 'Bearing (kg)',
  '抑制率': 'Inhibition rate',
  '报损': 'Damage',
  '报损员': 'Loss reporter',
  '报表': 'Statement',
  '报表名称': 'Name of statement',
  '报警前缀': 'Alarm prefix',
  '报警前缀不能为空': 'Alarm prefix shall not be left blank',
  '报错': 'Error',
  '抽样数量': 'Number of samples',
  '抽样时间': 'Sampling time',
  '抽检': 'Sampling',
  '拆并': 'merge',
  '拆并中': 'Breaking and merging in progress',
  '拆并员': 'Split and combination staff',
  '拆并对象': 'Split and combination object',
  '拆零': 'Separation',
  '拆零拣货位': 'Separation picking location',
  '拆零拣货配置': 'Separation picking configuration',
  '拒收': 'Reject',
  '拒收件数': 'Pieces rejected',
  '拒收原因': 'Reason for rejection:',
  '拒收成功': 'Rejected successfully',
  '拒收数量': 'Rejection quantity',
  '拒收明细第{length}行的原因不能为空': 'The reason for rejection details line {length} cannot be empty',
  '拒收明细第{length}行的数量最大为{maxQty}': 'Quantity for row {length} in rejection details cannot exceed {maxQty}',
  '拒绝收货': 'rejection of goods',
  '拖拽至此 或 点击上传': 'en-拖拽至此 或 点击上传',
  '拖拽至此 或 点击上传': 'Drag it to   or   and click to upload',
  '拣容器号': 'Picking container number',
  '拣货': 'Picking',
  '拣货中': 'Picking',
  '未开始': 'Not started',
  '拣货件数': 'Number of Picked Pieces',
  '拣货件数必须大于0！': 'The number of picked pieces must be greater than 0!',
  '拣货任务列表': 'Picking task list',
  '拣货任务号': 'Picking task no.',
  '拣货任务释放成功！': 'Picking task released successfully!',
  '拣货位': 'Picking location',
  '拣货位分组配置': 'Grouping configuration of the picking location',
  '拣货位提总': 'Overall picking',
  '拣货位调整单': 'Picking Position Adjustment Form',
  '拣货位调整单不存在': 'The adjustment of picking location does not exist',
  '拣货作业': 'Picking operations',
  '拣货出': 'Picking',
  '拣货分区': 'Picking Partition',
  '拣货分区存储范围': 'Storage scope in the picking partition',
  '拣货分区：{pickarea}已有配置项': 'Picking partition: {pickarea} already has configuration items',
  '拣货分组': 'Picking partition',
  '拣货区域': 'Picking region',
  '拣货单': 'Picking List',
  '拣货单位': 'Picking unit',
  '拣货单分组是否考虑货位重合度配置': 'Whether the picking list grouping considers the contact ratio configuration of the goods location',
  '拣货单分组货位重合度配置': 'Contact ratio configuration of goods location in the picking list grouping',
  '拣货单列表': 'Picking list',
  '拣货单号': 'Pick order number',
  '拣货单号,多个单号以逗号隔开': 'en-拣货单号,多个单号以逗号隔开',
  '拣货单审核是否校验配货控制天数': 'Whether the review of picking list checks the distribution control days',
  '拣货单审核校验配货控制天数配置': 'Picking list review, verification, distribution control days configuration',
  '拣货单据类型': 'en-拣货单据类型',
  '拣货单据默认容器配置': 'The container configuration is default in the picking list',
  '拣货单数': 'Picking quantity',
  '拣货后是否直接平移': 'en-拣货后是否直接平移',
  '拣货员': 'Picking staff',
  '拣货员不能为空': 'The picking staff shall not be left blank',
  '拣货员不能为空。': 'Picker cannot be empty.',
  '拣货员代码': 'Code of the picking staff',
  '拣货员作业配置': 'Operation configuration of the picking staff',
  '拣货员名称': 'Name of the picking staff',
  '拣货员拣货范围配置': 'Configuration of picking scope of the picking staff',
  '拣货存储位': 'Pick storage',
  '拣货完成': 'Picking done',
  '拣货容器': 'Picking container',
  '拣货指令': 'Picking Order',
  '拣货提总': 'Overall picking',
  '拣货操作影响RF补货动线': 'The picking operation affects the RF replenishment line',
  '拣货数量': 'Picking quantity',
  '拣货数量不能超过设置的超拣比例！': 'The picking quantity shall not be greater than the over-picking proportion set!',
  '拣货数量必须大于0！': 'Picking quantity must be greater than 0!',
  '拣货数量调整': 'Adjustment of picking quantity',
  '实拣数量调整': 'Adjustment of picking quantity',
  '应拣数量调整': 'Adjustment of need picking quantity',
  '拣货方式': 'Picking mode',
  '拣货时间': 'Picking time',
  '拣货显示代码': 'Picking display code',
  '拣货显示数量': 'Picking display quantity',
  '拣货显示整箱数量': 'Picking shows FCL quantity',
  '拣货显示零散数量': 'Picking shows scattered quantities',
  '拣货暂存位': 'Picking staging',
  '拣货深度': 'Picking depth',
  '拣货满足率(%)': 'en-拣货满足率(%)',
  '拣货状态': 'en-拣货状态',
  '拣货类型': 'Pick Type',
  '拣货组配置': 'Configuration of picking group',
  '拣货规格': 'Picking specification',
  '拣货记录': 'Picking records',
  '拣货进度': 'Picking progress',
  '拣货释放时机': 'Picking release time',
  '拣货量': 'en-拣货量',
  '拣货门店': 'Picking store',
  '拣货面板': 'Picking Board',
  '拣货面板功能配置': 'Function configuration of picking board',
  '拣货面板员工任务分配配置': 'Task allocation configuration of picking board',
  '拣货顺序': 'Pick order',
  '拣货顺序不能为空，请填写完整': 'en-拣货顺序不能为空，请填写完整',
  '拣货顺序方案': 'Pick Sequence Scheme',
  '拣货顺序方案配置': 'Configuration of picking sequence scheme',
  '越库分播拣货容器类型配置': 'Configuration of container types for cross stock broadcast picking',
  '拼托盘门店数': 'en-拼托盘门店数',
  '拼箱': 'LCL',
  '拼箱收货': 'LCL receipt',
  '拼箱订单': 'LCL Order',
  '挂起': 'Suspension',
  '挂起原因': 'Suspension reasons',
  '挂起原因不能为空': 'Reason for suspension cannot be left blank',
  '挂起成功': 'Suspended successfully',
  '挂起时间': 'hang time',
  '指令上架': 'order listing',
  '指令号': 'Instruction No.',
  '指令号: {taskNumber}': 'en-指令号: {taskNumber}',
  '指令看板': 'Instruction Board',
  '指令确认成功！': 'Confirm the instruction successfully!',
  '指令类型': 'Instruction type',
  '指定的上架单{billNumber}不存在！': 'Specified put away list {billNumber} does not exist!',
  '指定的上架单不存在！': 'Specified put away list does not exist!',
  '指定的仓位不存在！': 'The specified warehouse location does not exist!',
  '指定的供应商不存在！': 'Specified supplier does not exist!',
  '指定的供应商交接单{billNumber}不存在！': 'Specified supplier handover order {billNumber} does not exist!',
  '指定的供应商拣货单{billNumber}不存在！': 'Specified supplier picking list {billNumber} does not exist!',
  '指定的供应商退货通知单{billNumber}不存在！': 'Specified supplier return notice {billNumber} does not exist!',
  '指定的修正单{billNumber}不存在！': 'Specified correction sheet {billNumber} does not exist!',
  '指定的修正单不存在！': 'The specified correction order does not exist!',
  '指定的入园单{billNumber}不存在！': 'Specified admission form {billNumber} does not exist!',
  '指定的入园单{value}不存在！': 'Specified admission form {value} does not exist!',
  '指定的入库指令{billNumber}不存在！': 'Specified inbound instruction {billNumber} does not exist!',
  '指定的入库指令不存在！': 'The specified storage order does not exist!',
  '指定的入库订单{billNumber}不存在！': 'Specified inbound order {billNumber} does not exist!',
  '指定的入库订单不存在！': 'The specified inbound order does not exist!',
  '指定的内部管理指令{billNumber}不存在！': 'Specified internal management instruction {billNumber} does not exist!',
  '指定的内部管理指令不存在！': 'Specified internal management instruction does not exist!',
  '指定的出库指令{billNumber}不存在！': 'Specified outbound instruction {billNumber} does not exist!',
  '指定的出库指令不存在！': 'The specified outbound instruction does not exist!',
  '指定的分播墙不存在！': 'The specified distribution wall does not exist!',
  '指定的加工单{billNumber}不存在！': 'Specified processing order {billNumber} does not exist!',
  '指定的加工单不存在！': 'The specified work order does not exist!',
  '指定的加工方案不存在！': 'The specified machining plan does not exist!',
  '指定的商品不存在！': 'Specified product does not exist!',
  '指定的容器出入单{billNumber}不存在！': 'Specified container in-out order {billNumber} does not exist!',
  '指定的容器复查单{billNumber}不存在！': 'Specified container review order {billNumber} does not exist!',
  '指定的容器拆并单{billNumber}不存在！': 'Specified container disassembly order {billNumber} does not exist!',
  '指定的容器类型不存在！': 'Specified container type does not exist!',
  '指定的容器绑定单{billNumber}不存在！': 'Specified container binding order {billNumber} does not exist!',
  '指定的封仓解仓单{billNumber}不存在！': 'Specified warehousing and sealing order {billNumber} does not exist!',
  '指定的封仓解仓单不存在！': 'The specified warehouse closing order does not exist!',
  '指定的平移单{billNumber}不存在！': 'Specified plane move list {billNumber} does not exist!',
  '指定的库存调整单{billNumber}不存在！': 'Specified inventory adjustment order {billNumber} does not exist!',
  '指定的库存调整单不存在！': 'Specified inventory adjustment order does not exist!',
  '指定的感官质检单{billNumber}不存在！': 'Specified sensory inspection order {billNumber} does not exist!',
  '指定的感官质检单不存在！': 'Specified sensory inspection order does not exist!',
  '指定的承运商不存在！': 'Specified carrier does not exist!',
  '指定的拣货位调整单{billNumber}不存在！': 'Specified picking location adjustment order {billNumber} does not exist!',
  '指定的拣货分区不存在！': 'The specified pick partition does not exist!',
  '指定的拣货单{billNumber}不存在！': 'Specified picking list {billNumber} does not exist!',
  '指定的拣货单不存在！': 'The specified picking list does not exist!',
  '指定的拣货指令{taskNumber}不存在！': 'The specified picking instruction {taskNumber} does not exist!',
  '指定的拣货指令不存在！': 'The specified pick order does not exist!',
  '指定的拼箱订单{billNumber}不存在！': 'The specified LCL order {billNumber} does not exist!',
  '指定的拼箱订单不存在！': 'The specified LCL order does not exist!',
  '指定的损耗单{billNumber}不存在！': 'The specified truck loading order {billNumber} does not exist!',
  '指定的损耗单不存在！': 'The specified loss order does not exist!',
  '指定的排车单{billNumber}不存在！': 'The specified platoon list {billNumber} does not exist!',
  '指定的收货单{billNumber}不存在！': 'The specified receipt {billNumber} does not exist!',
  '指定的收货单不存在！': 'The specified receiver does not exist!',
  '指定的替换方案不存在！': 'The specified alternative does not exist!',
  '指定的模板不存在！': 'The specified template does not exist!',
  '指定的波次单{billNumber}不存在！': 'The specified wave order {billNumber} does not exist!',
  '指定的波次单不存在！': 'The specified wave order does not exist!',
  '指定的溢余单{billNumber}不存在！': 'The specified overflow sheet {billNumber} does not exist!',
  '指定的溢余单不存在！': 'The specified excess order does not exist!',
  '指定的理化质检单{billNumber}不存在！': 'The specified physical and chemical quality inspection document {billNumber} does not exist!',
  '指定的理化质检单不存在！': 'The specified physical and chemical quality inspection document does not exist!',
  '指定的电商运单{billNumber}不存在！': 'The specified e-commerce waybill {billNumber} does not exist!',
  '指定的电商运单不存在！': 'The specified e-commerce waybill does not exist!',
  '指定的电子凭证单{billNumber}不存在！': 'The specified electronic voucher {billNumber} does not exist!',
  '指定的电子凭证单不存在！': 'The specified electronic voucher does not exist!',
  '指定的盘点单{billNumber}不存在！': 'The specified count sheet {billNumber} does not exist!',
  '指定的盘点计划{billNumber}不存在！': 'The specified count plan {billNumber} does not exist!',
  '指定的移库单{billNumber}不存在！': 'The specified stock transfer order {billNumber} does not exist!',
  '指定的移库单不存在！': 'The specified transfer order does not exist!',
  '指定的类别不存在！': 'The specified category does not exist!',
  '指定的补货单{billNumber}不存在！': 'The specified replenishment order {billNumber} does not exist!',
  '指定的装车单{billNumber}不存在！': 'The specified loading order {billNumber} does not exist!',
  '指定的货主不存在！': 'The specified owner does not exist!',
  '指定的货位类型不存在！': 'The specified slot type does not exist!',
  '指定的质检通知单{billNumber}不存在！': 'The specified quality inspection notice {billNumber} does not exist!',
  '指定的车型不存在！': 'The specified vehicle type does not exist!',
  '指定的车辆不存在！': '指定的车辆不存在！',
  '指定的退仓上架单{billNumber}不存在！': 'The specified return put away list {billNumber} does not exist!',
  '指定的退仓单{billNumber}不存在！': 'The specified return order {billNumber} does not exist!',
  '指定的退仓通知单{billNumber}不存在！': 'The specified withdrawal notice {billNumber} does not exist!',
  '指定的配货差异单{billNumber}不存在！': 'The specified allocation variance document {billNumber} does not exist!',
  '指定的配货通知单{billNumber}不存在！': 'The specified allocation notice {billNumber} does not exist!',
  '指定的配货通知单不存在！': 'The specified delivery notice does not exist!',
  '指定的配送中心不存在！': 'The specified distribution center does not exist!',
  '指定的锁定解锁单{billNumber}不存在！': 'The specified lock unlock order {billNumber} does not exist!',
  '指定的锁定解锁单不存在！': 'The specified lock and unlock order does not exist!',
  '指定的门店不存在！': 'The specified store does not exist!',
  '指定的门店交接单{billNumber}不存在！': 'The specified store handover form {billNumber} does not exist!',
  '指定的门店交接单不存在！': 'The specified store handover form does not exist!',
  '指定的集货区复查单{billNumber}不存在！': 'The specified collection area review sheet {billNumber} does not exist!',
  '指定的集货管理方案不存在！': 'The specified collection management scheme does not exist!',
  '指定的预检单{billNumber}不存在！': 'The specified pre inspection sheet {billNumber} does not exist!',
  '指定的预检单不存在！': 'The specified pre-check form does not exist!',
  '指定的预约单{billNumber}不存在！': 'The specified booking {billNumber} does not exist!',
  '指定的预约单不存在！': 'The specified appointment form does not exist!',
  '指定的领用单{billNumber}不存在！': 'The specified requisition {billNumber} does not exist!',
  '指定的领用单不存在！': 'The specified receipt does not exist!',
  '指定的领用返还单{billNumber}不存在！': 'The specified collection return document {billNumber} does not exist!',
  '指定的领用返还单不存在！': 'The specified collection return form does not exist!',
  '指定箱号': 'The specified box number',
  '指定货位数分配集货位需人为确认': 'The distributed goods location with designated number shall be confirmed manually:',
  '指定货位数管理': 'Designated inventory management',
  '按体积计算': 'by volume',
  '按到效期': 'Expiry date',
  '按库存量': 'As per the inventory',
  '按应拣件数审核时，目标容器不能设置为虚拟容器': 'When auditing by the number of pieces to be picked, the target container cannot be set as a virtual container',
  '按数量': 'As per the quantity',
  '按数量回收': 'Recovered as per the quantity',
  '按数量回收容器数': 'Recover the containers as per the quantity',
  '按数量批量回收': 'Bulk recovery as per the quantity',
  '按条码': 'As per the barcode',
  '按条码回收': 'Recover as per the barcode',
  '按条码回收容器数': 'Recover the containers as per the barcode',
  '按生产日期': 'As per the production date',
  '按货位体积计算': 'Calculated by volume',
  '按门店组打印': 'Print as per the stores',
  '振幅': 'Amplitude',
  '损溢商品数量金额限制配置': 'Quantity and amount limitation configuration of the profit and loss goods',
  '损溢处理方式': 'Profit and loss handling mode',
  '损溢配置': 'Profit and loss configuration',
  '损耗': 'Loss',
  '损耗件数': 'Loss pieces',
  '损耗前件数': 'Pieces before loss',
  '损耗前数量': 'Quantity before loss',
  '损耗单': 'Loss List',
  '损耗单品数量金额限制': 'Quantity and amount limitation for the products in the loss list',
  '损耗后件数': 'Number of pieces after wear',
  '损耗后数量': 'Quantity after loss',
  '损耗溢余': 'Loss surplus',
  '损耗类型': 'Loss type',
  '损耗类型的明细不设置目标货位！': 'The details of the loss type do not set the target location!',
  '换容失败': 'Replacement failed',
  '换容成功': 'The replacement was successful',
  '换播箱扫描': 'Change Box Scan',
  '换箱时打印': 'Print when changing boxes',
  '授权成功': 'Authorization succeeded',
  '排车中': 'Be dispatching',
  '排车任务信息': 'Dispatch task information',
  '排车任务明细和附件明细不能同时为空': 'Dispatch task details and attachment details cannot be empty at the same time',
  '排车任务明细看板': 'Detailed board of dispatch tasks',
  '排车任务看板': 'Dispatch task board',
  '排车单': 'Dispatch List',
  '排车单中门店所属线路体系必须相同，请先根据线路体系筛选！': 'The route system to which the store belongs in the vehicle scheduling list must be the same. Please filter based on the route system first!',
  '排车单号': 'Dispatch list No.',
  '接口中间表保留时长(天)': 'Remaining days of interface intermediate table',
  '接口中间表保留时长不能为空': 'The remaining days of the interface intermediate table shall not be left blank',
  '接口名称': 'Interface name',
  '接口日志': 'Interface Log',
  '接口日志表保留时长(天)': 'Retention days in the log sheet of interface',
  '接口日志表保留时长不能为空': 'The retention days in the log sheet of interface shall not be left blank',
  '接口配置': 'Interface configuration',
  '接收供应商': 'Receiving supplier',
  '接收供应商退货通知单': 'Receive the supplier\'s return notice',
  '接收入库订单': 'Receive inbound orders',
  '接收商品': 'receive merchandise',
  '接收商品类别': 'Tupe of commodity received',
  '接收日期': 'Reception date',
  '接收时间': 'Receiving time',
  '接收用户': 'Receiving user',
  '接收退仓通知单': 'Receive a cancellation notice',
  '接收配货差异单': 'Receive distribution discrepancies',
  '接收配货通知单': 'Receive delivery notices',
  '接收门店': 'Store received',
  '接收（创建）时间': 'Time of receiving (creation)',
  '控制器': 'Controller',
  '控制器删除失败': 'Fail to delete the controller',
  '推荐类型': 'US 推荐类型',
  '推荐集货位': 'Recommended collection location',
  '提交': 'Submit',
  '提交成功': 'Submission succeeded',
  '提交成功！': 'Submitted successfully!',
  '提总': 'Overall picking',
  '提总后自动平移': 'Automatic translation after overall picking',
  '提总审核': 'Submit for general review',
  '提总成功': 'total success',
  '提总打印模板': 'Printing template of overall picking',
  '提总拣货': 'Overall picking',
  '提总方式': 'total way',
  '提总状态': 'Status of overall picking',
  '提总类型': 'Type of overall picking',
  '提总组': 'General team',
  '提示': 'Prompt',
  '插件ID': 'Plugin ID',
  '插件类型': 'Plug-in type',
  '插件类型不能为空': 'The type of plug-in shall not be left blank',
  '搜索': 'Search',
  '搜索{title}': 'Search {title}',
  '搜索商品名称': 'Search Product Name',
  '搜索菜单': 'Search Menu',
  '搜索配置名称': 'Title of search configuration',
  '搜索门店名称': 'Search Store Name',
  '摘果': 'fruit picking',
  '摘果打印模板': 'Template of digital picking printing',
  '播种': 'sowing',
  '播种剩余库存生成': 'Generate by remaining inventory of sow picking task',
  '播种打印模板': 'digital assorting print template',
  '播种拣货': 'Digital Assorting Picking',
  '播种拣货单': 'Digital Assorting Picking List',
  '播种拣货单审核校验配货控制天数': 'Review and verify the allocation control days of the seeding picking list',
  '操作': 'Operate',
  '操作一': 'Operation I',
  '操作三': 'Operation III',
  '操作二': 'Operation II',
  '操作五': 'Operation V',
  '操作人': 'Operator',
  '操作人：': 'Operator:',
  '操作六': 'Operation VI',
  '操作员': 'Operator',
  '操作四': 'Operation IV',
  '操作成功': 'Operation succeeded',
  '操作成功！': 'Successful operation!',
  '操作方式': 'Operation method',
  '操作方式不能为空': 'Operation information cannot be left blank',
  '操作日志': 'Operation log',
  '操作时间': 'Operation duration',
  '操作记录': 'Operating record',
  '操作配置': 'Operation configuration',
  '支持异常商品出货配单类型配置': 'Support the  type and configuration of the dispatching order of commodity shipment',
  '支持扩展名：.xls xlsx': 'Support the extension: .xls xlsx',
  '收藏': 'Favorites',
  '收藏成功': 'Favorites succeeded',
  '收藏模块': 'Collection module',
  '收货': 'Order receiving',
  '收货不校验控制天数订单类型配置': 'en-收货不校验控制天数订单类型配置',
  '收货中': 'Receiving',
  '收货人姓名': 'Consignee\'s name',
  '收货人电话': 'Tel.',
  '收货件数': 'Pcs received',
  '收货修正': 'Receipt correction',
  '收货分配跳转至库存分配': 'Skip from receiving allocation to the inventory allocation',
  '收货单': 'Receiving Note',
  '收货单号': 'Receiving note number',
  '收货后打印容器条码': 'Print the container barcode after receiving the goods',
  '收货员': 'consignee',
  '收货容器后置打印': 'Rear printing of receiving container',
  '收货容器类型': 'Type of goods-receiving container',
  '收货容超': 'Goods-receiving capacity',
  '收货展示拆零拣货位': 'Receiving display dismantling zero picking position',
  '收货库存多规格校验': 'Receipt Inventory Multi Specification Verification',
  '收货成功！': 'Goods received!',
  '收货打印': 'Goods-receiving printing',
  '收货打印模板配置': 'Configuration of Goods-receiving printing template',
  '收货打印模板配置日志': 'Log of configuration of goods-receiving print template',
  '收货批注预设内容配置': 'Preset content configuration of the remarks upon receiving',
  '收货控制天数': 'Days controlled for receiving',
  '收货数量': 'Receipt quantity',
  '收货日结': 'receipt date',
  '收货时仅录入': 'Only enter when receiving the goods',
  '收货时采集': 'Collect upon receipt',
  '收货未分播信息': 'Received and not distributed information',
  '收货规格': 'Receiving specification',
  '收货规格是否采集': 'Whether the receiving specification is collected',
  '收货配置': 'Receiving configuration',
  '收起': 'Pack up',
  '效期先进先出': 'Expiration date first in first out',
  '数字': 'Number',
  '数据不能为空': 'Data cannot be empty',
  '数据位': 'Data bit',
  '数据库名': 'Database name',
  '数据类型': 'type of data',
  '数量': 'Quantity',
  '数量不能为空': 'The quantity cannot be left blank',
  '数量不能为空且需大于0': 'The quantity shall not be left blank and it shall greater than 0.',
  '数量不能大于对应商品的领用数量': 'The quantity cannot be greater than the received quantity of the corresponding product',
  '数量为0': 'The quantity is 0',
  '数量大于': 'The quantity is greater than',
  '数量小于': 'The quantity is less than',
  '数量小于0': 'The quantity is less than 0',
  '数量必须大于0': 'The quantity shall be greater than 0',
  '数量明细': 'Quantity details',
  '数量结算': 'Quantity settlement',
  '整件': 'Whole-piece',
  '整件+拆零': 'Whole piece + dismantling',
  '整件+拆零拣货配置': 'Whole piece + split picking configuration',
  '整件+拆零配置': 'Whole piece + split configuration',
  '整件或拆零拣货位有值，是否继续保存': 'The picking location of the whole piece or split has the values Whether to continue saving',
  '整件拣货位': 'Whole-piece picking location',
  '整件拣货配置': 'Whole-piece picking configuration',
  '整件数': 'Number of the whole piece',
  '整体满足率(%)': 'Overall fulfillment rate (%)',
  '整单加工': 'Whole-order processing',
  '整托': 'Entire pallet',
  '整托拣': 'Entire-pallet picking',
  '整托盘': 'Entire-pallet',
  '整托盘优先级': 'Entire-pallet priority',
  '整托盘优先级配置': 'Configuration of the entire-pallet priority',
  '整托补货': 'Whole pallet replenishment',
  '整托补货实际件数数量须等于待补': 'The actual number of pieces to be replenished must be equal to the quantity to be replenished',
  '整箱': 'FCL',
  '整箱数': 'FCL',
  '整箱配置': 'FCL configuration',
  '文件列名': 'Document list',
  '文件：{fileName}上传成功，请导入！': 'File: {fileName} uploaded successfully, please import!',
  '新供应商': 'New supplier',
  '新到效日期': 'New expiry date',
  '新品标识默认值': 'Default mark of new products',
  '新品结算方式默认值': 'Default value of the settlement mode of new products',
  '新品结算方式默认值 保存成功': 'The default value of the new product settlement method has been successfully saved',
  '新品资料默认值配置': 'Configuration of default value of new product data',
  '新增任务': 'Add task',
  '新增商品组': 'Newly-added commodity group',
  '新增明细': 'Newly-added details',
  '新增附件': 'Newly added attachment',
  '新建': 'Create',
  '新建{bill}': 'en-新建{bill}',
  '新建体系': 'create System',
  '新建作业点': 'Create Job Site',
  '新建供应商退货位配置': 'Create Supplier\'s Return Location Configuration',
  '新建供应商集货位配置': 'Create Supplier\'s Goods Location Configuration',
  '新建保存成功': 'Successfully created and saved',
  '新建分播墙': 'Create Distribution Wall',
  '新建分播管理方案': 'Create Distribution Management Scheme',
  '新建加工波次': 'Create Processing Wave',
  '新建周期': 'Create Cycle',
  '新建承运商': 'Create Carrier',
  '新建拣货员拣货范围配置': 'Create Picking Scope Configuration',
  '新建控制器': 'Create Controller',
  '新建标签': 'Create Label',
  '新建网关服务': 'Create Gateway Service',
  '新建角色': 'Create Role',
  '新建配送周期': 'Create Distribution Cycle',
  '新建门店组': 'Create Store Group',
  '新建高叉员': 'Create High-level Forklift Operator',
  '新批号': 'New batch number',
  '新批次': 'New batch',
  '新父容器': 'New parent container',
  '新生产日期': 'New Date of production',
  '新的快递单号': 'New tracking number',
  '新的承运商': 'New carrier',
  '新的目录': 'New Directory',
  '新皮重值': 'New tare weight',
  '新皮重值(kg)': 'New tare value (kg)',
  '新皮重类型': 'Type of new weight',
  '新规格': 'New specification',
  '新规格/计量单位': 'New specification/unit of measurement',
  '方案': 'Scheme',
  '方案策略': 'program strategy',
  '旋转灯': 'rotating light',
  '无': 'None',
  '无可打印数据': 'No printable data available',
  '无可核价的明细！': 'No verifiable price details!',
  '无感官质检科目': 'No sensory quality inspection subject',
  '无效': 'Invalid',
  '无法删除企业端维护的门店起要量': 'Fail to delete the minimum demand of the stores maintained at the enterprise end',
  '无法获取打印模板': 'Fail to acquire the print template',
  '无需质检': 'No quality inspection required',
  '无预约': 'No appointment',
  '日志': 'Log',
  '日志时间': 'Log time',
  '日志清理配置': 'Log cleaning configuration',
  '日志类型': 'Log type',
  '日志级别': 'Log level',
  '日志级别不能为空': 'The log level shall not be left blank',
  '日志详情': 'Log details',
  '日志路径': 'Log path',
  '日结日志': 'Daily settlement   Log',
  '日结类型': 'Day End Type',
  '日结配置': 'Daily settlement   Configuration',
  '旧父容器': 'Previous parent container',
  '早安，': 'Good morning',
  '时间轴': 'Time axis',
  '明盘': 'Ming plate',
  '明细': 'Details',
  '明细不能为空': 'The details shall not be left blank',
  '明细第{line}和第{otherLine}重复': 'Details repeat at row {line} and {otherLine}',
  '明细第{line}行不能为空！': 'Detail line {line} cannot be empty!',
  '明细第{line}行与第{line}行重复！': 'Details repeat at row {line} and {line}!',
  '明细第{line}行与第{otherLine}行单据字段重复！': 'The document fields in the {line} and {otherLine} lines of the details are duplicate!',
  '明细第{line}行与第{otherLine}行商品不同,目标货位相同！': 'The commodity in line {line} and {otherLine} of the details are different, but the target location is the same!',
  '明细第{line}行与第{otherLine}行封签号不一致！': 'The seal number of line {line} and {otherLine} of the details is inconsistent!',
  '明细第{line}行与第{otherLine}行文件列名重复！': 'The file column names in line {line} and {otherLine} of the details are duplicate!',
  '明细第{line}行与第{otherLine}行重复！': 'Details repeat at row {line} and {otherLine}!',
  '明细第{line}行商品不能为空！': 'Commodity in line {line} of details cannot be empty!',
  '明细第{line}行地址不能为空': 'The address in line {line} of the details cannot be empty',
  '明细第{line}行地址街道不能为空': 'Address street in line {line} of details cannot be empty',
  '明细第{line}行地址街道最大长度为200': 'The max length of the detailed address street in line {line} is 200',
  '明细第{line}行数量结算商品，件数是m+n格式，m和n不能同时为0': 'The quantity of commodities in line {line} of the details is settled in the format of m+n, and m and n cannot be both 0',
  '明细第{line}行文件列名不能为空！': 'The file column name in line {line} of the details cannot be empty!',
  '明细第{line}行新供应商不能与原供应商一致！': 'The new supplier in line {line} of the details cannot be the same as the original supplier!',
  '明细第{line}行新供应商不能为空！': 'The new supplier in line {line} of the details cannot be empty!',
  '明细第{line}行新到效期不能为空！': 'The new expiration date in line {line} of the details cannot be empty!',
  '明细第{line}行新生产日期不能为空！': 'The new production date in line {line} of the details cannot be empty!',
  '明细第{line}行新生产日期与原生产日期、新到效期也原到效期不能都一致！': 'The new production date in line {line} of the details cannot be consistent with the original production date, and the new expiry date cannot be consistent with the original expiry date!',
  '明细第{line}行新皮重类型不能为空！': 'The new tare type in line {line} of the details cannot be empty!',
  '明细第{line}行新规格不能与原规格一致！': 'The new specification in line {line} of the details cannot be consistent with the original specification!',
  '明细第{line}行新规格不能为空！': 'The new specification in line {line} of the details cannot be empty!',
  '明细第{line}行无商品规格1*1*1！': 'There is no product specification 1 * 1 * 1 in line {line} of the details!',
  '明细第{line}行服务模式不能为空': 'The service mode in line {line} of the details cannot be empty',
  '明细第{line}行来源货位不能等于目标货位！': 'The source location in line {line} of the details cannot be equal to the target location!',
  '明细第{line}行来源货位代码不能为空！': 'The source location code in line {line} of the details cannot be empty!',
  '明细第{line}行目标货位代码不能为空！': 'The target location code in line {line} of the details cannot be empty!',
  '明细第{line}行码头集不能为空！': 'The dock set in line {line} of the details cannot be empty!',
  '明细第{line}行移库数量不能为0！': 'The warehouse shifting quantity in line {line} of the details cannot be 0!',
  '明细第{line}行移库数量为0！': 'The warehouse shifting quantity in line {line} of the details is 0!',
  '明细第{line}行移库目标容器不能为空！': 'The target container for warehouse shifting in line {line} of the details cannot be empty!',
  '明细第{line}行移库目标货位不能为空！': 'The target location for warehouse shifting in line {line} of the details cannot be empty!',
  '明细第{line}行线路不能为空！': 'Line {line} of details cannot be empty!',
  '明细第{line}行重复': 'Duplicate row {line} of details',
  '明细第{line}行重量结算的商品，件数和数量不能同时为0': 'The number of pieces and quantity of commodity settled by weight in line {line} of the details shall not be 0 at the same time',
  '明细第{line}行门店不能为空！': 'The store in line {line} of the details cannot be empty!',
  '明细行': 'Detail Lines',
  '明细行只能为同一供应商': 'Detail lines can only be the same supplier',
  '是': 'Yes',
  '是否为默认': 'Whether it is default',
  '是否为默认生产日期': 'Whether it is a default date of production',
  '是否作废通知单': 'Whether to make the notice void',
  '是否删除容器出入单': 'Whether to delete the container entry and exit list',
  '是否删除该用户': 'Whether to delete the user',
  '是否删除质检通知单': 'Whether to delete the quality inspection notice',
  '是否删除退仓上架单': 'Whether to delete the return put away list',
  '是否删除退仓单': 'Whether to delete the return list',
  '是否删除通知单': 'Whether to delete the notice',
  '是否删除配货差异单': 'Whether to delete the distribution difference list',
  '是否动态拣货': 'Whether to pick dynamically',
  '是否合并生成任务': 'Whether to merge generation tasks',
  '是否合格': 'Eligibility',
  '是否启动多货强分加强算法': 'Whether to enable the enhanced algorithm of multi-commodity mandatory distribution',
  '是否启用': 'Whether to enable',
  '是否启用RFiD装车复核': 'Whether to enable the RFiD loading review',
  '是否启用RFiD集货平移复核': 'Whether to enable the review of RFiD goods collection translation',
  '是否启用分拣机配置': 'Whether to enable the configuration of the sorter',
  '是否启用加工单完成状态': 'Whether to enable the completion status of the processing list',
  '是否启用包装机配置': 'Whether to enable the configuration of the packaging machine',
  '是否复制通知单': 'Whether to copy the notice',
  '是否复查': 'Whether to review',
  '是否审核': 'Audit or not',
  '是否审核通知单': 'Whether to audit the notice',
  '是否差异': 'Is there a difference',
  '是否已分配': 'Is it allocated',
  '是否已加工': 'Processed or not',
  '是否已打印': 'Printed or not',
  '是否已盘': 'Is it set',
  '是否强制绑定': 'Whether to conduct the mandatory binding',
  '是否强制预检': 'Whether to conduct the mandatory pre-check',
  '是否强制预约': 'Whether to conduct the mandatory pre-appointment',
  '是否批准质检通知单': 'Whether to approve the notice of quality inspection',
  '是否批量': 'Whether it is in batch',
  '是否批量{action}{number} 个选项?': 'Do you want to batch {action} {number} options?',
  '是否批量{action}{number}个{item}?': 'Do you want to batch {action} {number} {item}?',
  '是否批量{action}{number}个选项?': 'Do you want to batch {action} {number} options?',
  '是否损耗': 'Loss or not',
  '是否新品': 'New products or not',
  '是否最新版本': 'Is the latest version',
  '是否核价': 'Whether to check the price',
  '是否生成质检单': 'Whether to generate the quality checklist',
  '是否电商专属': 'Is it exclusive to e-commerce',
  '直接集货': 'collect goods directly',
  '是否确认切换新指令拣货？': 'Whether to switch the new instruction for picking?',
  '是否确认切换门店分播？': 'Whether to switch the store distribution?',
  '是否确认回收': 'Whether to confirm the receipt',
  '是否确认完成通知单': 'Whether to confirm to complete the notice',
  '是否确认审核:{billNumber}': 'Confirm approval: {billNumber}',
  '是否确认审核容器出入单': 'Whether to confirm to audit the container entry and exit list',
  '是否确认审核退仓上架单': 'Whether to confirm to audit the returned put away list',
  '是否确认审核退仓单': 'Whether to confirm to audit the return list',
  '是否确认审核配货差异单': 'Whether to confirm to audit the distribution difference list',
  '是否确认配送门店交接单': 'Whether to confirm the distribution of the store\'s EIR',
  '是否称重': 'Whether to weigh',
  '是否管理温度': 'Whether to manage temperature',
  '是否自动绑箱': 'Whether to automatically bind the box',
  '是否自动获取容器': 'en-是否自动获取容器',
  '是否要删除所选数据？': 'Whether to delete the data selected?',
  '是否要删除此行？': 'Whether to delete the row?',
  '是否要删除选择行？': 'Whether to delete the row?',
  '是否设为默认': 'Whether to set it as default',
  '是否配置悬挂称打印': 'Whether to configure the printing of suspension scale',
  '是否配置摘果打印': 'Whether to configure the digital picking printing',
  '是否配置播种打印': 'Whether to configure the digital assorting printing',
  '是否零库存': 'Whether there is zero inventory',
  '是否默认': 'Default or not',
  '显示规格数量': 'Display the number of specifications',
  '暂不支持{printPluginType}打印': '{printPluginType} printing is not currently supported',
  '暂无任务': 'No task yet',
  '暂无数据': 'No data temporarily',
  '暂无数据,请先选择任务': 'No data temporarily, please select the task firstly',
  '暂无数据，请刷新重试': 'No data temporarily Please try again later',
  '暂无符合条件的数据': 'No eligible data available',
  '暂未添加此数据': 'This data has not been added yet',
  '更多': 'More',
  '更换商品': 'Change the commodity',
  '更新': 'Updated',
  '更新商品组': 'Update the commodity group',
  '更新成功': 'update completed',
  '更新配送周期': 'Update the delivery cycle',
  '更正件数': 'Correction cases',
  '更正成功': 'Correction successful',
  '更正数量': 'number of corrections',
  '替换': 'Replace',
  '替换商品明细第{line}行与第{otherLine}行重复！': 'The replacement item detail line {line} is duplicated with line {otherLine}!',
  '替换明细': 'Replacement details',
  '替换量必须大于0': 'Replacement must be greater than 0',
  '最低库存应小于等于最高库存': 'Minimum inventory should be less than or equal to maximum inventory',
  '最后打印时间：': 'Time of last printing:',
  '最多可预品项数必须大于0！': 'The max number of appointed items must be greater than 0!',
  '最多可预约件数必须大于0！': 'The max number of appointed pieces must be greater than 0!',
  '最大体积': 'Max volume',
  '最大体积不能为空': 'The max volume cannot be empty',
  '最大单据数': 'Max number of the document',
  '最大容量': 'Max capacity',
  '最大批号': 'Max lot number',
  '最大明细数必须是正整数': 'Max details must be a positive integer',
  '最大用户数不能小于1': 'The max number of users cannot be less than 1',
  '最大货主用户数': 'Max number of users of the owner',
  '最大货位数': 'Max number of goods location',
  '最大长度为30': 'Max length is 30',
  '最小体积': 'Min volume',
  '最小打印标签数': 'Min number of printed labels',
  '展示下一单门店信息': 'Show the next single store information',
  '展示门店拣货进度': 'Show the store picking progress',
  '最小批号': 'Min lot number',
  '最高最低库存': 'Max and Min Inventory',
  '有': 'Yes',
  '有效': 'efficient',
  '服务关闭成功': 'Service shutdown succeeded',
  '服务启动成功': 'Service started successfully',
  '服务器管理': 'Server',
  '服务地址': 'Service address',
  '服务模式': 'Service mode',
  '服务版本号': 'Service version number',
  '服务重启成功': 'Service restarted successfully',
  '未交接': 'No handover',
  '未分配强分数量': 'Unassigned mandatory distribution amount',
  '未勾选的不能移动': 'Unchecked items cannot be moved',
  '未命名': 'Unnamed',
  '未在订单中找到此商品条码': 'This product barcode was not found in the order',
  '未完成': 'en-未完成',
  '未审核': 'Not Audited',
  '未批准': 'Not approved',
  '未找到可提交的复核数据': 'No review data found to submit',
  '未找到复核商品': 'No review items found',
  '未找到当前容器类型序列': 'Current container type sequence not found',
  '未找到此承运商的复核台配置': 'The review desk configuration for this carrier was not found',
  '未拼箱': 'No LCL',
  '未排车': 'Not arranged',
  '未查询到快递公司信息': 'No courier company information found',
  '未查询到所选商品的拣货位方案': 'The picking location plan for the selected product was not queried',
  '未查询到通知单中的商品': 'Not inquire the commodity in the notice',
  '未添加配置项': 'No configuration item added',
  '未生成盘点单，该盘点计划已完成': 'Counting order has not been generated, the counting plan has been completed',
  '未生成补货单': 'Replenishment order not generated',
  '未维护打印机设置': 'Printer settings are not maintained',
  '未维护打印机，请先配置打印机': 'Printer not maintained, please configure the printer first',
  '未维护虚拟货位': 'Virtual slot not maintained',
  '未装车': 'Not loaded',
  '未设置分播打印模板，请设置打印模板设置': 'No multicast print template has been set. Please set the print template settings',
  '未设置提总打印模板，请设置打印模板设置': 'The total print template is not set, please set the print template settings',
  '未质检': 'Unqualified',
  '未配置iWMS打印插件': 'Not configure the iwms printing interface',
  '未配置打印模板': 'No print template configured',
  '未配置端口，检查设备是否已连接': 'Port not configured, check if the device is connected',
  '本次复查无差异，是否确认结束？': 'en-本次复查无差异，是否确认结束？',
  '本次收货超过超收比例，是否确认收货？': 'The goods-receiving exceeds the excessive receiving proportion Do you confirm the goods receiving?',
  '本次送出容器': 'This delivery container',
  '本次送出容器 + 装车时在门店容器': 'This delivery container+container at the store during loading',
  '本次预约': 'This appointment',
  '机器人拣货': 'Robot picking',
  '权限信息': 'Permission information',
  '条': 'Piece',
  '条码': 'Barcode',
  '条码前缀': 'Barcode prefix',
  '条码前缀必须是大写字母组成，长度最大为2位': 'The barcode prefix shall be composed of capital and the max length is 2.',
  '条码类型': 'Barcode type',
  '条码规格关系配置': 'Configuration of barcode specification relation',
  '条码长度': 'Barcode length',
  '条码：{barcode} 已存在，规格：{qpcStr} 已存在': 'Barcode: {barcode} already exists, specification: {qpcStr} already exists',
  '来源仓库': 'Source warehouse',
  '来源代码': 'Source data',
  '来源位置': 'Source location',
  '来源单号': 'Source No.',
  '来源单号最大长度为30': 'The max length of source number is 30.',
  '来源单据': 'source document',
  '来源单据类型': 'Source document type',
  '来源单据行号': 'Source document line No.',
  '来源容器': 'Source container',
  '来源对象': 'Source object',
  '来源方式': 'Source mode',
  '来源类型': 'Source type',
  '来源组织': 'Source organization',
  '来源货位': 'source location',
  '来源货位用途': 'Source location purpose',
  '来源货位范围': 'Scope of source location',
  '构建菜单结构': 'Construct the menu structure',
  '查看': 'Check',
  '查看任务': 'View Tasks',
  '查看差异': 'view differences',
  '查看详情': 'View details',
  '查询': 'Query',
  '查询上游库存': 'Check the upstream inventory',
  '标准规格': 'Standard specification',
  '标签': 'Label',
  '标签分播': 'Label Distribution',
  '标签提总/分播': 'Total label/ Distribution',
  '标签地址': 'Label address',
  '标签属性': 'Label property',
  '标签拣货': 'label picking',
  '标签提总': 'total label',
  '标签提总/分播配置': 'Overall picking of label/ distribution configuration',
  '标签类型': 'Label type',
  '标签范围': 'Tag range',
  '标签补货': 'Label replenishment',
  '校验强度': 'Verification strength',
  '校验码': 'Check code',
  '校验规则': 'Check rules',
  '样品大类': 'Sample categories',
  '样品小类': 'sample subclass',
  '核价{length}个选项': 'Check the price of {length} options',
  '核对价格高于原价': 'Checked price is higher than the original price',
  '根据目标货位：{toBinCode}查不到生鲜拣货分区配置': 'According to the target location: {toBinCode}, the fresh goods picking partition configuration cannot be found',
  '格式为1*m*n': 'The format is 1*m*n',
  '格式：2001-3090,4001-5090 格式': 'Format:  2001-3090,4001-5090',
  '档期编号': 'Schedule No.',
  '检查到你还有未提交数据，请先满容提交再结束复核': 'We have detected that you have not submitted any data yet. Please submit at full capacity before ending the review',
  '检查插件': 'Check plug-in',
  '检测单位': 'Detection unit',
  '检测员': 'Inspector',
  '检测时间': 'Test time',
  '检测机构代码': 'Check the institution code',
  '检测机构代码最大长度为30': 'The max length of the institution code is 30',
  '检测机构名称': 'Title of inspection institution',
  '检测机构名称最大长度为100': 'The max length of the institution name is 100',
  '检疫证': 'free pratique',
  '概要': 'outline',
  '模块名': 'Module Name',
  '模式': 'Mode',
  '模板': 'Template',
  '模板下载': 'Template download',
  '模板名称': 'Template name',
  '模板路径': 'Template path',
  '模板配置': 'Template configuration',
  '正向修改': 'Forward modification',
  '正向修正单明细第{line}行与第{otherLine}行重复！': 'The {line} and {otherLine} lines of the forward correction order details are duplicate!',
  '正向修正明细第{line}行修正原因不能为空！': 'The correction reason in row {line} of forward correction details cannot be empty!',
  '正向修正明细第{line}行到效期不能为空！': 'The expiration date of row {line} of forward correction details cannot be empty!',
  '正向修正明细第{line}行单价不能为空或小于0！': 'Unit price in row {line} of forward correction details cannot be blank or less than 0!',
  '正向修正明细第{line}行商品不能为空！': 'Product in line {line} of forward correction details cannot be empty!',
  '正向修正明细第{line}行容器条码不能为空！': 'The container barcode in row {line} of forward correction details cannot be empty!',
  '正向修正明细第{line}行数量不能为0！': 'The quantity of row {line} of forward correction details cannot be 0!',
  '正向修正明细第{line}行生产日期不能为空！': 'The production date in line {line} of the forward correction details cannot be blank!',
  '正向修正明细第{line}行货位代码不能为空！': 'Location code of line {line} of forward correction details cannot be empty!',
  '正在{action}': '{action} in progress',
  '正在复核：{box},当前第{index}个,共{total}个': 'Reviewing: {box}, currently {index} of {total}',
  '正常': 'normal',
  '正常收货': 'Normal receiving',
  '正排序': 'Be sorting..',
  '此包裹号已扫描': 'This package number has been scanned',
  '此快递单中没有此包裹号或此包裹已扫描过': 'This package number is not on this courier note or this package has been scanned',
  '此快递单号查询结果为空': 'The query result of this express bill number is empty',
  '此盘点单不允许多人盘点': 'This inventory list does not allow multiple people to inventory',
  '此规格存在库存,不允许被删除': 'This specification has inventory and cannot be deleted',
  '此订单没有待收货的商品或已收货完毕': 'This order has no goods to be received or has been received completely',
  '每次新增': 'New addition every time',
  '每次跨度': 'Span every time',
  '每组拣货单数量': 'Quantity of picking list per group',
  '每组拣货单数量不为空': 'The quantity of the picking list per group shall not be left blank',
  '比例分配': 'Proportional allocation',
  '比较录入结果': 'Compare entry results',
  '毛重': 'Gross weight',
  '毛重/皮重': 'Gross weight/tare weight',
  '毛重/皮重管理方案': 'Management scheme of gross weight/tare weight',
  '毛重/皮重管理配置': 'Management configuration of gross weight/tare weight',
  '毛重/读称': 'Gross weight/read',
  '永久': 'Permanent',
  '汇总信息': 'Summary information',
  '没有分播门店信息或已分播完毕，无法提交': 'There is no distribution store information or the distribution has been completed, and cannot be submitted',
  '没有可分组数据': 'No Groupable Data',
  '没有商品规格信息返回': 'No product specification information returned',
  '没有指定箱号': 'No CTN No. specified',
  '没有数据': 'no data',
  '没有选择货主。': 'No owner selected.',
  '没有选择货主或者仓位。': 'No owner or warehouse location selected.',
  '没有需要提交的数据！': 'There is no data to submit!',
  '油耗': 'Fuel consumption',
  '波次(%)': 'wave(%)',
  '波次-选择释放时机': 'Waves - Select release timing',
  '波次任务释放时机配置': 'Time configuration of wave task release',
  '波次作业分单配单类型配置': 'Configuration of wave operation HB/L type',
  '波次信息': 'Wave information',
  '波次单': 'Wave List',
  '波次单不能为空': 'The wave order cannot be empty',
  '波次单号': 'Wave No.',
  '波次单号不能为空': 'The wave no. shall not be left blank',
  '波次单号，多个波次单号以英文逗号隔开': 'Wave order numbers, multiple wave order numbers separated by English commas',
  '波次单号，多个波次单号以逗号隔开': 'Wave order numbers, multiple wave order numbers separated by commas',
  '波次单选择': 'Wave list selection',
  '波次号': 'Wave No.',
  '波次号不能为空': 'The wave no. shall not be left blank',
  '波次执行是否允许修改释放时机': 'Whether the release time is allowed to modify in the wave execution',
  '波次算法功能配置': 'Configuration of wave algorithm',
  '波次类型': 'Wave type',
  '波次补货': 'Wave replenishment',
  '波特率': 'Baud rate',
  '注册成功': 'registration success',
  '注解:': 'Notes:',
  '派件中': 'Being dispatched',
  '流程进度': 'Process schedule',
  '测试': 'Test',
  '测试新建': 'Test New',
  '测试查看': 'Test and check',
  '测试编辑': 'Test and edit',
  '浏览历史': 'Browsing history',
  '海外': 'Overseas',
  '海鼎': 'Heading',
  '海鼎信息工程股份有限公司': 'Shanghai HEADING information Engineering Co',
  '消息配置': 'Message configuration',
  '混合单据日志': 'Mixed document log',
  '混合提总': 'Mixed overall picking',
  '混载': 'Mixed loading',
  '混载上架': 'Mixed-loading inventory in-log',
  '添加': 'Add',
  '添加上级菜单': 'Add the parent menu.',
  '添加分割线': 'Add the cutting line',
  '添加容器': 'Add the container',
  '添加平级菜单': 'Add the sibling menu',
  '添加库存信息': 'Add the inventory information',
  '添加成功': 'Successfully added',
  '添加明细': 'Add details',
  '添加用户': 'Add user',
  '添加线路': 'Add route',
  '添加网关': 'Add the gateway',
  '添加门店': 'Add the store',
  '添加门店组': 'Add the store group',
  '添加默认门店': 'Add the default store',
  '清屏': 'Clear screen',
  '温度': 'Temperature',
  '溢余': 'Surplus',
  '溢余件数': 'Surplus pieces',
  '溢余前件数': 'Number of cases before overflow',
  '溢余前数量': 'Quantity before surplus',
  '溢余单': 'Surplus List',
  '溢余单保存成功': 'The surplus order was saved successfully',
  '溢余单品数量金额限制': 'Quantity and amount limitation for the products in the surplus list',
  '溢余单明细不能为空！': 'The details of the excess order cannot be empty!',
  '溢余单明细第{line1}行与第{line2}行重复！': 'US 溢余单明细第{line1}行与第{line2}行重复！',
  '溢余单明细第{line}行与第{otherLine}行重复！': 'Line {line} and {otherLine} of the surplus list details are duplicate!',
  '溢余单明细第{line}行件数或数量不合法': 'The number of pieces or quantity in the line {line} of the surplus list details is illegal',
  '溢余单明细第{line}行供应商不能为空！': 'The supplier in the line {line} of the surplus list details cannot be empty!',
  '溢余单明细第{line}行到效期不能为空！': 'The expiration date of line {line} of the surplus list details cannot be empty!',
  '溢余单明细第{line}行单价不能为空！': 'The unit price in line {line} of the surplus list details cannot be blank!',
  '溢余单明细第{line}行商品不能为空！': 'The product in line {line} of the surplus list details cannot be empty!',
  '溢余单明细第{line}行备注长度最大为255！': 'The max length of the remarks in the line {line} of the surplus list details is 255!',
  '溢余单明细第{line}行容器条码不能为空！': 'The container barcode in the line {line} of the surplus list details cannot be empty!',
  '溢余单明细第{line}行溢余数量不能为0！': 'The surplus quantity in the line {line} of the surplus list details cannot be 0!',
  '溢余单明细第{line}行生产日期不能为空！': 'The production date in the line {line} of the surplus list details cannot be blank!',
  '溢余单明细第{line}行货位代码不能为空！': 'The location code of the line {line} of the surplus list details cannot be empty!',
  '溢余后件数': 'Post-surplus pieces',
  '溢余后数量': 'Quantity after surplus',
  '溢余员': 'Surplus personnel',
  '溢余类型': 'Type of surplus',
  '溢出': 'Surplus',
  '满容': 'Full capacity',
  '满容{length}个选项': 'Full capacity {length} options',
  '满容并打印': 'Full capacity and print',
  '满容成功': 'Full capacity succeeded',
  '满容成功！': 'Full of success!',
  '满箱': 'Full container',
  '满足m+n、m格式': 'Meet the format of m+n, m',
  '满足格式10、10(1/2)、10-20，多个以逗号隔开': 'Meet the format 10, 10 (1/2), 10-20, multiple separated by commas',
  '点击上传': 'Click Upload',
  '爆品模式': 'Popular item mode',
  '爆品模式条件配置': 'Condition configuration under popular product mode',
  '爆品秒杀': 'Explosive spike',
  '父容器': 'parent container',
  '版本信息': 'Version Information',
  '版本号': 'Version No.',
  '物流及ERP均可发起': 'Both logistics and ERP can be initiated',
  '物流发起': 'Logistics Initiation',
  '物流模式': 'Logistics model',
  '物流模式为“越库”时，订单号必须输入。': 'When the logistics mode is "cross-dock", the order number must be entered.',
  '物流模式：{logisticMode}': 'Logistics Mode: {logisticMode}',
  '状态': 'Status',
  '状态：': 'Status:',
  '理化质检单': 'Physical and Chemical Quality Checklist',
  '理化质检看板': 'Physical and Chemical Quality Inspection Board',
  '理化质检科目': 'Physical and chemical quality inspection items',
  '理化质检配置': 'Configuration of physical and chemical quality inspection',
  '生产企业': 'manufacturer',
  '生产日期': 'Date of production',
  '生产日期不能晚于当前日期': 'The production date cannot be later than the current date',
  '生产日期管理配置': 'Configuration on management of production date',
  '生产规格': 'Production specification',
  '生成任务': 'Generate tasks',
  '生成快照': 'Generate the snapshot',
  '生成快照{length}个选项': '{length} options for generating snapshots',
  '生成快照成功': 'Snapshot generated successfully',
  '生成成功': 'Generation succeeded',
  '生成指令': 'Generate the instruction',
  '生成指令成功': 'Successfully generated instructions',
  '生成排车单': 'Generate the dispatch list',
  '生成数量': 'Generate quantity',
  '生成时间': 'Generation time',
  '生成盘点单': 'Generate the check list',
  '生成装车单': 'Generate the loading list',
  '生成规则': 'Generate rules',
  '生成进度': 'Generate progress',
  '生效': 'Effective',
  '生效成功': 'Effective successfully',
  '生鲜': 'Fresh food',
  '生鲜拣货分区配置': 'Configuration of fresh food picking partition',
  '生鲜拣货打印配置': 'Configuration of fresh food picking printing',
  '生鲜摘果': 'Digital picking of fresh food',
  '生鲜摘果使用容器方式': 'Container in digital picking of fresh food',
  '生鲜播种': 'fresh seed',
  '生鲜收货': 'Fresh delivery',
  '生鲜盘点': 'Fresh Inventory',
  '生鲜配置': 'Fresh food configuration',
  '生鲜面板拣货顺序方案配置': 'Configuration of picking sequence scheme of fresh food panel',
  '用户': 'Users',
  '用户信息': 'User information',
  '用户名': 'Username',
  '用户管理': 'User management',
  '用户配置': 'User configuration',
  '货位容器管理配置': 'Management configuration of storage bin container',
  '存储位容器管理 保存成功': 'Successfully saved the storage bin container management configuration',
  '存储位容器管理': 'Management container of the storage location',
  '用途': 'Purpose',
  '电商': 'E-commerce',
  '电商分播': 'E-commerce distribution',
  '电商客户订单可作废状态配置': 'Configuration of voided status for status of the E-commerce customer',
  '电商拣货': 'en-电商拣货',
  '电商拣货设备配置': 'Configuration of E-commerce picking equipment',
  '电商专人拣货配货类型配置': 'Configuration of e-commerce business person picking distribution type',
  '电商提总是否自动带出箱零': 'Whether the e-commerce total is automatically brought out of the box',
  '电商模式每次只允许复核一张拣货单': 'The e-commerce model only allows one pick list to be reviewed at a time',
  '电商运单信息': 'E-commerce Waybill Information',
  '电商配置': 'E-commerce configuration',
  '电子凭证单': 'Electronic Voucher',
  '电子凭证单保存成功': 'Successfully saved the electronic voucher',
  '电子凭证单明细不能为空！': 'Electronic voucher details cannot be empty!',
  '电子凭证单明细第{line}行原因不能为空！': 'The reason in line {line} of the electronic voucher details cannot be blank!',
  '电子凭证单明细第{line}行备注长度最大为255！': 'The max length of the remarks in the line {line} of the electronic voucher details is 255!',
  '电子标签': 'Electronic tags',
  '电子标签包装数': 'Packing qty of the e-tag',
  '电子标签回传': 'Electronic label return',
  '电子标签拣货作业': 'Electronic Label Picking Operation',
  '电子标签组件': 'E-tag component',
  '电子标签组件：': 'en-电子标签组件：',
  '电子秤': 'Electronic Scale',
  '电子秤测试': 'Electronic scale',
  '电子运单号': 'Electronic waybill number',
  '界面显示': 'Interface display',
  '界面跳转': 'Interface jump',
  '登录信息失效，请重新登录！': 'Login information is invalid, please login again!',
  '登记成功': 'Registered successfully',
  '皮重/读称': 'Tare weight/read',
  '皮重值(kg)': 'Tare value (kg)',
  '皮重比例': 'Tare ratio',
  '皮重类型': 'Type of tare weight',
  '皮重记录维度': 'Record dimension of tare weight',
  '皮重记录维度设置': 'Setting of record dimension of tare weight',
  '盒马门店条码': 'Bar code of Hema store',
  '盘点': 'Inventory',
  '盘点件数触发值': 'Trigger value of counting pieces',
  '盘点信息': 'Inventory information',
  '盘点修改': 'Inventory modification',
  '盘点单': 'Check List',
  '盘点单生成成功，共生成单据{data}张': 'The check list was successfully generated, with a total of {data} sheets generated',
  '盘点员': 'Inventory',
  '盘点员不能为空': 'The inventory personnel cannot be left blank',
  '盘点序列号': 'Inventory S/N',
  '盘点库存处理方式': 'Check the inventory processing mode',
  '盘点录入': 'Check entry',
  '盘点方式': 'Inventory method',
  '盘点方式不能为空': 'Check information cannot be left blank',
  '盘点明细不能为空': 'Inventory details cannot be empty',
  '盘点模式': 'inventory mode',
  '盘点模式不能为空': 'The inventory mode cannot be left blank',
  '盘点生产日期': 'Check the date of production',
  '盘点生成': 'Inventory generation',
  '盘点范围': 'Check scope',
  '盘点计划': 'Inventory Plan',
  '盘点计划已删除': 'Inventory plan deleted',
  '盘点计划已完成': 'Inventory plan completed',
  '盘点路径顺序': 'en-盘点路径顺序',
  '盘点配置': 'Checking configuration',
  '盘点默认计入方式': 'Inventory default counting method',
  '目录名称': 'Catalog name',
  '目标优先级': 'Target priority',
  '目标位置': 'Target location',
  '目标位置不能为空': 'The target location cannot be left blank',
  '目标位置为集货暂存位时，必须输入目标容器': 'When the target location is the temporary storage position, the target container must be entered',
  '目标容器': 'Target container',
  '目标序号': 'Target S/N',
  '目标操作方式': 'Target operation mode',
  '目标状态': 'Target status',
  '目标组号': 'Target group number',
  '目标行号': 'Target row number',
  '目标货位': 'target location',
  '目标货位为{caption}须填写目标容器': 'The target location is {caption}, shall fill in the target container',
  '盲盘': 'blind',
  '省/直辖市': 'Province/municipality',
  '看板展示': 'Board display',
  '看板库存配置': 'Configuration of board inventory',
  '知道了': 'understood',
  '码头': 'Dock',
  '码头不存在': 'Dock does not exist',
  '码头信息': 'Code information',
  '码头集': 'Dock set',
  '码头集不能为空': 'The dock set shall not be left blank',
  '码头集货位配置': 'Wharf collection location configuration',
  '码头集配置': 'Configuration of dock set',
  '码头集集货位配置': 'Configuration of goods location of dock set',
  '确定': 'OK',
  '确定删除该拣货员作业配置:{name}吗?': 'Are you sure to delete the Picker Job Configuration: {name}?',
  '确定删除该领料员作业配置:{name}吗?': 'Are you sure to delete the Picker Job Configuration: {name}?',
  '确定要停止测试吗?': 'Are you sure to stop the test?',
  '确定要删除当前数据': 'Are you sure to delete the current data?',
  '确定要删除当前线路？': 'Are you sure to delete the current route?',
  '确定要删除所选门店': 'Are you sure to delete the store selected',
  '确定要删除所选门店？': 'Are you sure to delete the store selected?',
  '确定要启动测试吗?': 'Are you sure to enable the test?',
  '确认': 'OK',
  '确认{length}个选项': 'Confirm {length} options',
  '确认{message}': 'Confirm {message}',
  '确认{operate}': 'en-确认{operate}',
  '确认{operate}该{object}吗?': 'Confirm {operate} this {object}?',
  '确认{operate}该商品组？': 'Confirm {operate} the commodity group?',
  '确认{operate}该报表[{reportName}]吗？': 'Confirm {operate} the report [{reportName}]?',
  '确认{operate}该模板？': 'en-确认{operate}该模板？',
  '确认{operate}该目录[{menuName}]吗?若该目录下存在报表，则不能被删除，建议将报表移动至到其他目录下再做删除操作': 'Confirm {operate} the directory [{menuName}]? If there are reports in this directory, they cannot be deleted. It is recommended to move the report to another directory before performing the deletion operation',
  '确认{operate}该配置：{name}': 'Confirm {operate} the configuration: {name}',
  '确认{operate}该门店组？': 'Confirm {operate} the commodity group?',
  '确认中断录入结果操作吗？': 'Are you sure you want to interrupt the input result operation?',
  '确认修改分拣策略类型?修改分拣策略类型将导致明细清空': 'Confirm to modify the sorting strategy type? Modifying the sorting strategy type will cause the details to be cleared',
  '确认修改分播方式{length}个选项': 'Confirm to modify {length} options for the distribution mode',
  '确认修改商品？修改商品将会导致耗材明细清空': 'Are you sure to modify the commodity? The commodity modification will clear the details of the consumables',
  '确认修改拣货员{length}个选项': 'Confirm to modify the {length} options of the picking staff',
  '确认修改拣货类型为单品模式': 'Confirm to modify the picking type as the single-item mode',
  '确认修改拣货类型为多品模式': 'Confirm to modify the picking type as the multiple-item mode',
  '确认修改补货步骤': 'Confirm the modification step of replenishment',
  '确认分播审核{length}个选项': 'Confirm {length} options for multicast auditing',
  '确认删除': 'Confirm deletion',
  '确认删除?': 'Confirm deletion?',
  '确认删除[': 'Confirm deletion',
  '确认删除[{code}{name}]角色吗?': 'Confirm to delete the [{code} {name}] role?',
  '确认删除{length}个选项': 'Confirm to delete {length} options',
  '确认删除控制器[': 'Are you sure to delete the controller',
  '确认删除此交接单{billNumber}？': 'Confirm to delete this EIR {billNumber}?',
  '确认删除此分拣道口:{billNumber}？': 'Confirm to delete this sorting crossing: {billNumber}?',
  '确认删除此分播管理方案{entity}？': 'Confirm to delete this multicast management scheme {entity}?',
  '确认删除此商品耗材:{billNumber}？': 'Confirme to delete this commodity consumables: {billNumber}?',
  '确认删除此附件？': 'Are you sure to delete the attachment?',
  '确认删除该分播类型：{type}': 'en-确认删除该分播类型：{type}',
  '确认删除该拣货组？': 'Confirm to delete this picking group?',
  '确认删除该模板？': 'Are you ensure to delete the template?',
  '确认删除该配置{codeName}？': 'en-确认删除该配置{codeName}？',
  '确认删除该配置？': 'Are you sure you want to delete this configuration?',
  '确认删除选中的明细？': 'Are you sure to delete the details selected?',
  '确认删除？': 'en-确认删除？',
  '确认启用该分拣道口管理：{code}': 'Confirm to enable the sorting crossing management: {code}',
  '确认启用该门店道口关系:{code}': 'Confirm to enable the store crossing relationship: {code}',
  '确认完成{length}个选项': 'Confirm completion of {length} options',
  '确认审核吗': 'Are you sure to audit?',
  '确认对播种拣货单 [{billNumber}] 分播？': 'Are you sure to distribute the digital assorting picking list [{billNumber}]?',
  '确认对播种拣货单 [{billNumber}] 提总？': 'Are you sure to summarize the digital assorting picking list [{billNumber}]?',
  '确认并创建': 'Confirm and create',
  '确认成功': 'Confirm it successfully',
  '确认打印?': 'Confirm to print?',
  '确认批量删除{length}个选项': 'Confirm to batch delete {length} options',
  '确认批量生成拣货单{length}个选项': 'en-确认批量生成拣货单{length}个选项',
  '确认提总审核{length}个选项': 'Confirm the {length} options for total approval',
  '确认清屏吗？': 'Are you sure to clear the screen?',
  '确认满容': 'Confirm the full capacity',
  '确认生效{length}个选项': 'Confirm {length} options are valid',
  '确认禁用该分拣道口管理：{code}': 'Confirm disabling the sorting crossing management: {code}',
  '确认禁用该门店道口关系：{code}': 'Confirm disabling the crossing relationship of this store: {code}',
  '确认离开后，此页面数据将不会保存': 'After confirming the lease, the page data will not be saved',
  '确认离开当前页面吗？': 'Are you sure to leave the current page?',
  '确认离开此界面？': 'Are you sure to leave this interface?',
  '确认移除': 'Confirm deletion',
  '确认要删除{title}{code}下的货位吗？': 'Are you sure to delete the storage location under {title} {code}?',
  '确认要删除该数据？': 'Are you sure to delete the data?',
  '确认要删除该高叉员作业配置:{name}吗？': 'Are you sure to delete the high-level forklift worker job configuration: {name}?',
  '确认该波次单{name}吗?': 'Are you sure about the wave list {name}?',
  '确认配送': 'Confirm the distribution',
  '确认释放{length}个选项！': 'Confirm to release {length} options!',
  '磁盘详情': 'Details of magnetic disc',
  '禁止': 'en-禁止',
  '禁用': 'Disable',
  '禁用{length}个选项': 'Disable {length} options',
  '禁用成功': 'Disable successfully',
  '秒': 'Second',
  '称重': 'Weighing',
  '称重价': 'Weighing',
  '移动': 'Mobile',
  '移动成功': 'Move succeeded',
  '移库': 'Warehouse shifting',
  '移库不上传类型配置': 'The type and configuration are not uploaded in warehouse shifting',
  '移库中': 'Moving',
  '移库入': 'Warehouse shifting entry',
  '移库出': 'move out',
  '移库单': 'Transfer Order',
  '移库单不上传移库类型配置': 'The type and configuration are not uploaded in the warehouse shifting list',
  '移库单日结': 'Warehouse transfer single day settlement',
  '移库暂存位': 'Temporary location of warehouse shifting',
  '移库类型': 'Type of warehouse shifting',
  '移库配置': 'Warehouse shifting configuration',
  '移库锁定': 'Relocation lock',
  '移除': 'Remove',
  '移除用户': 'Remove users',
  '税率': 'Tax rate',
  '空': 'Left Blank',
  '空闲': 'idle',
  '端口号': 'Port number',
  '第{count}行明细地址记为-,只允许一行明细地址记录为-': 'The detailed address in line {count} is recorded as -, and only one line of detailed address is allowed to be recorded as-',
  '第{errorLines}行录入单价不允许高于含税单价': 'The unit price entered in line {errorLines} cannot be higher than the unit price including tax',
  '第{id}行耗材不能为空': 'Consumables in line {id} cannot be empty',
  '第{id}行耗材数量不能为空': 'The consumable quantity in line {id} cannot be empty',
  '第{id}行耗材重复': 'Duplicate consumables in line {id}',
  '第{id}行道口不能为空': 'The {id} crossing cannot be empty',
  '第{id}行道口对应门店{repeatStore}已有配置': 'The corresponding store {repeatStore} of the {id} crossing has already been configured',
  '第{id}行道口明细不能为空': 'The crossing details of line {id} cannot be empty',
  '第{id}行道口重复': 'Repeat for the {id} crossing',
  '第{id}行门店{repeatStore}已有配置道口': 'The {id} line store {repeatStore} already has a configured crossing',
  '第{id}行门店不能为空': 'The store in line {id} cannot be empty',
  '第{id}行门店明细不能为空': 'Store details in line {id} cannot be empty',
  '第{length}行商品：{article}费用明细重复': 'Product in line {length}: {article} expense details are duplicate',
  '第{length}行实际数量大于超拣数量，是否确认？': 'The actual quantity in line {length} is greater than the over-picked quantity. Are you sure?',
  '第{length}行录入单价高于含税单价，是否确认！': 'The entered unit price in line {length} is higher than the unit price including tax. Are you sure!',
  '第{length}行行数量不能为0': 'The number of rows in line {length} cannot be 0',
  '第{length}行货位范围不{message}': 'The {length} line location range is not {message}',
  '第{length}行费用明细费用类型不能为空': 'Expense details expense type in line {length} cannot be empty',
  '第{length}行费用明细费用金额不能为空': 'Expense detail expense amount in line {length} cannot be empty',
  '第{line}行{title}': 'Line {line} {title}',
  '第{line}行{wrh}仓位已有配置货位范围': 'The {wrh} warehouse location in line {line} already has a configured storage range',
  '第{line}行与第{otherLine}行容器相同，货位不同！': 'The container in line {line} is the same as that in line {otherLine}, but the storage location is different!',
  '第{line}行与第{otherLine}行重复': 'Line {line} is duplicated with line {otherLine}',
  '第{line}行与第{otherLine}行重复！': 'Line {line} is duplicated with line {otherLine}!',
  '第{line}行价格不能为空且不能小于0': 'The price in line {line} cannot be empty and cannot be less than 0',
  '第{line}行供应商不能为空！': 'Supplier in line {line} cannot be empty!',
  '第{line}行到效期不能为空！': 'The expiration date of line {line} cannot be empty!',
  '第{line}行到效期不能早于当前日期！': 'The expiration date of line {line} cannot be earlier than the current date!',
  '第{line}行单价不能为空': 'Unit price in line {line} cannot be empty',
  '第{line}行可预约最大品项数为{maxArticleCount}，最小为0且不能为0，请检查！': 'The max number of items that can be reserved in line {line} is {maxArticleCount}, and the min is 0 and cannot be 0. Please check!',
  '第{line}行商品{article}是温度管理商品，温度不能为空': 'Product {article} in line {line} is a temperature management product, and the temperature cannot be empty',
  '第{line}行商品不能为空！': 'Product in line {line} cannot be empty!',
  '第{line}行商品为空': 'Line {line} commodity is empty',
  '第{line}行商品实拣数量小于数量，来源容器不能作为目标容器。': 'The actual picked quantity of goods in line {line} is less than the quantity, and the source container cannot be used as the target container.',
  '第{line}行商品，实拣件数小于件数或实拣数量小于数量，来源容器不能作为目标容器。': 'For the goods in line {line}, if the actual number of pieces picked is less than the number of pieces or the actual number picked is less than the quantity,the source container cannot be used as the target container.',
  '第{line}行备注长度最大为255': 'The max length of the note at {line} is 255.',
  '第{line}行外部批次不能为空！': 'External batch in row {line} cannot be empty!',
  '第{line}行实拣件数不能大于件数。': 'The actual number of pieces picked in line {line} cannot be greater than the number of pieces.',
  '第{line}行实拣数量不能大于数量。': 'The actual picking quantity in line {line} cannot be greater than the quantity.',
  '第{line}行实际件数不能大于件数': 'The actual number of pieces in line {line} cannot be greater than the number of pieces',
  '第{line}行实验数量不能小于等于0！': 'The number of experiments in row {line} cannot be less than or equal to 0!',
  '第{line}行容器不能为空！': 'The container in row {line} cannot be empty!',
  '第{line}行容器条码不能为-！': 'The container barcode in row {line} cannot be -!',
  '第{line}行容器条码不能为空！': 'The container barcode in row {line} cannot be empty!',
  '第{line}行容器类型不能为空！': 'The container type in row {line} cannot be empty!',
  '第{line}行差异类型不能为空！': 'The difference type in row {line} cannot be empty!',
  '第{line}行库存相关信息：货位、容器、供应商、批号、生产日期、规格、批次等不能为空，请检查修改。': 'Inventory related information in line {line}: Location, container, supplier, batch number, production date, specification, batch number, etc. cannot be blank. Please check and modify.',
  '第{line}行总数量不能小于等于0！': 'The total quantity of row {line} cannot be less than or equal to 0!',
  '第{line}行批次不能为空！': 'Batch in row {line} cannot be empty!',
  '第{line}行数据实际件数不能小于0': 'The actual number of pieces of data in row {line} cannot be less than 0',
  '第{line}行数量、件数不能同时小于等于0！': 'The number of {line} lines, the number of pieces cannot be less than or equal to 0! ',
  '第{line}行数量不能为0': 'The quantity of line {line} cannot be 0',
  '第{line}行数量不能小于0！': 'The quantity of row {line} cannot be less than 0!',
  '第{line}行数量不能小于等于0！': 'The number of rows {line} cannot be less than or equal to 0!',
  '第{line}行数量必须大于0': 'The quantity of line {line} must be greater than 0',
  '第{line}行明细不能为空': 'The details of row {line} cannot be empty',
  '第{line}行明细与第{line}行明细相同': 'The details in line {line} are the same as those in line {line}',
  '第{line}行是重量结算商品，件数、数量不能同时为0，且不可为负数。': 'Line {line} is a weight settled commodity. The number of pieces and quantity cannot both be 0 and cannot be negative.',
  '第{line}行来源容器条码不能为空！': 'Source container barcode in row {line} cannot be empty!',
  '第{line}行生产日期不能为空！': 'Production date in line {line} cannot be blank!',
  '第{line}行生产日期不能晚于当前日期！': 'The production date in line {line} cannot be later than the current date!',
  '第{line}行的单价不允许为空或0，请检查修改。': 'The unit price in line {line} cannot be blank or 0. Please check and modify it.',
  '第{line}行的目标货位不能为空': 'The target location in line {line} cannot be empty',
  '第{line}行目标位置为空，请填写后再审核': 'The target location in line {line} is empty, please fill it in before review',
  '第{line}行目标容器不能为空。': 'The target container on line {line} cannot be empty.',
  '第{line}行目标容器条码不能为空！': 'The target container barcode in row {line} cannot be empty!',
  '第{line}行目标货位不可以为空': 'The target location in line {line} cannot be empty',
  '第{line}行目标货位不能为空。': 'The target location in line {line} cannot be empty.',
  '第{line}行目标货位不能为空！': 'The target location in line {line} cannot be empty!',
  '第{line}行目标货位为集货暂存位，目标容器不能为空或-': 'The target location in line {line} is a collection staging location, and the target container cannot be empty or-',
  '第{line}行码头集不能为空': 'The dock set in row {line} cannot be empty',
  '第{line}行规格不能为空！': 'The specification of line {line} cannot be empty!',
  '第{line}行订单不能为空': 'Order in line {line} cannot be empty',
  '第{line}行货位不是存储位、拣货位、拣货存储位、虚拟货位、大型拣货位，容器不能为虚拟容器！': 'The location in line {line} is not a storageBin, picking location, picking storage location, virtual location, or large picking location, and the container cannot be a virtual container!',
  '第{line}行货位不能为空': 'Location in line {line} cannot be empty',
  '第{line}行货位不能为空！': 'Location in line {line} cannot be empty!',
  '第{line}行货位代码不能为空！': 'The location code of line {line} cannot be empty!',
  '第{line}行货位用途不能为空': 'Location usage in line {line} cannot be empty',
  '第{line}行退仓类型不能为空！': 'Return type in line {line} cannot be empty!',
  '第{line}行门店不能为空': 'The store in line {line} cannot be empty',
  '第{line}行集货位不能为空': 'The collection location in row {line} cannot be empty',
  '第{line}行集货位代码不能为空': 'The collection location code in line {line} cannot be empty',
  '第{line}行集货位数不能为空，且值需为大于0的整数': 'The number of collection digits in row {line} cannot be empty, and the value must be an integer greater than 0',
  '第{line}行集货位数据超长!': 'The storage location data in row {line} is too long!',
  '第{line}行集货位范围不能为空': 'The collection location range in row {line} cannot be empty',
  '第{line}行预约件数不能为空且不能为0': 'The number of reserved pieces in line {line} cannot be empty and cannot be 0',
  '第{line}行，请先设置目标货位！': 'Line {line}, please set the target location first!',
  '第{line}行，配差结果均为0，不允许保存！': 'en-第{line}行，配差结果均为0，不允许保存！',
  '第{line}行，零散数不可大于{maxQtyStr}': 'In line {line}, the scattered number cannot be greater than {maxQtyStr}',
  '第{line}行，非整托拣货类型的供应商拣货单，来源容器不能作为目标容器': 'In line {line}, the source container cannot be used as the target container for a supplier\'s picking list that is not a Non-entire pallet picking type',
  '第{line}行与第{otherLine}行同一目标容器，但不同目标货位，不允许。': 'In line {line}、{otherLine}, the target container is same, but the target bin is different.',
  '第{qtyIds}行实拣数量不能大于超拣比例': 'The actual picking quantity in line {qtyIds} cannot be greater than the over-picking proportion',
  '第{stringify}行数据相同': 'The data in row {stringify} is the same',
  '第{stringify}行数据门店相同': 'The data store in row {stringify} is the same',
  '第{valueIds}行实拣数量不能为0': 'The picked quantity in row {valueIds} cannot be 0',
  '第{weightIds}行实拣数量大于超拣比例。': 'The actual picking quantity in row {weightIds} is greater than the over-picking ratio.',
  '简体中文': '简体中文',
  '简称': 'Short name',
  '算法加强': 'Algorithm enhanced',
  '管理': 'Management',
  '管理凭证原因': 'Manage voucher reason',
  '管理卸货方式': 'US 管理卸货方式',
  '管理员名称': 'Title of the administrator',
  '管理员手机号': 'Mobile phone number of the administrator',
  '管理外部批次': 'Manage the external batch',
  '管理外部批次配置': 'Manage the external batch configuration',
  '管理存储条件': 'Manage the storage conditions',
  '管理容器': 'Manage the container',
  '管理库存调整原因': 'Manage the reason of inventory adjustment',
  '管理拒收原因': 'Manage the refusal reason',
  '管理挂起原因': 'Manage the suspension reason',
  '管理方案': 'Management scheme',
  '管理类型': 'Management type',
  '管理订单类型': 'Manage the order type',
  '管理费用类型': 'Manage the fee type',
  '管理起要量': 'Manage the min demand',
  '管理返还类型': 'Manage the type of return',
  '管理退货类型': 'Manage return types',
  '管理送货对象类型': 'Manage the type of delivery object',
  '管理领用类型': 'Manage the requisition type',
  '箱/零': 'Box/remaining part',
  '箱号': 'CTN No.',
  '箱号不唯一，无法指定箱号': 'The box number is not unique, the box number cannot be specified',
  '箱号不能为空': 'The CTN No. shall not be left blank',
  '箱标': 'Box label',
  '箱标打印机': 'Box label printer',
  '箱标打印模板': 'Box label printing template',
  '箱码': 'Case code',
  '箱类型': 'Box type',
  '类别': 'Category',
  '类别存储范围配置': 'Class Storage Range Configuration',
  '类型': 'Types',
  '类型不能为空': 'The type cannot be left blank',
  '类越库': 'Class cross-docking',
  '类越库不可同时分播多容器员工配置': 'en-类越库不可同时分播多容器员工配置',
  '类越库分播': 'Category cross-dock distribution',
  '类越库分播是否需要跳过商品扫描': 'Whether the category cross-dock distribution needs to skip the commodity scanning',
  '类越库分播显示门店代码': 'The category cross-dock distribution displays the store code',
  '类越库分播管理方案配置': 'Configuration of management scheme of the category cross-dock distribution',
  '类越库商品分播': 'Category cross-dock goods distribution',
  '库存查询': 'Stock query',
  '最小配货规格': 'Minimum distribution specifications',
  '最小批号库存规格': 'Minimum batch stock specification',
  '数量结算商品整箱起要量使用规格配置': 'Store pick quantity specification for quantity configuration',
  '类越库容器类型': 'Type of the category cross-dock container',
  '类越库库存分配配置': 'Configuration of category cross-dock inventory allocation',
  '类越库打印模板': 'Category cross-dock printing template',
  '类越库拣货': 'cross-dock-like picking',
  '类越库收货': 'Cross-dock-like receipt',
  '类越库收货暂存位': 'Temporary location of the category cross-dock receipt',
  '类越库波次单功能配置': 'Function configuration of category cross-dock wave list',
  '类越库波次门店及商品组限制': 'Limitation of category cross-dock wave store and commodity group',
  '类越库自动获取容器': 'class-cross docking automatic acquisition of containers',
  '类越库集货': 'cross-dock-like',
  '粗式管理': 'Rough management',
  '精细化管理': 'Delicacy management',
  '精细化管理打包暂存位配单类型': 'Refinement management of packaging and temporary storage position allocation order types',
  '系统功能': 'System functions',
  '系统推送': 'System push',
  '繁体中文': '繁体中文',
  '线上预约': 'Online appointment',
  '线路': 'Route',
  '线路体系': 'Route System',
  '线路体系新建成功': 'Create the route system successfully',
  '线路新建成功': 'Create the route successfully',
  '组别': 'Group',
  '组号': 'Group No.',
  '组织': 'Organization',
  '组织类型': 'Organization type',
  '终止条码': 'End the code',
  '终止列码': 'End the column code',
  '终止层码': 'End the floor code',
  '终止货区范围': 'End the scope of goods area',
  '终止货架范围': 'End the scope of goods shelf',
  '终止货道范围': 'End the scope of goods lane',
  '经营类型': 'Business type',
  '经营面积': 'Operation area',
  '绑定': 'Binding',
  '绑定员': 'Binding to staff',
  '绑定时间': 'Bind time',
  '结束': 'End',
  '结束上架': 'End adding',
  '结束上架时间': 'Time to end adding',
  '结束交接': 'Complete the handover',
  '结束作业': 'End Job',
  '结束加工波次': 'End the processing wave',
  '结束复查': 'end review',
  '结束复核': 'End review',
  '结束复核成功': 'End review successfully',
  '结束拆并': 'end demolition',
  '结束拆并时间': 'End the split and combination time',
  '结束拣货': 'End the goods picking',
  '结束播种': 'Complete the digital assorting',
  '结束收货': 'End the goods receiving',
  '结束收货时间': 'End the receiving time',
  '结束时间': 'End time',
  '结束时间必须大于开始时间': 'The end time must be greater than the start time',
  '结束盘点': 'close inventory',
  '结束盘点时间': 'Time of ending inventory',
  '结束移库时间': 'Time of ending the warehouse shifting',
  '结束绑定': 'End the binding',
  '结束绑定时间': 'End the bidding time',
  '结束补货': 'end of replenishment',
  '结束装车': 'End the loading',
  '结束订单': 'End order',
  '结束退仓': 'End the warehouse return',
  '结束退仓时间': 'Time of ending the warehouse return',
  '结点': 'Node',
  '结点地址': 'Node address',
  '结点用途': 'Node purpose',
  '结点类型': 'Node type',
  '结算方式': 'Settlement method',
  '统配': 'Allocated',
  '统配分播位面板': 'Panel of distribution location in unified allocation',
  '统配容器类型': 'Type of the container in unified allocation',
  '统配打印模板': 'Printing template in unified allocation',
  '统配拣货': 'Unified goods picking',
  '统配拣货实拣显示': 'Real picking display',
  '统配拣货显示商品代码': 'Unified Picking Display Commodity Code',
  '统配拣货满容后跳转平移': 'Jump and pan when the order is full',
  '统配收货': 'unified delivery',
  '统配收货暂存位': 'Temporary goods-receiving location in unified allocation',
  '统配波次多次执行': 'Multiple executions of the unified allocation wave',
  '统配波次多次执行配置': 'Multiple executive configuration of the unified allocation wave',
  '统配自动获取容器': 'Unified automatic acquisition container',
  '统配集货': 'Unified distribution and collection',
  '统配集货位面板': 'Panel of goods location in unified allocation',
  '统配集货暂存位': 'Temporary storage space for unified distribution',
  '继续': 'en-继续',
  '维护值': 'Maintenance value',
  '编译时间': 'en-编译时间',
  '编辑': 'Edit',
  '编辑{bill}': 'en-编辑{bill}',
  '编辑上架单不存在！': 'The editing return put away list does not exist!',
  '编辑保存成功': 'Edit saved successfully',
  '编辑分播墙': 'Editing a Distribution Wall',
  '编辑分播管理方案': 'Edit distribution management scheme',
  '编辑承运商交接单': 'Editing a Carrier Delivery Note',
  '编辑拣货位调整单': 'Edit Pick Position Adjustment',
  '编辑模板': 'Edit template',
  '编辑的修正单不存在！': 'Edited fix sheet does not exist!',
  '编辑的封仓解仓单不存在！': 'The edited warehouse closing order does not exist!',
  '编辑的损耗单不存在！': 'Edited attrition slips do not exist!',
  '编辑的收货单不存在！': 'The edited receipt does not exist!',
  '编辑的波次单不存在！': 'Edited wave order does not exist!',
  '编辑的溢余单不存在！': 'Edited excess orders do not exist!',
  '编辑的电子凭证单不存在！': 'The edited electronic voucher does not exist!',
  '编辑的移库单不存在！': 'The edited transfer order does not exist!',
  '编辑的订单不存在！': 'The edited order does not exist!',
  '编辑的配单不存在！': 'The edited allocation document does not exist!',
  '编辑的配货差异单不存在！': 'The edited distribution variance document does not exist!',
  '编辑的锁定解锁单不存在！': 'The edited lock unlock form does not exist!',
  '编辑的集货位管理方案不存在！': 'The edited collection location management scheme does not exist!',
  '编辑的预检单不存在！': 'The edited preflight slip does not exist!',
  '编辑的预约单不存在！': 'The edited appointment form does not exist!',
  '编辑的领用单不存在！': 'The requisition list edited does not exist!',
  '编辑的领用返还单不存在！': 'The edited receipt and return form does not exist!',
  '编辑盘点单': 'Edit Inventory List',
  '编辑门店': 'Edit the store',
  '编辑页行数': 'Edit Page Rows',
  '缺货': 'Out of stock',
  '缺货不允许关单类型配置': 'The configuration of the customs document is not allowed when it is out of stock',
  '缺货分配优先级': 'Shortage allocation priority',
  '缺货库存分配方案配置': 'Configuration of inventory allocation scheme when it is out of stock',
  '网关': 'Gateway',
  '网关号': 'Gateway number',
  '网关服务': 'Gateway service',
  '网络订单号': 'Network order number',
  '耗材': 'Consumables',
  '耗材库存填充': 'Consumables inventory filling',
  '耗材数量': 'Number of consumables',
  '耗材明细': 'Consumables details',
  '耗材明细不能为空': 'Consumable details cannot be empty',
  '耗材标记': 'Consumables mark',
  '耗材类型': 'Type of consumables',
  '自动': 'Automatic',
  '自动创建': 'automatically created',
  '自动包装': 'Automatic packaging',
  '自动差错': 'Automatic error',
  '自动模式': 'Automatic mode',
  '自定义': 'customize',
  '自定义付款模式': 'User-defined payment mode',
  '自定义字段1名称': 'Custom Field 1 Name',
  '自定义字段2名称': 'Custom Field 2 Name',
  '自定义字段3名称': 'Custom Field 3 Name',
  '自定义字段4名称': 'Custom Field 4 Name',
  '自定义字段5名称': 'Custom Field 5 Name',
  '自定义字段6名称': 'Custom Field 6 Name',
  '自定义字段名称': 'Custom Field Name',
  '自定义导入': 'User-defined Import',
  '自定义导入配置': 'User-defined import configuration',
  '自定义服务模式': 'User-defined service mode',
  '自定义模板': 'User-defined templates',
  '自定义菜单': 'custom menu',
  '自定义运单号': 'User-defined waybill number',
  '自定义间隔时间': 'User-defined internal time',
  '自重(kg)': 'Tare weight (kg)',
  '至多输入30个字符': 'Enter up to 30 characters',
  '至多输入80个字符': 'Enter up to 80 characters',
  '获取': 'Acquire',
  '获取上一单失败': 'Failed to get previous order',
  '获取下一单失败': 'Failed to obtain the next order',
  '获取商品控制天数信息失败': 'Failed to get product control days information',
  '获取堆栈': 'Acquire the stack',
  '获取打印机失败': 'Failed to get printer',
  '获取收货容器成功！': 'Successfully obtained the receiving container!',
  '获取用户组织信息失败！': 'Failed to obtain user organization information!',
  '获取线程': 'Acquire the thread',
  '获取验证码': 'Get verification code',
  '蓝牙打印': 'Bluetooth printing',
  '虚拟容器': 'Virtual container',
  '虚拟货位': 'virtual slot',
  '虚拟货位不能为空': 'The virtual location shall not be left blank',
  '虚拟货位来源': 'Source of virtual location',
  '行': 'Row',
  '行号': 'Row number',
  '行号调整': 'Adjustment of row number',
  '补货': 'Replenishment',
  '补货上架': 'Replenishment',
  '补货下架': 'Replenishment off-shelf',
  '补货中': 'Replenishment in progress',
  '补货中转位': 'Transit location of replenishment',
  '补货件数': 'Pcs replenished',
  '补货任务释放成功！': 'The replenishment task is released successfully!',
  '补货入': 'Replenishment',
  '补货单': 'Replenishment List',
  '补货员': 'Replenishment personnel',
  '补货回板': 'Replenishment backboard',
  '补货工具': 'Replenishment tool',
  '补货扫描': 'Replenishment scanning',
  '补货显示代码': 'Replenishment display code',
  '补货显示总量': 'Total quantity of replenishment displayed',
  '补货显示数量': 'Quantity of replenishment displayed',
  '补货显示整箱数量': 'Replenishment shows FCL quantity',
  '补货显示零散数量': 'Replenishment shows scattered quantities',
  '补货暂存位': 'Temporary replenishment location',
  '补货步骤': 'Replenishment steps',
  '补货满': 'restocked',
  '补货算法': 'Replenishment algorithm',
  '补货配置': 'Replenishment configuration',
  '补货释放时机': 'Replenishment release time',
  '表名': 'Form name',
  '被检企业': 'The company under inspection',
  '装卸员': 'Stevedore',
  '装盘建议': 'Loading suggestions',
  '装盘建议不能为空': 'The loading suggestion shall not be left blank',
  '装车': 'Loading',
  '装车上传': 'Loading -- upload',
  '装车中': 'Be loading',
  '装车件数': 'Pcs installed',
  '装车件数来源配置': 'Source configuration of loading pieces',
  '装车单': 'Loading List',
  '装车员': 'Loading staff',
  '装车完成': 'Loading completion',
  '装车容器的展示按时间排序': 'The display of loading containers is sorted by time',
  '装车数': 'number of vehicles',
  '装车数量': 'Loading quantity',
  '装车时在门店容器': 'The container in store when loading',
  '装车来源配置查询出错': 'Loading source configuration query error',
  '装车类型': 'Type of loading',
  '装车自动完成加工单': 'Complete the processing list automatically in loading',
  '是否启用门店交接单初始状态': 'Enable initial status of store handover order',
  '感官质检单审核后是否自动完成': 'Automatic completion of sensory inspection order after audit',
  '装车项': 'Loading items',
  '装车顺序': 'Loading order',
  '装载号': 'Loading number',
  '要货': 'Demand',
  '要货 :': 'Demand:',
  '要货件数': 'Number of items',
  '要货品项数上限': 'Upper limit of the demand items',
  '要货数量': 'quantity requested',
  '要货量': 'quantity required',
  '规格': 'Specification',
  '规格/单位': 'Specification/unit',
  '规格/计量单位': 'Specifications/Units of Measurement',
  '规格/计量单品': 'Specification/single item of measurement',
  '规格作条件': 'Specification as the conditions',
  '规格信息': 'Information for specification',
  '规格调整': 'Adjustment of specification',
  '规格：{qpcStr} 已存在': 'Specification: {qpcStr} already exists',
  '角色': 'Role',
  '角色管理': 'Role management',
  '解仓': 'unload',
  '解析外部批号': 'Analyze the external batch number',
  '解析外部批号配置': 'Configuration in analyzing the external batch number',
  '解释说明': 'explain',
  '解锁': 'Unlock',
  '解除成功': 'Unsuccessful',
  '解除挂起': 'Unlock and suspend',
  '解除锁定': 'Unlock',
  '触发401': 'Trigger 401',
  '触发403': 'Trigger 403',
  '触发404': 'Trigger 404',
  '触发500': 'Trigger 500',
  '计划件数': 'number of planned pieces',
  '计划数量': 'Number of plans',
  '计划配货件数': 'Planned number of shipments',
  '计划配货体积': 'Planned delivery volume',
  '计划量': 'Planned amount',
  '计费': 'Billing',
  '订单': 'Order',
  '订单体积(m³)': 'Order volume (m3)',
  '订单供应商存在退货，确认继续收货？': 'en-订单供应商存在退货，确认继续收货？',
  '订单单号': 'Order number',
  '订单号': 'Order No.',
  '订单品项数': 'Order items',
  '订单完成成功': 'Order completed successfully',
  '订单收货成功': 'Order received successfully',
  '订单收货日结': 'Order receipt date',
  '订单明细不能为空': 'Order details cannot be empty',
  '订单未收货信息': 'Order non-receipt information',
  '订单来源单号': 'Order/source order No',
  '订单类型': 'Order type',
  '订单类型不为类越库或二步越库，无法进行分播': 'The order type is not class cross-dock or two-step cross-dock, and cannot be distributed',
  '订单过期日结': 'order expiration date',
  '订单：{billNumber}无可预检项': 'Order: {billNumber} has no pre inspection items',
  '记为整箱复核的容器类型配置': 'Configuration of container type of the FCL review',
  '记录': 'Records',
  '记录值': 'Record value',
  '许可证内容': 'License contents',
  '许可证内容不能为空': 'The license contents shall not be left blank',
  '许可证前端地址': 'Front-end address of license',
  '许可证密码不能为空': 'The license passwords shall not be left blank',
  '许可证服务地址': 'Service address of license',
  '许可证服务地址不能为空': 'The service address of license shall not be left blank',
  '许可证用户名不能为空': 'The user name of license shall not be left blank',
  '许可证管理': 'License',
  '许可证配置': 'License Configuration',
  '设为默认': 'Set as default',
  '设备代码': 'device code',
  '设备名称': 'device name',
  '设备维护': 'Equipment Maintenance',
  '设置别名': 'Set up the alias',
  '设置失败': 'Setting failed',
  '设置差异原因': 'Set up the difference reason',
  '设置成功': 'Setting succeeded',
  '设置拣货位成功': 'Set Picking Position Successfully',
  '设置拣货员': 'Set up the picking staff',
  '设置目标位置': 'Set up the target location',
  '设置目标容器': 'Set Target Container',
  '设置目标货位': 'Set up the target location',
  '设置码头集': 'Set up the dock set',
  '设置菜单权限': 'Set up the menu permission',
  '设置调整数量': 'Set up the adjustment quantity',
  '设置货位校验码': 'Set up the check code of goods location',
  '设置配送中心': 'Set distribution center',
  '设置首选收货成功': 'Set preferred delivery success',
  '设置首选退货成功': 'Set Preferred Return Success',
  '诚信包裹收货': 'Integrity parcel receipt',
  '诚信收货': 'Receipt with good faith',
  '诚信无包裹收货': 'Package-free receipt with good faith',
  '该功能在企业端不适用！': 'This feature is not applicable on the enterprise side!',
  '该单未预检': 'This order is not pre-checked',
  '该单未预约': 'This order is not pre-appointed',
  '该商品需要检疫证，请核实有无检疫证': 'The commodity needs the free pratique Please check whether there is any free pratique',
  '该波次单{billNumber}：{msg}，是否继续？': 'The wave order {billNumber}: {msg}, do you want to continue?',
  '该目录下为空': 'The directory is empty',
  '该订单未预检，不可收货': 'This order has not been pre-checked and it could not be received',
  '该订单未预约，不可收货': 'This order has not been appointed and it could not be received',
  '详情': 'Details',
  '详情查看': 'View details',
  '详情页行数': 'Number of rows for the detail page',
  '列表页数据自动加载': 'Automatic loading of list page data',
  '有效范围': 'Scope of valid documents: inbound orders, shelving orders, receipt orders, distribution notices, wave orders, picking orders, replenishment orders, surplus orders, loss orders, transfer orders, loading orders, store handover orders, return notices, return orders, supplier picking orders',
  '列表页查询条件完整展示': 'Complete display of query criteria on the list page',
  '请上传RF安装文件': 'Please upload the RF installation file',
  '请下载安装打印服务，重新打开页面': 'Please download and install the print service and reopen the page',
  '请使用英文输入法输入逗号': 'Please enter a comma using the English input method',
  '请先上传文件': 'Please upload the file first',
  '请先勾选': 'Please tick it firstly',
  '请先勾选,再进行批量操作': 'Please tick first, then perform batch operations',
  '请先勾选商品': 'Please check the item first',
  '请先勾选，再进行操作': 'Please tick first before proceeding',
  '请先安装插件': 'Please install the plug-in',
  '请先按条件查询返回结果集': 'Please first query by condition to return the result set',
  '请先清空复核区': 'Please clear the review area first',
  '请先确认拆零页,再提交': 'Please confirm the zero page before submitting',
  '请先获取任务': 'Please obtain the task first',
  '请先选择仓位': 'Please select a warehouse location first',
  '请先选择修正类型': 'Please select a correction type first',
  '请先选择加工波次单': 'Please select the processing wave order first',
  '请先选择单据商品': 'Please select a document product first',
  '请先选择单据商品及规格': 'Please select the document product and specification first',
  '请先选择商品！': 'Please select a product first!',
  '请先选择复核容器': 'Please select a review container first',
  '请先选择容器': 'Please select a container first',
  '请先选择异常拣货单': 'Please select the abnormal pick list first',
  '请先选择或新建线路体系': 'Please select or create the route system',
  '请先选择打印机': 'Please select a printer first',
  '请先选择拣货单': 'Please select a picking list first',
  '请先选择数据': 'Please select data first',
  '请先选择数据行': 'Please select data line first',
  '请先选择来源单据': 'Please select a source document first',
  '请先选择线路': 'Please select the route firstly',
  '请先选择行': 'Please select a row first',
  '请先选择要修改的行': 'Please select the row you want to edit first',
  '请先选择要修改的行！': 'Please select the row to modify first!',
  '请先选择要删除的数据': 'Please select the data to delete first',
  '请先选择要删除的线路': 'Please select the route to be deleted',
  '请先选择要删除的行': 'Please select the row to delete first',
  '请先选择要删除行！': 'Please select the row to delete first!',
  '请先选择要刷新的明细': 'Please select the details to refresh first',
  '请先选择要刷新的装车员': 'Please select the loader to refresh first',
  '请先选择要添加的行': 'Please select the row to add first',
  '请先选择要设置目标供应商退货位的行': 'Please first select the row where you want to set the target supplier return location',
  '请先选择要设置目标供应商退货位的行！': 'Please select the row where you want to set the target supplier return location first!',
  '请先选择要设置目标供应商退货位行的供应商': 'Please first select the supplier for which you want to set the target supplier return location line',
  '请先选择要设置目标供应商退货位行的供应商！': 'Please select the supplier for which you want to set the target supplier return location line first!',
  '请先选择要设置目标拣货位的行！': 'Please select the row where you want to set the target pick position first!',
  '请先选择要设置目标拣货位行的商品': 'Please first select the item for which you want to set the target pick location line',
  '请先选择要设置目标拣货位行的商品！': 'Please first select the item you want to set the target pick location line for!',
  '请先选择订单/入园单': 'Please select the order/entry slip first',
  '请先选择订单商品': 'Please select an order item first',
  '请先选择退仓通知单！': 'Please select the cancellation notice first!',
  '请先选择道口': 'Please select a crossing first',
  '请勾选数据': 'Please tick the data',
  '请勾选，再进行批量操作': 'Please tick, and then perform batch operations',
  '请勾选，再进行操作': 'Please tick, and then proceed',
  '请填入真实的手机号': 'Please enter the real mobile phone number',
  '请填入真实的联系方式': 'Please fill in the real contact way',
  '请填入真实的邮编': 'Please fill in the real postal code',
  '请填写完整': 'Please fill in complete',
  '请扫描商品条码': 'Please scan the commodity barcode',
  '请求超时': 'request timeout',
  '请添加明细': 'Please add details',
  '请确认商品规格': 'Please confirm the product specification',
  '请设置多配默认处理方式': 'Please set the default processing method for exceeding delivery quantity',
  '请设置少配默认处理方式': 'Please set the default processing method for Insufficient delivery quantity',
  '请设置拆零配置': 'Please set the zero configuration',
  '请设置整件配置': 'Please set the entire configuration',
  '请设置默认打印模板！': 'Please set the default print template!',
  '请输入': 'Please enter',
  '请输入0-10000之间的整数': 'Please enter an integer from 0 to 10000',
  '请输入0-100之间的整数': 'Please enter an integer between 0 and 100.',
  '请输入6-16位密码，允许数字字母以及特殊字符#@!~%^&*': 'Please enter a 6-16 digit password that allows numbers, letters, and special characters # @!~%^&*',
  '请输入Token': 'Please enter Token',
  '请输入excel表字段': 'Please enter the field of the excel sheet',
  '请输入{placeholderName}的名称': 'Please enter a name for {placeholderName}',
  '请输入不合格数量': 'Please enter the unqualified quantity',
  '请输入不超过30位A-H之内的字母': 'Please enter the letters not more than 30 within A-H.',
  '请输入不超过30位字母数字组合': 'Please enter the combination of the letters and numbers that are not less than 30.',
  '请输入业务单号': 'Please enter the business number',
  '请输入中间表字段名': 'Please enter the intermediate table field name',
  '请输入代码': 'Please enter the code',
  '请输入企业代码': 'Please enter the enterprise code',
  '请输入体积': 'Please enter the volume',
  '请输入到效期': 'Please enter the expiry date',
  '请输入前端地址': 'Please enter the front-end address',
  '请输入加工人数': 'Please enter the number of processing',
  '请输入包名': 'Please enter the package name',
  '请输入包含的配货通知单单号': 'Please enter the included allocation notice number',
  '请输入包裹号': 'Please enter the package number',
  '请输入单号': 'Please enter the number',
  '请输入司机': 'Please enter the driver',
  '请输入名称': 'Please enter the name',
  '请输入员工代码': 'en-请输入员工代码',
  '请输入员工代码或名称': 'Please enter employee code or title',
  '请输入商品': 'Please enter the product',
  '请输入商品代码': 'Please enter the commodity code',
  '请输入商品备注': 'Please enter the notes to the commodity',
  '请输入商品条码': 'Please enter the commodity barcode',
  '请输入固定的最低库存件数，如10。': 'Please enter the fixed min inventory pieces, such as 10.',
  '请输入固定的最高库存件数，如10。': 'Please enter the fixed max inventory pieces, such as 10.',
  '请输入备注': 'Please enter the remark',
  '请输入复核商品条码': 'Please enter the commodity barcode reviewed',
  '请输入外部批次': 'Please enter an external batch',
  '请输入外部批次号': 'Please enter the external batch number',
  '请输入大于0的数': 'Please enter a number greater than 0',
  '请输入实体日志表保留时长': 'Please enter the retention days of log sheet of the entity',
  '请输入实际值': 'Please enter the actual value',
  '请输入客户单数': 'Please enter the order quantity of the customer',
  '请输入容器条码': 'Please enter the container barcode',
  '请输入容器条码！': 'Please enter the container barcode!',
  '请输入密码': 'Please enter the passwords',
  '请输入库存操作日志表保留时长': 'Please enter the retention days of the operation log sheet of the inventory',
  '请输入库存流水表保留时长': 'Please enter the retention days of inventory statement of the inventory',
  '请输入快递单号': 'Please enter the tracking number',
  '请输入报警前缀': 'Please enter the alarm prefix',
  '请输入抽样件数': 'Please enter the sampling pieces',
  '请输入拣货单号': 'Please enter the picking list number',
  '请输入拣货单数量': 'Please enter the quantity of picking list',
  '请输入接口中间表保留时长': 'Please enter the retention days of the interface intermediate table',
  '请输入接口日志表保留时长': 'Please enter the retention days of log sheet of the interface',
  '请输入收货数量！': 'Please enter the received quantity!',
  '请输入数量': 'Please enter the quantity',
  '请输入更正件数': 'Please enter the pieces corrected',
  '请输入更正数量': 'Please enter the quantity corrected',
  '请输入替换量': 'Please enter replacement amount',
  '请输入正确的容器条码格式': 'Please enter the correct container barcode format',
  '请输入波次单号': 'Please enter the wave no.',
  '请输入温度': 'Please enter the temperature',
  '请输入满足率': 'Please enter the satisfaction rate',
  '请输入生产日期': 'Please enter the date of production',
  '请输入用户名': 'Please enter the user name',
  '请输入目标位置': 'Please enter the target location',
  '请输入码头集代码或名称': 'Please enter the code or title of the dock set',
  '请输入耗材数量': 'Please enter the quantity of consumables',
  '请输入自定义值': 'Please enter the user-defined value',
  '请输入装卸员': 'Please enter the stevedore',
  '请输入装盘规格对应的百分比，如80。': 'Please enter the corresponding percentage of the loading specification, such as 80.',
  '请输入要调整的序号': 'Please enter the S/N to be adjusted',
  '请输入订单单号': 'Please enter the order  No.',
  '请输入订单号': 'Please enter the order  No.',
  '请输入订单号/入园单号': 'Please enter the order number/ entry list number',
  '请输入订单号/入园单号/预检序号': 'Please enter the order No./entry list/pre-tax S/N',
  '请输入许可证内容': 'Please enter the license contents',
  '请输入许可证服务地址': 'Please enter the service address of the license',
  '请输入调整数量': 'Please enter the quantity adjusted',
  '请输入货位': 'Please enter the goods location',
  '请输入货位范围': 'Please enter the scope of goods location',
  '请输入质检员': 'Please enter the quality inspector',
  '请输入质检明细第{length}行合格结果': 'Please enter qualified results in line {length} of quality inspection details',
  '请输入费用金额': 'Please enter the expense amount',
  '请输入车型': 'Please enter the vehicle model',
  '请输入车辆': 'Please enter the vehicle',
  '请输入载重': 'Please enter the loading capacity',
  '请输入通知单号': 'Please enter the notice list number',
  '请输入配置名称': 'Please enter the title of configuration',
  '请输入重命名': 'Please enter the rename',
  '请输入重量': 'Please enter the weight',
  '请输入门店交接单': 'Please enter the store\'s EIr',
  '请输入门店代码/名称': 'Please enter the store code/title',
  '请输入门店代码或名称': 'Please enter the store code/title',
  '请输入门店封签号': 'Please enter the store\'s seal number',
  '请输入门店组代码': 'Please enter the code of the store group',
  '请输入间隔时间': 'Please enter interval time',
  '请输入集货位': 'Please enter the goods location',
  '请输入预分配量': 'Please enter the pre allocation amount',
  '请选择': 'please choose',
  '请选择人员': 'en-请选择人员',
  '请选择人员类型': 'en-请选择人员类型',
  '请选择仓位': 'Please select the warehouse location',
  '请选择企业': 'Please select enterprise',
  '请选择供应商': 'Please select the supplier',
  '请选择入库仓位': 'Please select the warehousing warehouse location',
  '请选择分单内容': 'Please select the HB/L contents',
  '请选择分单配置': 'Please select the HB/L configuration',
  '请选择分播打印模板': 'Please select the distribution printing template',
  '请选择加工单配方限制': 'Please select the limitation of the processing list formula.',
  '请选择满容录入附件限制': 'Please select the limitation of the container full attachment',
  '请选择加工台': 'Please select a processing stage',
  '请选择加工台和加工方案': 'Please select a processing stage and processing scheme',
  '请选择原料量上下限制计算维度': 'Please select the upper and lower limit of the raw material volume to calculate dimension',
  '请选择员工': 'Please select the employee',
  '请选择商品': 'Please select an item',
  '请选择商品下拉框': 'Please select the drop-down box of the commodity',
  '请选择商品组': 'Please select the commodity group',
  '请选择商品！': 'Please select the commodity!',
  '请选择回收容器取值模式': 'Please select the recycling container value taking mode',
  '请选择处理人': 'Please select the processor',
  '请选择复核台': 'Please select the review workbench',
  '请选择容器': 'Please select a container',
  '请选择容器号': 'Please select a container',
  '请选择容器类型': 'Please select the type of container',
  '请选择少配类型的明细行': 'Please select a detail line with less matching type',
  '请选择待处理数据': 'Please select data to process',
  '请选择快递公司类型': 'Please select the type of the courier service company',
  '请选择成品商品': 'Please select the finished commodity',
  '请选择打印机': 'Please select the printer',
  '请选择打印模板': 'Please select the printing template',
  '请选择承运商': 'Please select the carrier',
  '请选择拣货单': 'Please select the picking list',
  '请选择拣货员': 'Please select the picking staff',
  '请选择配货类型': 'Please select the allocation type',
  '配货类型和拣货员只能同时为空或同时不为空': 'The distribution type and the picker can only be empty or not empty at the same time',
  '请选择挂起原因': 'Please select the suspension reason',
  '请选择提总打印模板': 'Please select the printing template of overall picking',
  '请选择插件类型': 'Please select the type of plug-in',
  '请选择操作方式': 'Please select the operation mode',
  '请选择数据': 'Please select data',
  '请选择新品结算方式默认值': 'Please select the default value of the new-product settlement mode',
  '请选择日志级别': 'Please select the log level.',
  '请选择是否允许定位交接': 'Please select whether to allow positioning handover',
  '请选择是否合格': 'Please select whether it is qualified',
  '请选择是否损耗': 'Please select whether it has the loss',
  '请选择是否支持所有门店': 'Please choose whether to support all stores',
  '请选择是否整单加工': 'Please select whether the whole-order processing is selected',
  '请选择模板': 'Please select a template',
  '请选择波次号': 'Please select the wave no.',
  '请选择目标位置': 'Please select the target location',
  '请选择管理类型': 'Please select the type of management',
  '请选择箱类型': 'Please select the case type',
  '请选择箱类型,箱类型不能为空': 'Please select a box type, the box type cannot be empty',
  '请选择耗材类型': 'Please select the type of consumables',
  '请选择虚拟货位': 'Please select a virtual slot',
  '请选择装卸员': 'Please select the stevedore',
  '请选择要删除的数据': 'Please select the data to be deleted',
  '请选择要删除的明细': 'Please select the details to delete',
  '请选择要删除的门店': 'Please select the store to be deleted',
  '请选择要调整的数据': 'Please select the data to adjust',
  '请选择规格': 'Please select specifications',
  '请选择货主': 'Please select the owner',
  '请选择货位': 'Please select a location',
  '请选择货位用途': 'Please select the purpose of goods location',
  '请选择费用类型': 'Please select expense type',
  '请选择车辆': 'Please select a vehicle',
  '请选择道口': 'Please select the crossing',
  '请选择配送中心': 'Please select the distribution center',
  '请选择配送任务': 'Please select a delivery task',
  '请选择门店': 'Please select the store',
  '请选择门店分播位': 'Please select the distribution location of the store',
  '请选择门店分播方案': 'Please select the distribution scheme of the store',
  '请选择门店集货方案': 'Please select the goods collection scheme of the store',
  '请选择需要打印的数据': 'Please select the data to be printed',
  '请选择需要操作的数据': 'Please select the data that needs to be manipulated',
  '请配置模板打印机': 'Please configure a template printer',
  '请配置波次任务释放时机': 'Please configure the release time of wave task',
  '请重试或返回列表页': 'Please try again or return to the list page',
  '读取数据': 'Read Data',
  '调序': 'Sequence adjustment',
  '调序成功': 'Sequence adjustment succeeded',
  '调度看板': 'Dispatching Board',
  '调度看板展示容器类型': 'Dispatching board to display the type of the container',
  '调拨': 'transfer',
  '调拨收货': 'Allocation receiving',
  '调拨类型': 'Allocation type',
  '调拨类型退仓单不支持': 'Transfer type return orders are not supported',
  '调拨返厂退仓收货中': 'Transferring back to factory, returning to warehouse, receiving goods',
  '调整': 'adjustment',
  '调整件数': 'Pcs of adjustment',
  '调整原因': 'Reasons for adjustment',
  '调整员': 'Adjusting personnel',
  '调整序号': 'Serial number of adjustment',
  '调整成功': 'Adjusted successfully',
  '调整数量': 'Adjustment quantity',
  '调整数量不能为空': 'The adjusted quantity shall not be left blank',
  '调整类型': 'Type of adjustment',
  '调整行号': 'Row number of adjustment',
  '调整量': 'Adjustment amount',
  '调用': 'transfer',
  '调用打印机失败': 'Failed to call printer',
  '账号管理': 'Account management',
  '货主': 'Owner',
  '货主创建': 'Shipper created',
  '货主别名': 'Shipper alias',
  '货主或仓位未填选！': 'The owner or warehouse location has not been filled in!',
  '货主数': 'Number of the owner',
  '货主权限信息': 'Owner\'s permission',
  '货位': 'Goods Location',
  '货位不能为空': 'The goods location cannot be left blank',
  '货位代码': 'Code of goods location',
  '货位代码,多个货位以逗号隔开': 'Location code, multiple locations separated by commas',
  '货位代码显示格式': 'Location code display format',
  '货位代码显示格式{successLocale}': 'Location code display format {successLocale}',
  '货位别名': 'Alias of goods location',
  '货位及货位用途': 'Goods location and its purpose',
  '货位名称': 'Name of goods location',
  '货位地址': 'Address of goods location',
  '货位展示及确认配置': 'Position display and confirmation configuration',
  '货位展示及确认配置{successLocale}': 'Location display and confirmation configuration {successLocale}',
  '货位数': 'Number of goods location',
  '货位显示配置': 'Display configuration of goods location',
  '货位来源类型不能为空': 'The source and type of goods location shall not be left blank',
  '货位校验码范围': 'Scope of check code of goods location',
  '货位状态': 'Slot status',
  '货位用途': 'Purpose of goods location',
  '货位类型': 'Goods Location Type',
  '货位类型存储关系': 'Type and storage relationship of the goods location',
  '货位范围': 'Scope of goods location:',
  '货位范围、起始日期、货位用途、拣货分区、货位类型与商品范围不能同时为空': 'Slot range, start date, slot usage, pick zone, slot type and item range cannot be empty at the same time',
  '货位裁剪': 'Slot cutting',
  '货位输入方式': 'Goods location entry method',
  '货位顺序': 'Goods location sequence',
  '货区': 'Goods area',
  '货区/货道/货位': 'Goods area/goods lane/ goods location',
  '货区代码': 'Code of goods area',
  '货区名称': 'Name of goods area',
  '货区范围': 'Scope of goods area',
  '货区范围不为空，请填写完整': 'The scope of the goods area shall not be left blank Please complete it',
  '商品复核数量与拣货数量不一致，请查看后再结束复核': 'The number of items reviewed is inconsistent with the number of items picked, please check and then end the review',
  '货架': 'Shelves',
  '货架数': 'Number of goods shelf',
  '货架数必须为正整数': 'The number of goods shelf shall be a positive integer',
  '货架范围': 'Scope of goods shelf',
  '货架范围不为空，请填写完整': 'The scope of the goods shelf shall not be left blank, please fully complete it',
  '货道': 'cargo lane',
  '货道范围': 'Scope of goods lane',
  '货道范围不为空，请填写完整': 'The scope of the goods lane shall not be left blank Please complete it',
  '质检': 'Quality inspection',
  '质检{length}个选项': 'Quality {length} options',
  '质检中': 'under quality inspection',
  '质检单': 'Quality checklist',
  '质检单号': 'Quality checklist number',
  '质检单生成成功': 'Quality inspection order generated successfully',
  '质检员': 'Quality inspector',
  '质检强度': 'Strength of quality inspection',
  '质检成功': 'Successful quality inspection',
  '质检时间': 'Quality inspection time',
  '质检明细': 'Details of quality inspection',
  '质检明细第{length}行质检实际值不能为空': 'The actual quality inspection value in line {length} of the quality inspection details cannot be empty',
  '质检明细第{length}行质检实际值不能超过1000000': 'The actual quality inspection value in line {length} of the quality inspection details cannot exceed 1000000',
  '质检机构代码': 'Code of quality inspection institution',
  '质检机构名称': 'Title of quality inspection institution',
  '质检标记': 'Quality inspection mark',
  '质检标识': 'Quality inspection identification',
  '质检科目': 'Quality inspection items',
  '质检科目数': 'Number of items in quality inspection',
  '质检类型': 'Type of quality inspection',
  '质检结果': 'Quality inspection results',
  '质检通知单': 'Quality Inspection Notice',
  '质检通知单号': 'Quality inspection notice No.',
  '费率': 'Rate',
  '费用单': 'Fee Bill',
  '费用明细': 'Expense details',
  '费用类型': 'types of fee',
  '费用金额': 'expenses',
  '起始条码': 'Starting code',
  '起始列码': 'Starting column code',
  '起始单数': 'Starting order quantity',
  '起始层码': 'Starting floor code',
  '起始货区范围': 'Scope of starting goods area',
  '起始货架': 'Starting goods shelf',
  '起始货架范围': 'Scope of starting goods shelf',
  '起始货道': 'Starting goods lane',
  '起始货道范围': 'Scope of starting goods lane',
  '超保出货': 'Over-insured shipment',
  '超保单日结': 'Exceeding policy day settlement',
  '超保质期出货': 'Shipping beyond the expiration date',
  '超出了超拣比例，是否确认？': 'It exceeds the over-picked proportion Are you sure to confirm?',
  '超出比例(%)': 'Exceeded proportion (%)',
  '超拣上限': 'Over-Pick Cap',
  '超拣比例': 'Over-picked proportion',
  '超控制天数出库配置': 'Ex-warehouse configuration of the excessive control days',
  '超收': 'Over-collected',
  '超收/超出/超拣限制影响配置': 'Configuration of over-collected/exceeded/over-picked limit effect',
  '超收/超出/超拣限制影响配置{successLocale}': 'The configuration {successLocale} is affected by the over/over/over picking limit',
  '一步越库超收限制配置': 'One step over inventory limit configuration',
  '超配拣货': 'Over-dispatched picking',
  '超配货控制天数出货': 'Over-distribution control days to ship',
  '越库': 'Cross-dock',
  '越库分播管理方案配置': 'Configuration of management scheme of the cross-dock distribution',
  '越库已集货': 'The goods have been collected under the cross-dock mode',
  '越库拣货': 'cross-dock picking',
  '越库收货': 'cross-docking',
  '越库未集货': 'The goods are not collected under the cross-dock mode',
  '越库波次完成日结': 'Cross Docking Wave Completion Day End',
  '越库集货': 'cross-docking',
  '越库集货暂存位': 'cross-dock staging location',
  '跳过': 'Skip',
  '跳过{action}': 'Skip {action}',
  '车型': 'Model',
  '车牌号': 'License plate number',
  '车牌号或车辆代码': 'License plate number or vehicle code',
  '车辆': 'Vehicle',
  '车辆状态': 'Vehicle state',
  '车队承担': 'Undertaken by the fleet',
  '转运': 'Transfer',
  '载重(吨)': 'Loading capacity (t)',
  '输入字符串过长': 'The input string is too long',
  '输入插件ID': 'Enter the plug-in ID',
  '输入方式': 'Input',
  '输入货位取值': 'Enter the value of goods location',
  '输入配单号，则只以配单装车，否则以波次+门店进行装车': 'Enter the dispatching order number and load with it Otherwise, load I with the wave + store',
  '边拣边播': 'Pick and Play',
  '运单状态': 'Waybill status',
  '运输中': 'In transit',
  '运输波次': 'Transport wave',
  '运输管理': 'Transportation',
  '返厂': 'Return',
  '返厂控制天数': 'Return to factory control days',
  '返厂的目标货位': 'Target location of return',
  '返厂退仓收货中': 'Returning to factory, returning to warehouse, receiving goods',
  '返厂集货 ': 'Return to the factory to collect goods',
  '返回': 'Back',
  '返配件数': 'Pieces of returning parts',
  '返配明细': 'Details of returning parts',
  '返配明细第{line}行与第{otherLine}行重复！': 'The {line} and {otherLine} lines of the return configuration details are duplicate!',
  '返配明细第{line}行返配件数不能为空！': 'The number of returned accessories in line {line} of the return details cannot be empty!',
  '返配明细第{line}行返配件数必须大于0！': 'The number of returned accessories in line {line} of the return details must be greater than 0!',
  '返配明细第{line}行返配类型不能为空！': 'The configuration type in line {line} of configuration details cannot be empty!',
  '返配类型': 'Return type',
  '返配类型配置': 'Configuration of return type',
  '还原': 'Restore',
  '还原容器{containerBarcode}失败': 'Failed to restore container {containerBarcode}',
  '进入': 'Enter',
  '进入虚拟货位': 'Enter virtual storage location',
  '进行中': 'Processing',
  '进行中的项目': 'Ongoing item',
  '连接出错，检查插件和设置是否正常连接': 'Connection error. Check whether the plug-in and settings are connected properly',
  '连续打印次数': 'Number of continuous printing',
  '退仓': 'Return',
  '退仓上架中': 'Returning from warehouse and putting on shelf',
  '退仓上架单': 'Return Put Away List',
  '退仓上架明细不能为空': 'The details of withdrawal and listing cannot be empty',
  '退仓业务': 'Return business',
  '退仓修正': 'Exit correction',
  '退仓单': 'Return List',
  '退仓单供应商退货位推荐配置': 'US 退仓单供应商退货位推荐配置',
  '退仓单操作默认值配置': 'Clearance order operation default value configuration',
  '退仓单收货日结': 'Receipt date settlement',
  '退仓原因': 'Return reason',
  '退仓员': 'liquidator',
  '退仓收货': 'Return receipt',
  '退仓收货实收显示': 'Receipt actual receipt display',
  '退仓收货暂存位': 'Temporary location of returning receipt',
  '退仓明细不能为空': 'The withdrawal details cannot be empty',
  '退仓类型': 'Type of return',
  '退仓通知单': 'Return Notice List',
  '退仓通知单过期日结': 'Expiration date of cancellation notice',
  '退件': 'Pieces returnable',
  '退件已签收': 'The pieces returnable have been signed',
  '退出': 'Exit',
  '退出登录': 'Logout',
  '退单明细': 'en-退单明细',
  '退货': 'Return of goods',
  '退货仓位': 'Return Warehouse Location',
  '退货修正': 'Return correction',
  '退货条件': 'Return conditions',
  '退货类型': 'Type of return',
  '退货调拨配置': 'Configuration return transfer',
  '退货通知单号': 'en-退货通知单号',
  '退货配置': 'Return configuration',
  '送货地址': 'delivery address',
  '送货地址不能为空。': 'The shipping address cannot be empty.',
  '送货对象': 'Delivery object',
  '送货对象不可用容器类型配置': 'The delivery object could not be configured with the container type',
  '送货对象类型': 'Type of delivery object',
  '送货对象类型不可用容器类型配置': 'Shipping object type is not available container type configuration',
  '送货类型': 'Delivery type',
  '适应门店明细第{line}行与第{otherLine}行重复！': 'The {line} and {otherLine} lines of the applicable store details are duplicate!',
  '适应门店明细第{line}行门店不能为空！': 'The store in line {line} of the applicable store details cannot be empty!',
  '逆向修改': 'Reverse modification',
  '逆向修正单明细第{line}行与第{otherLine}行重复！': 'The reverse correction order details line {line} and line {otherLine} are duplicate!',
  '逆向修正明细第{line}行修正原因不能为空！': 'The correction reason in line {line} of the reverse correction details cannot be blank!',
  '逆向修正明细第{line}行单价不能空或小于0！': 'The unit price in row {line} of the reverse correction details cannot be empty or less than 0!',
  '逆向修正明细第{line}行商品不能为空！': 'Product in line {line} of reverse correction details cannot be empty!',
  '逆向修正明细第{line}行数量不能为0！': 'The quantity of row {line} of the reverse correction details cannot be 0!',
  '逆向物流': 'Reverse Logistics',
  '选取波次号': 'Select the wave no.',
  '选择': 'Select',
  '选择全选时请取消其他选项！': 'Please cancel other options when selecting All!',
  '选择加工波次': 'Select the process wave',
  '选择包装机类型': 'Select the type of the packaging machine',
  '选择商品': 'Select the commodity',
  '选择录入结果': 'Select the entry results',
  '选择打印数据': 'Select the printing data',
  '选择明细中没有退仓类型位好退的明细,请重新勾选': 'In the selection details, there is no details of the type of withdrawal that is good for withdrawal, please re-check',
  '选择标签属性': 'Select the label property',
  '选择的数据中包含状态为非已审核的数据，请选择已审核的数据': 'The selected data contains data with a status of non approved. Please select approved data',
  '选择的明细只能为同一供应商': 'The selected details can only be for the same supplier',
  '选择的订单已无可预检项': 'The selected order has no pre-check items',
  '选择虚拟货位': 'Select the virtual goods location',
  '选择装车员': 'Select the loading staff',
  '选择装车来源': 'Select the loading source',
  '选择订单仓位与预检已有仓位不一致': 'The selection of the order warehouse location is inconsistent with the pre-check existing warehouse location',
  '选择订单供应商与预检已有供应商不一致': 'The selection of the order supplier is inconsistent with the pre-check existing supplier',
  '选择订单货主与预检已有货主不一致': 'The selection of the owner of the order is inconsistent with the existing owner of the pre-check',
  '选择货位': 'Select the goods location',
  '选项配置': 'Option Configuration',
  '通知单': 'Notice',
  '通知单到效日期不能早于当前日期': 'The effective date of the notice cannot be earlier than the current date',
  '通知单到效期不能早于当前日期': 'The notice expiration date cannot be earlier than the current date',
  '通知单号': 'Notice No.',
  '通知单号或来源单号': 'Notice No. or source No.',
  '通知单明细不能为空': 'Notice details cannot be empty',
  '通知单来源单号': 'Source number of notice',
  '通知单来源行号': 'Source row number of notice',
  '通知单退货日期不能早于当前日期': 'The return date of the notice cannot be earlier than the current date',
  '通知管理': 'Notice management',
  '通道数': 'Number of channels',
  '通道数必须为正整数': 'The number of the channels shall be a positive integer',
  '逾期关闭': 'Overdue closing',
  '道口': 'road crossing',
  '道口货位': 'Goods location of crossing',
  '部分预检': 'Partial preflight',
  '部分预约': 'Partial pre-appointment',
  '配单不能为空': 'Order cannot be empty',
  '配单拣货完成日结': 'Order picking completion date',
  '配单接收': 'Order receipt',
  '配单数据上传TMS': 'Order data upload to TMS',
  '配单类型配置': 'Configuration of type of the dispatching order',
  '配单装车状态刷新日结': 'Refresh the daily settlement of the single loading status',
  '配单过期日结': 'Order Expiration Date',
  '配差单类型': 'Type of dispatch order',
  '配置中心': 'Configuration Center',
  '配置信息': 'Configuration information',
  '配置名称': 'Configuration name',
  '配置日志': 'Configuration log',
  '配置类型': 'Type of configuration',
  '配货单号': 'Allocation number',
  '配货差异使用虚拟货位配置': 'The distribution difference uses the configuration of the virtual goods location',
  '配货差异单': 'Distribution Discrepancy',
  '配货差异单日志': 'Log of distribution difference list',
  '配货差异单移库': 'Distribution Difference Order transfer',
  '配货差异可用处理方式配置': 'Configuration of available processing mode of distribution difference',
  '配货差异审核提示配置': 'Audit prompt and configuration of the distribution difference',
  '配货控制天数': 'Delivery Control Days',
  '配货日期': 'Allocation date',
  '配货状态': 'Allocation status',
  '配货类型': 'Allocation type',
  '配货通知单': 'Allocation Notice',
  '配货通知单号': 'Delivery notice number',
  '配货通知单类型': 'Allocation notice  Type',
  '配送': 'Delivery',
  '配送中': 'Under delivery',
  '配送中心': 'Distribution Center',
  '配送中心不为空': 'The distribution center is not empty',
  '配送中心权限信息': 'Permission of distribution center',
  '配送中心组织': 'Organization of distribution center',
  '配送中心设置成功': 'Distribution center setup succeeded',
  '配送中心：{code} 已存在': 'Distribution center: {code} already exists',
  '配送主动退货供应商配置': 'Active return of the supplier\'s configuration',
  '配送周期': 'Distribution cycle',
  '配送周期代码': 'Code of distribution cycle',
  '配送周期名称': 'Title of distribution cycle',
  '配送周期方案': 'Distribution Cycle Scheme',
  '配送确认': 'Distribution confirmed',
  '配送设置': 'Distribution setting',
  '采购核价配置': 'Configuration of purchase and price check',
  '采集体积': 'Collection volume',
  '释放': 'Release',
  '释放成功': 'release successfully',
  '释放拣货单': 'Release the picking list',
  '释放补货单': 'Release the replenishment list',
  '里程': 'Mileage',
  '里程登记': 'Mileage registration',
  '重': 'Weight',
  '重(g)': 'Weight (g)',
  '重印': 'reprint',
  '重发': 'Resend',
  '重发{length}个选项': 'Replay {length} options',
  '重启': 'Restart',
  '重命名': 'rename',
  '重命名不能为空': 'Rename cannot be empty',
  '重算{length}个选项': 'Recalculate {length} options',
  '重算成功': 'Recalculation succeeded',
  '重置': 'Reset',
  '重置密码': 'Reset passwords',
  '重置密码成功': 'Reset password successfully',
  '重量': 'Weight',
  '重量(kg)': 'Weight (kg)',
  '重量(吨)': 'Weight (t)',
  '重量/读称': 'Weight/read',
  '重量不能为空': 'The weight cannot be left blank',
  '重量商品拣货自动提交': 'Automatic submission of weight item picking',
  '金额': 'amount',
  '金额(元)': 'Amount (RMB)',
  '钉钉配置': 'DingTalk configuration',
  '锁定': 'Lock',
  '锁定解锁配置': 'Locking and unlocking configuration',
  '镇/街道': 'Town/sub-district',
  '长': 'Length',
  '长(cm)': 'Length (cm)',
  '长/宽/高': 'Length/Width/Height',
  '门店': 'Store',
  '门店 :': 'Store:',
  '门店/客户': 'Store/customer',
  '门店{code} 已存在': 'Store {code} already exists',
  '门店交接': 'Store handover',
  '门店交接单': 'Store Handover',
  '门店代码': 'Store code',
  '门店代码/名称': 'Store code/title',
  '门店价格查询': 'Store price inquiry',
  '门店信息': 'Store information',
  '门店信息第{line}行封签号不能为空！': 'The seal number of the {line} line of store information cannot be empty!',
  '门店分播位': 'Store distribution',
  '门店分播位数量与客户单数不符': 'The number of stores in the store does not match the number of customers',
  '门店分播位方案': 'Scheme of the store distribution location',
  '门店分播方案不能为空': 'The distribution scheme of the store shall not be left blank',
  '门店单号': 'Store order number',
  '门店名称': 'Store name',
  '门店容器数': 'Number of containers of the store',
  '门店封签号': 'Sealing number of the store',
  '门店已交接': 'The store has been handed over',
  '门店拣货信息调整面板': 'Adjustment Panel of The Store\'s Picking Information',
  '门店拣货容器类型提示': 'Picking container prompt of the store',
  '门店拣货容器类型配置': 'Store Pick Container Type Configuration',
  '门店明细': 'Store details',
  '门店权限信息': 'Store permission information',
  '门店业态': 'Store format',
  '门店纬度': 'Store latitude',
  '门店线路': 'store line',
  '门店组': 'Store group',
  '门店组名称': 'Title of the store group',
  '门店组织': 'Store organization',
  '门店组配置': 'Configuration of the store group',
  '门店要货量': 'Demand of the store',
  '门店起要量': 'Minimum demand of the store ',
  '门店跳过成功！': 'Store skipped successfully!',
  '门店退仓': 'Store checkout',
  '门店退仓通知单': 'Return notice list of the store',
  '门店道口关系{sortStrategy}': 'Store crossing relationship {sortStrategy}',
  '门店道口关系不存在': 'Store crossing relationship does not exist',
  '门店道口关系方案': 'Store Crossing Relationship Scheme',
  '门店道口关系方案：{entity}': 'Store crossing relationship scheme: {entity}',
  '间隔时间(ms)': 'Interval time (ms)',
  '间隔时间设置': 'Interval setting',
  '附件': 'Attachment',
  '附件信息': 'Attachment information',
  '附件入库': 'Attachment storage',
  '附件出库': 'Accessories out of stock',
  '附件明细': 'Attachment details',
  '附件管理': 'Attachment management',
  '附件类型': 'Attachment type',
  '附件绑定维护分类': 'Attachment Binding Maintenance Classification',
  '附件配置': 'Attachment configuration',
  '降幅': 'Decline',
  '限1M以内': 'Within 1M.',
  '限制字段': 'Restricted Fields',
  '限制强度': 'Limiting strength',
  '限制影响类型': 'Limit the type of impact',
  '随波次': 'with waves',
  '随统配集货': 'Collection in the mode of unified distribution',
  '随车': 'With the vehicle',
  '集货位': 'Goods location',
  '集货位{tips}已在其他门店分配记录中，是否确认保存?': 'The collection location {tips} is already in the allocation record of other stores. Are you sure you want to save it?',
  '集货位复查单日结': 'Collection location review single-day settlement',
  '集货位数': 'Number of goods location',
  '集货位管理方案-指定货位数管理': 'Collection location management solution-specified location management',
  '集货位管理方案-粗式管理': 'Collection location management solution - rough management',
  '集货位管理方案-精细化管理': 'Collection location management solution - refined management',
  '集货位跨度': 'Span of goods location',
  '集货位面板': 'Panel of goods location',
  '集货信息查询': 'Inquiry of goods collection information',
  '集货区复查': 'Collection area review',
  '集货区复查容器最大输入数量配置': 'Review the max entry quantity configuration of the container in the shipping area',
  '集货区复查容器类型配置': 'Review the type and configuration of the container in the shipping area',
  '集货区复查是否影响装车': 'Whether the review in the shipping area affect the loading',
  '集货区复查是否影响装车配置': 'Check whether the cargo area affects the loading configuration',
  '集货区复查装车配置': 'Check the loading configuration in the collection area',
  '集货区复查规格维护': 'Maintenance of review specification in the shipping area',
  '集货区复查货位用途配置': 'Review the purpose and configuration of goods location in the shipping area',
  '集货复查后装车': 'Loading after collection and review',
  '集货复查装车': 'Collection review for loading',
  '集货方案': 'Collection plan',
  '集货暂存位': 'Temporary collection location',
  '集货管理方案': 'Collection Scheme',
  '零散': 'Odd',
  '零散数': 'Scattered number',
  '需要检疫证': 'Require the free pratique',
  '静态补货': 'Static replenishment',
  '非手工单据的分播方式将修改为手工单据，手工单据的将修改为原分播方式': 'The distribution mode of non-manual document will be modified to the manual document, and the manual document will be modified as the original distribution mode',
  '非手工单据的拣货单将修改为手工单据，手工单据的将修改为原操作方式': 'The picking list for non manual documents will be modified to a manual document, and for manual documents, the original operation method will be modified',
  '非手工单据的提总方式将修改为手工单据，手工单据的将修改为原提总方式': 'The overall picking mode of non-manual document will be modified to the manual document, and the manual document will be modified as the original overall picking mode',
  '非手工单据的补货单将修改为手工单据，手工单据的将修改为原操作方式': 'The replenishment mode of non-manual document will be modified to the manual document, and the manual document will be modified as the original operation mode',
  '非整托': 'Non-entire pallet',
  '非整托补货': 'Non-full pallet replenishment',
  '非配送数据支持配货差异': 'Non distribution data supports distribution differences',
  '非配送数据支持配货差异配置': 'The allocation difference configuration is supported under non-distribution data',
  '非默认规格': 'Non-default specification',
  '面单打印机': 'Receipt printer',
  '页面正在编辑中，如要刷新请先取消编辑': 'The page is being edited, if you want to refresh, please cancel the editing first',
  '项目数': 'Number of items',
  '项目访问': 'Item visit',
  '顺序调整': 'Sequential adjustment',
  '顾客下单时间': 'Customer order time',
  '预估卸货时长(h)': 'Estimated unloading time (h)',
  '预分配': 'Pre allocation',
  '预分配明细': 'Pre allocation details',
  '预分配量': 'Preallocated amount',
  '预分配：<空>': 'Pre allocation:<empty>',
  '预分配：{article}': 'Pre allocation: {article}',
  '预检': 'Pre-inspection',
  '预检不能混物流模式': 'Preflight cannot mix flow modes',
  '预检单': 'Pre-inspection List',
  '预检单完成日结': 'Pre-check form completion date',
  '预检员': 'Pre-inspection personnel',
  '预检完成': 'Preflight completed',
  '预检序号': 'Preflight sequence number',
  '预检库存多规格校验': 'Pre inspection inventory multi specification verification',
  '预检限制': 'Pre-inspection limitation',
  '预留操作高度(cm)': 'Reserved operation height (cm)',
  '预约': 'Appointment',
  '预约人': 'Appointment personnel',
  '预约单号': 'Appointment list No.',
  '预约品项数': 'Number of items appointed',
  '预约完成': 'Appointment completed',
  '预约日期': 'Appointment date',
  '预约日期：{time}': 'Appointment Date: {time}',
  '预约时间': 'Appointment time',
  '预约时间配置': 'Appointed time configuration',
  '预约量配置': 'Configuration of appointment volume',
  '预约限制': 'Appointment limitation',
  '预约预检流程配置': 'Configuration of the appointment pre-inspection process',
  '预补': 'pre-fill',
  '预补补货': 'Pre-replenishment',
  '预览': 'preview',
  '预计送达时间': 'Expected delivery time',
  '领用': 'Receive',
  '领用{length}个选项': 'Collect {length} options',
  '领用主动发起配置': 'Actively initiate configuration for requisition',
  '领用主动发起配置{successLocale}': 'Collecting Active Initiation Configuration {successLocale}',
  '领用主动发起配置类型': 'Actively initiate configuration type for requisition',
  '领用人': 'Recipient',
  '领用人代码': 'Receiver Code',
  '领用单': 'Requisition List',
  '领用对象': 'Requisition object',
  '领用成功': 'Receive successfully',
  '领用来源单号': 'Requisition source number',
  '领用类型': 'Requisition type',
  '领用通知单': 'Requisition Notice',
  '首选收货': 'Preferred receiving',
  '首选退货': 'Preferred return',
  '首选退货供应商': 'Preferred return supplier',
  '上游配送中心默认供应商': 'Upper distribution center default supplier',
  '驾驶员': 'Driver',
  '验证码只能包含数字和英文字母': 'The verification code can only contain numbers and English letters',
  '高': 'Height',
  '高(cm)': 'Height (cm)',
  '高叉作业': 'High fork operation',
  '高叉作业补货跳过源容器校验': 'High fork job replenishment skips source container verification',
  '高叉员作业配置': 'Operation configuration of the high-level forklift worker',
  '默认': 'Default',
  '默认付款方式': 'Default payment mode',
  '默认供应商': 'Default supplier',
  '默认供应商退货位': 'Default Supplier Return Location',
  '默认处理方式': 'Default processing mode',
  '默认库存分配类型': 'Type of default inventory allocation:',
  '默认强分门店配置': 'Default enhanced configuration of stores',
  '默认操作方式': 'Default operation mode',
  '默认正常仓位': 'Default normal warehouse location',
  '默认状态': 'Default status',
  '默认生产日期配置': 'Default configuration of date of production',
  '默认箱类型': 'Default case type',
  '默认虚拟货位': 'Default virtual storage location',
  '默认规格': 'Default specification',
  '默认退仓类型': 'Default type of return',
  '默认退货仓位': 'Default return warehouse location',
  '，祝你开心每一天！': 'Wish you happy every day!',
  '修改拣货方式': 'Modify the picking mode',
  '已发送状态拣货单，是否更改成功需等待外部系统确认结果，需保持关注': 'The status pick list has been sent. Whether the change is successful needs to be confirmed by the external system',
  '已发送状态拣货单，是否更改成功需等待外部系统确认结果，请保持关注': 'The status pick list has been sent. Whether the change is successful needs to be confirmed by the external system. Please keep an eye on it',
  '接口状态': 'Interface status',
  '确认中': 'confirm',
  '同一门店码头集是否允许同时排多车配置': 'Whether the dock set of the same store allows the configuration of multiple vehicles at the same time',
  '封签号管理配置': 'Seal number config',
  '封签号样式配置': 'Seal number style configuration',
  '单条码': 'Single bar Code',
  '组合条码': 'Combination Bar Code',
  '封签号数量配置': 'Packet number quantity configuration',
  '单门': 'single door',
  '多门': 'many doors',
  '封签号位置': 'Signature number location',
  '封签号为多门时，必须维护封签号位置': 'US 封签号为多门时，必须维护封签号位置',
  '预分配总量': 'Total pre allocation amount',
  '预分配总量大于可分配量': 'The total pre allocated amount is greater than the allocatable amount',
  '剩余可分配量': 'Total remaining distributable amount',
  '共存在{x}家门店的预分配量为0，是否继续生成指令?': 'There are {x} stores with a pre allocation quantity of 0. Do you want to continue generating instructions?',
  '电子标签拣货': 'Electronic Label Picking Operation',
  '勾选后支持电子标签拣货负库存': 'After ticking, support the electronic Label for negative picking inventory',
  '封签号为多门时，必须维护封签号门位置': 'US 封签号为多门时，必须维护封签号门位置',
  '请先选择要设置整件拣货位的行！': 'en-请先选择要设置整件拣货位的行！',
  '请先选择要设置拆零拣货位的行！': 'en-请先选择要设置拆零拣货位的行！',
  '请先选择要设置整件拣货位行的商品！': 'en-请先选择要设置整件拣货位行的商品！',
  '请先选择要设置拆零拣货位行的商品！': 'en-请先选择要设置拆零拣货位行的商品！',
  '封签号': 'en-封签号',
  '封签条码': 'en-封签条码',
  '封签位置': 'en-封签位置',
  '封签信息': 'en-封签信息',
  '封签信息第{line}行封签位置不能为空': 'en-封签信息第{line}行封签位置不能为空',
  '封签信息第{line}行封签号不能为空': 'en-封签信息第{line}行封签号不能为空',
  '封签信息第{line}行封签条码不能为空': 'en-封签信息第{line}行封签条码不能为空',
  '门店{stores}有装车库存,但未录入封签信息': 'en-门店{stores}有装车库存,但未录入封签信息',
  '容器交接类型维度配置': 'Handover Type of Container Config',
  '容器交接类型维度': 'Handover Type of Container',
  '门店交接单操作配置': 'Operate Of Store Handover List Config',
  '未交接的门店交接单web端可确认': 'The store handover list of unhandover can be confirmed manauly',
  '已交接的门店交接单web端可确认': 'The store handover list of handovered can be confirmed manauly',
  '承运商交接单审核生成': 'en-承运商交接单审核生成',
  '全部配送中心': 'All distribution centers',
  '入库流程/收货单日结，请至少填写一个时间': 'Warehousing process/one-day receipt, please fill in at least one time',
  '定时': 'timer',
  '轮询': 'poll',
  '小时': 'HOUR',
  '不强制复查的码头集配置': 'US 不强制复查的码头集配置',
  '日结锁定忽略货位用途配置': 'Daily settlement lock ignoring location usage configuration',
  '拣货位多库存规格配置': 'Multi-inventory specification configuration for picking positions',
  '奇数容器': 'Odd container',
  '偶数容器': 'Even container',
  '奇偶容器': 'Parity container',
  '封签明细第{line}行封签位置不能为空！': 'en-封签明细第{line}行封签位置不能为空！',
  '封签明细第{line}行封签号不能为空！': 'en-封签明细第{line}行封签号不能为空！',
  '封签明细第{line}行封签码不能为空！': 'en-封签明细第{line}行封签码不能为空！',
  '门店提报数': 'Store offer number',
  '实际装车数': 'The actual number of vehicles loaded',
  '封签位置': 'Seal position',
  '封签号': 'Seal code',
  '封签条码': 'Seal barcode',
  '奇偶容器': 'Parity container',
  '已复查': 'reviewed',
  '部分复查': 'Part review',
  '未复查': 'no review',
  '仓库确认': 'wms confirm',
  '拣货单{pickupBillNumber}，已无可调整明细，请核实': 'en-拣货单{pickupBillNumber}，已无可调整明细，请核实',
  '无法批量修改拣货数量，请单独进入拣货数量调整模块操作': 'en-无法批量修改拣货数量，请单独进入拣货数量调整模块操作',
  '复查标记': 'review state',
  '回收信息中，容器类型{containerType}有多行，不允许保存': 'en-回收信息中，容器类型{containerType}有多行，不允许保存',
  '复查标记': 'review state',
  '收拣业务小数位配置': 'BusinessDecimalDigitsConfig',
  '小数位数': 'DecimalDigits',
  '无需复查': 'no need review',
  '勾选后可在排车看板页面查看AGV出库暂存位的信息,不可装车': 'en-勾选后可在排车看板页面查看AGV出库暂存位的信息,不可装车',
  '回收明细第{line}行容器类型不能为空！': 'en-回收明细第{line}行容器类型不能为空！',
  '回收明细第{line}行交接类型不能为空！': 'en-回收明细第{line}行交接类型不能为空！',
  '回收明细第{line}行实际回收数不能为空！': 'en-回收明细第{line}行实际回收数不能为空！',
  '容器类型${containerTypes}，实际回收数为0，而门店提报量非0，是否确认?': 'en-容器类型${containerTypes}，实际回收数为0，而门店提报量非0，是否确认?',
  '距预计送达时间（M）': 'en-距预计送达时间（M）',
  '轮询间隔（M）': 'en-轮询间隔（M）',
  '自动波次配置': 'en-自动波次配置',
  '声音文件': 'Sound files',
  '支持wav': 'Support for wav',
  '文件名': 'file name',
  '试听': 'audition',
  '播放': 'play',
  'iwms保存报错': 'IWMS save error',
  '提示音': 'prompt tone',
  '目标货位状态': 'Target Location Status',
  '是否自动交接': 'Automatic handover or not',
  'rawRequisitionBill.title': 'Raw Requisition List',
  'rawRequisitionBill.index.batchButton.modifyPicker': 'Modify Picker',
  'rawRequisitionBill.detail.table.column.pickTime': 'Picking time',
  'rawRequisitionBill.picker': 'Picker',
  '修改领料员{length}个选项': 'Modify {length} options for the piker',
  '请先选择领料单。': 'please select the raw requisition list firstly。',
  '领料员不能为空。': 'The picker cannot be empty.',
  '开始领料': 'Start pick',
  '结束领料': 'End pick',
  '应领件数': 'QTY_STR',
  '打印数据不能为空': 'en-打印数据不能为空',
  '无默认模板，请先完成配置': 'en-无默认模板，请先完成配置',
  '电子标签日志': 'E-tag Log',
  '确认按数量回收{length}个选项': 'en-确认按数量回收{length}个选项',
  '领料任务': 'Material requisition task',
  '请输入上浮比例': 'Please enter the floating ratio',
  '选择配货日期': 'Select the distribution date',
  '生成领料单': 'Generate Material Requisition',
  '目标数量': 'target number',
  '可用库存': 'Available Stock',
  '待加工量': 'Quantity to be processed',
  'menu.inner.rawRequisitionTask': 'Material requisition task',
  '波次原因': 'en-波次原因',
  '库存分配类型': 'en-库存分配类型',
  '预设条件': 'en-预设条件',
  '周时间': 'en-周时间',
  '自定义语句': 'Custom SQL',
  '保存预设条件': 'en-保存预设条件',
  '预设条件名称': 'en-预设条件名称',
  '波次': 'en-波次',
  '名称已存在，是否覆盖当前预设条件': 'en-名称已存在，是否覆盖当前预设条件',
  '是否确认删除': 'en-是否确认删除',
  '确认生成领料单?': 'en-确认生成领料单?',
  '上浮比例请输入0-100的数字': 'en-上浮比例请输入0-100的数字',
  '待加工量为0': 'en-待加工量为0',
  '按天': 'en-按天',
  '按波次': 'en-按波次',
  '领料集货': 'RAWREQUISITION',
  '自定义语句中使用到主表时，需要使用占位符{masterAlias}进行替代': 'en-自定义语句中使用到主表时，需要使用占位符{masterAlias}进行替代',
  '建议加工量': 'en-建议加工量',
  '待加工量': 'en-待加工量',
  '已加工量': 'en-已加工量',
  '成品容器': 'en-成品容器',
  '箱': 'en-箱',
  '零': 'en-零',
  '选择模板': 'choose template',
  '结束加工': 'end process',
  '选择加工方案': 'select process shceme',
  '输入搜索加工方案': 'en-输入搜索加工方案',
  '选择加工台': 'en-选择加工台',
  '请先选择加工台': 'en-请先选择加工台',
  '商品/规格': 'en-商品/规格',
  '选择原料池': 'en-选择原料池',
  '结束加工-剩余原料': 'en-结束加工-剩余原料',
  'Web加工': "Web Process",
  '容器/商品': 'en-容器/商品',
  '规格/单位': "en-规格/单位",
  '跨波次跟随': "Cross wave following",
  '集货区复查是否受拣货完成限制配置': 'US 集货区复查是否受拣货完成限制配置',
  '体积范围最大值必须大于0': 'US 体积范围最大值必须大于0',
  '{article}商品实退{realQty}超出应退数量{qty}.': 'Product{article} real return quantity {realQty} is greater than refunded quantity {qty}.',
  '是否确认': 'whether to confirm',
  '体积范围最大值必须大于0': 'US 体积范围最大值必须大于0',
  '正在前往IWMS系统，请稍后...': 'en-正在前往IWMS系统，请稍后...',
  '按超收比例': 'According to the overcharging ratio',
  '不允许超量': 'No excess allowed',
  '不允许超收': 'No overcharging allowed',
  '目标货位范围': 'Target bin range',
  '补货触发时机': 'Replenishment trigger timing',
  '固定件数': 'Fixed QtyStr',
  '随拣货分区': 'With pick area',
  '拣货分区和目标货位不能同时为空': 'Pick area and target bin range cannot be empty at the same time',
  '低于最低库存': 'Lower than minimum stock',
  '低于固定件数': 'Lower than fixed qtystr',
  '低于库存比例': 'Lower than Stock ratio',
  '指定配货数据': 'Specified alc data',
  '打印标志': 'Print mark',
  '配单数': 'Count of distribution',
  '实际配货金额': 'Actual amount of distribution',
  '配单打印看板': 'Board of Distribution Print',
  '可打印': 'printable',
  '不可打印': 'not printable',
  '是否确认删除该预设条件：{name}吗？': 'en-是否确认删除该预设条件：{name}吗？',
  '只允许输入正整数数字': 'Only positive integer numbers are allowed to be entered',
  '补货优先级': 'Replenishment Priority',
  '报表-': 'report-',
  '无匹配结果': 'No Result',
  '需满足非负数格式': 'Must meet non negative number format',
  '费用登记': 'Fee registration',
  '装卸费用': 'Stevedorage',
  '车型': 'vehicleModel',
  '费用备注': 'feeNote',
  '配送进价': 'purchasePrice',
  '配送售价': 'shippingPrice',
  '请输入分播中转位代码': 'Please enter the transposition code in the broadcast',
  '看板线路体系默认值配置': 'Dispatch board route system default configuration',
  '代码最小': 'minimal code',
  '摘果拣货后直接平移': 'Direct translation after picking fruits',
  '生鲜摘果是否需要跳过商品校验': 'Do you need to skip product verification when picking fresh fruits',
  '控制RF生鲜摘果拣货模块，是否展示输入/扫描商品条码': 'Control whether the RF fresh fruit picking module displays input/scan of product barcodes',
  '明细第{line}行无供应商{vendor}！': 'en-明细第{line}行无供应商{vendor}！',
  '明细第{line}行无商品规格{qpcStr}！': 'en-明细第{line}行无商品规格{qpcStr}！',
  '修改新供应商': 'modify new Vendors',
  '修改新生产日期': 'modify new date of manufacture',
  '修改新商品': "modify new commodities",
  '修改新规格': 'modify new specifications',
  '是否要撤销删除此行？': "Do you want to cancel the action of remove",
  '撤销删除': 'Cancel remove',
  '接口上传': 'en-接口上传',
  '商品转换': 'Commodities transfer',
  '新商品': 'new commodities',
  '商品组别': 'Commodity Group',
  '附件支持jpg、jpeg、png、doc、docx、xls、xlsx、pdf格式文件，一行明细最多上传3个附件': 'en-附件支持jpg、jpeg、png、doc、docx、xls、xlsx、pdf格式文件，一行明细最多上传3个附件',
  '明细第{line}行新商品不能为空！': 'en-明细第{line}行新商品不能为空！',
  '取&emsp;消': 'Cancel',
  '确&emsp;认': 'Ok',
  '总接收件数': 'Total number of received pieces',
  '总接收品项数': 'Total number of items received',
  '总接收金额': 'Total amount received',
  '平移容器': 'Plane move container',
  '容器未校验或校验不通过': 'en-容器未校验或校验不通过',
  '平移容器': 'Plane move container',
  '大型拣货位上架逻辑': 'Large picking space rack logic',
  '只上拣货位': 'Only picking location',
  '依据上架货位维护值': 'Maintain the value according to the shelf location',
  '上架配置': 'The inventory in-log configuration',
  '扣减费用': 'Amount of loss',
  '选择的明细只能为同一供应商': 'Only one vendor can be selected',
  '确认{operate}{length}个选项': 'en-确认{operate}{length}个选项',
  '附件下载': 'Download file',
  '{name}大小超过30M,无法上传': 'en-{name}大小超过30M,无法上传',
  '普通盘点': 'en-普通盘点',
  '匹配货位盘点': 'en-匹配货位盘点',
  '实盘来源': 'en-实盘来源',
  '复盘单生成维度配置': 'Dimension configuration for review order generation',
  '货位+容器+商品': 'Goods location + container + Commodity',
  '车牌号': 'License plate number',
  '仅支持jpg、jpeg、png、doc、docx、xls、xlsx、pdf格式': 'en-仅支持jpg、jpeg、png、doc、docx、xls、xlsx、pdf格式',
  '文件大小不要超过30M': 'en-文件大小不要超过30M',
  '特殊门店集货位范围': 'The special store collection location range',
  '附件支持jpg、jpeg、png、doc、docx、xls、xlsx、pdf格式文件，建议上传文件大小不超过30M，一行明细最多上传{count}个附件': 'en-附件支持jpg、jpeg、png、doc、docx、xls、xlsx、pdf格式文件，建议上传文件大小不超过30M，一行明细最多上传{count}个附件',
  "第{a_line}行明细与第{b_line}行明细相同": 'en-第{a_line}行明细与第{b_line}行明细相同',
  '出库无皮重记录时的采集维度': 'Collect the tare weight dimension out warehousing',
  "到货日期": 'Arrival date',
  '订单/来源订单号': 'Order No./Source order No.',
  '装车码头': 'Loading Dock',
  '件数不能小于等于0': 'The number of packets cannot be less than or equal to 0',
  '毛重不能小于等于0': 'Gross weight cannot be less than or equal to 0',
  '皮重不能大于毛重': 'Tare should not be greater than gross',
  '实现全程精细化、智能化管理': 'Realize the whole process of fine and intelligent management',
  '海鼎智慧仓储管理系统': "HEADING Intelligent Warehouse Management System",
  '仅支持上传图片': 'Only support pictures',
  '{name}大小超过{count}M,无法上传': "en-{name}大小超过{count}M,无法上传",
  '登录页设置': 'en-登录页设置',
  '主标题': "Main heading",
  '副标题': 'Subject heading',
  '自定义图片': "Custom pictures",
  '建议图片尺寸{width}*{height}px,大小不超过{size}M': "en-建议图片尺寸{width}*{height}px,大小不超过{size}M",
  '首页设置': "en-首页设置",
  'menu.account.loginConfig': 'en-登录页设置',
  'menu.account.homeConfig': 'en-首页设置',
  "成品加工位容器管理": 'Finished product processing bit container management',
  "成品加工位容器管理 保存成功": 'Finished product processing bit container management saved successfully',
  'WMS配送中心': 'WMS Distribution Center',
  '优先上游配送中心': 'Priority Upstream Distribution Center',
  '库存模式&商品状态取值来源': 'Inventory mode & commodity status value source',
  '库存模式&商品状态业务限制': 'Inventory mode & commodity status limit',
  '新橙家特制条码': 'New orange home special bar code',
  '门店拣货校验生产日期配置': 'Store picking verify production date configuration',
  '拣货日期比例': 'picking date ratio',
  '预留天数': 'reserved days',
  '-100~100整数': '-100~100 integer',
  '分子请输入1~100整数': 'Please enter an integer from 1 to 100 for the numerator',
  '分母请输入1~100整数': 'Please enter an integer from 1 to 100 for the denominator',
  '拣货日期比例分子不能大于分母': 'The numerator of the picking date ratio cannot be greater than the denominator',
  '门店代码或名称': 'the store code/title',
  '加工方向': 'Machining direction',
  '逆向': 'Reverse',
  '正向': 'Forward direction',
  '门店计划时间提示/展示': 'Store planning time tips/displays',
  '勾选后RF统配拣货、容器复查、分播等模块提示或展示计划开始拣货时间、计划结束拣货时间、计划装车完成时间': 'After the selection, the modules such as RF unified distribution picking, container review, and separation will prompt or display the planned start picking time, planned end picking time, and planned loading completion time',
  '供应商退货位和供应商集货位只能同时为空或同时不为空': 'Supplier return and supplier collection can only be empty or not empty at the same time',
  '日结虚拟货位': 'Daily settlement virtual location',
  '分钟': 'minute',
  '请输入正整数': 'please input positive integer',
  '轮询时间最大不可超过1440': 'The maximum polling time cannot exceed 1440',
  '轮询时间': 'cron',
  '收货采集车牌号': 'Receive and collect license plate number',
  '勾选后RF正常收货、RF快速收货、RF诚信收货采集车牌号': 'After checking, RF normal receiving, RF fast receiving, RF good faith receiving collection license plate number',
  '统配波次允许多分播方案': 'Unify wave allow multicast distribution scheme',
  '允许多分播方案': 'Allow multicast distribution scheme',
  '预检单号': 'Pre-inspection List No.',
  "末次拣货时间": "en-末次拣货时间",
  "末次拣货员": "en-末次拣货员",
  "一键分播": "en-一键分播",
  '拣货分区组': 'Picking Partition Group',
  '拣货分区范围': 'Range of picking Partition',
  '无附件可下载': 'No attachments are available for download',
  '门店指定日期配货配置': 'Store specified date distribution configuration',
  '配货日期比例提示': 'M/N format, the store requires that the number of days from the expiration date of the commodity shall not be less than M/N of the shelf life of the commodity',
  '配货日期比例分子不能大于分母': 'Distribution date ratio numerator should not be greater than denominator',
  '配货日期比例': 'Distribution date ratio',
  '指定类型': 'Specified type',
  '语言切换': 'Language Switch',
  '组合单号不为空，不允许修改拣货员！': 'The combination order number is not empty, and it is not allowed to modify the picker!',
  '组合单号不为空，不允许修改拣货方式！': 'The combination order number is not empty, it is not allowed to modify the picking method!',
  '组合类型': 'Composite types',
  '组合单号': 'Combined reference number',
  '指定类型': 'Specifying a type',
  '确认修改{length}个选项': 'Confirm to update {length} options!',
  '同店多区': 'same Store MultipleArea',
  '同区多店': 'same Area MultipleStore',
  '拣货分区组不能为空': 'Picking Partition Group cannot be left blank',
  '拣货单状态': 'state',
  '品项数范围': 'Phase number range',
  '起始品项数': 'Number of initial phases',
  '终止品项数': 'Number of terminating phases',
  '件数范围': 'QtyStr range',
  '起始件数': 'QtyStr of initial phases',
  '终止件数': 'QtyStr of terminating phases',
  '体积范围(m³)': 'Volume range',
  '起始体积': 'Volume of initial phases',
  '终止体积': 'Volume of terminating phases',
  '1~100整数':'1-100 integer',
  '同店多区组合': 'Same store multi-district combination',
  '确认是否进行同店多区组合': 'Confirm whether to carry out the same store multi-area combination',
  '计划开始拣货时间': 'StartPickTime',
  '计划结束拣货时间': 'EndPickTime',
  '确认修改{length}个选项！': 'Confirm to update {length} options!',
  '拣货单组合': 'Pick list combination',
  '拣货件数进度': 'PickQtyProgress',
  '拣货体积进度': 'PickVolumeProgress',
  '总应拣件数': 'TotalQtyStr',
  '总应拣体积(m³)': 'TotalVolume(m³)',
  '应拣体积(m³)': 'TotalVolume(m³)',
  '选择总应拣件数': 'SelectTotalQtyStr',
  '选择总应拣体积(m³)': 'SelectTotalVolume(m³)',
  '选择明细中没有退仓类型为返厂的明细,请重新勾选': 'There are no details in the selection details that have a return type of return to factory. Please check again',
  '序号请输入正整数':'Please enter a positive integer',
  '请输入拣货分区':'Please enter the pick area',
  '选择全部门店':'Select all Store',
  '配出件数': 'Match the number of pieces',
  '配出数量': 'Quantity of matching',
  '总实际件数': 'Total actual number of pieces',
  '总实际金额': 'Total actual amount',
  '总实际体积': 'Total actual volume',
  '总实际品项数': 'Total actual items',
  '总实际重量': 'Total actual weight',
  '自定义字段': 'Custom Fields',
  '备用1': 'Standby 1',
  '备用2': 'Standby 2',
  '波次启动校验配置':'Wave start verify configuration',
  '是否强制更新': 'Whether to force update',
  '强制维护固定拣货位仓位范围':'Force the maintenance of the fixed picking location warehouse range',
  '选中应拣件数': 'SelectPickQtyStr',
  '选中应拣体积(m³)': 'SelectPickVolume(m³)',
  '领用返还单': 'Receive return slip',
  '当前订单中包含已保存的收货单，确认是否完成该订单?': 'The current order contains the receipt that is being saved. Confirm whether the order is completed?',
  '订单{billNumber}存在已保存收货单，是否确认完成?': 'A saved receipt exists for the order {billNumber}, is it confirmed to be completed?',
  '货位{binCode}存在商品{articleCode}库存，是否确认修改': 'There is product {articleCode} in stock in space {binCode}, please confirm the modification',
  '第{line}行重量结算商品，件数不为0，重量不能为0': 'line {line} weight settlement goods, the number of pieces is not 0, weight cannot be 0',
  '订单{billNumber}存在已保存收货单，是否确认完成?': 'A saved receipt exists for the order {billNumber}, is it confirmed to be completed?',
  '系统规则': 'System rules',
  '全局配置': 'Global configuration',
  '资料配置': 'Data configuration',
  '运输配置': 'Configuration of transport',
  '移库规则': 'Transfer rule',
  '业务单据使用货位用途规则': 'Business documents use the rules for the use of the location',
  'RF操作配置': 'RF operation configuration',
  '单据操作限制配置': 'Document operation limit configuration',
  '容器后置打印配置': 'The container prints the configuration behind it',
  '员工作业配置': 'Staff job configuration',
  '类越库拣货员作业配置': 'Similar to the cross warehouse picking personnel operation configuration',
  '退货拣货员作业配置': 'Return picker operation configuration',
  '预约预检': 'Reservation Pre-check',
  '波次配置': 'Wave frequency configuration',
  '默认库存分配方案配置': 'Default inventory allocation scheme configuration',
  '默认拣货顺序方案配置': 'Default picking order scheme configuration',
  '默认集货管理方案配置': 'Default collection management scheme configuration',
  '默认集货复查装车配置': 'Default collection review loading configuration',
  '默认允许重复执行配置': 'By default, repeated configuration execution is allowed',
  '默认商品组分单配置': 'Default product component list configuration',
  '分单默认值配置': 'Split single default value configuration',
  '同容器拣货限制': 'Same-container picking restrictions',
  '请选择分单默认值配置': 'Please select the split order default configuration',
  '请选择同容器拣货限制': 'Please select same-container picking limit',
  '默认越库分播管理方案配置': 'Default cross-base multicast management scheme configuration',
  '超控制天数出库仓位配置': 'Over control days outbound position configuration',
  '拣货配置': 'Picking configuration',
  '集货配置': 'Collection configuration',
  '拣货区域与码头集对应配置': 'The picking area is configured corresponding to the quay set',
  '配货差异': 'Difference in distribution',
  '指令配置': 'Instruction configuration',
  '运输配置': 'Configuration of transport',
  '看板配置': 'Kanban board configuration',
  '排车配置': 'Platoon configuration',
  '装车配置': 'Loading configuration',
  '交接配置': 'Handover configuration',
  '返配类型': 'Type of return matching',
  '请先选择要设置目标货位行的商品': 'Please first select the product for which you want to set the target picking location line',
  '请选择少配移库类型的明细行': 'Please select the details line for the type of less matching and shifting type',
  '上一个': 'Last',
  '下一个': 'Next',
  '不存在上一个': 'There is no previous',
  '不存在下一个': 'There is no next',
  '获取上一个失败': 'Get last failed',
  '获取下一个失败': 'Get next failed',
  '调序成功': 'Shuffle successfully',
  '订单 {billNumber} 存在已保存收货单，是否确认完成？': 'A saved receipt exists for the order {billNumber}, is it confirmed to be completed?',
  '备用3': 'Standby 3',
  '备用4': 'Standby 4',
  '订单 {billNumber} 存在已保存收货单，是否确认完成？': 'A saved receipt exists for the order {billNumber}, is it confirmed to be completed?',
  '领料单': 'material requisition',
  '统配拣货显示商品条码': 'Unified Picking Display Commodity BarCode',
  '临时车辆配置': 'Temporary vehicle configuration',
  '临时车辆使用已有车型': 'Temporary vehicles use existing models',
  '勾选后RF统配拣货模块显示商品的第二代码,不勾选不显示': 'After ticking, the RF unified picking module  displays the commodity barcode, and it will not be displayed if not ticked',
  'WEB': 'WEB',
  '采集终端': 'Acquisition terminal',
  '附件强度': 'Strength of attachment',
  '第{line}行明细,感官质检科目{sense}的附件强度为强制限制,质检结果至少要有一个附件': 'In line {line}, the attachment strength of the sensory quality inspection subject {sense} is mandatory, and the quality inspection result must have at least one attachment',
  '不合格原因': 'Reason for failure',
  '审批结果': 'Approval results',
  '第{line}行明细,质检结果为不合格,至少选择一个不合格原因': 'In the detail of line {line}, the quality inspection result is unqualified, and at least one unqualified reason is selected',
  '可复核缺货处理配单类型': 'Can be reviewed out of stock handling order type',
  '分单标识': 'Splitting Condition',
  '分单描述': 'Splitting Desc',
  '同时存在分单标识{conditionStr}的单据，分单标识不同不能合并预检': 'Bills with split label {conditionStr} simultaneously cannot be merged for pre inspection due to different split labels',
  '同时存在分单标识{conditionStr}的单据，分单标识不同不能存在一个波次中': 'Bills with split label {0} simultaneously cannot exist in the same wave due to different splitting labels',
  '复核缺货打印': 'Online Review Stock out',
  '不支持多容器打印': 'Multi-container printing is not supported',
  '缺货打印机': 'Out of stock printer',
  '报表类型': 'report type',
  '帆软': 'fine report',
  '最高最低为0': 'The highest and lowest values are 0',
  '帆软': 'fine report',
  'Token密钥': 'Token key',
  '租户': 'Tenant',
  'Gem服务': 'Gem service',
  '配置': 'config',
  'FineReport': 'FineReport',
  'PasoReport': 'PasoReport',
  '修改配置': 'update config',
  '请填写模板路径': 'Please fill in the template path.',
  '模板路径(FineReport)': 'FineReport Url',
  '模板路径(PasoReport)': 'PasoReport Url',
  '出入业务小数位配置 ': 'InOrOutDecimalDigitsConfig',
  '请输入Token密钥': 'Please enter Token key',
  '请输入租户': 'Please enter tenant',
  '请输入Gem服务': 'Please enter Gem service',
  'Token有效期': 'Token expiration date',
  '商品{article}包装规格{qpcStr}不存在装盘建议' : 'Item {article} packing specification {qpcStr} there is no packing advice',
  '商品{article}包装规格{qpcStr}最低库存应小于等于最高库存' : 'Item {article} packing specification {qpcStr} minimum inventory should be less than or equal to maximum inventory',
  '修改货主会导致替换商品/适用门店信息清空，请确认修改？': 'Modifying the owner of the goods will cause the information of the replacement goods to be cleared. Please confirm the modification.',
  '是否继续审核？': 'Do you want to continue the audit? ',
  '确认审核': 'Confirm audit ',
  '商品：{article}，拣货数量：{qty}，超过最大拣货数量：{overQty}': 'Goods: {article}, pick quantity: {qty}, over maximum pick quantity: {overQty}',
  '拣货是否直接平移': 'Whether the picking is translated directly',
  '用于登录页以及系统导航展开时左上角位置显示，图片要求.png格式,大小不超过2M': 'Used for the login page and the upper left corner of the system navigation expansion, the picture requires.png format, the size is not more than 2M',
  '用于系统导航收起时左上角位置显示，图片要求.png格式,大小不超过2M': 'It is used for display in the upper left corner of the system navigation when it is folded up. The picture requires.png format and the size is not more than 2M',
  'LOGO长图片': 'LOGO long picture',
  'LOGO方图片': 'LOGO square picture',
  '副文案': 'Associate copy',
  '登录页左侧插图': 'Illustration on the left of the login page',
  '货主范围': 'owner range',
  '登录页LOGO图片': 'Login page LOGO image',
  '用于登录页右上角位置显示，图片要求.png格式,大小不超过2M': 'Used for display in the upper right corner of the login page, the picture requires.png format, the size is not more than 2M',
  '菜单LOGO图片': 'Menu LOGO image',
  '用于菜单导航栏展开/收起是的左上角位置显示,图片要求.png格式,大小不超过2M': 'For the menu navigation bar to expand/close is displayed in the upper left corner position, the picture requires.png format, the size is not more than 2M',
  '长logo': 'Long logo',
  '方logo': 'Square logo',
  '容器个数和附件个数比例 最长是30': 'The maximum ratio between the number of containers and the number of attachments is 30',
  '仅支持PNG的图片': 'Only PNG images are supported',
  '是否确认损耗': 'Whether to confirm the loss',
};
